(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
app.pkg("admin");
app.admin.EmailForUsersDataModel = Backbone.Model.extend({
    validation: {
        content: {
            required: true
        },
        title: {
            required: true
        }
    },

    urlRoot: '/api/service/admin/email-for-users'
});

},{}],2:[function(require,module,exports){
app.pkg('admin.emailForUsers');
app.admin.emailForUsers.EmailForUsersFormView = Backbone.FormView.extend({

    template: _.template(app.templates['admin-emailForUsers-EmailForUsersFormView']),


    additionalInitializeActions: function () {
        Backbone.Validation.bind(this);
    },

    setModelValues: function () {
        this.$('#title').val(this.model.get('title'));
        this.$('#content').val(this.model.get('content'));

        tinymce.init({
            selector: "#content",
            height: 300,
            plugins: "link, paste",
            paste_use_dialog: true,
            paste_auto_cleanup_on_paste: true,
            toolbar: " fontsizeselect | sizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link",
            style_formats: [],
            language: app.currentLocale
        });
    },

    getNewModelInstance: function () {
        return new app.admin.EmailForUsersDataModel({
            id: null
        });
    },
    additionalSaveSuccess: function () {
        this.model = this.getNewModelInstance();
        this.render();
        Backbone.Validation.bind(this);
    },


    getFormValues: function () {
        var formVals = {};
        this.$("input[type=text], input[type=email], textarea, select").each(function () {
            formVals[$(this).attr("name")] = $(this).val();
        });

        formVals.content = tinymce.get('content').getContent();
        return formVals;
    },


    displaySuccessCreateMessage: function () {
        app.displayAlertMessage("success", app.getMessage("successEmailsSentMessageTitle"),  app.getMessage("successEmailsSentMessageTitle"));
    }
});

},{}],3:[function(require,module,exports){
app.pkg('admin.emailForUsers');
app.admin.emailForUsers.EmailForUsersBootstrap = function () {

    var model = new app.admin.EmailForUsersDataModel({});

    new app.admin.emailForUsers.EmailForUsersFormView({
        el: $('[data-content="email-for-users-form"]'),
        model: model
    });
};

},{}],4:[function(require,module,exports){
require('./EmailForUsersDataModel');
require('./emailForUsers/EmailForUsersPageBootstrap');
require('./emailForUsers/EmailForUsersForm');
},{"./EmailForUsersDataModel":1,"./emailForUsers/EmailForUsersForm":2,"./emailForUsers/EmailForUsersPageBootstrap":3}],5:[function(require,module,exports){
app.pkg("availableGameTripRanking");

app.availableGameTripRanking.AvailableGameTripRankingDataModel = Backbone.Model.extend({
    validation: {
        name: {
            required: true
        },

        referee_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_score_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_time_ranking: {
            required: true,
            pattern: 'number'
        },
        commissioner_ranking: {
            required: true,
            pattern: 'number'
        },
        referee_appointment_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_appointment_ranking: {
            required: true,
            pattern: 'number'
        },
        driver_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_4_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_5_ranking: {
            required: true,
            pattern: 'number'
        },

        secretary_statistics_2_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_3_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_information_ranking: {
            required: true,
            pattern: 'number'
        },

    },


    urlRoot: '/api/availbale-game-trip-rankings/data'
});

},{}],6:[function(require,module,exports){
app.pkg("availableGameTripRanking");

app.availableGameTripRanking.AvailableGameTripRankingsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/availbale-game-trip-rankings/all'
});

},{}],7:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingDisplayPage');
app.availableGameTripRanking.availableGameTripRankingDisplayPage.AvailableGameTripRankingDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['availableGameTripRanking-availableGameTripRankingDisplayPage-AvailableGameTripRankingDataDisplayView']),


    events: {},

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    window.location.href = "/availbale-game-trip-rankings";
                }
            });
        } else {
            window.location.href = "/availbale-game-trip-rankings";
        }
    }

});

},{}],8:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingDisplayPage');
app.availableGameTripRanking.availableGameTripRankingDisplayPage.AvailableGameTripRankingDisplayPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }

    var model = new app.availableGameTripRanking.AvailableGameTripRankingDataModel({
        id: id
    });

    new app.availableGameTripRanking.availableGameTripRankingDisplayPage.AvailableGameTripRankingDataDisplayView({
        el: $('[data-content="ranking-data-display"]'),
        model: model
    });

    $('[data-main-menu-item="leagues"]').addClass("active");
    $('[data-sidebar-menu-item="trip-rankings"]').addClass("active");
};


},{}],9:[function(require,module,exports){
require('./AvailableGameTripRankingDataDisplayView');
require('./AvailableGameTripRankingDisplayPageBootstrap');






},{"./AvailableGameTripRankingDataDisplayView":7,"./AvailableGameTripRankingDisplayPageBootstrap":8}],10:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingEditPage');
app.availableGameTripRanking.availableGameTripRankingEditPage.AvailableGameTripRankingEditPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.availableGameTripRanking.AvailableGameTripRankingDataModel({
        id: id
    });

    new app.availableGameTripRanking.availableGameTripRankingEditPage.AvailableGameTripRankingFormView({
        el: $('[data-content="ranking-form"]'),
        model: model
    });

    $('[data-main-menu-item="leagues"]').addClass("active");
    $('[data-sidebar-menu-item="new-trip-ranking"]').addClass("active");
};

},{}],11:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingEditPage');
app.availableGameTripRanking.availableGameTripRankingEditPage.AvailableGameTripRankingFormView = Backbone.FormView.extend({

    template: _.template(app.templates['availableGameTripRanking-availableGameTripRankingEditPage-AvailableGameTripRankingFormView']),

    additionalEvents: {},

    additionalInitializeActions: function () {
        Backbone.Validation.bind(this);
    },

    additionalSaveSuccess: function (wasNew) {
        if (wasNew) {
            app.openAvailbleGameRankingEditPage(this.model.id);
        }
    },

    setModelValues: function () {
        this.$('#name').val(this.model.get('name'));
        this.$('#referee_ranking').val(this.model.get('referee_ranking'));
        this.$('#secretary_score_ranking').val(this.model.get('secretary_score_ranking'));
        this.$('#secretary_statistics_ranking').val(this.model.get('secretary_statistics_ranking'));
        this.$('#secretary_time_ranking').val(this.model.get('secretary_time_ranking'));
        this.$('#trip_ranking').val(this.model.get('trip_ranking'));
        this.$('#commissioner_ranking').val(this.model.get('commissioner_ranking'));
        this.$('#driver_ranking').val(this.model.get('driver_ranking'));

        this.$('#secretary_4_ranking').val(this.model.get('secretary_4_ranking'));
        this.$('#secretary_5_ranking').val(this.model.get('secretary_5_ranking'));

        this.$('#secretary_statistics_2_ranking').val(this.model.get('secretary_statistics_2_ranking'));
        this.$('#secretary_statistics_3_ranking').val(this.model.get('secretary_statistics_3_ranking'));
        this.$('#secretary_information_ranking').val(this.model.get('secretary_information_ranking'));

    },
    getNewModelInstance: function () {
        return new app.availableGameTripRanking.AvailableGameTripRankingDataModel({
            id: null
        });
    }
});

},{}],12:[function(require,module,exports){
require('./AvailableGameTripRankingEditPageBootstrap');
require('./AvailableGameTripRankingFormView');






},{"./AvailableGameTripRankingEditPageBootstrap":10,"./AvailableGameTripRankingFormView":11}],13:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingsPage');
app.availableGameTripRanking.availableGameTripRankingsPage.AvailableGameTripRankingsListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['availableGameTripRanking-availableGameTripRankingsPage-AvailableGameTripRankingListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="remove-element"]': "removeRanking"
    },

    onItemClick: function() {
        app.openAvailbleGameRankingDisplayPage(this.model.id);
    },

    removeRanking: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));

                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/availbale-game-trip-rankings/edit/" + this.model.id);
        this.$('[data-action="preview-element"]').attr("href", "/availbale-game-trip-rankings/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        return this;
    }



});

},{}],14:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingsPage');
app.availableGameTripRanking.availableGameTripRankingsPage.AvailableGameTripRankingsListView = Backbone.LazyLoadListView.extend({
    getCollectionElementsDisplayDiv: function() {
        return this.$('#available-rankings-list tbody');
    }

});

},{}],15:[function(require,module,exports){
app.pkg('availableGameTripRanking.availableGameTripRankingsPage');
app.availableGameTripRanking.availableGameTripRankingsPage.availableGameTripRankingsPageBootstrap = function() {
    new app.availableGameTripRanking.availableGameTripRankingsPage.AvailableGameTripRankingsListView({
        el: $('[data-content="available-game-trip-rankings-list"]'),
        collection: new app.availableGameTripRanking.AvailableGameTripRankingsCollection(),
        listItemDisplayViewType: app.availableGameTripRanking.availableGameTripRankingsPage.AvailableGameTripRankingsListItemView,
        template: app.templates['availableGameTripRanking-availableGameTripRankingsPage-AvailableGameTripRankingsListView']
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    $('[data-sidebar-menu-item="trip-rankings"]').addClass("active");
};

},{}],16:[function(require,module,exports){
require('./AvailableGameTripRankingsListItemView');
require('./AvailableGameTripRankingsListView');
require('./AvailableGameTripRankingsPageBootstrap');






},{"./AvailableGameTripRankingsListItemView":13,"./AvailableGameTripRankingsListView":14,"./AvailableGameTripRankingsPageBootstrap":15}],17:[function(require,module,exports){
require('./availableGameTripRankingDisplayPage');
require('./availableGameTripRankingEditPage');
require('./availableGameTripRankingsPage');
require('./AvailableGameTripRankingDataModel');
require('./AvailableGameTripRankingsCollection');






},{"./AvailableGameTripRankingDataModel":5,"./AvailableGameTripRankingsCollection":6,"./availableGameTripRankingDisplayPage":9,"./availableGameTripRankingEditPage":12,"./availableGameTripRankingsPage":16}],18:[function(require,module,exports){
app.pkg("components.gamesList");

app.components.gamesList.GamesCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/games/all/paginated'
});

},{}],19:[function(require,module,exports){
app.pkg('components.gamesList');
app.components.gamesList.GamesListItemView = Backbone.View.extend({

    tagName: 'tr',
    template: _.template(app.templates['components-gamesList-GamesListItemView']),

    events: {
        'click ': 'onItemClick'
    },

    onItemClick: function() {
        app.openGameDisplayPage(this.model.id);
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
        this.additionalInitializeActions();
    },

    additionalInitializeActions: function() {

    },

    renderTemplate: function() {
        var data = this.model.toJSON();
        data.shortTimeExpr = this.model.get('event_date').substring(this.model.get('event_date').length - 5,
            this.model.get('event_date').length);
        this.$el.html(this.template(data));
        app.addTooltips(this.$el);

    },
    render: function() {
        this.renderTemplate();
        this.$('[data-action="edit-element"]').attr("href", "/game/edit/" + this.model.id);
        this.$el.attr("id", this.model.id);

        this.$('[data-action="preview-element"]').attr("href", "/game/" + this.model.id);
        this.renderAppointments();
        this.additionalRender();
        if (this.model.get("canceled")) {
            this.$el.addClass("canceled");
        } else {
            this.$el.removeClass("canceled");
        }

        if (this.model.get("modified")) {
            this.$el.addClass("modified");
        } else {
            this.$el.removeClass("modified");
        }
        return this;
    },

    additionalRender: function() {

    },

    renderAppointments: function() {
        var appointments = this.model.get("game_appointments");
        appointments = _.sortBy(appointments, function(elem) {
            return elem.id;
        });
        for (var i = 0; i < appointments.length; i++) {
            var data = appointments[i];
            if (data.user_id !== null) {
                var model = new app.gameAppointment.GameAppointmentModel(data);
                this.renderItem(model);
            }
        }
    },

    renderItem: function(model) {
        var view = new app.gameAppointment.gameAppointmentDisplay.GameAppointmentDisplayView({
            model: model,
            noTitle: true
        });
        if (model.get('user_type_in_event').indexOf("ref") === 0) {
            this.$('[data-content="refs-selection"]').append(view.el);
        } else if (model.get('user_type_in_event').indexOf("secretary") === 0) {
            this.$('[data-content="secretary-selection"]').append(view.el);
        } else {
            this.$('[data-content="persons-selection"]').append(view.el);
        }

    }


});

},{}],20:[function(require,module,exports){
app.pkg('components.gamesList');
app.components.gamesList.GamesListView = Backbone.LazyLoadListView.extend({
    separatorTemplate: _.template(app.templates['components-gamesList-GamesListSeparatorView']),
    templateName: app.templates['components-gamesList-GamesListView'],
    FILTERS_COOKIE_NAME: "GAMES_LIST_FILTER",
    SAVE_FILTERS: true,

    additionalInitializeActions: function () {
        if (this.options.FILTERS_COOKIE_NAME) {
            this.FILTERS_COOKIE_NAME = this.options.FILTERS_COOKIE_NAME;
        }
    },

    getDefaultValueForFilter: function (key) {
        if (!this.SAVE_FILTERS) {
            return undefined;
        }
        var cookieValue = app.getCookie(this.FILTERS_COOKIE_NAME);
        if (cookieValue) {
            var defaultFilterValues = JSON.parse(cookieValue);
            return defaultFilterValues[key]
        } else {
            return undefined;
        }
    },

    additionalRender: function () {
        this.initDatePicker();
        this.initLeagueTypeFilter();
        this.initExternalFilters();
        this.fetchCollection();
        this.subViewAditionalRender();
    },

    subViewAditionalRender: function () {
    },

    initExternalFilters: function () {
    },

    initLeagueTypeFilter: function () {
        this.$("#league_type").val(this.getDefaultValueForFilter("leagueType"));
        this.$("#league_type").change(this.onFilterChange);
    },

    onFilterChange: function () {
        this.resetCollection();
        this.fetchCollection();
    },

    getDateFilterValue: function () {
        return this.$("#filter_by_date").val();
    },

    getLeagueTypeFilterValue: function () {
        return this.$("#league_type").val() || "normal";
    },

    getExternalFetchParams: function () {

    },

    getFetchParams: function () {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        filters.startDate = this.getDateFilterValue();
        filters.leagueType = this.getLeagueTypeFilterValue();
        _.extend(filters, filters, this.getExternalFetchParams());

        return filters;
    },

    saveFilterValue: function(){
        var filters = this.getFetchParams();
        if (this.SAVE_FILTERS) {
            app.setCookie(this.FILTERS_COOKIE_NAME, JSON.stringify(filters));
        }
    },

    afterSuccessFetch: function(){
        this.saveFilterValue();
    },

    initDatePicker: function () {
        var view = this,
            defaultValue = this.getDefaultValueForFilter("startDate");
        if (!defaultValue) {
            defaultValue = $.datepicker.formatDate("yy-mm-dd", new Date());
        }
        this.$("#filter_by_date").val(defaultValue);
        this.$("#filter_by_date").datepicker({
            onSelect: function () {
                view.onFilterChange();
            }
        });
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#games-list tbody');
    },

    getOnlyDateInString: function (model) {
        return app.getDateStringFromDateTimeString(model.get('event_date'));
        // return model.get('event_date').substring(0, model.get('event_date').length - 6);
    },

    renderSeparators: function () {
        var view = this;
        var separatorDates = [];
        _(this.collection.models).each(function (model) {
            separatorDates.push({
                date: new Date(this.getOnlyDateInString(model)).getTime(),
                formatedDate: $.datepicker.formatDate("yy-mm-dd", new Date(this.getOnlyDateInString(model))),
                origDate: model.get("event_date")
            });
        }, this);

        separatorDates.sort(function (a, b) {
            if (a.date > b.date) {
                return 1;
            } else if (a.date < b.date) {
                return -1;
            } else {
                return 0;
            }
        });
        for (var i in separatorDates) {
            view.addSeparator(separatorDates[i].formatedDate);
        }

    },

    renderCollectionElements: function () {
        if (this.collection.pageInfo.page === 0) {
            this.getCollectionElementsDisplayDiv().empty();
            this.updateScrollbar();
        }
        this.renderSeparators();
        var view = this;
        _(this.collection.models).each(function (model) {
            view.renderCollectionElement(model);
        }, this);
        if (this.collection.models.length === 0) {
            var element = $("#no-games-list");
            if (!element.length) {
                this.getCollectionElementsDisplayDiv().append("<div id='no-games-list'>"+app.getMessage('noGames')+"</div>");
            }
        }
        this.afterCollectionRender();
    },

    afterCollectionRender: function () {

    },

    renderCollectionElement: function (model) {
        var formatedDate = $.datepicker.formatDate("yy-mm-dd", new Date(this.getOnlyDateInString(model)));
        var separator = this.$('[data-separator-date="' + formatedDate + '"]');
        var view = new this.options.listItemDisplayViewType({
            model: model
        });
        var lastElement = this.$('[data-event-date="' + formatedDate + '"]').last();
        if (lastElement.length > 0) {
            $(view.el).insertAfter(lastElement);
        } else {
            $(view.el).insertAfter(separator);
        }
        $(view.el).attr("data-event-date", formatedDate);
    },

    addSeparator: function (date) {
        var separator = this.$('[data-separator-date="' + date + '"]');
        if (separator.length === 0) {
            var element = this.createSeparatorDiv(date);
            this.getCollectionElementsDisplayDiv().append(element);
        }
    },

    createSeparatorDiv: function (date) {
        var dayExpr = $.datepicker.formatDate("DD", new Date(date));
        return $("<tr></tr>").html(this.separatorTemplate({
            date: date,
            dayExpr: dayExpr
        })).addClass("separator").attr('data-separator-date',
            date);
    }


});

},{}],21:[function(require,module,exports){
require('./GamesCollection');
require('./GamesListItemView');
require('./GamesListView');


},{"./GamesCollection":18,"./GamesListItemView":19,"./GamesListView":20}],22:[function(require,module,exports){
require('./gamesList');
require('./leagueSelection');
require('./modalWindow');
require('./postsList');
require('./usersList');
require('./rangeSelectionFilter');
require('./monthSelectionFilter');






},{"./gamesList":21,"./leagueSelection":24,"./modalWindow":26,"./monthSelectionFilter":28,"./postsList":32,"./rangeSelectionFilter":34,"./usersList":37}],23:[function(require,module,exports){
app.pkg('components.leagueSelection');
app.components.leagueSelection.LeagueSelectionView = Backbone.View.extend({
    template: _.template(app.templates['components-leagueSelection-LeagueSelectionView']),
    rendered: false,
    initialize: function() {
        _.bindAll(this);
        this.collection = new app.league.LeaguesCollection();
        this.render();
        this.fetchCollection();
    },

    render: function() {
        this.$el.html(this.template());
        return this;
    },

    fetchCollection: function() {
        var view = this;
        this.collection.fetch({
            data: {},
            success: function() {
                view.renderCollectionElements();
            },
            error: function() {}
        });
    },

    getFilterValue: function() {
        if (this.rendered) {
            return this.$('[name="league_id"]').val();
        } else {
            return this.options.selectedLeagueId || null;
        }
    },

    renderCollectionElements: function() {
        var view = this;
        if (this.options.isEmpty) {
            view.$('[name="league_id"]').append('<option value="null">'+app.getMessage("selectPlaceholder")+'</option>');
        }
        var models = _.filter(this.collection.models, function(item){
            var league_group = item.get('league_group');
            return !league_group || !league_group.is_archived;
        })
        _(models).each(function(model) {
            view.$('[name="league_id"]').append('<option value="' + model.id + '">' + model.get('name') + '</option>');
        }, this);
        this.$('[name="league_id"]').val(this.options.selectedLeagueId);
        this.rendered = true;
    }

});

},{}],24:[function(require,module,exports){
require('./LeagueSelectionView');

},{"./LeagueSelectionView":23}],25:[function(require,module,exports){
app.pkg('components.modalWindow');
app.components.modalWindow.ModalWindowView = Backbone.View.extend({
    template: _.template(app.templates['components-modalWindow-ModalWindowView']),
    className: "modal hide fade",
    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template({
            headerText: this.options.headerText
        }));
        this.$el.modal();
        var that = this;
        if (this.options.contentView !== undefined) {
            var content = new this.options.contentView(this.options.contentParams);
            this.$('.modal-body').append(content.el);
            content.on('hide-modal', function() {
                that.$el.modal('hide');
            });
        }
        var view = this;
        this.$el.on('hidden', function() {
            view.onModalHide();
        });
        return this;
    },


    onModalHide: function() {
        this.trigger("modal-hide");
        this.remove();
    }


});

},{}],26:[function(require,module,exports){
require('./ModalWindowView');

},{"./ModalWindowView":25}],27:[function(require,module,exports){
app.pkg('components.monthSelectionFilter');
app.components.monthSelectionFilter.MonthSelectionFilterView = Backbone.View.extend({
    template: _.template(app.templates['components-monthSelectionFilter-MonthSelectionFilterView']),

    events: {
        'change #filter_month': 'filterChanged'
    },

    initialize: function() {
        _.bindAll(this, 'getFilterValues');
        this.render();
    },


    render: function() {
        this.$el.html(this.template());
        this.renderOptions();
        var currentMonth = new Date().getMonth() + 1;
        this.$('#filter_month').val(currentMonth);
        return this;
    },

    renderOptions: function() {
        var months = require("../../../../data/months")(app);
        var current = new Date().getFullYear();
        var years = [];
        years.push(current - 1);
        years.push(current);
        for (var j = 0; j < years.length; j++) {
            for (var i = 0; i < 12; i++) {
                this.$('#filter_month').append("<option value='" + (i + 1) + "' data-year='" + years[j] + "' > " + years[j] + " " + months[i] + "</option>");
            }
        }
    },

    getFilterValues: function() {
        return {
            month: this.$('#filter_month option:selected').val(),
            year: this.$('#filter_month option:selected').attr("data-year")
        };
    },

    filterChanged: function() {
        this.trigger('filterChanged');
    }


});

},{"../../../../data/months":346}],28:[function(require,module,exports){
require("./UsersListFilterView");

},{"./UsersListFilterView":27}],29:[function(require,module,exports){
app.pkg('components.postsList');
app.components.postsList.PostListItemView = Backbone.View.extend({

    tagName: 'div',
    className: 'news-item row-fluid',
    template: _.template(app.templates['components-postsList-PostListItemView']),

    events: {
        'click [data-action="delete-post"]': 'deletePost',
        'click [data-action="edit-post"]': 'editPost',
        'click ': 'onItemClick'
    },

    editPost: function(e) {
        e.stopImmediatePropagation();
        app.openPostEditPage(this.model.id);
    },

    onItemClick: function() {
        $('body').append(new app.components.modalWindow.ModalWindowView({
            contentView: app.components.postsList.PostView,
            contentParams: {
                model: this.model
            },
            headerText: this.model.get("title")
        }).el);
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    deletePost: function(e) {
        e.stopImmediatePropagation();
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
    },

    render: function() {
        var data = this.model.toJSON();
        data.croppedContent = app.cropText(data.content, 150);
        data.postDay = $.datepicker.formatDate("dd", new Date(app.getDateStringFromDateTimeString(data.updated_at)));
        data.postMonth = $.datepicker.formatDate("M", new Date(app.getDateStringFromDateTimeString(data.updated_at)));
        this.$el.html(this.template(data));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }

        return this;
    }
});

},{}],30:[function(require,module,exports){
app.pkg('components.postsList');
app.components.postsList.PostView = Backbone.View.extend({
    tagName: 'div',
    className: 'row-fluid log-item',
    template: _.template(app.templates['components-postsList-PostView']),
    
    initialize: function() {
        _.bindAll(this);
        this.render();
    },
    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        return this;
    }

});

},{}],31:[function(require,module,exports){
app.pkg('components.postsList');
app.components.postsList.PostsListView = Backbone.LazyLoadListView.extend({
    templateName: app.templates['components-postsList-PostsListView'],
    render: function() {
        this.$el.html(this.template());
        this.renderedViews = [];
        this.initScroll();
        return this;
    },

    getFetchParams: function() {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    },

    getCollectionElementsDisplayDiv: function() {
        return this.$('.news-list');
    },

    resetCollection: function() {
        this.collection.resetCollection();
        this.updateScrollbar();
        this.renderedViews = [];
    },

    renderCollectionElements: function() {
        if (this.collection.pageInfo.page === 0) {
            this.getCollectionElementsDisplayDiv().empty();
            this.updateScrollbar();
        }
        var view = this;
        _(this.collection.models).each(function(model) {
            view.renderCollectionElement(model);
        }, this);
    },

    onRecordOpen: function(id) {
        for (var i = 0; i < this.renderedViews.length; i++) {
            if (this.renderedViews[i].model.id != id)
                this.renderedViews[i].trigger("close-record");
        }
    },

    renderCollectionElement: function(model) {
        var view = new app.components.postsList.PostListItemView({
            model: model
        });
        this.getCollectionElementsDisplayDiv().append(view.el);
        view.on("open-record", this.onRecordOpen, this);
        this.renderedViews.push(view);
    }

});

},{}],32:[function(require,module,exports){
require('./PostListItemView');
require('./PostsListView');
require('./PostView');



},{"./PostListItemView":29,"./PostView":30,"./PostsListView":31}],33:[function(require,module,exports){
app.pkg('components.rangeSelectionFilter');
app.components.rangeSelectionFilter.RangeSelectionFilterView = Backbone.View.extend({
    template: _.template(app.templates['components-rangeSelectionFilter-RangeSelectionFilterView']),


    initialize: function() {
        _.bindAll(this, 'getFilterValues');
        this.render();
    },


    render: function() {
        this.$el.html(this.template());
        this.initDatePickers();
        return this;
    },

    initDatePickers: function() {
        var self = this;
        var date_from_options = {
                numberOfMonths: 3,

                onClose: function(selectedDate) {
                    self.$('#date_to').datepicker("option", "minDate", selectedDate);
                }
            },
            date_to_options = {
                numberOfMonths: 3,
                onClose: function(selectedDate) {
                    self.$('#date_from').datepicker("option", "maxDate", selectedDate);
                }

            };
        if (this.options.maxDate) {
            date_from_options.maxDate = this.options.maxDate;
            date_to_options.maxDate = this.options.maxDate;
        }

        this.$('#date_from').datepicker(date_from_options);
        this.$('#date_to').datepicker(date_to_options);

        if (this.options.dafault_from) {
            this.$('#date_from').val($.datepicker.formatDate("yy-mm-dd", this.options.dafault_from));
        }
        if (this.options.default_to) {
            this.$('#date_to').val($.datepicker.formatDate("yy-mm-dd", this.options.default_to));
        }
    },

    getFilterValues: function() {
        return {
            date_from: this.$('#date_from').val(),
            date_to: this.$('#date_to').val()
        };
    },


    filterChanged: function() {
        this.trigger('filterChanged');
    }



});

},{}],34:[function(require,module,exports){
require("./RangeSelectionFilterView");

},{"./RangeSelectionFilterView":33}],35:[function(require,module,exports){
app.pkg('components.usersList');
app.components.usersList.UsersListFilterView = Backbone.View.extend({
    template: _.template(app.templates['components-usersList-UsersListFilterView']),

    events: {
        'change #filter_user_type': 'onSelectChange',
        'keyup #filter_text': 'filterChanged'
    },

    initialize: function() {
        _.bindAll(this, 'getFilterValues');
        this.render();
    },


    render: function() {
        this.$el.html(this.template());
        return this;
    },


    getFilterValues: function() {
        return {
            user_type: this.$('#filter_user_type').val(),
            search_text: this.$("#filter_text").val()
        };
    },

    onSelectChange: function() {
        this.$("#filter_text").val('');
        this.filterChanged();
    },

    filterChanged: function() {
        this.trigger('filterChanged');
    }
});

},{}],36:[function(require,module,exports){
app.pkg('components.usersList');
app.components.usersList.UsersListView = Backbone.LazyLoadListView.extend({

    render: function () {
        this.$el.html(this.template());
        this.renderFilters();
        this.initScroll();
        return this;
    },

    additionalInitializeActions: function () {

    },

    renderFilters: function () {
        this.filterView = new app.components.usersList.UsersListFilterView();
        this.$('.filters-form').prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
        this.fetchCollection();
        app.addTooltips(this.$el);
        if (app.User && !app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
    },

    onFilterChanged: function () {
        this.collection.resetCollection();
        this.getCollectionElementsDisplayDiv().empty();
        this.fetchCollection();
    },

    getFetchParams: function () {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#users-list tbody');
    }

});
},{}],37:[function(require,module,exports){
require('./UsersListView');
require('./UsersListFilterView');


},{"./UsersListFilterView":35,"./UsersListView":36}],38:[function(require,module,exports){
app.pkg('dashboard');
app.dashboard.DashboardMyGamesListItemView = app.components.gamesList.GamesListItemView.extend({
    template: _.template(app.templates['dashboard-DashboardMyGamesListItemView']),

    additionalRender: function () {
        if (app.User.type == "referee") {
            this.$('[data-content="secretary-selection"]').hide();
            this.$('[data-content="persons-selection"]').hide();
        }
        if (app.User.type == "secretary") {
            this.$('[data-content="refs-selection"]').hide();
            this.$('[data-content="persons-selection"]').hide();
        }
        if (app.User.type == "commissioner") {
            this.$('[data-content="refs-selection"]').hide();
            this.$('[data-content="secretary-selection"]').hide();
        }
    }
});
},{}],39:[function(require,module,exports){
app.pkg('dashboard');
app.dashboard.DashboardMyGamesListView = app.components.gamesList.GamesListView.extend({
    SAVE_FILTERS: false,
    templateName: app.templates['dashboard-DashboardMyGamesListView'],

    getDateFilterValue: function() {
        return $.datepicker.formatDate("yy-mm-dd", new Date());
    },

    subViewAditionalRender: function() {
        this.$('.form-inline').remove();
        if (app.User.type == "referee") {
            this.$('[data-content="secretary-selection"]').remove();
            this.$('[data-content="persons-selection"]').remove();
        }
        if (app.User.type == "secretary") {
            this.$('[data-content="refs-selection"]').remove();
            this.$('[data-content="persons-selection"]').remove();
        }
        if (app.User.type == "commissioner") {
            this.$('[data-content="refs-selection"]').remove();
            this.$('[data-content="secretary-selection"]').remove();
        }
    }

});

},{}],40:[function(require,module,exports){
app.pkg('dashboard');
app.dashboard.DashboardPageBootstrap = function(dashboardPopup) {
    var chartColors = ['#94BA65', '#2B4E72', '#2790B0', '#777', '#555', '#999', '#bbb', '#ccc', '#eee'];

    var dataMonth = [],
        monthChartHolder = $("#month-games-chart");

    if (app.isSmallScreen()) {
        $("#sidebar-holder").hide();
    } else {
        drawCharts();
    }

    function drawCharts() {
        $.ajax({
            url: '/api/dashboard/charts/data',
            type: 'GET'
        }).done(function(data) {
            for (var i = 0; i < data.length; i++) {
                dataMonth.push({
                    data: data[i].appointments_count,
                    label: data[i].league_name
                });
                drawChart(monthChartHolder, dataMonth);
            }
            if (data.length === 0) {
                $("#month-games-chart").append('<span style="text-align: center; width:100%; float:left;">'+app.getMessage('noGamesThisMonth')+'</span>');
            }
        }).fail(function(jqxhr, status) {
            app.displayAlertMessage("error", app.getMessage('errorTryAgain'), jqxhr.responseText);
        });
    }

    function drawChart(holder, data) {
        $.plot(holder, data, {
            // colors: chartColors,
            series: {
                pie: {
                    show: true,
                    innerRadius: 0,
                    stroke: {
                        width: 4
                    }
                }
            },

            legend: {
                position: 'se'
            },

            tooltip: true,
            tooltipOpts: {
                content: '%s: %y'
            },

            grid: {
                hoverable: true
            }
        });
    }

    new app.components.postsList.PostsListView({
        el: $('[data-content="posts-list"]'),
        collection: new app.post.PostsCollection()
    });

    new app.dashboard.DashboardMyGamesListView({
        el: $('[data-content="games-list"]'),
        collection: new app.schedule.mySchedule.MyScheduleGamesCollection(),
        listItemDisplayViewType: app.dashboard.DashboardMyGamesListItemView
    });

    if (false) {
        var popupCookie = app.getCookie("dashboard-popup-procentai");
        if (!popupCookie) {
            var modal = new app.components.modalWindow.ModalWindowView({
                contentView: app.dashboard.DashboardPopupContentView,
                headerText: "2 procentai"
            });
            modal.on("modal-hide", function() {
                app.setCookie("dashboard-popup", true);
            });
            $('body').append(modal.el);
        }

    }

    $('[data-main-menu-item="dashboard"]').addClass("active");
};

},{}],41:[function(require,module,exports){
app.pkg('dashboard');
app.dashboard.DashboardPopupContentView = Backbone.View.extend({
    template: _.template(app.templates['dashboard-DashboardPopupContentView']),

    initialize: function () {
        _.bindAll(this);
        this.render();
    },

    render: function () {
        this.$el.html(this.template({headerText: this.options.headerText }));
        return this;
    }

});
},{}],42:[function(require,module,exports){
require('./DashboardMyGamesListItemView');
require('./DashboardMyGamesListView');
require('./DashboardPopupContentView.js');
require('./DashboardPageBootstrap');





},{"./DashboardMyGamesListItemView":38,"./DashboardMyGamesListView":39,"./DashboardPageBootstrap":40,"./DashboardPopupContentView.js":41}],43:[function(require,module,exports){
app.pkg("documents.documentsPage");

app.documents.documentsPage.DocumentCategoryDataModel = Backbone.Model.extend({
    validation: {
        title: {
            required: true,
        }
    },

    urlRoot: '/api/service/documents/categories',

});

},{}],44:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentCategoryDisplay = Backbone.View.extend({
    tagName: 'div',
    template: _.template(app.templates['documents-documentsPage-DocumentCategoryDisplay']),

    events: {
        'click [data-action="close-item"]': "closeItem",
        'click [data-action="edit-item"]': "editItem",
        'click [data-action="add-document"]': "addDocument",
        'click [data-action="remove-item"]': "removeItem"
    },

    initialize: function() {
        _.bindAll(this);
        this.collection = new app.documents.documentsPage.DocumentCategoryDocumentCollection({
            categoryId: this.model.id
        });
        var self = this;
        this.model.bind("change", function() {
            self.render();
            self.renderCollectionElements();
        })
        this.render();
        this.fetchCollection();
    },

    closeItem: function () {
        this.trigger("closeItem");
        return false;
    },
    fetchCollection: function() {
        var view = this;
        this.collection.fetch({
            success: function() {
                view.renderCollectionElements();
            },
            error: function() {}
        });
    },

    renderCollectionElements: function() {
        this.$('[data-content="documents"]').empty();
        var view = this;
        _(this.collection.models).each(function(model) {
            view.renderItem(model);
        }, this);
        if (this.collection.models.length === 0) {
            this.$('[data-content="documents"]').append(app.getMessage('noRecords'));
        }
    },

    renderItem: function(model) {
        var view = new app.documents.documentsPage.DocumentDisplayView({
            model: model
        });
        view.on("remove-item", this.fetchCollection, this);
        this.$('[data-content="documents"]').append(view.el);
    },


    editItem: function(){
        var self = this;
        var modal = new app.components.modalWindow.ModalWindowView({
            contentView: app.documents.documentsPage.DocumentCategoryFormView,
            contentParams: {
                model: self.model
            },
            headerText: app.getMessage('addDocumentCategory')
        });

        $('body').append(modal.el);
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        app.addTooltips(this.$el);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    },

    addDocument: function(){
        var self = this;
        var modal = new app.components.modalWindow.ModalWindowView({
            contentView: app.documents.documentsPage.DocumentFormView,
            contentParams: {
                categoryId: this.model.id
            },
            headerText: app.getMessage('addDocument')
        });


        modal.on("modal-hide", function() {
            self.fetchCollection();
        });

        $('body').append(modal.el);
    },

    removeItem: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));
                }
            });
        }
        return false;
    },


});

},{}],45:[function(require,module,exports){
app.pkg('documents.documentsPage');

app.documents.documentsPage.DocumentCategoryDocumentCollection = Backbone.Collection.extend({
    initialize: function(options) {
        this.categoryId = options.categoryId;
    },

    url: function() {
        return '/api/service/documents/by_category/' + this.categoryId;
    }
});

},{}],46:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentCategoryFormView = Backbone.FormView.extend({

    template: _.template(app.templates['documents-documentsPage-DocumentCategoryFormView']),
    selections: [],

    additionalInitializeActions: function () {
        if(!this.model){
            this.model = this.getNewModelInstance();
        }
        this.render();
        Backbone.Validation.bind(this);
    },


    setModelValues: function () {
        this.$('#title').val(this.model.get('title'));
    },


    getFormValues: function() {

        var formVals = {
            id: this.model.id,
            title: this.$('[name="title"]').val(),
        };
        return formVals;
    },

    getNewModelInstance: function () {
        return new app.documents.documentsPage.DocumentCategoryDataModel({
            id: null
        });
    },

    additionalSaveSuccess: function() {
        this.trigger("hide-modal");
    },

});

},{}],47:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentCategoryListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['documents-documentsPage-DocumentCategoryListItemView']),

    events: {
        'click ': 'onItemClick'
    },
    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    onItemClick: function() {
        this.trigger("item-clicked", this.model.id);
        if (this.$el.hasClass("not-clickable")) {
            return;
        }
        this.$el.html("");
        this.$el.addClass("not-clickable");

        this.$el.append('<td class="expanded-holder" colspan="2"></td>');
        this.categoryDisplay = new app.documents.documentsPage.DocumentCategoryDisplay({
            el: this.$('.expanded-holder'),
            model: this.model
        });
        this.categoryDisplay.on("closeItem", this.closeItem, this);

    },

    closeItem: function() {
        if (this.categoryDisplay !== undefined) {
            this.renderNormalDisplay();
        }
    },
    additionalInitializeActions: function() {
        this.on("close-item", this.closeFormDisplay, this);
    },


    renderNormalDisplay: function() {
        this.$el.removeClass("not-clickable");
        this.categoryDisplay = undefined;
        this.render();
        this.trigger("item-closed-rendered", this.model.id);

    },



    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        app.addTooltips(this.$el);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    }


});

},{}],48:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentCategoryListView = Backbone.LazyLoadListView.extend({
    events: {
        'click [data-action="add-record"]': 'addRecord'
    },
    render: function () {
        this.$el.html(this.template());
        this.initScroll();
        if (!app.User.isAdmin) {
          this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#doc-categories-list tbody');
    },

    addRecord: function(){
       var self = this;
       var modal = new app.components.modalWindow.ModalWindowView({
           contentView: app.documents.documentsPage.DocumentCategoryFormView,
           contentParams: {},
           headerText: app.getMessage('addDocumentCategory')
       });

        modal.on("modal-hide", function() {
            self.fetchCollection();
        });

        $('body').append(modal.el);
    }

});

},{}],49:[function(require,module,exports){
app.pkg("documents.documentsPage");

app.documents.documentsPage.DocumentDataModel = Backbone.Model.extend({
    validation: {
        title: {
            required: true,
        },
        file: {
            required:  true
        },
        fileName: {
            required:  true
        }
    },

    urlRoot: '/api/service/documents',

});

},{}],50:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentDisplayView = Backbone.View.extend({
    template: _.template(app.templates['documents-documentsPage-DocumentDisplayView']),
    events: {
        'click [data-action="remove-element"]': 'deleteItem',
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    deleteItem: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }

        this.$('[ data-content="link"]').attr('href', '/api/service/documents/aws-document/'+ this.model.get('file_name'))

        return this;
    }

});

},{}],51:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentFormView = Backbone.FormView.extend({

    template: _.template(app.templates['documents-documentsPage-DocumentFormView']),
    selections: [],

    additionalEvents: {
    },



    additionalInitializeActions: function () {
        if(!this.model){
            this.model = this.getNewModelInstance();
        }
        this.render();
        Backbone.Validation.bind(this);
    },


    setModelValues: function () {
        this.$('#title').val(this.model.get('title'));
    },

    saveRecord: function(e) {
        app.displayLoadDialog();
        var self = this;
        var file = this.$('[name="file"]')[0].files[0];
        var fileName = file.name;
        var reader = new FileReader();
        reader.onload = function (fileEvent) {
            var formValues = {
                file: fileEvent.target.result,
                fileName: fileName,
                title: this.$('[name="title"]').val(),
                categoryId: this.options.categoryId
            };

            if (this.isModelValid(formValues)){
                self.saveData(formValues)
            }
        }.bind(this)
        reader.onerror = function () {
            console.log("error", arguments);
            app.hideLoadDialog();
        }
        reader.readAsDataURL(file);
        e.preventDefault();
    },

    saveData: function(formValues){
        var view = this;
        this.model.save(formValues, {
            success: function(model, response, options) {
                view.displaySuccessCreateMessage();
                app.hideLoadDialog();
                view.trigger("hide-modal");
            },
            error: function(model, response) {
                app.hideLoadDialog();
                view.displayErrorMessage(response.responseText);
            }
        })
    },

    getNewModelInstance: function () {
        return new app.documents.documentsPage.DocumentDataModel({
            id: null
        });
    },


});

},{}],52:[function(require,module,exports){
app.pkg("documents.documentsPage");

app.documents.documentsPage.DocumentsCategoryCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/documents/categories'
});

},{}],53:[function(require,module,exports){
app.pkg('documents.documentsPage');
app.documents.documentsPage.DocumentsPageBootstrap = function() {
    new app.documents.documentsPage.DocumentCategoryListView({
        el: $('[data-content="documents-list"]'),
        collection: new app.documents.documentsPage.DocumentsCategoryCollection(),
        listItemDisplayViewType: app.documents.documentsPage.DocumentCategoryListItemView,
        template: app.templates['documents-documentsPage-DocumentCategoryListView']
    });

    $('[data-main-menu-item="documents"]').addClass("active");
    $('[data-sidebar-menu-item="documents"]').addClass("active");

};

},{}],54:[function(require,module,exports){
require('./DocumentsCategoryCollection');
require('./DocumentsPageBootstrap');
require('./DocumentCategoryListView');
require('./DocumentCategoryListItemView');
require('./DocumentCategoryDisplay');
require('./DocumentCategoryDocumentCollection');
require('./DocumentDisplayView');
require('./DocumentFormView');
require('./DocumentDataModel');



require('./DocumentCategoryFormView');
require('./DocumentCategoryDataModel');






},{"./DocumentCategoryDataModel":43,"./DocumentCategoryDisplay":44,"./DocumentCategoryDocumentCollection":45,"./DocumentCategoryFormView":46,"./DocumentCategoryListItemView":47,"./DocumentCategoryListView":48,"./DocumentDataModel":49,"./DocumentDisplayView":50,"./DocumentFormView":51,"./DocumentsCategoryCollection":52,"./DocumentsPageBootstrap":53}],55:[function(require,module,exports){
require('./documentsPage');






},{"./documentsPage":54}],56:[function(require,module,exports){
app.pkg("game");

app.game.GameDataModel = Backbone.Model.extend({
    validation: {
        address: {
            required: true
        },
        event_date: {
            required: true
        },
        league_id: {
            required: true
        },
        team1: {
            required: true
        },
        team2: {
            required: true
        }
    },

    urlRoot: '/api/service/game/data'
});

},{}],57:[function(require,module,exports){
app.pkg('game.gameDisplayPage');
app.game.gameDisplayPage.GameDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['game-gameDisplayPage-GameDataDisplayView']),
    events: {},

    initialize: function () {
        _.bindAll(this);
        this.appointmentsCollection = new app.gameAppointment.GameAppointmentsCollection();
        this.fetchModel();
    },

    render: function () {
        this.$el.html(this.template(this.model.attributes));
        if (this.model.get('canceled')) {
            this.$('.canceled').show();
        } else {
            this.$('.canceled').hide();
        }
        if (this.model.get('modified')) {
            this.$('.modified').show();
        } else {
            this.$('.modified').hide();
        }
        this.fetchCollection();
        this.renderGameEvaluations();
        this.renderGameExpenses();
        this.renderGameTripDriverSelection();
        return this;
    },

    fetchModel: function () {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function () {
                    view.render();
                },
                error: function () {
                    window.location.href = "/schedule/full";
                }
            });
        } else {
            window.location.href = "/schedule/full";
        }
    },

    fetchCollection: function () {
        var view = this;
        this.appointmentsCollection.fetch({
            data: {
                gameId: this.model.id
            },
            success: function () {
                view.renderCollectionElements();
            },
            error: function () {
            }
        });
    },

    renderCollectionElements: function () {
        var view = this;
        _(this.appointmentsCollection.models).each(function (model) {
            view.renderItem(model);
        }, this);
        if (this.appointmentsCollection.models.length < 1) {
            this.$('[data-content="appointments-display"]').hide();
        }
    },

    renderItem: function (model) {
        var view = new app.gameAppointment.gameAppointmentDisplay.GameAppointmentDisplayView({
            model: model
        });
        if (model.get('user_type_in_event').indexOf("ref") === 0) {
            this.$('[data-content="refs-selection"]').append(view.el);
        } else {
            this.$('[data-content="secretary-selection"]').append(view.el);
        }
    },

    renderGameEvaluations: function () {
        if (!this.model.isNew() && this.$('[data-content="evaluations"]').length) {
            this.gameEvaluations = new app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationsDisplayView({
                gameId: this.model.id,
                showLegend: true
            });
            this.$('[data-content="evaluations"]').append(this.gameEvaluations.el);
        }
    },


    renderGameExpenses: function () {
        if (!this.model.isNew() && this.$('[data-content="expenses"]').length) {
            this.expenses = new app.gameExpenses.gameExpensesDisplay.GameExpensesDisplayView({
                gameId: this.model.id,
                showLegend: true
            });
            this.$('[data-content="expenses"]').append(this.expenses.el);
        }
    },

    renderGameTripDriverSelection: function () {
        if (this.model.get("is_trip")) {
            this.gameDriver = new app.game.gameDisplayPage.GameDriverSelectionView({
                gameId: this.model.id,
            });
            this.$('[data-content="game-driver"]').append(this.gameDriver.el);
        }
    }

});

},{}],58:[function(require,module,exports){
app.pkg('game.gameDisplayPage');
app.game.gameDisplayPage.GameDisplayPageBootstrap = function (id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.game.GameDataModel({
        id: id
    });

    new app.game.gameDisplayPage.GameDataDisplayView({
        el: $('[data-content="game-data-display"]'),
        model: model
    });
    $('[data-main-menu-item="schedule"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-game"]').addClass("active");
    } else $('[data-sidebar-menu-item="full-schedule"]').addClass("active");
};

},{}],59:[function(require,module,exports){
app.pkg('game.gameDisplayPage');
app.game.gameDisplayPage.GameDriverSelectionView = Backbone.View.extend({
    template: _.template(app.templates['game-gameDisplayPage-GameDriverSelectionView']),
    className: "row-fluid",

    events: {
        'change #driver': 'driverChanged'
    },

    initialize: function() {
        _.bindAll(this);
        this.getData();
    },

    getData: function() {

        var self = this;
        $.ajax({
            url: '/api/service/game-trip-ranking/game/' + this.options.gameId + '/drivers',
            type: 'GET'
        }).done(function(data) {
            self.data = data;
            self.render();
        });
    },


    render: function() {
        var html = this.template({});
        if (!this.data) {
            html = '';
        }
        this.$el.html(html);
        if (this.data) {
            this.renderOptions();
        }

        return this;
    },

    renderOptions: function() {
        var self = this;
        _(this.data.appointments).each(function(item) {
            if (item.user.id) {
                var selected = item.user.id === self.data.ranking.driver_id ? 'selected=selected' : '';
                self.$('#driver').append("<option value=" + item.user.id + " " + selected + ">" + item.user.short_name + "</option>");
            }
        }, this);


    },

    driverChanged: function() {
        var self = this;
        app.displayLoadDialog();
        $.ajax({
            url: '/api/service/game-trip-ranking/driver-update',
            type: 'PUT',
            data: {
                driverId: this.$("#driver").val(),
                gameId: this.options.gameId,
                rankingId: this.data.ranking.id
            }
        }).done(function(data) {
            app.displayAlertMessage("success", app.getMessage('recordSavedMessage'), app.getMessage('recordSavedMessage'));
            app.hideLoadDialog();
        }).fail(function(jqxhr, status) {
            app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
            app.hideLoadDialog();
        });
    }
});

},{}],60:[function(require,module,exports){
require('./GameDataDisplayView');
require('./GameDisplayPageBootstrap');
require('./GameDriverSelectionView');

},{"./GameDataDisplayView":57,"./GameDisplayPageBootstrap":58,"./GameDriverSelectionView":59}],61:[function(require,module,exports){
app.pkg('game.gameEditPage');
app.game.gameEditPage.GameEditPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.game.GameDataModel({
        id: id
    });
    new app.game.gameEditPage.GameFormView({
        el: $('[data-content="game-form"]'),
        model: model
    });
    $('[data-main-menu-item="schedule"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="add-games"]').addClass("active");
    } else $('[data-sidebar-menu-item="games-assign"]').addClass("active");
};

},{}],62:[function(require,module,exports){
app.pkg('game.gameEditPage');
app.game.gameEditPage.GameFormView = Backbone.FormView.extend({

    template: _.template(app.templates['game-gameEditPage-GameFormView']),
    tagname: "div",
    additionalEvents: {
        'click [data-action="close-record"]': 'closeForm',
        'click [data-action="delete-record"]': 'deleteRecord',
        'click [data-action="send-mail"]': 'sendInfoMail',
        'click [data-action="open-game-trip-ranking"]': 'openGameTripRanking',
        'click [data-action="open-trip-mail"]': 'openTripMail',
        'click [data-action="preview-record"]': 'openGamePreview',
        'click [data-action="game-evaluations"]': 'showGameEvaliationsModal',
        'change [data-action="is_trip"]': 'updateModel',
        'change [data-action="modified"]': 'updateModel',
        'change [data-action="commissioner_remotely"]': 'updateModel'

    },

    sendInfoMail: function () {
        if (confirm(app.getMessage('doYouWantToSendEmail'))) {
            var url = app.sendGameEmailUrl(this.model.id);
            app.displayLoadDialog();
            $.ajax({
                url: url,
                type: 'PUT',
                data: {}
            }).done(function () {
                app.hideLoadDialog();
                app.displayAlertMessage("success", app.getMessage('emailSent'), app.getMessage('emailSent'));
            }).fail(function (jqxhr) {
                app.hideLoadDialog();
                app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
            });
        }
    },
    openTripMail: function () {
        $('body').append(new app.components.modalWindow.ModalWindowView({
            contentView: app.gameTripInfo.GameTripInfoFormView,
            contentParams: {
                game_id: this.model.id
            },
            headerText: app.getMessage("gameTripInfo")
        }).el);
    },

    openGameTripRanking: function () {
        $('body').append(new app.components.modalWindow.ModalWindowView({
            contentView: app.gameTripRanking.GameTripRankingFormView,
            contentParams: {
                game_id: this.model.id
            },
            headerText: app.getMessage("fieldTrip") + ' ' + app.getMessage("ranking")
        }).el);
    },

    closeForm: function () {
        this.trigger("close-form");
        return false;
    },

    additionalInitializeActions: function () {
        Backbone.Validation.bind(this);
    },

    renderLeagueSelection: function () {
        this.leagueSelection =
            new app.components.leagueSelection.LeagueSelectionView({
                selectedLeagueId: this.model.get("league_id")
            });
        this.$('[data-content="league-selection"]').append(this.leagueSelection.el);
    },

    renderAppointments: function () {
        if(this.gameAppointments) {
            this.gameAppointments = null;
            this.$('[data-content="appointments-selection"]').empty();
        }
        if (!this.model.isNew()) {
            this.gameAppointments =
                new app.gameAppointment.gameAppointmentsEdit.GameAppointmentsFormView({
                    gameId: this.model.id,
                    created_at: this.model.get('created_at'),
                    updated_at: this.model.get('updated_at'),
                    event_date: this.model.get('event_date'),

                });
            this.$('[data-content="appointments-selection"]').append(this.gameAppointments.el);
            this.gameAppointments.on("model-changed", this.getFormModel, this);
        }
    },

    changeGameRankingButtonDisplay: function () {
        if (this.model.get('is_trip') && !this.model.isNew()) {
            this.$('[data-action="open-game-trip-ranking"]').show();
        } else {
            this.$('[data-action="open-game-trip-ranking"]').hide();
        }
    },

    changeModifiedTextDisplay: function () {
        var element = this.$('[data-type="modified-text"]');
        if (this.model.get('modified') && !this.model.isNew()) {
            element.show();
        } else {
            element.hide();
        }
    },

    setModelValues: function () {
        this.$('#address').val(this.model.get('address'));
        this.$('#event_date').val(this.model.get('event_date'));
        this.$('#team1').val(this.model.get('team1'));
        this.$('#team2').val(this.model.get('team2'));
        this.$('#game_number').val(this.model.get('game_number'));
        this.$('#modified_text').val(this.model.get('modified_text'));
        if (this.model.get('is_trip')) {
            this.$('#is_trip').attr('checked', 'checked');
        }
        if (this.model.get('canceled')) {
            this.$('#canceled').attr('checked', 'checked');
        }
        if (this.model.get('modified')) {
            this.$('#modified').attr('checked', 'checked');
        }
        if (this.model.get('tv_broadcast')) {
            this.$('#tv_broadcast').attr('checked', 'checked');
        }
        if (this.model.get('commissioner_remotely')) {
            this.$('#commissioner_remotely').attr('checked', 'checked');
        }
    },

    deleteRecord: function () {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function (model) {
                    view.closeForm();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function () {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));
                }
            });
        }
    },

    additionalRender: function () {
        var view = this;
        this.$('#event_date').datetimepicker({
            onSelect: function () {
                var e = jQuery.Event("blur");
                view.updateModel(e);
            }
        });
        this.renderLeagueSelection();
        this.renderAppointments();
        if (this.model.isNew()) {
            this.$('[data-action="close-record"]').hide();
            this.$('.trip-mail').hide();
        }
        this.changeGameRankingButtonDisplay();
        this.changeModifiedTextDisplay();
    },

    additionalSaveSuccess: function (wasNew) {
        if (wasNew) {
            app.openGameEditPage(this.model.id);
        }
        this.changeGameRankingButtonDisplay();
        this.changeModifiedTextDisplay();
        this.renderAppointments();
        // if(this.gameAppointments){
        //     this.gameAppointments.trigger("rerender")
        // }
    },

    openGamePreview: function () {
        app.openGamePage(this.model.id);
    },

    getFormModel: function () {
        var league = this.leagueSelection.collection.get(this.model.get("league_id"));
        this.model.set({
            "game_appointments": this.gameAppointments.collection.toJSON(),
            league: league.toJSON()
        });
        return this.model;
    },

    showGameEvaliationsModal: function () {
        $('body').append(new app.components.modalWindow.ModalWindowView({
            contentView: app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationsDisplayView,
            contentParams: {
                gameId: this.model.id,
                showLegend: false
            },
            headerText: app.getMessage('gameEvaluations')
        }).el);
    }


});

},{}],63:[function(require,module,exports){
require('./GameEditPageBootstrap');
require('./GameFormView');





},{"./GameEditPageBootstrap":61,"./GameFormView":62}],64:[function(require,module,exports){
app.pkg("game.gamesPage");
app.game.gamesPage.GamesCollection = app.components.gamesList.GamesCollection.extend({
});
},{}],65:[function(require,module,exports){
app.pkg('game.gamesPage');
app.game.gamesPage.GamesListItemView = app.components.gamesList.GamesListItemView.extend({
    template: _.template(app.templates['game-gamesPage-GamesListItemView']),


    onItemClick: function() {
        this.trigger("item-clicked", this.model.id);
        if (this.$el.hasClass("not-clickable")) {
            return;
        }
        this.$el.html("");
        this.$el.addClass("not-clickable");
        this.$el.append('<td class="form-holder" colspan="8"></td>');
        var model = new app.game.GameDataModel({
            id: this.model.id
        });
        this.gameForm = new app.game.gameEditPage.GameFormView({
            el: this.$('.form-holder'),
            model: model
        });
        this.gameForm.on("close-form", this.closeFormDisplay, this);
        this.gameForm.on("remove-item", this.removeItem, this);

    },

    onModelChange: function(model) {
        this.model = model;
    },

    removeItem: function() {
        this.remove();
    },
    closeFormDisplay: function() {
        if (this.gameForm !== undefined) {
            this.onModelChange(this.gameForm.getFormModel());
            this.renderNormalDisplay();
        }
    },
    additionalInitializeActions: function() {
        this.on("close-item", this.closeFormDisplay, this);
    },


    renderNormalDisplay: function() {
        this.$el.removeClass("not-clickable");
        this.gameForm = undefined;
        this.render();
        this.trigger("item-closed-rendered", this.model.id);

    }

});

},{}],66:[function(require,module,exports){
app.pkg('game.gamesPage');
app.game.gamesPage.GamesListView = app.components.gamesList.GamesListView.extend({
    templateName: app.templates['game-gamesPage-GamesListView'],
    renderedItems: [],
    FILTERS_COOKIE_NAME: "GAME_ASSIGN_LISTS_FILTER",

    additionalEvents: {
        'change #display_user_type': "onDisplayTypeChange"
    },

    initExternalFilters: function() {
        this.renderLeagueFilter();
        this.updateDefaultDisplayTypeFilterValue();
    },

    getExternalFetchParams: function() {
        return {
            leagueId: this.getLeagueFilterValue(),
            userDisplayType: this.getDisplayUsersFilter()
        }
    },

    getLeagueFilterValue: function() {
        return this.leagueSelection.getFilterValue() || null;
    },

    updateDefaultDisplayTypeFilterValue: function(){
        this.$("#display_user_type").val(this.getDefaultValueForFilter("userDisplayType") || '');
        this.onDisplayTypeChange();
    },

    renderLeagueFilter: function() {
        this.leagueSelection = new app.components.leagueSelection.LeagueSelectionView({
            isEmpty: true,
            selectedLeagueId: this.getDefaultValueForFilter("leagueId") || null
        });
        this.$('[data-content="league-selection"]').append(this.leagueSelection.el);
        this.leagueSelection.$("select").change(this.onFilterChange);
    },

    resetCollection: function() {
        this.collection.resetCollection();
        this.updateScrollbar();
        this.renderedItems = [];
    },

    whenListItemClicked: function(itemModelId) {
        for (var i = 0; i < this.renderedItems.length; i++) {
            if (this.renderedItems[i].model.id != itemModelId)
                this.renderedItems[i].trigger("close-item");
        }
    },

    getDisplayUsersFilter: function() {
        return this.$("#display_user_type").val();
    },

    displayOnlySpecificAppointmentColumn: function() {
        var view = this;

        var value = this.getDisplayUsersFilter();
        this.$('#display_user_type option').each(function() {
            view.$('[data-content="' + $(this).val() + '"]').hide();
        });

        if(value === 'all'){
            this.$('#display_user_type option').each(function() {
                view.$('[data-content="' + $(this).val() + '"]').show();
            });

        } else {
            this.$('[data-content="' + value + '"]').show();
        }


    },

    afterCollectionRender: function() {
        this.displayOnlySpecificAppointmentColumn();
    },

    onDisplayTypeChange: function() {
        this.saveFilterValue();
        this.displayOnlySpecificAppointmentColumn();
    },

    renderCollectionElement: function(model) {
        var formatedDate = $.datepicker.formatDate("yy-mm-dd", new Date(this.getOnlyDateInString(model)));
        var separator = this.$('[data-separator-date="' + formatedDate + '"]');
        var view = new this.options.listItemDisplayViewType({
            model: model
        });
        var lastElement = this.$('[data-event-date="' + formatedDate + '"]').last();
        if (lastElement.length > 0) {
            $(view.el).insertAfter(lastElement);
        } else {
            $(view.el).insertAfter(separator);
        }
        $(view.el).attr("data-event-date", formatedDate);


        $('[data-content="' + this.getDisplayUsersFilter() + '"]', view.el).hide();
        view.on("item-clicked", this.whenListItemClicked, this);
        view.on("item-closed-rendered", this.whenItemIsClosedAndRendered, this);

        this.renderedItems.push(view);
    },

    whenItemIsClosedAndRendered: function() {
        this.displayOnlySpecificAppointmentColumn();
    },

    getScrollableContentOffset: function() {
        var elOffset = this.getCollectionElementsDisplayDiv().offset();
        if (elOffset !== null)
            return this.getCollectionElementsDisplayDiv().offset().top - 70;
        else return 0;
    }
});

},{}],67:[function(require,module,exports){
app.pkg('game.gamesPage');
app.game.gamesPage.GamesPageBootstrap = function () {
    new app.game.gamesPage.GamesListView({
        el: $('[data-content="games-list"]'),
        collection: new app.game.gamesPage.GamesCollection(),
        listItemDisplayViewType: app.game.gamesPage.GamesListItemView
    });
    $('.admin-bar').hide();
    $('.content-bar').hide();

    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="games-assign"]').addClass("active");
};

},{}],68:[function(require,module,exports){
require('./GamesCollection');
require('./GamesListItemView');
require('./GamesListView');
require('./GamesPageBootstrap');






},{"./GamesCollection":64,"./GamesListItemView":65,"./GamesListView":66,"./GamesPageBootstrap":67}],69:[function(require,module,exports){
require('./gameDisplayPage');
require('./gameEditPage');
require('./gamesPage');
require('./GameDataModel');
require('./unconfirmedGamesPage');







},{"./GameDataModel":56,"./gameDisplayPage":60,"./gameEditPage":63,"./gamesPage":68,"./unconfirmedGamesPage":72}],70:[function(require,module,exports){
app.pkg("game.unconfirmedGamesPage");

app.game.unconfirmedGamesPage.UnconfirmedGamesCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/games/unconfirmed/paginated'
});

},{}],71:[function(require,module,exports){
app.pkg('game.unconfirmedGamesPage');
app.game.unconfirmedGamesPage.UnconfirmedGamesPageBootstrap = function() {
    new app.components.gamesList.GamesListView({
        FILTERS_COOKIE_NAME: "UNCONFIRMED_GAMES_PAGE_LIST_FILTER",
        el: $('[data-content="unconfirmed-games-list"]'),
        collection: new app.game.unconfirmedGamesPage.UnconfirmedGamesCollection(),
        listItemDisplayViewType: app.components.gamesList.GamesListItemView
    });
    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="unconfirmed-games-assign"]').addClass("active");
};

},{}],72:[function(require,module,exports){
require('./UnconfirmedGamesCollection');
require('./UnconfirmedGamesPageBootstrap');






},{"./UnconfirmedGamesCollection":70,"./UnconfirmedGamesPageBootstrap":71}],73:[function(require,module,exports){
app.pkg('gameAppointment');
app.gameAppointment.GameAppointmentConfirmButtonView = Backbone.View.extend({
    template: _.template(app.templates['gameAppointment-GameAppointmentConfirmButtonView']),
    className: "dropdown",
    events: {
        'click .dropdown-toogle': 'onDropDownClick',
        'click [data-action="status-approved"]': 'changeStatusToApproved',
        'click [data-action="status-declined"]': 'changeStatusToDeclined',
        'click [data-action="status-pending"]': 'changeStatusToPending'

    },
    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    onDropDownClick: function(e) {
        this.$el.addClass('open');
        e.preventDefault();
        return false;
    },

    changeStatusToApproved: function(e) {
        this.changeStatus("approved", e);
    },

    changeStatusToDeclined: function(e) {
        this.changeStatus("declined", e);

    },

    changeStatusToPending: function(e) {
        this.changeStatus("pending", e);
    },

    changeStatus: function(status, e) {
        this.$el.removeClass('open');
        if (this.model.get("user_id") !== null) {
            if (this.canChangeStatus()) {
                this.saveStatus(status);
            }
        }
        e.stopPropagation();
        return false;
    },

    canChangeStatus: function() {
        var canChange = false;
        if (app.User !== null && app.User.isAdmin) {
            canChange = true;
        }
        if (app.User !== null && parseInt(app.User.id) === parseInt(this.model.get("user_id"))) {
            canChange = true;
        }
        //        if (!this.model.get("is_editable") && app.User != null && !app.User.isAdmin) {
        //            canChange = false;
        //        }
        return canChange;
    },

    saveStatus: function(status) {
        var view = this;
        $.ajax({
            url: view.model.appointmentStatusChangeUrl(status),
            type: 'PUT',
            data: {}
        }).done(function(data) {
            view.model.set(data);
            view.render();
            app.displayAlertMessage("success", app.getMessage('recordSavedMessage'), app.getMessage('recordSavedMessage'));

        }).fail(function(jqxhr, status) {
            if (jqxhr.status === 422) {
                app.displayAlertMessage("warning", app.getMessage("errorActionNotAvailableMessageTitle"), jqxhr.responseText);
            } else app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
            view.render();
        });
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.id = new Date().getTime();
        this.$el.attr('id', this.id);
        this.initTooltips();
        this.changeButtonIconDisplay();

        if (!this.canChangeStatus()) {
            this.$('[data-value="status-display"]').addClass("disabled-icon");
            this.$('.dropdown-menu').remove();

        }
        this.initButtonClose();

        if (app.User && !app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }

        return this;
    },
    initButtonClose: function() {
        var that = this;
        $('body').click(function(e) {
            if (that.$el.hasClass('open')) {
                var currentEl = false;
                var parent = $(e.target).parent();
                while (parent) {
                    if (parent.attr('id')) {
                        if (parent.attr('id') == that.id) {
                            currentEl = true;
                            break;
                        }
                    }
                    parent = parent.parent();

                    if (!parent.length) {
                        currentEl = true;
                        break;
                    }
                    if (parent.get(0).tagName == 'HTML') {
                        break;
                    }
                }
                if (!currentEl) {
                    that.$el.removeClass('open');
                }
            }
        });
    },

    changeButtonIconDisplay: function() {

        this.$('[data-value="status-display"]').removeClass("app-confirm-icons-pending").removeClass("app-confirm-icons-ok").removeClass("app-confirm-icons-not-ok");

        if (this.model.get("status") === "pending") {
            this.$('[data-value="status-display"]').addClass("app-confirm-icons-pending");
        }
        if (this.model.get("status") === "approved") {
            this.$('[data-value="status-display"]').addClass("app-confirm-icons-ok");

        }
        if (this.model.get("status") === "declined") {
            this.$('[data-value="status-display"]').addClass("app-confirm-icons-not-ok");
        }
        if (this.model.get("status") === "empty") {
            //Do nothing
        }
    },

    initTooltips: function() {

    }

});

},{}],74:[function(require,module,exports){
app.pkg("gameAppointment");
app.gameAppointment.GameAppointmentModel = Backbone.Model.extend({
    urlRoot: '/api/service/game-appointment',
    appointmentStatusChangeUrl: function(newStatus) {
        return this.urlRoot + "/" + this.id + "/" + "status/" + newStatus;
    }
});

},{}],75:[function(require,module,exports){
app.pkg("gameAppointment");

app.gameAppointment.GameAppointmentsCollection = Backbone.Collection.extend({
    model: app.gameAppointment.GameAppointmentModel,

    url: '/api/service/game-appointments'
});

},{}],76:[function(require,module,exports){
app.pkg('gameAppointment.gameAppointmentDisplay');
app.gameAppointment.gameAppointmentDisplay.GameAppointmentDisplayView = Backbone.View.extend({
    template: _.template(app.templates['gameAppointment-gameAppointmentDisplay-GameAppointmentDisplayView']),
    className: "appointment-display row-fluid",

    events: {
        'click [data-action="change-confirmed-status"]': 'changeConfirmedStatus'
    },

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameAppointment.GameAppointmentModel(this.model.attributes);
        this.render();
    },

    initAppointmentStatusDisplay: function() {
        var buttonView = new app.gameAppointment.GameAppointmentConfirmButtonView({
            model: this.model
        });
        this.$(".appointment-status").append(buttonView.el);
    },
    render: function() {
        var noTitle = false;
        if (this.options.noTitle !== undefined) {
            noTitle = this.options.noTitle;
        }
        var data = this.model.toJSON();
        if(data.game && data.game.commissioner_remotely && data.user_type_in_event === 'commissioner'){
            data.user_type_in_event = "commissioner_analytics"
        }
        data.noTitle = noTitle;
        this.$el.html(this.template(data));
        app.addTooltips(this.$el);

        if (noTitle) {
            this.$('.appointment-title').hide();
            this.$('.appointment-owner').removeClass("span3");
            this.$('.appointment-status').removeClass("span2");
        }
        if (this.model.get("user") !== null) {

            this.initAppointmentStatusDisplay();
        }
        return this;
    }

});

},{}],77:[function(require,module,exports){
require('./GameAppointmentDisplayView');





},{"./GameAppointmentDisplayView":76}],78:[function(require,module,exports){
app.pkg('gameAppointment.gameAppointmentsEdit');
app.gameAppointment.gameAppointmentsEdit.GameAppointmentInputView = Backbone.FormView.extend({
    template: _.template(app.templates['gameAppointment-gameAppointmentsEdit-GameAppointmentInputView']),
    className: "appointment-input row-fluid",
    initialize: function() {
        _.bindAll(this);
        this.suggestionsColl = new app.user.UserSuggestionsCollection();
        this.render();
    },

    events: {
        'blur [data-value="appointment-user"]': 'onInputBlur',
    },

    render: function() {
        var data = this.model.toJSON();
        if(data.game && data.game.commissioner_remotely && data.user_type_in_event === 'commissioner'){
           data.user_type_in_event = "commissioner_analytics"
        }

        this.$el.html(this.template(data));
        this.initUserDisplay();
        this.addSuggestionBox();
        this.initAppointmentStatusDisplay();
        app.addTooltips(this.$el);
        return this;
    },

    initAppointmentStatusDisplay: function() {
        var buttonView = new app.gameAppointment.GameAppointmentConfirmButtonView({
            model: this.model
        });
        this.$(".appointment-status").append(buttonView.el);
    },

    initUserDisplay: function() {
        if (this.model.get("user") !== null) {
            this.$('#user_name').val(this.model.get("user").short_name);
        }
    },

    getSuggestionCollection: function(query, elementToSendResponse) {

        if (!app.isStringEmpty(query)) {
            var type = this.model.get("user_type_in_event").split("_")[0];
            var view = this;
            this.suggestionsColl.fetch({
                data: {
                    query: query,
                    eventDate: view.options.event_date,
                    gameId: view.options.gameId,
                    type: type
                },
                success: function() {
                    view.buildSuggestionsList(elementToSendResponse, query);
                    return [];
                }
            });
        } else return [];

    },

    isAppointmentAvailable: function(model){
        var eventDate = this.options.event_date;

        var message = model.get("suspended_until") ? " ("+app.getMessage('userSuspendedUntil')+": " + model.get("suspended_until") + ")" : "";
        var disabled = model.get("suspended_until") !== ""

        var certificate_until = model.get('certificate_until');
        if(certificate_until){
            if(new Date(certificate_until) < new Date(eventDate)){
                disabled = true;
                message = " ("+app.getMessage('userCertificateExpires')+": "+ eventDate +" )";
            }
        }

        if(model.get('user_availabilities')){

            if(app.isFunctionalityEnabled('availabilityRestrictions')){
                var items = _.filter(model.get('user_availabilities'), function(item){
                    return app.isDateBetween(new Date(item.start_date), new Date(item.end_date), new Date(eventDate)) && item.unavailable;
                });
                if(items.length){
                    disabled = false;
                    var dateDisplay = app.formatDateWithTime(items[0].start_date) + ' - ' + app.formatDateWithTime(new Date(items[0].end_date));
                    message = " ("+app.getMessage('userIsNotAvailableForAppointment') +": "+ dateDisplay+")";

                }
            } else {
                const disabledDays = _.uniq(_.flatten(model.get('user_availabilities').map(function(item){
                    return app.getDaysArray(new Date(item.start_date), new Date(item.end_date) )
                }))).map(function(item){
                    return $.datepicker.formatDate('yy-mm-dd', item);
                });

                if(disabledDays.indexOf($.datepicker.formatDate('yy-mm-dd', new Date(eventDate))) > -1){
                    disabled = false;
                    message = " ("+app.getMessage('userIsNotAvailableForAppointment') +": "+ $.datepicker.formatDate('yy-mm-dd', new Date(eventDate)) +")";
                }
            }

        }


        return {message: message, disabled: disabled}
    },

    buildSuggestionsList: function(elementToSendResponse, query) {
        var result = [];
        var self = this;
        _(this.suggestionsColl.models).each(function(model) {
            var isAppointmentAvailable = self.isAppointmentAvailable(model);
            result.push({
                id: model.id,
                name: model.get('first_name') + " " + model.get('last_name') + isAppointmentAvailable.message,
                disabled: isAppointmentAvailable.disabled
            });
        }, this);
        if (elementToSendResponse !== null)
            elementToSendResponse.process(result);
        return result;
    },


    addSuggestionBox: function() {
        var view = this;
        this.$('[data-value="appointment-user"]').typeahead({
            source: function(query) {
                view.getSuggestionCollection(query, this);
                return [];
            },
            onselect: function(obj) {
                if(obj && !obj.disabled){
                    view.selectElement(obj);
                }
            },
            listItemPropToMatch: "name"
        });
    },

    selectElement: function(selectedObj) {
        var model = this.suggestionsColl.get(selectedObj.id);
        var formVals = {};
        if (model !== undefined) {
            this.$('[data-value="appointment-user"]').val(model.get("short_name"));
            formVals = {
                user_id: model.id,
                user: model.attributes
            };
        } else {
            formVals = {
                user_id: null,
                user: null
            };
        }
        this.saveModel(formVals);
    },


    saveModel: function(formValues) {
        var view = this;
        if (this.hasChangedValues(formValues)) {
            this.model.save(formValues, {
                success: function(model, response, options) {
                    view.render();
                    app.displayAlertMessage("success", app.getMessage('recordSavedMessage'), app.getMessage('appointmentSaveMessage'));
                },
                error: function(model, xhr, options) {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));
                }
            });
        }
    },

    onInputBlur: function() {
        var view = this;
        setTimeout(function() {
            if (view.$('[data-value="appointment-user"]').val() === "") {
                view.selectElement({
                    id: null,
                    name: ""
                });
            } else {
                if (view.model.get("user") === null) {
                    view.$('[data-value="appointment-user"]').val("");
                    view.$('[data-value="appointment-user"]').val(null);
                } else view.$('[data-value="appointment-user"]').val(view.model.get("user").short_name);
            }
        }, 300);
        return false;
    }

});

},{}],79:[function(require,module,exports){
app.pkg('gameAppointment.gameAppointmentsEdit');
app.gameAppointment.gameAppointmentsEdit.GameAppointmentsFormView = Backbone.View.extend({
    template: _.template(app.templates['gameAppointment-gameAppointmentsEdit-GameAppointmentsFormView']),

    initialize: function() {
        _.bindAll(this);
        this.collection = new app.gameAppointment.GameAppointmentsCollection();
        this.render();
        this.fetchCollection();
    },

    events: {
        'click [data-action="show-history"]': 'showHistory'
    },

    showHistory: function() {
        $('body').append(new app.components.modalWindow.ModalWindowView({
            contentView: app.gameLog.GameLogsListView,
            contentParams: {
                collection: new app.gameLog.GameLogsCollection(),
                game_id: this.options.gameId,
                created_at: this.options.created_at,
                updated_at: this.options.updated_at,
                listItemDisplayViewType: app.gameLog.GameLogsItemView
            },
            headerText: "Istorija"
        }).el);
    },

    render: function() {
        this.$el.html(this.template());
        return this;
    },

    fetchCollection: function() {
        var view = this;
        this.collection.fetch({
            data: {
                gameId: this.options.gameId
            },
            success: function() {
                view.renderCollectionElements();
            },
            error: function() {}
        });
    },

    renderCollectionElements: function() {
        var view = this;
        _(this.collection.models).each(function(model) {
            view.renderItem(model);
        }, this);
    },

    onModelChange: function() {
        this.trigger("model-changed");
    },

    renderItem: function(model) {
        var view = new app.gameAppointment.gameAppointmentsEdit.GameAppointmentInputView({
            model: model,
            event_date: this.options.event_date,
            gameId: this.options.gameId
        });
        if (model.get('user_type_in_event').indexOf("ref") === 0) {
            this.$('[data-content="refs-selection"]').append(view.el);
        } else if (model.get('user_type_in_event').indexOf("secretary") === 0) {
            this.$('[data-content="secretary-selection"]').append(view.el);
        } else {
            this.$('[data-content="persons-selection"]').append(view.el);
        }
        view.on("changed-model", this.onModelChange, this);

    }



});

},{}],80:[function(require,module,exports){
require('./GameAppointmentInputView');
require('./GameAppointmentsFormView');





},{"./GameAppointmentInputView":78,"./GameAppointmentsFormView":79}],81:[function(require,module,exports){
require('./gameAppointmentDisplay');
require('./gameAppointmentsEdit');
require('./GameAppointmentConfirmButtonView');
require('./GameAppointmentModel');
require('./GameAppointmentsCollection');






},{"./GameAppointmentConfirmButtonView":73,"./GameAppointmentModel":74,"./GameAppointmentsCollection":75,"./gameAppointmentDisplay":77,"./gameAppointmentsEdit":80}],82:[function(require,module,exports){
app.pkg("gameEvaluation");

app.gameEvaluation.GameEvaluationDataModel = Backbone.Model.extend({

    urlRoot: '/api/game-evaluation/data'

});

},{}],83:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationDataDisplayView']),


    events: {
        'click [data-content="commissioner_report_export"]': "exportReport",
        'click [data-content="commissioner_report_short_export"]': "exportShortReport",
        'click [data-content="referee_evaluation_report_export"]': "exportRefereeEvaluationExport"
    },

    refereeAppointments: [],


    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    exportReportAction: function(url) {
        window.open(url);
        // app.displayLoadDialog();
        // $.ajax({
        //     url: url,
        //     type: 'GET'
        // }).done(function(data) {
        //     app.hideLoadDialog();
        //     window.open("/pdf/" + data.file_name);
        // }).fail(function(jqxhr, status) {
        //     app.hideLoadDialog();
        //     app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        // });
    },

    exportReport: function() {
        this.exportReportAction("/game-evaluation/export/" + this.model.id);
    },

    exportShortReport: function() {
        this.exportReportAction("/game-evaluation/export-short/" + this.model.id);
    },

    exportRefereeEvaluationExport: function() {
        this.exportReportAction("/game-evaluation/export-referee-evaluation/" + this.model.id);
    },

    setValuesForModel: function() {
        var commisionierAppointment, userAppointment, self = this;
        _(this.model.get("game").game_appointments).each(function(appointment) {
            if (appointment.user_type_in_event === 'commissioner') {
                commisionierAppointment = appointment;
            }
            if (appointment.user_id === parseInt(self.model.get("user_id"))) {
                userAppointment = appointment;
            }

            if (appointment.user_type_in_event.indexOf("ref") === 0 && appointment.user) {
                self.refereeAppointments.push(appointment);
            }
        }, this);
        this.model.set({
            commisionier_appointment: commisionierAppointment
        });
        this.model.set({
            user_appointment: userAppointment
        });
    },

    _loopTemplateItems: function(nameStart, viewInstance, contentDiv) {
        for (var i = 1; i <= 100; i++) {
            var name = nameStart + i,
                value = this.model.get("evaluation")[name];
            if (value) {
                var view = new viewInstance({
                    index: i,
                    name: name,
                    values: this.model.get("evaluation")[name]
                });
                contentDiv.append(view.el);
            } else {
                break;
            }
        }
    },

    getCountOfItems: function(initial){
        var result = {
            good_things: 0,
            bad_things: 0,
            video_situations: 0
        };
        var getBigger = function(a, b){
            if(a>b){
                return a;
            } return b;
        }
        var keys = Object.keys(this.model.get("evaluation"));
        keys.forEach(function(item){
            if(item.indexOf('good_things') > -1){
                result.good_things = result.good_things + 1;
            }
            if(item.indexOf('bad_things') > -1){
                result.bad_things = result.bad_things + 1;
            }
            if(item.indexOf('video_situations') > -1){
                result.video_situations = result.video_situations + 1;
            }
        });
        initial.good_things = getBigger(result.good_things, initial.good_things);
        initial.bad_things = getBigger(result.bad_things, initial.bad_things);
        initial.video_situations = getBigger(result.video_situations, initial.video_situations);
        return initial;
    },

    renderItems: function() {
        var templateOptions = this.getCountOfItems(this.options.formTemplate);
        if (templateOptions.good_things) {
            this._loopTemplateItems("good_things_", app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationSimpleTextDisplay, this.$('[data-content="good-things-display-items"]'));
        } else {
            this.$('[data-content="good-things-display"]').hide();
        }

        if (templateOptions.bad_things) {
            this._loopTemplateItems("bad_things_", app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationSimpleTextDisplay, this.$('[data-content="bad-things-display-items"]'));
        } else {
            this.$('[data-content="bad-things-display"]').hide();
        }

        if (!templateOptions.good_things && !templateOptions.bad_things) {
            this.$('[data-content="good-bad-things-display"]').hide();
        }

        if (templateOptions.video_situations) {
            this._loopTemplateItems("video_situations_", app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationVideoDisplay, this.$('[data-content="video-situations-display-items"]'));
        } else {
            this.$('[data-content="video-situations-display"]').hide();
        }
        if (Object.keys(this.model.get("evaluation")).filter(function(item){
            return item.startsWith('referee_evaluation_')
        }).length > 0) {
            for (var i = 0; i < this.refereeAppointments.length; i++) {
                var appointment = this.refereeAppointments[i],
                    name = "referee_evaluation_" + appointment.user_type_in_event,
                    view = new app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationRefereeRankingDisplay({
                        index: i,
                        name: name,
                        user: appointment.user,
                        values: this.model.get("evaluation")[name]
                    });

                this.$('[data-content="referee-evaluation-display-items"]').append(view.el);
            }
        } else {
            this.$('[data-content="referee-evaluation-display"]').hide();
        }
        if (templateOptions.game_review && this.model.get("evaluation").game_review) {
            var gameReviewView = new app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationSimpleTextDisplay({
                index: '',
                name: 'game_review',
                values: this.model.get("evaluation").game_review
            });
            this.$('[data-content="game-review-display-items"]').append(gameReviewView.el);
        } else {
            this.$('[data-content="game-review-display"]').hide();
        }

        if (this.model.get("evaluation").referee_parameters_evaluation && this.model.get("evaluation").referee_parameters_evaluation.length > 0 ) {
            for (var i = 0; i < this.refereeAppointments.length; i++) {
                var appointment = this.refereeAppointments[i];
                var data = this.model.get("evaluation").referee_parameters_evaluation.find(function(item){
                    return item.user_id === appointment.user.id
                });
                if(data){
                    var view  = new app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationRefereeParametersDisplay({
                        index: i,
                        data: data,
                        agg: this.model.get("evaluation").parameter_evaluation_param_agg_value.find(function(item){
                            return item.user_id === appointment.user.id
                        }) || {},
                        user: appointment.user,
                    })
                    this.$('[data-content="referee-evaluation-by-params-display-items"]').append(view.el);
                }


            }
        } else {
            this.$('[data-content="referee-evaluation-by-params-display"]').hide();
        }

    },

    renderCorretGameInfoDisplay: function() {
        if (this.options.formTemplate.type === 'commissioner') {
            this.$('[data-content="user_display"]').hide();

            this.$('[data-content="game_status_display"]').hide();
            for (var i = 0; i < this.refereeAppointments.length; i++) {
                var appointment = this.refereeAppointments[i],
                    elementWhereAppend = this.$('[data-content="game_referees_display"]').find('.info-value');
                if (i > 0) {
                    elementWhereAppend.append(', ');
                }
                elementWhereAppend.append(appointment.user.short_name);

            }
        } else {
            this.$('[data-content="commissioner_report_export"]').hide();
            this.$('[data-content="commissioner_report_short_export"]').hide();
            this.$('[data-content="game_referees_display"]').hide();
        }
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderCorretGameInfoDisplay();
        this.renderItems();
        app.addTooltips();
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.setValuesForModel();
                    view.render();
                },
                error: function() {
                    window.location.href = "/";
                }
            });
        } else {
            window.location.href = "/";
        }
    }

});

},{}],84:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationDisplayPageBootstrap = function(id, formTemplate) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.gameEvaluation.GameEvaluationDataModel({
        id: id
    });
    new app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationDataDisplayView({
        el: $('[data-content="game-evaluation-display"]'),
        model: model,
        formTemplate: formTemplate
    });

};

},{}],85:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationRefereeParametersDisplay = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationRefereeParametersDisplay']),
    className: "items-row form-info-display",

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.options));
        this.$('[data-content="add-value-display"]').text(this.getAggValDisplay())
        return this;
    },

    getAggValDisplay: function(){
        return this.options.agg.message + ' (' + this.options.agg.value + ')';
    }



});

},{}],86:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationRefereeRankingDisplay = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationRefereeRankingDisplay']),
    className: "evaluation-result-display row-fluid",

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.RefereeRankingDataModel(this.options);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        return this;
    },

});

},{}],87:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationSimpleTextDisplay = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationSimpleTextDisplay']),
    className: "evaluation-result-display row-fluid",

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.SimpleInputDataModel(this.options);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        if (!this.model.get("index")) {
            this.$(".info-label").hide();
        }
        return this;
    },



});

},{}],88:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationDisplayPage');
app.gameEvaluation.gameEvaluationDisplayPage.GameEvaluationVideoDisplay = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationVideoDisplay']),
    className: "evaluation-result-display evaluation-video-display row-fluid",

    initialize: function () {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.VideoInputDataModel(this.options);
        this.render();
    },
    render: function () {
        if (this.model.get("values").time) {
            this.$el.html(this.template(this.model.attributes));
        }
        return null;
    },

});

},{}],89:[function(require,module,exports){
require('./GameEvaluationDisplayPageBootstrap');
require('./GameEvaluationDataDisplayView');
require('./GameEvaluationRefereeRankingDisplay');
require('./GameEvaluationSimpleTextDisplay');
require('./GameEvaluationVideoDisplay');
require('./GameEvaluationRefereeParametersDisplay');

},{"./GameEvaluationDataDisplayView":83,"./GameEvaluationDisplayPageBootstrap":84,"./GameEvaluationRefereeParametersDisplay":85,"./GameEvaluationRefereeRankingDisplay":86,"./GameEvaluationSimpleTextDisplay":87,"./GameEvaluationVideoDisplay":88}],90:[function(require,module,exports){
app.pkg("gameEvaluation");

app.gameEvaluation.GameEvaluationEditDataModel = Backbone.Model.extend({
    initialize: function(options) {
        this.gameId = options.gameId;
    },

    urlRoot: function() {
        return '/api/game-evaluation/edit/' + this.gameId + "/data";
    }
});

},{}],91:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationEditPageBootstrap = function(id, gameId, formTemplate) {
    if (id == 'new' || id === undefined) {
        id = null;
    }

    var model = new app.gameEvaluation.GameEvaluationEditDataModel({
        id: id,
        gameId: gameId
    });
    new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationFormView({
        el: $('[data-content="game-evaluation-form"]'),
        model: model,
        formTemplate: formTemplate
    });

    $('[data-main-menu-item="schedule"]').addClass("active");

};

},{}],92:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationFormView = Backbone.FormView.extend({

    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationFormView']),
    tagname: "div",
    views: [],
    refereeAppointments: [],

    additionalEvents: {
        'click [data-action="add-video"]': 'addVideo'
    },

    addVideo: function () {
        var templateOptions = this.getCountOfItems(this.options.formTemplate);
        templateOptions.video_situations = templateOptions.video_situations + 1;
        this.options.formTemplate = templateOptions;

        var view = new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationVideoInput({
            index: templateOptions.video_situations,
            name: 'video_situations_' + templateOptions.video_situations,
            values: {},
            extraData: {
                userAppointment: this.model.get("user_appointment"),
                gameAppointments: this.model.get("game").game_appointments
            }
        });
        this.$('[data-content="video-situations-display-items"]').append(view.el);
        this.views.push(view);

    },

    setValuesForModel: function () {
        var commisionierAppointment, userAppointment, self = this;
        _(this.model.get("game").game_appointments).each(function (appointment) {
            if (appointment.user_type_in_event === 'commissioner') {
                commisionierAppointment = appointment;
            }
            if (appointment.user_id === parseInt(app.User.id)) {
                userAppointment = appointment;
            }
            if (appointment.user_type_in_event.indexOf("ref") === 0 && appointment.user) {
                self.refereeAppointments.push(appointment);
            }
        }, this);
        this.model.set({
            commisionier_appointment: commisionierAppointment
        });
        this.model.set({
            user_appointment: userAppointment
        });
    },

    fetchModel: function () {
        var view = this;
        this.model.fetch({
            success: function (model) {
                view.setValuesForModel();
                view.render();
            }
        });
    },

    _loopTemplateItems: function (nameStart, viewInstance, count, contentDiv, extraData) {
        for (var i = 1; i <= count; i++) {
            var name = nameStart + i,
                view = new viewInstance({
                    index: i,
                    name: name,
                    values: this.model.get("evaluation")[name],
                    extraData: extraData
                });
            contentDiv.append(view.el);
            this.views.push(view);
        }
    },
    getCountOfItems: function (initial) {
        var result = {
            good_things: 0,
            bad_things: 0,
            video_situations: 0
        };
        var getBigger = function (a, b) {
            if (a > b) {
                return a;
            }
            return b;
        }
        var keys = Object.keys(this.model.get("evaluation"));
        keys.forEach(function (item) {
            if (item.indexOf('good_things') > -1) {
                result.good_things = result.good_things + 1;
            }
            if (item.indexOf('bad_things') > -1) {
                result.bad_things = result.bad_things + 1;
            }
            if (item.indexOf('video_situations') > -1) {
                result.video_situations = result.video_situations + 1;
            }
        });
        initial.good_things = getBigger(result.good_things, initial.good_things);
        initial.bad_things = getBigger(result.bad_things, initial.bad_things);
        initial.video_situations = getBigger(result.video_situations, initial.video_situations);
        return initial;
    },


    renderTemplateItems: function () {
        var templateOptions = this.getCountOfItems(this.options.formTemplate);
        if (templateOptions.good_things) {
            this._loopTemplateItems("good_things_", app.gameEvaluation.gameEvaluationEditPage.GameEvaluationSimpleInput, templateOptions.good_things, this.$('[data-content="good-things-display-items"]'));
        } else {
            this.$('[data-content="good-things-display"]').hide();
        }

        if (templateOptions.bad_things) {
            this._loopTemplateItems("bad_things_", app.gameEvaluation.gameEvaluationEditPage.GameEvaluationSimpleInput, templateOptions.bad_things, this.$('[data-content="bad-things-display-items"]'));
        } else {
            this.$('[data-content="bad-things-display"]').hide();
        }

        if (!templateOptions.good_things && !templateOptions.bad_things) {
            this.$('[data-content="good-bad-things-display"]').hide();
        }

        if (templateOptions.video_situations) {
            var extraData = {
                gameAppointments: this.model.get("game").game_appointments,
                userAppointment: this.model.get("user_appointment")
            };
            this._loopTemplateItems(
                "video_situations_",
                app.gameEvaluation.gameEvaluationEditPage.GameEvaluationVideoInput,
                templateOptions.video_situations,
                this.$('[data-content="video-situations-display-items"]'), extraData);
        } else {
            this.$('[data-content="video-situations-display"]').hide();
        }

        if (templateOptions.referee_evaluation && this.refereeAppointments.length) {
            for (var i = 0; i < this.refereeAppointments.length; i++) {
                var appointment = this.refereeAppointments[i],
                    name = "referee_evaluation_" + appointment.user_type_in_event,
                    view = new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeRankingInput({
                        index: i,
                        name: name,
                        user: appointment.user,
                        values: this.model.get("evaluation")[name]
                    });

                this.$('[data-content="referee-evaluation-display-items"]').append(view.el);
                this.views.push(view);
            }
        } else {
            this.$('[data-content="referee-evaluation-display"]').hide();
        }

        if (templateOptions.game_review) {
            var gameReviewView = new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationSimpleInput({
                index: '',
                name: 'game_review',
                values: this.model.get("evaluation").game_review
            });
            this.$('[data-content="game-review-display-items"]').append(gameReviewView.el);
            this.views.push(gameReviewView);
        } else {
            this.$('[data-content="game-review-display"]').hide();
        }


        if (templateOptions.referee_evaluation_by_parameters) {
            var gameEvaluationRefereeParametersInputsView = new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeParametersInputsView({
                name: 'referee_parameters_evaluation',
                appointments: this.refereeAppointments,
                evaluations: this.model.get("evaluation").referee_parameters_evaluation || []
            });
            this.views.push(gameEvaluationRefereeParametersInputsView);
            this.$('[data-content="referee-evaluation-by-params-display-items"]').append(gameEvaluationRefereeParametersInputsView.el);
        } else {
            this.$('[data-content="referee-evaluation-by-params-display"]').hide();
        }



    },
    renderCorretGameInfoDisplay: function () {
        if (this.options.formTemplate.type === 'commissioner') {
            this.$('[data-content="user_display"]').hide();
            this.$('[data-content="game_status_display"]').hide();
            for (var i = 0; i < this.refereeAppointments.length; i++) {
                var appointment = this.refereeAppointments[i],
                    elementWhereAppend = this.$('[data-content="game_referees_display"]').find('.info-value');
                if (i > 0) {
                    elementWhereAppend.append(', ');
                }
                elementWhereAppend.append(appointment.user.short_name);

            }
        } else {
            this.$('[data-content="game_referees_display"]').hide();

        }
    },

    additionalRender: function () {
        this.renderTemplateItems();
        this.renderCorretGameInfoDisplay();
    },

    setModelValues: function () {

    },

    getFormValues: function () {
        var formValues = {};
        _(this.views).each(function (view) {

            formValues[view.options.name] = view.getFormValues();
        }, this);
        return formValues;

    },

    isValid: function () {
        var isValid = true;
        _(this.views).each(function (view) {
            if (!view.isValid()) {
                isValid = false;
            }
        }, this);
        return isValid;
    },


    saveRecord: function (e) {
        e.preventDefault();
        var view = this,
            wasNew = this.model.isNew();
        if (this.isValid()) {
            var formValues = this.getFormValues();
            app.displayLoadDialog();
            this.model.save({
                type: this.options.formTemplate.type,
                evaluation: formValues
            }, {
                success: function (model, response, options) {
                    if (wasNew) {
                        view.displaySuccessCreateMessage();
                        app.openGameEvaluationEditPage(view.model.get("gameId"), response.evaluation.id);
                    } else {
                        view.displaySuccessUpdateMessage();
                    }
                    app.hideLoadDialog();
                },
                error: function (model, response) {
                    app.hideLoadDialog();
                    view.displayErrorMessage(response.responseText.error);
                }
            });
        }
    }

});

},{}],93:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeParametersInput = Backbone.FormView.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeParametersInput']),
    className: "items-row",

    additionalEvents: {
        'change [name="refereeParametersInputFouls"]': 'updateCalculations',
        'change [name="refereeParametersInputGameControl"]': 'updateCalculations',
        'change [name="refereeParametersInputViolations"]': 'updateCalculations',
        'change [name="refereeParametersInputMechanics"]': 'updateCalculations',
        'change [name="refereeParametersInputLooks"]': 'updateCalculations'
    },

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.RefereeParametersRankingDataModel(this.options);
        this.render();
        if(this.model.get("data") && Object.keys(this.model.get("data")).length > 0){
            this.updateCalculations();
        }
        Backbone.Validation.bind(this);
    },


    setModelValues: function() {
        this.$('[name="refereeParametersInputFouls"]').val(this.model.get("data").fouls)
        this.$('[name="refereeParametersInputGameControl"]').val(this.model.get("data").game_control)
        this.$('[name="refereeParametersInputViolations"]').val(this.model.get("data").violations)
        this.$('[name="refereeParametersInputMechanics"]').val(this.model.get("data").mechanics)
        this.$('[name="refereeParametersInputLooks"]').val(this.model.get("data").looks)
    },

    updateCalculations: function(){
        var view = this;
        var values = this.getFormValues();
        $.ajax({
            url: '/api/game-evaluations/parameter-calculate-result',
            type: 'POST',
            data: values
        }).done(function(data) {
            view.$('[data-content="parameter-agg"]').text(data.message + ' (' + data.value + ')')
        });
    },

    isValid: function() {
        var formValues = this.getFormValues();
        return this.isModelValid(formValues);
    },

    getFormValues: function() {
        return {
            user_id: this.model.get('user').id,
            fouls:  parseInt(this.$('[name="refereeParametersInputFouls"]').val()),
            game_control:  parseInt(this.$('[name="refereeParametersInputGameControl"]').val()),
            violations:  parseInt(this.$('[name="refereeParametersInputViolations"]').val()),
            mechanics:  parseInt(this.$('[name="refereeParametersInputMechanics"]').val()),
            looks:  parseInt(this.$('[name="refereeParametersInputLooks"]').val())
        };
    }

});

},{}],94:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeParametersInputsView = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeParametersInputsView']),
    className: "row-fluid",

    events: {},
    views: [],

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template());
        for (var i = 0; i < this.options.appointments.length; i++) {
            var appointment = this.options.appointments[i],
              view = new app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeParametersInput({
                  index: i,
                  data: this.options.evaluations.find(function(item){
                    return item.user_id === appointment.user.id
                  }) || {},
                  user: appointment.user,
              });
            this.$('[data-content="parameter-inputs"]').append(view.el);
            this.views.push(view);
        }
    },

  isValid: function () {
    var isValid = true;
    _(this.views).each(function (view) {
      if (!view.isValid()) {
        isValid = false;
      }
    }, this);
    return isValid;
  },

    getFormValues: function () {
      var formValues = [];
      _(this.views).each(function (view) {
        formValues.push(view.getFormValues());
      }, this);
      console.log(formValues);
      return formValues;
    },


});

},{}],95:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationRefereeRankingInput = Backbone.FormView.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeRankingInput']),
    className: "referee-ranking-game-evaluation-input row-fluid",

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.RefereeRankingDataModel(this.options);
        this.render();
        Backbone.Validation.bind(this);
    },

    setModelValues: function() {
        this.$('[name="evaluation"]').val(this.model.get("values"));
    },

    isValid: function() {
        var formValues = this.getFormValues();
        return this.isModelValid(formValues);
    },

    getFormValues: function() {
        return this.$('[name="evaluation"]').val();
    }

});

},{}],96:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationSimpleInput = Backbone.FormView.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationSimpleInput']),
    className: "simple-game-evaluation-input row-fluid",

    initialize: function() {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.SimpleInputDataModel(this.options);
        this.render();
        Backbone.Validation.bind(this);
    },

    setModelValues: function() {
        this.$("textarea").val(this.model.get("values"));
    },

    additionalRender: function() {
        if (!this.model.get("index")) {
            this.$(".game-form-item-label").hide();
        }
        this.$("textarea").attr("id", this.model.get("id"));
    },

    isValid: function() {
        var formValues = this.getFormValues();
        return this.isModelValid(formValues);
    },

    getFormValues: function() {
        return this.$("textarea").val();
    }

});

},{}],97:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationEditPage');
app.gameEvaluation.gameEvaluationEditPage.GameEvaluationVideoInput = Backbone.FormView.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationVideoInput']),
    className: "game-evaluation-video-input row-fluid",

    initialize: function () {
        _.bindAll(this);
        this.model = new app.gameEvaluation.gameEvaluationEditPage.VideoInputDataModel(this.options);
        this.gameAppointments = this.options.extraData.gameAppointments;
        this.userAppointment = this.options.extraData.userAppointment;
        this.render();
        this.renderReferees();
        Backbone.Validation.bind(this);
    },

    renderReferees: function () {
        var self = this;
        _(this.gameAppointments).each(function (item) {
            if (item.user && (item.user_type_in_event === 'referee_one' ||
                item.user_type_in_event === 'referee_two' ||
                item.user_type_in_event === 'referee_three')) {
                var selected = (this.options.values && this.options.values.referee === item.user.short_name) ? 'selected=selected' : '';
                self.$('[name="referee"]').append("<option value='" + item.user.short_name + "' " + selected + " data-id='" + item.user.id + "'>" + item.user.short_name + "</option>")
            }
        }, this);
        this.$('[name="referee"]').change(this.onRefereeChange);
    },

    onRefereeChange: function () {
        var optionSelected = this.$('[name="referee"] option:selected');
        this.$('[name="referee_id"]').val(optionSelected.data('id'));
    },

    setModelValues: function () {
        var values = this.model.get("values") || {};
        this.$('[name="comment"]').val(values.comment);
        this.$('[name="decision"]').val(values.decision);
        this.$('[name="evaluation"]').val(values.evaluation);
        this.$('[name="period"]').val(values.period);
        this.$('[name="time"]').val(values.time);
        this.$('[name="referee"]').val(values.referee);
        this.$('[name="referee_id"]').val(values.referee_id);
        this.$('[name="priority"]').val(values.priority);
        this.$('[name="priority"]').val(values.priority);
        if (values.has_video) {
            this.$('#has_video').attr('checked', 'checked');
        }
    },

    additionalRender: function () {
    },

    isValid: function () {
        var formValues = this.getFormValues();
        return this.isModelValid(formValues);
    }
});

},{}],98:[function(require,module,exports){
app.pkg("gameEvaluation.gameEvaluationEditPage");
app.gameEvaluation.gameEvaluationEditPage.RefereeParametersRankingDataModel = Backbone.Model.extend({
    validation: {
        // evaluation: {
        //     required: true
        // }
    }
});

},{}],99:[function(require,module,exports){
app.pkg("gameEvaluation.gameEvaluationEditPage");
app.gameEvaluation.gameEvaluationEditPage.RefereeRankingDataModel = Backbone.Model.extend({
    validation: {
        evaluation: {
            required: true
        }
    }
});

},{}],100:[function(require,module,exports){
app.pkg("gameEvaluation.gameEvaluationEditPage");
app.gameEvaluation.gameEvaluationEditPage.SimpleInputDataModel = Backbone.Model.extend({
    validation: {
        comment: {
            required: true
        }
    }
});

},{}],101:[function(require,module,exports){
app.pkg("gameEvaluation.gameEvaluationEditPage");

app.gameEvaluation.gameEvaluationEditPage.VideoInputDataModel = Backbone.Model.extend({
    validation: {}
});

},{}],102:[function(require,module,exports){
require('./GameEvaluationFormView');
require('./SimpleInputDataModel');
require('./VideoInputDataModel');
require('./GameEvaluationEditDataModel');
require('./RefereeRankingDataModel');
require('./GameEvaluationRefereeRankingInput');
require('./GameEvaluationSimpleInput');
require('./GameEvaluationVideoInput');
require('./GameEvaluationEditPageBootstrap');
require('./GameEvaluationRefereeParametersInput');
require('./RefereeParametersRankingDataModel');
require('./GameEvaluationRefereeParametersInputsView');


},{"./GameEvaluationEditDataModel":90,"./GameEvaluationEditPageBootstrap":91,"./GameEvaluationFormView":92,"./GameEvaluationRefereeParametersInput":93,"./GameEvaluationRefereeParametersInputsView":94,"./GameEvaluationRefereeRankingInput":95,"./GameEvaluationSimpleInput":96,"./GameEvaluationVideoInput":97,"./RefereeParametersRankingDataModel":98,"./RefereeRankingDataModel":99,"./SimpleInputDataModel":100,"./VideoInputDataModel":101}],103:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationsDisplay');
app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationItemDisplayView = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationsDisplay-GameEvaluationItemDisplayView']),
    className: "row-fluid",

    events: {},

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.$('[data-action="preview"]').attr("href", "/game-evaluation/" + this.model.id);
        return this;
    }

});

},{}],104:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationsDisplay');

app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationsCollection = Backbone.Collection.extend({
    initialize: function(options) {
        this.gameId = options.gameId;
    },

    url: function() {
        return '/api/game-evaluations/' + this.gameId;
    }
});

},{}],105:[function(require,module,exports){
app.pkg('gameEvaluation.gameEvaluationsDisplay');
app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationsDisplayView = Backbone.View.extend({
    template: _.template(app.templates['gameEvaluation-gameEvaluationsDisplay-GameEvaluationsDisplayView']),
    className: "row-fluid",

    events: {},

    initialize: function() {
        _.bindAll(this);
        this.collection = new app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationsCollection({
            gameId: this.options.gameId
        });
        this.render();
    },

    fetchCollection: function() {
        var view = this;
        this.collection.fetch({
            success: function() {
                view.renderCollectionElements();
            },
            error: function() {}
        });
    },

    render: function() {
        this.$el.html(this.template({}));
        this.fetchCollection();
        this.renderCreateNewButton();
        if (!this.options.showLegend) {
            this.$('.js-legend-display').hide();
        }
        return this;
    },

    renderCreateNewButton: function() {
        var self = this;
        $.ajax({
            url: '/api/game-evaluation/' + this.options.gameId + "/available/",
            type: 'GET'
        }).done(function(data) {
            if (data.available) {
                self.$('[data-content="game-evaluations"]').prepend('<div><a href="/game-evaluation/edit/' + self.options.gameId + '/new" class="btn btn-green btn-small">'+app.getMessage('fillReport')+'</a></div>');
            }
        });
    },

    renderCollectionElements: function() {
        var view = this;
        _(this.collection.models).each(function(model) {

            view.renderItem(model);
        }, this);
    },

    renderItem: function(model) {
        var view = new app.gameEvaluation.gameEvaluationsDisplay.GameEvaluationItemDisplayView({
            model: model
        });
        this.$('[data-content="game-evaluations"]').append(view.el);
    }

});

},{}],106:[function(require,module,exports){
require("./GameEvaluationsDisplayView");
require("./GameEvaluationsCollection");
require("./GameEvaluationItemDisplayView");

},{"./GameEvaluationItemDisplayView":103,"./GameEvaluationsCollection":104,"./GameEvaluationsDisplayView":105}],107:[function(require,module,exports){
require('./gameEvaluationEditPage');
require('./GameEvaluationDataModel');
require('./gameEvaluationDisplayPage');
require('./gameEvaluationsDisplay');

},{"./GameEvaluationDataModel":82,"./gameEvaluationDisplayPage":89,"./gameEvaluationEditPage":102,"./gameEvaluationsDisplay":106}],108:[function(require,module,exports){
app.pkg("gameExpenses");

app.gameExpenses.GameExpensesModel = Backbone.Model.extend({
    validation: {
        expense_amount: {
            required: true,
            pattern: 'number'
        },
    },
    urlRoot: '/api/service/game-expenses'

});

},{}],109:[function(require,module,exports){
app.pkg('gameExpenses.gameExpensesDisplay');
app.gameExpenses.gameExpensesDisplay.GameExpenseFormView = Backbone.FormView.extend({

    template: _.template(app.templates['gameExpenses-gameExpensesDisplay-GameExpenseFormView']),
    selections: [],
    additionalEvents: {
        'blur input, textarea': 'onBlur',
    },
    onBlur: function () {
    },




    additionalInitializeActions: function () {
        this.model = this.getNewModelInstance();
        this.render();
        Backbone.Validation.bind(this);
    },


    setModelValues: function () {
        this.$('#expense_amount').val(this.model.get('expense_amount'));
    },


    getFormValues: function() {
        var formVals = {
            expense_amount: this.$('[name="expense_amount"]').val(),
            gameId: this.options.gameId
        };
        return formVals;
    },

    getNewModelInstance: function () {
        return new app.gameExpenses.GameExpensesModel({
            id: null
        });
    },

    additionalSaveSuccess: function() {
        this.trigger("hide-modal");
    },

});

},{}],110:[function(require,module,exports){
app.pkg('gameExpenses.gameExpensesDisplay');
app.gameExpenses.gameExpensesDisplay.GameExpenseItemDisplayView = Backbone.View.extend({
    template: _.template(app.templates['gameExpenses-gameExpensesDisplay-GameExpensesItemDisplayView']),
    className: "row-fluid",

    events: {
        'click [data-action="remove-element"]': 'deleteExpenseItem'
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    deleteExpenseItem: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.$('[data-action="preview"]').attr("href", "/game-evaluation/" + this.model.id);
        return this;
    }

});

},{}],111:[function(require,module,exports){
app.pkg('gameExpenses.gameExpensesDisplay');

app.gameExpenses.gameExpensesDisplay.GameExpensesCollection = Backbone.Collection.extend({
    initialize: function(options) {
        this.gameId = options.gameId;
    },

    url: function() {
        return '/api/service/game-expenses/' + this.gameId;
    }
});

},{}],112:[function(require,module,exports){
app.pkg('gameExpenses.gameExpensesDisplay');
app.gameExpenses.gameExpensesDisplay.GameExpensesDisplayView = Backbone.View.extend({
    template: _.template(app.templates['gameExpenses-gameExpensesDisplay-GameExpensesDisplayView']),
    className: "row-fluid",

    events: {
        'click [data-action="add-record"]': 'addRecord'
    },

    initialize: function() {
        _.bindAll(this);
        this.collection = new app.gameExpenses.gameExpensesDisplay.GameExpensesCollection({
            gameId: this.options.gameId
        });
        this.render();
    },

    fetchCollection: function() {
        var view = this;
        this.collection.fetch({
            success: function() {
                view.renderCollectionElements();
            },
            error: function() {}
        });
    },

    render: function() {
        this.$el.html(this.template({}));
        this.fetchCollection();
        if (!this.options.showLegend) {
            this.$('.js-legend-display').hide();
        }
        return this;
    },


    renderCollectionElements: function() {
        this.$('[data-content="game-expenses"]').empty();
        var view = this;
        _(this.collection.models).each(function(model) {

            view.renderItem(model);
        }, this);
    },

    renderItem: function(model) {
        var view = new app.gameExpenses.gameExpensesDisplay.GameExpenseItemDisplayView({
            model: model
        });
        view.on("remove-item", this.fetchCollection, this);
        this.$('[data-content="game-expenses"]').append(view.el);
    },

    addRecord: function(){
        var self = this;
        var modal = new app.components.modalWindow.ModalWindowView({
            contentView: app.gameExpenses.gameExpensesDisplay.GameExpenseFormView,
            contentParams: {
                gameId: this.options.gameId
            },
            headerText: app.getMessage('addExpenses')
        });

        modal.on("modal-hide", function() {
            self.fetchCollection();
        });

        $('body').append(modal.el);
    }

});

},{}],113:[function(require,module,exports){
require("./GameExpenseItemDisplayView");
require("./GameExpensesCollection");
require("./GameExpensesDisplayView");
require("./GameExpenseFormView");

},{"./GameExpenseFormView":109,"./GameExpenseItemDisplayView":110,"./GameExpensesCollection":111,"./GameExpensesDisplayView":112}],114:[function(require,module,exports){
require('./gameExpensesDisplay');
require('./GameExpenseDataModel');

},{"./GameExpenseDataModel":108,"./gameExpensesDisplay":113}],115:[function(require,module,exports){
app.pkg("gameLog");

app.gameLog.GameLogsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/gamelogs/all'
});

},{}],116:[function(require,module,exports){
app.pkg('gameLog');
app.gameLog.GameLogsItemView = Backbone.View.extend({


    tagName: 'div',
    className: 'row-fluid log-item',
    template: _.template(app.templates['gameLog-GameLogsItemView']),
    initialize: function() {
        _.bindAll(this);
        this.render();
    },
    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        return this;
    }


});

},{}],117:[function(require,module,exports){
app.pkg('gameLog');
app.gameLog.GameLogsListView = Backbone.LazyLoadListView.extend({
    templateName: app.templates['gameLog-GameLogsListView'],

    getFetchParams: function() {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        filters.game_id = this.options.game_id;
        return filters;
    },
    getCollectionElementsDisplayDiv: function() {
        return this.$('.aaa');
    },

    actionsAfterRender: function() {
        this.$('.created-display').text(this.options.created_at);
        this.$('.updated-display').text(this.options.updated_at);
    }

});

},{}],118:[function(require,module,exports){
require('./GameLogsCollection');
require('./GameLogsItemView');
require('./GameLogsListView');






},{"./GameLogsCollection":115,"./GameLogsItemView":116,"./GameLogsListView":117}],119:[function(require,module,exports){
app.pkg("gameTripInfo");

app.gameTripInfo.GameTripRankingDataModel = Backbone.Model.extend({
    validation: {
        content: {
            required: true
        }
    },
    urlRoot: '/api/service/game-trip-info'

});

},{}],120:[function(require,module,exports){
app.pkg('gameTripInfo');
app.gameTripInfo.GameTripInfoFormView = Backbone.FormView.extend({

    template: _.template(app.templates['gameTripInfo-GameTripInfoFormView']),

    additionalEvents: {},

    additionalInitializeActions: function() {
        this.model = this.getNewModelInstance();
        Backbone.Validation.bind(this);
        this.setModelValues();
        this.render();
    },


    setModelValues: function() {

    },

    getNewModelInstance: function() {
        return new app.gameTripInfo.GameTripRankingDataModel({
            id: null,
            game_id: this.options.game_id
        });
    },


    getFormValues: function() {
        var formVals = {};
        formVals.content = this.$('#content').val().replace(/\n/g, "<br />");
        return formVals;
    },


    additionalSaveSuccess: function() {
        this.trigger("hide-modal");
    },

    displaySuccessCreateMessage: function() {
        app.displayAlertMessage("success", app.getMessage('successEmailSentMessageTitle'), app.getMessage('successEmailSentMessageTitle'));
    }


});

},{}],121:[function(require,module,exports){
require("./GameTripInfoFormView");
require("./GameTripInfoDataModel");
},{"./GameTripInfoDataModel":119,"./GameTripInfoFormView":120}],122:[function(require,module,exports){
app.pkg("gameTripRanking");

app.gameTripRanking.GameTripRankingDataModel = Backbone.Model.extend({
    validation: {
        referee_one_ranking: {
            required: true,
            pattern: 'number'
        },
        referee_two_ranking: {
            required: true,
            pattern: 'number'
        },
        referee_three_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_score_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_time_ranking: {
            required: true,
            pattern: 'number'
        },
        commissioner_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_4_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_5_ranking: {
            required: true,
            pattern: 'number'
        },

        secretary_statistics_2_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_3_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_information_ranking: {
            required: true,
            pattern: 'number'
        },
    },

    urlRoot: '/api/service/game-trip-ranking',

    getGameTripRankingUrl: function(gameId) {
        return this.urlRoot + "/game/" + gameId;
    }
});

},{}],123:[function(require,module,exports){
app.pkg('gameTripRanking');
app.gameTripRanking.GameTripRankingFormView = Backbone.FormView.extend({

    template: _.template(app.templates['gameTripRanking-GameTripRankingFormView']),
    selections: [],
    additionalEvents: {
        'blur input, textarea': 'onBlur',
        'change #trip_target': 'onTripTargetChange'
    },
    onBlur: function () {
    },

    onTripTargetChange: function () {
        var value = this.$('#trip_target').val(),
            selected = null;
        _(this.selections).each(function (item) {
            if (String(item.id) === String(value)) {
                selected = item;
            }
        }, this);
        if (selected) {
            var kyz = Object.keys(selected);
            for (var i = 0; i < kyz.length; i++) {
                this.$('#' + kyz[i]).val(selected[kyz[i]]);
            }
            this.$('#referee_one_ranking').val(selected.referee_ranking);
            this.$('#referee_two_ranking').val(selected.referee_ranking);
            this.$('#referee_three_ranking').val(selected.referee_ranking);
        }

    },

    additionalInitializeActions: function () {
        this.model = this.getNewModelInstance();
        this.getModel();
        this.getAndRenderSelections();
        Backbone.Validation.bind(this);
    },

    getModel: function () {
        var view = this;
        app.displayLoadDialog();
        var url = this.model.getGameTripRankingUrl(this.options.game_id);
        $.ajax({
            url: url,
            type: 'GET',
            data: {}
        }).done(function (data) {
            view.model.set(data);
            view.render();
            app.hideLoadDialog();
        }).fail(function (jqxhr) {
            app.hideLoadDialog();
            app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        });
    },

    getAndRenderSelections: function () {
        var self = this;
        $.ajax({
            url: '/api/availbale-game-trip-rankings/available',
            type: 'GET',
            data: {}
        }).done(function (data) {
            self.selections = data;
            _(data).each(function (item) {
                self.$('#trip_target').append("<option value=" + item.id + ">" + item.name + "</option>");
            }, this);
        });
    },

    setModelValues: function () {
        this.$('#referee_one_ranking').val(this.model.get('referee_one_ranking'));
        this.$('#referee_two_ranking').val(this.model.get('referee_two_ranking'));
        this.$('#referee_three_ranking').val(this.model.get('referee_three_ranking'));
        this.$('#driver_ranking').val(this.model.get('driver_ranking'));
        this.$('#secretary_score_ranking').val(this.model.get('secretary_score_ranking'));
        this.$('#secretary_statistics_ranking').val(this.model.get('secretary_statistics_ranking'));
        this.$('#secretary_time_ranking').val(this.model.get('secretary_time_ranking'));
        this.$('#commissioner_ranking').val(this.model.get('commissioner_ranking'));
        this.$('#game_id').val(this.model.get('game_id'));
        this.$('#driver_id').val(this.model.get('driver_id'));
        this.$('#secretary_4_ranking').val(this.model.get('secretary_4_ranking'));
        this.$('#secretary_5_ranking').val(this.model.get('secretary_5_ranking'));

        this.$('#secretary_statistics_2_ranking').val(this.model.get('secretary_statistics_2_ranking'));
        this.$('#secretary_statistics_3_ranking').val(this.model.get('secretary_statistics_3_ranking'));
        this.$('#secretary_information_ranking').val(this.model.get('secretary_information_ranking'));


    },

    getFormValues: function () {
        var formVals = {};
        this.$("input[type=text], input[type=email],  input[type=password],textarea, select").each(function () {
            if ($(this).attr("name")) {
                var val = $(this).val();
                if (app.isIntFromString(val) && val !== "") {
                    val = parseInt(val);
                }
                formVals[$(this).attr("name")] = val;
            }
        });

        this.$("input[type=checkbox]").each(function () {
            formVals[$(this).attr("name")] = $(this).is(':checked');
        });
        formVals.game_id = this.options.game_id;
        return formVals;
    },

    additionalRender: function () {
    },

    getNewModelInstance: function () {
        return new app.gameTripRanking.GameTripRankingDataModel({
            id: null
        });
    }

});

},{}],124:[function(require,module,exports){
require('./GameTripRankingDataModel');
require('./GameTripRankingFormView');
//
//
//
//
//


},{"./GameTripRankingDataModel":122,"./GameTripRankingFormView":123}],125:[function(require,module,exports){
app.pkg("global");

app.global.AppPageBootstrap = function() {
    $.ajaxSetup({
        cache: false
    });
    app.addTooltips();
    if (app.isSmallScreen()) {
        $("#global-statistics-title").hide();
        $("#global-statistics").hide();
    };
    $.ajax({
        url: '/api/app/user/data',
        type: 'GET',
        data: {}
    }).done(function(data) {
        if (data.unconfirmed_appointments) {
            var element = $('[data-value="unconfirmed-appointments"]');
            if (data.unconfirmed_appointments === 0) {
                element.attr("data-original-title", app.getMessage('youHaveNoUnconfirmedAppointments'));
            } else {
                element.attr("data-original-title", app.getMessage('youHaveUnconfirmedAppointments'));
            }
            $('.count-display', element).text(data.unconfirmed_appointments);
        }
    });
};

},{}],126:[function(require,module,exports){
require('./AppBoostrap');

},{"./AppBoostrap":125}],127:[function(require,module,exports){
require('./utils/backboneHelpers');
require('./utils/backbonePaginator');
require('./components');
require('./dashboard');
require('./invoice');
require('./game');
require('./gameAppointment');
require('./gameLog');
require('./league');
require('./leagueGroup');
require('./post');
require('./schedule');
require('./user');
require('./journal');
require('./test');
require('./gameTripRanking');
require('./gameTripInfo');
require('./report');
require('./gameEvaluation');
require('./videoGroup');
require('./availableGameTripRanking');
require('./admin');
require('./global');
require('./statistics');
require('./userAvailability');
require('./gameExpenses');
require('./documents');


},{"./admin":4,"./availableGameTripRanking":17,"./components":22,"./dashboard":42,"./documents":55,"./game":69,"./gameAppointment":81,"./gameEvaluation":107,"./gameExpenses":114,"./gameLog":118,"./gameTripInfo":121,"./gameTripRanking":124,"./global":126,"./invoice":129,"./journal":151,"./league":177,"./leagueGroup":190,"./post":204,"./report":208,"./schedule":215,"./statistics":222,"./test":235,"./user":266,"./userAvailability":287,"./utils/backboneHelpers":306,"./utils/backbonePaginator":307,"./videoGroup":309}],128:[function(require,module,exports){
app.pkg("invoice");

app.invoice.InvoiceDataModel = Backbone.Model.extend({
    validation: {
        serial: {
            required: true
        },
        number: {
            required: true,
            pattern: 'digits',
            msg: 'Sąskaitos numeris turi būti skaičius'
        },

        invoice_date: {
            required: true
        },
        invoice_items: {
            required: true
        },
        invoice_seller_info: {
            required: true
        },
        invoice_buyer: {
            required: true
        }
    },

    urlRoot: '/api/service/invoice/data'
});

},{}],129:[function(require,module,exports){
require('./invoiceCreationPage');
require('./InvoiceDataModel');
require('./myInvoicesPage');


},{"./InvoiceDataModel":128,"./invoiceCreationPage":136,"./myInvoicesPage":141}],130:[function(require,module,exports){
app.pkg("invoice.invoiceCreationPage");

app.invoice.invoiceCreationPage.InvoiceCreationCollection = Backbone.Paginator.paginatedCollection.extend({

    parse: function (resp, xhr) {
        this.itemsCount = resp.itemsCount;
        this.sum = resp.sum;
        return resp.collection;
    },
    url: '/api/service/invoice/records/paginated'
});

},{}],131:[function(require,module,exports){
app.pkg('invoice.invoiceCreationPage');
app.invoice.invoiceCreationPage.InvoiceCreationConfirmationModalView = Backbone.View.extend({

    template: _.template(app.templates['invoice-invoiceCreationPage-InvoiceCreationConfirmationModalView']),

    events: {
        'click [data-action="confirm-invoice"]': 'confirmInvoice',
        'click [data-action="edit-invoice"]': 'closeModal',
        'click [data-action="download-file"]': 'previewInvoice'
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template({}));


        // this.$('[data-action="download-file"]').attr("href", "/pdf/" + this.options.file_name);
        return this;
    },

    previewInvoice: function(){
        console.log('SOMEHOW')
        // $.ajax({
        //     url: '/api/service/invoice/preview',
        //     type: 'POST',
        //     data: this.options.invoice_data,
        //     success: function(response, status, xhr) {
        //         // check for a filename
        //         var filename = "";
        //         var disposition = xhr.getResponseHeader('Content-Disposition');
        //         if (disposition && disposition.indexOf('attachment') !== -1) {
        //             var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        //             var matches = filenameRegex.exec(disposition);
        //             if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
        //         }
        //
        //         var type = xhr.getResponseHeader('Content-Type');
        //         var blob = new Blob([response], { type: type });
        //
        //         if (typeof window.navigator.msSaveBlob !== 'undefined') {
        //             // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
        //             window.navigator.msSaveBlob(blob, filename);
        //         } else {
        //             var URL = window.URL || window.webkitURL;
        //             var downloadUrl = URL.createObjectURL(blob);
        //
        //             if (filename) {
        //                 // use HTML5 a[download] attribute to specify filename
        //                 var a = document.createElement("a");
        //                 // safari doesn't support this yet
        //                 if (typeof a.download === 'undefined') {
        //                     window.location = downloadUrl;
        //                 } else {
        //                     a.href = downloadUrl;
        //                     a.download = filename;
        //                     document.body.appendChild(a);
        //                     a.click();
        //                 }
        //             } else {
        //                 window.location = downloadUrl;
        //             }
        //
        //             setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
        //         }
        //     }
        // })

    },

    closeModal: function() {
        this.trigger("hide-modal");
    },

    confirmInvoice: function() {
        $.ajax({
            url: '/api/service/invoice/confirm-invoice',
            type: 'POST',
            data: this.options.invoice_data
        }).done(function(data) {
            app.displayAlertMessage("success", app.getMessage("recordSavedMessage"), app.getMessage("recordSavedMessage"));
            app.openMyInvoicesDisplayPage();
        }).fail(function(jqxhr, status) {
            app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        });

        this.closeModal();
    }
});

},{}],132:[function(require,module,exports){
app.pkg('invoice.invoiceCreationPage');
app.invoice.invoiceCreationPage.InvoiceCreationFormView = Backbone.FormView.extend({

    template: _.template(app.templates['invoice-invoiceCreationPage-InvoiceCreationFormView']),

    additionalEvents: {},

    fetchModel: function() {
        var view = this;
        this.model.fetch({
            success: function(model) {
                view.render();
            },
            error: function() {}
        });
    },

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
    },

    additionalRender: function() {
        var self = this;
        this.listItemView = new app.invoice.invoiceCreationPage.InvoiceCreationListView({
            el: this.$('[data-content="invoice-items-list"]'),
            collection: new app.invoice.invoiceCreationPage.InvoiceCreationCollection(),
            listItemDisplayViewType: app.invoice.invoiceCreationPage.InvoiceCreationListItemView,
            template: app.templates['invoice-invoiceCreationPage-InvoiceCreationListView']
        });

        this.listItemView.collection.bind("change", this.onCollectionChange, this);
        this.listItemView.collection.bind("sync", this.onCollectionChange, this);

        this.$('#invoice_date').datepicker({
            onSelect: function() {
                var e = jQuery.Event("blur");
                e.target = this;
                self.validateField(e);
            }
        });
        this.$('#invoice_date').datepicker('setDate', new Date());
        this.renderBuyerOptions();
    },

    renderBuyerOptions: function() {
        var buyers = app.invoice.Buyers;
        for (var i = 0; i < buyers.length; i++) {
            this.$('#invoice_buyer').append("<option value='" + i + "' > " + buyers[i].name + "</option>");
        }
    },

    onCollectionChange: function() {
        var sum = 0,
            appointments = 0,
            selectedModels = [];
        _(this.listItemView.collection.models).each(function(model) {
            if (model.get("selected")) {
                var summed_ranking = model.get('split_rankings') ? parseFloat(model.get("summed_original_ranking")) : parseFloat(model.get("summed_ranking"));
                sum = sum + summed_ranking + parseFloat(model.get('summed_driver_ranking'));
                appointments = appointments + parseInt(model.get("appointments_count"));
                selectedModels.push(model);
            }
        }, this);


        this.$('[data-content="games-count"]').text(appointments);
        this.$('[data-content="games-sum"]').text(sum.toFixed(2));
        this.model.set({
            "invoice_sum": sum.toFixed(2)
        });

        var invoiceItemsVal = null;
        if (selectedModels.length > 0) {
            invoiceItemsVal = JSON.stringify(selectedModels);
        }
        this.$('#invoice_items').val(invoiceItemsVal);
    },

    additionalSaveSuccess: function(wasNew) {
        $('body').append(
            new app.components.modalWindow.ModalWindowView({
                contentView: app.invoice.invoiceCreationPage.InvoiceCreationConfirmationModalView,
                contentParams: {
                    file_name: this.model.get("file_name"),
                    invoice_data: this.model.get("invoice_data")
                },
                headerText: "Sąskaitos patvirtinimas"
            }).el
        );
    },

    getDynamicFormVals: function(formVals) {
        var buyer = app.invoice.Buyers[this.$('#invoice_buyer').val()],
            buyerValue = "";
        if (buyer) {
            buyerValue = buyer.description;
        }
        formVals.invoice_buyer = buyerValue;
        return formVals;
    },

    setModelValues: function() {
        this.$("#number").val(this.model.get("invoice_number"));
        this.$("#serial").val(this.model.get("invoice_serial"));
        this.$("#invoice_seller_info").val(this.model.get("invoice_seller_info"));

    }

});

},{}],133:[function(require,module,exports){
app.pkg('invoice.invoiceCreationPage');
app.invoice.invoiceCreationPage.InvoiceCreationListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['invoice-invoiceCreationPage-InvoiceCreationListItemView']),

    events: {
        'click': 'onItemClick'
    },

    onItemClick: function () {
        this.model.set({
            "selected": !this.model.get("selected")
        });
        this.$('#selected').prop('checked', this.model.get("selected") ? 'checked' : false);
    },

    initialize: function () {
        _.bindAll(this);
        this.render();
    },


    render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    }


});
},{}],134:[function(require,module,exports){
app.pkg('invoice.invoiceCreationPage');
app.invoice.invoiceCreationPage.InvoiceCreationListView = Backbone.LazyLoadListView.extend({
    disableScroll: true,

    render: function () {
        this.$el.html(this.template());
        this.renderFilters();
        this.initScroll();
        return this;
    },
    additionalInitializeActions: function () {

    },

    renderFilters: function () {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$el.prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
        this.fetchCollection();
    },

    onFilterChanged: function () {
        this.collection.resetCollection();
        this.getCollectionElementsDisplayDiv().empty();
        this.fetchCollection();
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#my-ranking-records-list tbody');
    },

    getFetchParams: function () {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    }

});
},{}],135:[function(require,module,exports){
app.pkg('invoice.invoiceCreationPage');
app.invoice.invoiceCreationPage.InvoiceCreationPageBootstrap = function () {
    var model = new app.invoice.InvoiceDataModel();
    new app.invoice.invoiceCreationPage.InvoiceCreationFormView({el: $('[data-content="invoice-form"]'), model: model});

    $('[data-main-menu-item="invoices"]').addClass("active");
    $('[data-sidebar-menu-item="invoice-generation"]').addClass("active");
};

},{}],136:[function(require,module,exports){
require('./InvoiceCreationPageBootstrap');
require('./InvoiceCreationListView');
require('./InvoiceCreationListItemView');
require('./InvoiceCreationCollection');
require('./InvoiceCreationFormView');
require('./InvoiceCreationConfirmationModalView');






},{"./InvoiceCreationCollection":130,"./InvoiceCreationConfirmationModalView":131,"./InvoiceCreationFormView":132,"./InvoiceCreationListItemView":133,"./InvoiceCreationListView":134,"./InvoiceCreationPageBootstrap":135}],137:[function(require,module,exports){
app.pkg("invoice.myInvoicesPage");

app.invoice.myInvoicesPage.MyInvoicesCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/invoices/my/paginated'
});

},{}],138:[function(require,module,exports){
app.pkg('invoice.myInvoicesPage');
app.invoice.myInvoicesPage.MyInvoicesListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['invoice-myInvoicesPage-MyInvoicesListItemView']),

    events: {
        'click [data-action="preview-element"]': 'previewElement',
        'click [data-action="remove-element"]': 'deleteInvoice'
    },
    initialize: function() {
        _.bindAll(this);
        this.render();

    },

    deleteInvoice: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },


    previewElement: function() {
        // app.displayLoadDialog();
        window.open('/api/service/invoice/preview-invoice/' + this.model.id)
        // $.ajax({
        //     url: '/api/service/invoice/preview-invoice/' + this.model.id,
        //     type: 'GET'
        // }).done(function(data) {
        //     app.hideLoadDialog();
        //     window.open("/pdf/" + data.file_name);
        // }).fail(function(jqxhr, status) {
        //     app.hideLoadDialog();
        //     app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        // });
    },

    render: function() {
        this.model.set("invoice_date", this.model.get("invoice_date").substring(0, this.model.get("invoice_date").length - 5));
        this.$el.html(this.template(this.model.toJSON()));
        app.addTooltips(this.$el);
        return this;
    }


});

},{}],139:[function(require,module,exports){
app.pkg('invoice.myInvoicesPage');
app.invoice.myInvoicesPage.MyInvoicesListView = Backbone.LazyLoadListView.extend({

    render: function () {
        this.$el.html(this.template());
        this.initScroll();
        return this;
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#my-invoices-list tbody');
    }

});
},{}],140:[function(require,module,exports){
app.pkg('invoice.myInvoicesPage');
app.invoice.myInvoicesPage.MyInvoicesPageBootstrap = function () {
    new app.invoice.myInvoicesPage.MyInvoicesListView({
        el: $('[data-content="my-invoices"]'),
        collection: new app.invoice.myInvoicesPage.MyInvoicesCollection(),
        listItemDisplayViewType: app.invoice.myInvoicesPage.MyInvoicesListItemView,
        template: app.templates['invoice-myInvoicesPage-MyInvoicesListView']
    });
    $('[data-main-menu-item="invoices"]').addClass("active");
    $('[data-sidebar-menu-item="my-invoices"]').addClass("active");
};



},{}],141:[function(require,module,exports){
require('./MyInvoicesCollection');
require('./MyInvoicesListItemView');
require('./MyInvoicesListView');
require('./MyInvoicesPageBootstrap');







},{"./MyInvoicesCollection":137,"./MyInvoicesListItemView":138,"./MyInvoicesListView":139,"./MyInvoicesPageBootstrap":140}],142:[function(require,module,exports){
app.pkg('journal.customUserJournalPage');
app.journal.customUserJournalPage.CustomUserJournalListView = app.journal.myJournalPage.MyJournalListView.extend({

    getFetchParams: function() {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        filters.userId = app.getRequestParameterByName("userId");
        return filters;
    }


});

},{}],143:[function(require,module,exports){
app.pkg('journal.customUserJournalPage');
app.journal.customUserJournalPage.CustomUserJournalPageBootstrap = function() {
    new app.journal.customUserJournalPage.CustomUserJournalListView({
        el: $('[data-content="journal-items-list"]'),
        collection: new app.journal.customUserJournalPage.CustomUserJournalRecordsCollection(),
        listItemDisplayViewType: app.journal.myJournalPage.MyJournalListItemView,
        template: app.templates['journal-customUserJournalPage-CustomUserJournalListView']
    });
    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="custom-user-ranking"]').addClass("active");

};

},{}],144:[function(require,module,exports){
app.pkg(".journal.customUserJournalPage");

app.journal.customUserJournalPage.CustomUserJournalRecordsCollection = app.journal.myJournalPage.MyJournalRecordsCollection.extend({
    url: '/api/service/journal/custom/paginated'
});

},{}],145:[function(require,module,exports){
require('./CustomUserJournalPageBootstrap');
require('./CustomUserJournalListView');
require('./CustomUserJournalRecordsCollection');








},{"./CustomUserJournalListView":142,"./CustomUserJournalPageBootstrap":143,"./CustomUserJournalRecordsCollection":144}],146:[function(require,module,exports){
app.pkg('journal.globalRankingPage');
app.journal.globalRankingPage.GlobalRankingListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['journal-globalRankingPage-GlobalRankingListItemView']),

    events: {},

    onItemClick: function() {},

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    render: function() {
        this.setRankingsDisplay();
        this.$el.html(this.template(this.model.toJSON()));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    },


    setRankingsDisplay: function() {
        var rankings = this.model.get("rankings");
        var rankingsDisplay = "";
        for (var i = 0; i < rankings.length; i++) {
            var ranking = rankings[i];
            rankingsDisplay += " <strong>" + ranking.league_name + ":</strong> ";
            rankingsDisplay += ranking.summed_ranking + " (" + ranking.appointments_count + ")";
        }
        this.model.set("rankings_display", rankingsDisplay);
    }



});

},{}],147:[function(require,module,exports){
app.pkg('journal.globalRankingPage');
app.journal.globalRankingPage.GlobalRankingListView = Backbone.LazyLoadListView.extend({

    render: function() {
        this.$el.html(this.template());
        this.renderFilters();
        this.initScroll();
        return this;
    },
    additionalInitializeActions: function() {

    },

    renderFilters: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$el.prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
        this.fetchCollection();
    },

    onFilterChanged: function() {
        this.collection.resetCollection();
        this.getCollectionElementsDisplayDiv().empty();
        this.fetchCollection();
    },

    getCollectionElementsDisplayDiv: function() {
        return this.$('#global-ranking-records-list tbody');
    },


    getFetchParams: function() {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    }


});

},{}],148:[function(require,module,exports){
app.pkg('journal.globalRankingPage');
app.journal.globalRankingPage.GlobalRankingPageBootstrap = function() {
    new app.journal.globalRankingPage.GlobalRankingListView({
        el: $('[data-content="global-ranking-items-list"]'),
        collection: new app.journal.globalRankingPage.GlobalRankingRecordsCollection(),
        listItemDisplayViewType: app.journal.globalRankingPage.GlobalRankingListItemView,
        template: app.templates['journal-globalRankingPage-GlobalRankingListView']
    });
    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="global-ranking"]').addClass("active");

};

},{}],149:[function(require,module,exports){
app.pkg("journal.globalRankingPage");

app.journal.globalRankingPage.GlobalRankingRecordsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/journal/ranking/global/paginated'
});

},{}],150:[function(require,module,exports){
require('./GlobalRankingPageBootstrap');
require('./GlobalRankingListView');
require('./GlobalRankingListItemView');
require('./GlobalRankingsRecordsCollection');










},{"./GlobalRankingListItemView":146,"./GlobalRankingListView":147,"./GlobalRankingPageBootstrap":148,"./GlobalRankingsRecordsCollection":149}],151:[function(require,module,exports){
require('./myJournalPage');
require('./myRankingPage');
require('./globalRankingPage');
require('./journalExportsPage');
require('./customUserJournalPage');
require('./myExpensesPage');
require('./myBalancePage');








},{"./customUserJournalPage":145,"./globalRankingPage":150,"./journalExportsPage":156,"./myBalancePage":160,"./myExpensesPage":164,"./myJournalPage":169,"./myRankingPage":174}],152:[function(require,module,exports){
app.pkg('journal.journalsExportsPage');
app.journal.journalsExportsPage.JournalExportItemView = Backbone.View.extend({
    tagName: 'div',
    template: _.template(app.templates['journal-journalsExportsPage-JournalExportItemView']),

    events: {
        'click': 'onItemClick'
    },

    onItemClick: function() {
        window.open(this.model.get("url") + "?" + app.serialize(this.options.parent.getFilterValues()), '_blank');
    },

    initialize: function() {
        _.bindAll(this);
        this.model = new app.journal.journalsExportsPage.JournalsExportItemModel(this.options.data);
        this.render();
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        return this;
    }



});

},{}],153:[function(require,module,exports){
app.pkg('journal.journalsExportsPage');

app.journal.journalsExportsPage.JournalsExportItemModel = Backbone.Model.extend({});

},{}],154:[function(require,module,exports){
app.pkg('journal.journalsExportsPage');
app.journal.journalsExportsPage.JournalsExportsPageBootstrap = function () {
    new app.journal.journalsExportsPage.JournalsExportsPageContent({
        el: $('[data-content="journal-exports-content"]')
    });

    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="journal-export"]').addClass("active");

};

},{}],155:[function(require,module,exports){
app.pkg('journal.journalsExportsPage');
app.journal.journalsExportsPage.JournalsExportsPageContent = Backbone.View.extend({

    journalExportItemTemplate: _.template(app.templates['journal-journalsExportsPage-JournalExportItemView']),

    events: {
        'click [data-action="export-journal"]': 'exportJournal'
    },

    initialize: function() {
        _.bindAll(this);
        this.journalTypes = [{
                url: "/api/service/journal/export/month/by_league",
                title: app.getMessage('journalExportByLeague')
            }, {
                url: "/api/service/journal/export/month/by_league_group",
                title: app.getMessage('journalExportByLeagueGroup')
            },

            {
                url: "/api/service/journal/export/month/by_league_group_v2",
                title: app.getMessage('journalExportByLeagueGroup') + ' NEW'
            },

            {
                url: "/api/service/journal/export/month/total",
                title: app.getMessage('jornalExportTotal')
            },
            {
                url: "/api/service/journal/export/month/referees_game_cost",
                title: app.getMessage('journalExportGameCost')
            },

            {
                url: "/api/service/journal/export/month/league_group_expenses",
                title: app.getMessage('journalExportLeagueGameExpenses')
            },
            {
                url: "/api/service/journal/export/month/balances",
                title: app.getMessage('journalExportBalance')
            }

        ];

        this.render();

    },

    render: function() {
        this.renderFilter();
        this.renderJournals();
        return this;
    },

    renderFilter: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$('[data-content="filter"]').append(this.filterView.el);
        // this.filterView.bind('filterChanged', this.onFilterChanged, this);
    },

    renderJournals: function() {
        for (var i = 0; i < this.journalTypes.length; i++) {
            var element = new app.journal.journalsExportsPage.JournalExportItemView({
                data: this.journalTypes[i],
                parent: this
            });
            this.$('[data-content="export-types"]').append(element.el);
        }

    },
    getFilterValues: function() {
        return this.filterView.getFilterValues();
    }



});

},{}],156:[function(require,module,exports){
require('./JournalsExportsPageBootstrap');
require('./JournalsExportsPageContent');
require('./JournalExportItemView');
require('./JournalsExportItemModel');










},{"./JournalExportItemView":152,"./JournalsExportItemModel":153,"./JournalsExportsPageBootstrap":154,"./JournalsExportsPageContent":155}],157:[function(require,module,exports){
app.pkg('journal.myBalance');
app.journal.myBalance.MyBalancePageBootstrap = function() {
    new app.journal.myBalance.MyBalancePageContent({
        el: $('[data-content="my-balance"]')
    });

    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="user-balance"]').addClass("active");

};

},{}],158:[function(require,module,exports){
app.pkg('journal.myBalance');
app.journal.myBalance.MyBalancePageContent = Backbone.View.extend({

    events: {
        'click [data-action="export-expenses"]': 'exportContent'
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.renderFilter();
        this.renderValues()
        return this;
    },

    renderValues: function(){
        var self = this;
        app.displayLoadDialog();
        self.$('[data-content="my-balance-content"]').empty();
        $.ajax({
            url: '/api/balance/my' + "?" + app.serialize(this.getFilterValues()),
            type: 'GET'
        }).done(function(data) {
            app.hideLoadDialog();
            data.forEach(function(item){
                self.renderItem(item)
            })
        }).fail(function(jqxhr, status) {
            app.hideLoadDialog();
            app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        });

    },

    renderItem: function(item) {
        var view = new app.journal.myBalance.MyBalancePageContentItemView({
            item: item
        });
        this.$('[data-content="my-balance-content"]').append(view.el)

    },

    onFilterChanged: function(){
        this.renderValues();
    },

    renderFilter: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$('[data-content="filter"]').append(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);

    },

    getFilterValues: function() {
        return this.filterView.getFilterValues();
    }



});

},{}],159:[function(require,module,exports){
app.pkg('journal.myBalance');
app.journal.myBalance.MyBalancePageContentItemView = Backbone.View.extend({

    template: _.template(app.templates['journal-myBalance-MyBalancePageContentItemView']),

    events: {
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    render: function() {
        this.$el.html(this.template(this.options.item));
        return this;
    }


});

},{}],160:[function(require,module,exports){
require('./MyBalancePageBootstrap');
require('./MyBalancePageContent');
require('./MyBalancePageContentItemView');











},{"./MyBalancePageBootstrap":157,"./MyBalancePageContent":158,"./MyBalancePageContentItemView":159}],161:[function(require,module,exports){
app.pkg('journal.myExpenses');
app.journal.myExpenses.MyExpensesPageBootstrap = function() {
    new app.journal.myExpenses.MyExpensesPageContent({
        el: $('[data-content="my-expenses"]')
    });

    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="user-expenses"]').addClass("active");

};

},{}],162:[function(require,module,exports){
app.pkg('journal.myExpenses');
app.journal.myExpenses.MyExpensesPageContent = Backbone.View.extend({

    events: {
        'click [data-action="export-expenses"]': 'exportContent'
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.renderFilter();
        return this;
    },

    exportContent: function() {
        window.open( '/api/service/journal/export/user-expenses' + "?" + app.serialize(this.getFilterValues()));
        // app.displayLoadDialog();
        // $.ajax({
        //     url: '/api/service/journal/export/user-expenses' + "?" + app.serialize(this.getFilterValues()),
        //     type: 'GET'
        // }).done(function(data) {
        //     app.hideLoadDialog();
        //     window.open("/pdf/" + data.file_name);
        // }).fail(function(jqxhr, status) {
        //     app.hideLoadDialog();
        //     app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        // });
    },

    renderFilter: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$('[data-content="filter"]').append(this.filterView.el);
    },

    getFilterValues: function() {
        return this.filterView.getFilterValues();
    }



});

},{}],163:[function(require,module,exports){
app.pkg('journal.myRankingPage');
app.journal.myRankingPage.MyRankingListView = Backbone.LazyLoadListView.extend({

    render: function() {
        this.$el.html(this.template());
        this.renderFilters();
        this.initScroll();
        return this;
    },
    additionalInitializeActions: function() {

    },

    renderFilters: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$el.prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
        this.fetchCollection();
    },

    onFilterChanged: function() {
        this.collection.resetCollection();
        this.getCollectionElementsDisplayDiv().empty();
        this.fetchCollection();
    },

    getCollectionElementsDisplayDiv: function() {
        return this.$('#my-ranking-records-list tbody');
    },

    actionsAfterRender: function() {
        this.$('[data-content="games-count"]').text(this.collection.itemsCount);
        this.$('[data-content="games-sum"]').text(this.collection.sum);
        this.$('[data-content="summed_driver_ranking"]').text(this.collection.summed_driver_ranking);
    },


    getFetchParams: function() {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    }


});

},{}],164:[function(require,module,exports){
require('./MyExpensesPageBootstrap');
require('./MyRankingListView');
require('./MyExpensesPageContent');











},{"./MyExpensesPageBootstrap":161,"./MyExpensesPageContent":162,"./MyRankingListView":163}],165:[function(require,module,exports){
app.pkg('journal.myJournalPage');
app.journal.myJournalPage.MyJournalListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['journal-myJournalPage-MyJournalListItemView']),

    events: {
        'click': 'onItemClick'
    },

    onItemClick: function() {
        app.openGameDisplayPage(this.model.get("game").id);
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    }
    
});

},{}],166:[function(require,module,exports){
app.pkg('journal.myJournalPage');
app.journal.myJournalPage.MyJournalListView = Backbone.LazyLoadListView.extend({

    render: function() {
        this.$el.html(this.template());
        this.renderFilters();
        this.initScroll();
        return this;
    },

    additionalInitializeActions: function() {

    },

    renderFilters: function() {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$el.prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
        this.fetchCollection();
    },

    onFilterChanged: function() {
        this.collection.resetCollection();
        this.getCollectionElementsDisplayDiv().empty();
        this.fetchCollection();
    },

    getCollectionElementsDisplayDiv: function() {
        return this.$('#my-journal-records-list tbody');
    },

    actionsAfterRender: function() {
        this.$('[data-content="games-count"]').text(this.collection.itemsCount);
        this.$('[data-content="games-sum"]').text(this.collection.sum);
        this.$('[data-content="driver-sum"]').text(this.collection.driver_ranking_sum);
    },


    getFetchParams: function() {
        var filters = this.filterView.getFilterValues();
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    }


});

},{}],167:[function(require,module,exports){
app.pkg('journal.myJournalPage');
app.journal.myJournalPage.MyJournalPageBootstrap = function() {
    new app.journal.myJournalPage.MyJournalListView({
        el: $('[data-content="journal-items-list"]'),
        collection: new app.journal.myJournalPage.MyJournalRecordsCollection(),
        listItemDisplayViewType: app.journal.myJournalPage.MyJournalListItemView,
        template: app.templates['journal-myJournalPage-MyJournalListView']
    });
    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="my-journal"]').addClass("active");

};

},{}],168:[function(require,module,exports){
app.pkg("journal.myJournalPage");

app.journal.myJournalPage.MyJournalRecordsCollection = Backbone.Paginator.paginatedCollection.extend({

    parse: function(resp, xhr) {
        this.itemsCount = resp.itemsCount;
        this.sum = resp.sum;
        this.driver_ranking_sum = resp.driver_ranking_sum;
        return resp.collection;
    },
    url: '/api/service/journal/my/paginated'
});

},{}],169:[function(require,module,exports){
require('./MyJournalRecordsCollection');
require('./MyJournalListView');
require('./MyJournalListItemView');
require('./MyJournalPageBootstrap');







},{"./MyJournalListItemView":165,"./MyJournalListView":166,"./MyJournalPageBootstrap":167,"./MyJournalRecordsCollection":168}],170:[function(require,module,exports){
app.pkg('journal.myRankingPage');
app.journal.myRankingPage.MyRankingListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['journal-myRankingPage-MyRankingListItemView']),

    events: {},

    onItemClick: function() {},

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        var data = this.model.toJSON();
        data.ranking_diff = Number(data.summed_ranking) - Number(data.summed_original_ranking);
        this.$el.html(this.template(data));
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    }
});

},{}],171:[function(require,module,exports){
arguments[4][163][0].apply(exports,arguments)
},{"dup":163}],172:[function(require,module,exports){
app.pkg('journal.myRankingPage');
app.journal.myRankingPage.MyRankingPageBootstrap = function() {
    new app.journal.myRankingPage.MyRankingListView({
        el: $('[data-content="ranking-items-list"]'),
        collection: new app.journal.myRankingPage.MyRankingRecordsCollection(),
        listItemDisplayViewType: app.journal.myRankingPage.MyRankingListItemView,
        template: app.templates['journal-myRankingPage-MyRankingListView']
    });
    $('[data-main-menu-item="journals"]').addClass("active");
    $('[data-sidebar-menu-item="my-ranking"]').addClass("active");

};

},{}],173:[function(require,module,exports){
app.pkg("journal.myRankingPage");

app.journal.myRankingPage.MyRankingRecordsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/journal/ranking/my/paginated',
    parse: function(resp, xhr) {
        this.itemsCount = resp.count;
        this.sum = resp.sum;
        this.summed_driver_ranking = resp.summed_driver_ranking;
        return resp.collection;
    }
});

},{}],174:[function(require,module,exports){
require('./MyRankingPageBootstrap');
require('./MyRankingListView');
require('./MyRankingListItemView');
require('./MyRankingsRecordsCollection');










},{"./MyRankingListItemView":170,"./MyRankingListView":171,"./MyRankingPageBootstrap":172,"./MyRankingsRecordsCollection":173}],175:[function(require,module,exports){
app.pkg("league");

app.league.LeagueDataModel = Backbone.Model.extend({
    validation: {
        name: {
            required: true
        },
        code: {
            required: true
        },

        referee_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_score_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_time_ranking: {
            required: true,
            pattern: 'number'
        },
        commissioner_ranking: {
            required: true,
            pattern: 'number'
        },
        delegate_ranking: {
            required: true,
            pattern: 'number'
        },
        referee_appointment_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_appointment_ranking: {
            required: true,
            pattern: 'number'
        },
        trip_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_4_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_5_ranking: {
            required: true,
            pattern: 'number'
        },

        secretary_statistics_2_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_statistics_3_ranking: {
            required: true,
            pattern: 'number'
        },
        secretary_information_ranking: {
            required: true,
            pattern: 'number'
        },

    },

    urlRoot: '/api/service/league/data'
});

},{}],176:[function(require,module,exports){
app.pkg("league");

app.league.LeaguesCollection = Backbone.Collection.extend({
    url: '/api/service/league/full/list'
});

},{}],177:[function(require,module,exports){
require('./leagueDisplayPage');
require('./leagueEditPage');
require('./leaguesPage');
require('./LeagueDataModel');
require('./LeaguesCollection');






},{"./LeagueDataModel":175,"./LeaguesCollection":176,"./leagueDisplayPage":180,"./leagueEditPage":183,"./leaguesPage":188}],178:[function(require,module,exports){
app.pkg('league.leagueDisplayPage');
app.league.leagueDisplayPage.LeagueDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['league-leagueDisplayPage-LeagueDataDisplayView']),


    events: {},

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    window.location.href = "/leagues";
                }
            });
        } else {
            window.location.href = "/leagues";
        }
    }

});

},{}],179:[function(require,module,exports){
app.pkg('league.leagueDisplayPage');
app.league.leagueDisplayPage.LeagueDisplayPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.league.LeagueDataModel({
        id: id
    });

    new app.league.leagueDisplayPage.LeagueDataDisplayView({
        el: $('[data-content="league-data-display"]'),
        model: model
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-league"]').addClass("active");
    } else $('[data-sidebar-menu-item="leagues"]').addClass("active");
};

},{}],180:[function(require,module,exports){
require('./LeagueDataDisplayView');
require('./LeagueDisplayPageBootstrap');






},{"./LeagueDataDisplayView":178,"./LeagueDisplayPageBootstrap":179}],181:[function(require,module,exports){
app.pkg('league.leagueEditPage');
app.league.leagueEditPage.LeagueEditPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.league.LeagueDataModel({
        id: id
    });

    new app.league.leagueEditPage.LeagueFormView({
        el: $('[data-content="league-form"]'),
        model: model
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-league"]').addClass("active");
        $(".page-title").text("Pridėti lygą");

    } else $('[data-sidebar-menu-item="leagues"]').addClass("active");
};

},{}],182:[function(require,module,exports){
app.pkg('league.leagueEditPage');
app.league.leagueEditPage.LeagueFormView = Backbone.FormView.extend({

    template: _.template(app.templates['league-leagueEditPage-LeagueFormView']),

    additionalEvents: {},

    additionalInitializeActions: function () {
        Backbone.Validation.bind(this);
    },

    additionalSaveSuccess: function (wasNew) {
        if (wasNew) {
            app.openLeagueEditPage(this.model.id);
        }
    },

    setModelValues: function () {
        this.$('#name').val(this.model.get('name'));
        this.$('#code').val(this.model.get('code'));
        this.$('#referee_ranking').val(this.model.get('referee_ranking'));
        this.$('#secretary_score_ranking').val(this.model.get('secretary_score_ranking'));
        this.$('#secretary_statistics_ranking').val(this.model.get('secretary_statistics_ranking'));
        this.$('#secretary_time_ranking').val(this.model.get('secretary_time_ranking'));

        this.$('#secretary_4_ranking').val(this.model.get('secretary_4_ranking'));
        this.$('#secretary_5_ranking').val(this.model.get('secretary_5_ranking'));

        this.$('#secretary_statistics_2_ranking').val(this.model.get('secretary_statistics_2_ranking'));
        this.$('#secretary_statistics_3_ranking').val(this.model.get('secretary_statistics_3_ranking'));
        this.$('#secretary_information_ranking').val(this.model.get('secretary_information_ranking'));


        this.$('#trip_ranking').val(this.model.get('trip_ranking'));
        this.$('#commissioner_ranking').val(this.model.get('commissioner_ranking'));
        this.$('#delegate_ranking').val(this.model.get('delegate_ranking'));
        this.$('#referee_appointment_ranking').val(this.model.get('referee_appointment_ranking'));
        this.$('#secretary_appointment_ranking').val(this.model.get('secretary_appointment_ranking'));

        this.$('#commissioner_remotely_ranking').val(this.model.get('commissioner_remotely_ranking'));

        if (this.model.get('invoiceable')) {
            this.$('#invoiceable').attr('checked', 'checked');
        }
        if (this.model.get('is_small')) {
            this.$('#is_small').attr('checked', 'checked');
        }
        if (this.model.get('in_cash')) {
            this.$('#in_cash').attr('checked', 'checked');
        }
        if (this.model.get('payed_by_other')) {
            this.$('#payed_by_other').attr('checked', 'checked');
        }
        if (this.model.get('split_rankings')) {
            this.$('#split_rankings').attr('checked', 'checked');
        }
    },

    getNewModelInstance: function () {
        return new app.league.LeagueDataModel({
            id: null
        });
    }
});

},{}],183:[function(require,module,exports){
require('./LeagueEditPageBootstrap');
require('./LeagueFormView');






},{"./LeagueEditPageBootstrap":181,"./LeagueFormView":182}],184:[function(require,module,exports){
app.pkg("league.leaguesPage");

app.league.leaguesPage.LeaguesCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/leagues/all/with-groups'
});

},{}],185:[function(require,module,exports){
app.pkg('league.leaguesPage');
app.league.leaguesPage.LeaguesListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['league-leaguesPage-LeaguesListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="remove-element"]': "removeLeague"
    },

    onItemClick: function() {
        app.openLeagueDisplayPage(this.model.id);
    },

    removeLeague: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.urlRoot = '/api/service/leagues/all';
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));

                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/league/edit/" + this.model.id);
        this.$('[data-action="preview-element"]').attr("href", "/league/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        return this;
    }



});

},{}],186:[function(require,module,exports){
app.pkg('league.leaguesPage');
app.league.leaguesPage.LeaguesListView = Backbone.LazyLoadListView.extend({

    render: function() {
        this.$el.html(this.template());
        this.initScroll();
        return this;
    },

    getCollectionElementsDisplayDiv: function() {
        return this.$('#leagues-list tbody');
    }

});

},{}],187:[function(require,module,exports){
app.pkg('league.leaguesPage');
app.league.leaguesPage.LeaguesPageBootstrap = function() {
    new app.league.leaguesPage.LeaguesListView({
        el: $('[data-content="leagues-list"]'),
        collection: new app.league.leaguesPage.LeaguesCollection(),
        listItemDisplayViewType: app.league.leaguesPage.LeaguesListItemView,
        template: app.templates['league-leaguesPage-LeaguesListView']
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    $('[data-sidebar-menu-item="leagues"]').addClass("active");
};

},{}],188:[function(require,module,exports){
require('./LeaguesCollection');
require('./LeaguesListItemView');
require('./LeaguesListView');
require('./LeaguesPageBootstrap');






},{"./LeaguesCollection":184,"./LeaguesListItemView":185,"./LeaguesListView":186,"./LeaguesPageBootstrap":187}],189:[function(require,module,exports){
app.pkg("leagueGroup");

app.league.LeagueGroupDataModel = Backbone.Model.extend({
    validation: {
        name: {
            required: true
        },

    },

    urlRoot: '/api/service/league-group/data'
});

},{}],190:[function(require,module,exports){
require('./leagueGroupsPage');
require('./leagueGroupEditPage');
require('./leagueGroupDisplayPage');
require('./LeagueGroupDataModel');






},{"./LeagueGroupDataModel":189,"./leagueGroupDisplayPage":193,"./leagueGroupEditPage":196,"./leagueGroupsPage":201}],191:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupDisplayPage");

app.leagueGroup.leagueGroupDisplayPage.LeagueGroupDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['leagueGroup-leagueGroupDisplayPage-LeagueGroupDataDisplayView']),

    events: {},

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderLeagues();
        return this;
    },

    renderLeagues: function() {
        _(this.model.get("leagues")).each(function(model) {
            this.$('[data-content="leagues"]').append('<a href="/league/' + model.id + '">' + model.name + '</a><br/>');
        }, this);
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    window.location.href = "/league-groups";
                }
            });
        } else {
            window.location.href = "/league-groups";
        }
    }

});

},{}],192:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupDisplayPage");

app.leagueGroup.leagueGroupDisplayPage.LeagueGroupDisplayPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.league.LeagueGroupDataModel({
        id: id
    });

    new app.leagueGroup.leagueGroupDisplayPage.LeagueGroupDataDisplayView({
        el: $('[data-content="league-group-data-display"]'),
        model: model
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-league-group"]').addClass("active");

    } else {
        $('[data-sidebar-menu-item="league-groups"]').addClass("active");
    }
};

},{}],193:[function(require,module,exports){
require('./LeagueGroupDataDisplayView');
require('./LeagueGroupDisplayPageBootstrap');






},{"./LeagueGroupDataDisplayView":191,"./LeagueGroupDisplayPageBootstrap":192}],194:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsEditPage");

app.leagueGroup.leagueGroupsEditPage.LeagueGroupEditPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.league.LeagueGroupDataModel({
        id: id
    });

    new app.leagueGroup.leagueGroupsEditPage.LeagueGroupFormView({
        el: $('[data-content="league-form"]'),
        model: model
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-league-group"]').addClass("active");
        $(".page-title").text("Pridėti lygų grupę");

    } else {
        $('[data-sidebar-menu-item="league-groups"]').addClass("active");
    }
};

},{}],195:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsEditPage");
app.leagueGroup.leagueGroupsEditPage.LeagueGroupFormView = Backbone.FormView.extend({

    template: _.template(app.templates['leagueGroup-leagueGroupsEditPage-LeagueGroupFormView']),

    additionalEvents: {},

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
        this.leaguesCollection = new app.league.LeaguesCollection();
    },

    additionalRender: function() {
        this.renderLeaguesSelection();

    },

    renderLeaguesSelection: function() {
        var self = this;
        if (this.leaguesCollection) {
            this.leaguesCollection.fetch({
                data: {},
                success: function() {
                    self.initSelect2();
                }
            });
        } else {
            this.$('[data-content="leagues-selection"]').hide();
        }
    },

    initSelect2: function() {
        var self = this;
        this.$('#leagues').select2({
            placeholder: "Pasirinkite lygą",
            allowClear: true,
            multiple: true,
            query: function(query) {
                var data = {
                    results: []
                };
                _(self.leaguesCollection.models).each(function(model) {
                    if (query.term.length === 0 ||
                        model.get("name").toUpperCase().indexOf(query.term.toUpperCase()) >= 0) {
                        data.results.push({
                            id: model.get("id"),
                            text: model.get("name")
                        });
                    }
                }, this);
                query.callback(data);
            }
        });
        var data = [];
        _(self.model.get("leagues")).each(function(model) {
            data.push({
                id: model.id,
                text: model.name
            });
        }, this);
        this.$('#leagues').select2('data', data);
    },

    getDynamicFormVals: function(formVals) {
        if (!formVals) {
            formVals = {};
        }
        formVals.leagues = this.$('#leagues').val();
        return formVals;
    },

    setModelValues: function() {
        this.$('#name').val(this.model.get('name'));
        this.$('#api_key').val(this.model.get('api_key'));
        if (this.model.get('has_api')) {
            this.$('#has_api').attr('checked', 'checked');
        }
        if (this.model.get('is_archived')) {
            this.$('#is_archived').attr('checked', 'checked');
        }
        if (this.model.get('balance_calculation_enabled')) {
            this.$('#balance_calculation_enabled').attr('checked', 'checked');
        }


    },

    getNewModelInstance: function() {
        return new app.league.LeagueGroupDataModel({
            id: null
        });
    },

    additionalSaveSuccess: function(wasNew) {
        if (wasNew) {
            app.openLeagueGroupEditPage(this.model.id);
        }
    }
});

},{}],196:[function(require,module,exports){
require('./LeagueGroupEditPageBootstrap');
require('./LeagueGroupFormView');






},{"./LeagueGroupEditPageBootstrap":194,"./LeagueGroupFormView":195}],197:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsPage");
app.leagueGroup.leagueGroupsPage.LeagueGroupsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/league-groups/all'
});

},{}],198:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsPage");

app.leagueGroup.leagueGroupsPage.LeagueGroupsListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['leagueGroup-leagueGroupsPage-LeagueGroupsListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="remove-element"]': "removeLeague"
    },

    onItemClick: function() {
        app.openLeagueGroupDisplayPage(this.model.id);
    },

    removeLeague: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.urlRoot = '/api/service/league-groups/all';
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));

                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/league-groups/edit/" + this.model.id);
        this.$('[data-action="preview-element"]').attr("href", "/league-groups/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        return this;
    }



});

},{}],199:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsPage");
app.leagueGroup.leagueGroupsPage.LeagueGroupsListView = Backbone.LazyLoadListView.extend({

    FILTERS_COOKIE_NAME: "LEAGUE_GROUPS_FILTER",
    SAVE_FILTERS: true,

    getDefaultValueForFilter: function (key) {
        if (!this.SAVE_FILTERS) {
            return undefined;
        }
        var cookieValue = app.getCookie(this.FILTERS_COOKIE_NAME);
        if (cookieValue) {
            var defaultFilterValues = JSON.parse(cookieValue);
            return defaultFilterValues[key]
        } else {
            return undefined;
        }
    },

    additionalRender: function () {
        this.initArchivedFilter();
    },

    onFilterChange: function () {
        console.log('FILTER CHANGED');
        this.resetCollection();
        this.fetchCollection();
    },

    initArchivedFilter: function () {
        this.$("#is_archived").val(this.getDefaultValueForFilter("is_archived"));
        this.$("#is_archived").change(this.onFilterChange);
    },


    getCollectionElementsDisplayDiv: function() {
        return this.$('#league-groups-list tbody');
    },

    getIsArchivedValue: function () {
        return this.$("#is_archived").val() || "no";
    },

    getFetchParams: function () {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        filters.is_archived = this.getIsArchivedValue();
        return filters;
    },

    saveFilterValue: function(){
        var filters = this.getFetchParams();
        if (this.SAVE_FILTERS) {
            app.setCookie(this.FILTERS_COOKIE_NAME, JSON.stringify(filters));
        }
    },

    afterSuccessFetch: function(){
        this.saveFilterValue();
    },


});

},{}],200:[function(require,module,exports){
app.pkg("leagueGroup.leagueGroupsPage");
app.leagueGroup.leagueGroupsPage.LeagueGroupssPageBootstrap = function() {
    new app.leagueGroup.leagueGroupsPage.LeagueGroupsListView({
        el: $('[data-content="league-groups-list"]'),
        collection: new app.leagueGroup.leagueGroupsPage.LeagueGroupsCollection(),
        listItemDisplayViewType: app.leagueGroup.leagueGroupsPage.LeagueGroupsListItemView,
        template: app.templates['leagueGroup-leagueGroupsPage-LeagueGroupsListView']
    });
    $('[data-main-menu-item="leagues"]').addClass("active");
    $('[data-sidebar-menu-item="league-groups"]').addClass("active");
};

},{}],201:[function(require,module,exports){
require('./LeagueGroupsCollection');
require('./LeagueGroupsListItemView');
require('./LeagueGroupsListView');
require('./LeagueGroupsPageBootstrap');






},{"./LeagueGroupsCollection":197,"./LeagueGroupsListItemView":198,"./LeagueGroupsListView":199,"./LeagueGroupsPageBootstrap":200}],202:[function(require,module,exports){
app.pkg("post");
app.post.PostDataModel = Backbone.Model.extend({
    validation: {
        content: {
            required: true
        },
        title: {
            required: true
        }
    },

    urlRoot: '/api/service/post/data'
});

},{}],203:[function(require,module,exports){
app.pkg("post");
app.post.PostsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/posts/all'
});

},{}],204:[function(require,module,exports){
require('./PostDataModel');
require('./PostsCollection');
require('./postEditPage');






},{"./PostDataModel":202,"./PostsCollection":203,"./postEditPage":207}],205:[function(require,module,exports){
app.pkg('post.postEditPage');
app.post.postEditPage.PostEditPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.post.PostDataModel({
        id: id
    });

    new app.post.postEditPage.PostFormView({
        el: $('[data-content="post-form"]'),
        model: model
    });
};

},{}],206:[function(require,module,exports){
app.pkg('post.postEditPage');
app.post.postEditPage.PostFormView = Backbone.FormView.extend({

    template: _.template(app.templates['post-postEditPage-PostFormView']),

    additionalEvents: {
        'click [data-action="delete-record"]': 'deletePost'
    },

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
    },

    additionalRender: function() {
        if (!this.model.isNew()) {
            this.$('[data-value="send-mail"]').hide();
        } else {
            this.$('[data-action="delete-record"]').remove();
        }
    },

    setModelValues: function() {
        this.$('#title').val(this.model.get('title'));
        this.$('#content').val(this.model.get('content'));
        this.$('#send_mail').attr('checked', 'checked');

        if (this.model.get('important')) {
            this.$('#important').attr('checked', 'checked');
        }

        tinymce.init({
            selector: "#content",
            height: 300,
            plugins: "link, paste",
            paste_use_dialog: true,
            paste_auto_cleanup_on_paste: true,
            toolbar: " fontsizeselect | sizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link",
            style_formats: [],
            language: app.currentLocale
        });
    },

    getNewModelInstance: function() {
        return new app.post.PostDataModel({
            id: null
        });
    },

    additionalSaveSuccess: function(wasNew) {
        if (wasNew) {
            app.openPostEditPage(this.model.id);
        }
    },


    deletePost: function(e) {
        e.preventDefault();
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    window.location.href = "/";
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
    },

    getFormValues: function() {
        var formVals = {};
        this.$("input[type=text], input[type=email], textarea, select").each(function() {
            formVals[$(this).attr("name")] = $(this).val();
        });

        this.$("input[type=checkbox]").each(function() {
            formVals[$(this).attr("name")] = $(this).is(':checked');
        });

        formVals.content = tinymce.get('content').getContent();
        return formVals;
    }
});

},{}],207:[function(require,module,exports){
require('./PostEditPageBootstrap');
require('./PostFormView');






},{"./PostEditPageBootstrap":205,"./PostFormView":206}],208:[function(require,module,exports){
require('./reportsPage');

},{"./reportsPage":212}],209:[function(require,module,exports){
app.pkg('report.reportsPage');
app.report.reportsPage.ReportsPageBootstrap = function(id) {

    new app.report.reportsPage.ReportsPageFormView({
        el: $('[data-content="reports-form"]'),
        model: new app.report.reportsPage.ReportsPageModel()
    });

    $('[data-main-menu-item="reports"]').addClass("active");
    $('[data-sidebar-menu-item="reports"]').addClass("active");

};

},{}],210:[function(require,module,exports){
app.pkg('report.reportsPage');
app.report.reportsPage.ReportsPageFormView = Backbone.View.extend({

    template: _.template(app.templates['report-reportsPage-ReportsPageFormView']),

    events: {
        'click [data-action="game-schedule-report"]': 'getGameScheduleReport',
        'click [data-action="cancelation-suspension-report"]': 'getCancelationSuspensionReport',
        'click [data-action="team-people-report"]': 'getTeamPeopleReport',
        'click [data-action="team-expenses-report"]': 'getTeamExpensesReport',
        'click [data-action="league-people-report"]': 'getLeaguePeopleReport',
        'click [data-action="team-player-report"]': 'saveRecord'
    },

    initialize: function() {
        this.render();

    },

    render: function() {
        this.$el.html(this.template());
        this.additionalRender();
        return this;
    },

    additionalRender: function() {
        var startDate = new Date();
        startDate.setDate(1);
        startDate.setMonth(startDate.getMonth() - 1);
        var maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 5);

        this.rangeFilterView = new app.components.rangeSelectionFilter.RangeSelectionFilterView({
            maxDate: maxDate,
            dafault_from: startDate,
            default_to: new Date()
        });
        this.$('.range-filter').append(this.rangeFilterView.el);
    },

    getFilterValues: function() {
        return this.rangeFilterView.getFilterValues();
    },

    isValid: function(filterValues) {
        if (!filterValues.date_from || !filterValues.date_to) {
            app.displayAlertMessage("error", app.getMessage('errorSelectRangeMessageTitle'), app.getMessage('errorSelectRangeMessageTitle'));
            return false;
        }
        return true;
    },

    getReport: function(url) {
        var filterValues = this.getFilterValues();
        if (this.isValid(filterValues)) {
            window.open(url + "?" + $.param(filterValues),
                '_blank');
        }
    },

    getTeamPeopleReport: function() {
        this.getReport("/api/reports/team-people-report");
    },

    getGameScheduleReport: function() {
        this.getReport("/api/reports/game-schedule-report");
    },

    getCancelationSuspensionReport: function() {
        this.getReport("/api/reports/canceled-appointments-report");
    },

    getLeaguePeopleReport: function (){
        this.getReport("/api/reports/league-people-report");
    },

    getTeamExpensesReport: function(){
        this.getReport("/api/reports/team-expenses-report");
    }

});

},{}],211:[function(require,module,exports){
app.pkg("report.reportsPage");

app.report.reportsPage.ReportsPageModel = Backbone.Model.extend({
    validation: {
        // first_name: {
        //     required: true
        // },
        // last_name: {
        //     required: true
        // },
        // email: {
        //     required: true,
        //     pattern: 'email'
        // },

        // invoice_number: function (value) {
        //     if (value) {
        //         if (!value.toString().match(/^\d+$/)) {
        //             return 'Sąskaitos numeris turi būti skaičius';
        //         }
        //     }
        // },

        // invoice_serial: {
        // },

        // invoice_seller_info: {
        // }
    },

    //urlRoot: '/service/user/data'
});

},{}],212:[function(require,module,exports){
require('./ReportsPageFormView');
require('./ReportsPageModel');
require('./ReportsPageBootstrap');

},{"./ReportsPageBootstrap":209,"./ReportsPageFormView":210,"./ReportsPageModel":211}],213:[function(require,module,exports){
app.pkg('schedule.fullSchedule');
app.schedule.fullSchedule.FullSchedulePageBootstrap = function() {
    new app.components.gamesList.GamesListView({
    	FILTERS_COOKIE_NAME: "FULL_SCHEDULE_PAGE_LIST_FILTER",
        el: $('[data-content="games-list"]'),
        collection: new app.components.gamesList.GamesCollection(),
        listItemDisplayViewType: app.components.gamesList.GamesListItemView
    });
    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="full-schedule"]').addClass("active");

};

},{}],214:[function(require,module,exports){
require('./FullSchedulePageBootstrap');






},{"./FullSchedulePageBootstrap":213}],215:[function(require,module,exports){
require('./fullSchedulePage');
require('./mySchedulePage');
require('./scheduleExportPage');







},{"./fullSchedulePage":214,"./mySchedulePage":218,"./scheduleExportPage":221}],216:[function(require,module,exports){
app.pkg("schedule.mySchedule");

app.schedule.mySchedule.MyScheduleGamesCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/games/my/paginated'
});

},{}],217:[function(require,module,exports){
app.pkg('schedule.mySchedule');
app.schedule.mySchedule.MySchedulePageBootstrap = function() {
    new app.components.gamesList.GamesListView({
    	FILTERS_COOKIE_NAME: "MY_SCHEDULE_PAGE_LIST_FILTER",
        el: $('[data-content="games-list"]'),
        collection: new app.schedule.mySchedule.MyScheduleGamesCollection(),
        listItemDisplayViewType: app.components.gamesList.GamesListItemView
    });
    $('[data-value="league-type-filter"]').hide();


    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="my-schedule"]').addClass("active");

};

},{}],218:[function(require,module,exports){
require('./MyScheduleGamesCollection');
require('./MySchedulePageBootstrap');






},{"./MyScheduleGamesCollection":216,"./MySchedulePageBootstrap":217}],219:[function(require,module,exports){
app.pkg('schedule.scheduleExport');
app.schedule.scheduleExport.ScheduleExportPageBootstrap = function() {
    new app.schedule.scheduleExportPage.ScheduleExportView({
        el: $('[data-content="schedule-export"]')
    });
    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="schedule-export"]').addClass("active");

};

},{}],220:[function(require,module,exports){
app.pkg('schedule.scheduleExportPage');
app.schedule.scheduleExportPage.ScheduleExportView = Backbone.View.extend({
    template: _.template(app.templates['schedule-scheduleExportPage-ScheduleExportView']),

    events: {
        'click [data-action="export"]': 'onExportClick',
        'click [data-action="export-custom-date"]': 'onExportForCustomDateClick'

    },

    initialize: function () {
        _.bindAll(this);
        this.render();
    },

    render: function () {
        this.$el.html(this.template());
        this.renderFilters();
        return this;
    },

    renderFilters: function () {
        this.filterView = new app.components.monthSelectionFilter.MonthSelectionFilterView();
        this.$el.prepend(this.filterView.el);
        this.filterView.bind('filterChanged', this.onFilterChanged, this);
    },

    onExportClick: function () {
        var filterValues = this.filterView.getFilterValues();
        window.open("/api/schedule/data/export?year=" + filterValues.year + "&month=" + filterValues.month, '_blank');
    },

    onExportForCustomDateClick: function () {
        var filterValues = this.filterView.getFilterValues();
        window.open("/api/schedule/data/export-custom-date?year=" + filterValues.year + "&month=" + filterValues.month,
            '_blank');
    }





});

},{}],221:[function(require,module,exports){
require('./ScheduleExportView');
require('./ScheduleExportPageBootstrap');







},{"./ScheduleExportPageBootstrap":219,"./ScheduleExportView":220}],222:[function(require,module,exports){
require('./statisticsPage');

},{"./statisticsPage":230}],223:[function(require,module,exports){
app.pkg('statistics.statisticsPage');
app.statistics.statisticsPage.StatisticsPageBootstrap = function () {
    new app.statistics.statisticsPage.StatisticsPageContent({
        el: $('[data-content="statistics"]')
    });
    $('.admin-bar').hide();
    $('.content-bar').hide();
    $('[data-main-menu-item="statistics"]').addClass("active");


};

},{}],224:[function(require,module,exports){
app.pkg('statistics.statisticsPage');
app.statistics.statisticsPage.StatisticsPageContent = Backbone.View.extend({

    template: _.template(app.templates['statistic-statisticsPage-StatisticsPageContent']),
    events: {
        'click [data-action="execute-search"]': 'executeSearch'
    },

    executeSearch: function () {
        this.resultsView.resetCollection();
        this.resultsView.fetchCollection();
    },

    initialize: function () {
        _.bindAll(this);
        this.refsView = [];
        this.refsInputCount = 3;
        this.render();

    },

    getFilters() {
        var selectedRefs = [];
        this.refsView.forEach(function (refView) {
            var value = refView.getSelection();
            if (value) {
                selectedRefs.push(value);
            }
        });
        return {
            evaluation: this.$('[name="evaluation"]').val(),
            decision: this.$('[name="decision"]').val(),
            refs: selectedRefs,
            startDate: this.$('[data-content="start-date-selection"]').val(),
            endDate: this.$('[data-content="end-date-selection"]').val()
        }
    },

    render: function () {
        this.$el.html(this.template());
        this.resultsView = new app.statistics.statisticsPage.StatisticsResultsView({
            el: $('[data-content="statistics-list"]'),
            collection: new app.statistics.statisticsPage.StatisticsResultsCollection(),
            listItemDisplayViewType: app.statistics.statisticsPage.StatisticsResultItemView,
            template: app.templates['statistic-statisticsPage-StatisticsResultsView'],
            filterValues: this.getFilters
        });

        for (var i = 0; i < this.refsInputCount; i++) {
            var view = new app.statistics.statisticsPage.StatisticsRefereeInputView({
                model: new Backbone.Model({})
            });
            this.$('[data-content="refs-selection"]').append(view.el);
            this.refsView.push(view);
        }

        this.initDatePicker();

        return this;
    },

    initDatePicker: function () {

        this.$('[data-content="start-date-selection"]').datepicker({});
        this.$('[data-content="end-date-selection"]').datepicker({});
    },

});

},{}],225:[function(require,module,exports){
app.pkg('statistics.statisticsPage');
app.statistics.statisticsPage.StatisticsRefereeInputView = Backbone.FormView.extend({
    template: _.template(app.templates['statistic-statisticsPage-StatisticsRefereeInputView']),
    className: "span4",
    initialize: function () {
        _.bindAll(this);
        this.suggestionsColl = new app.user.UserSuggestionsCollection();
        this.render();
    },

    events: {
        'blur [data-value="appointment-user"]': 'onInputBlur'
    },

    render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        this.initUserDisplay();
        this.addSuggestionBox();
        app.addTooltips(this.$el);
        return this;
    },

    initUserDisplay: function () {
        if (this.model.id !== null) {
            this.$('#user_name').val(this.model.get("short_name"));
        }
    },

    getSuggestionCollection: function (query, elementToSendResponse) {

        if (!app.isStringEmpty(query)) {
            var type = 'referee';
            var view = this;
            this.suggestionsColl.fetch({
                data: {
                    query: query,
                    type: type
                },
                success: function () {
                    view.buildSuggestionsList(elementToSendResponse, query);
                    return [];
                }
            });
        } else return [];

    },
    buildSuggestionsList: function (elementToSendResponse, query) {
        var result = [];
        _(this.suggestionsColl.models).each(function (model) {
            result.push({
                id: model.id,
                name: model.get('first_name') + " " + model.get('last_name'),
            });
        }, this);
        if (elementToSendResponse !== null)
            elementToSendResponse.process(result);
        return result;
    },


    addSuggestionBox: function () {
        var view = this;
        this.$('[data-value="appointment-user"]').typeahead({
            source: function (query) {
                view.getSuggestionCollection(query, this);
                return [];
            },
            onselect: function (obj) {
                view.selectElement(obj);
            },
            listItemPropToMatch: "name"
        });
    },

    getSelection: function () {
        return this.model ? this.model.id : null
    },

    selectElement: function (selectedObj) {
        var model = this.suggestionsColl.get(selectedObj.id);
        this.model = model;
        if (model !== undefined) {
            this.$('[data-value="appointment-user"]').val(model.get("short_name"));
        }
    },

    onInputBlur: function () {
        var view = this;
        setTimeout(function () {
            if (view.$('[data-value="appointment-user"]').val() === "") {
                view.selectElement({
                    id: null,
                    name: ""
                });
            } else {
                if (view.model.id === null) {
                    view.$('[data-value="appointment-user"]').val("");
                    view.$('[data-value="appointment-user"]').val(null);
                } else view.$('[data-value="appointment-user"]').val(view.model.get('short_name'));
            }
        }, 300);
        return false;
    }
});

},{}],226:[function(require,module,exports){
app.pkg('statistics.statisticsPage');
app.statistics.statisticsPage.StatisticsResultItemView = Backbone.View.extend({
    tagName: 'div',
    className: 'statistic-result-item',
    template: _.template(app.templates['statistic-statisticsPage-StatisticsResultItemView']),

    initialize: function () {
        _.bindAll(this);
        this.render();
    },

    renderVideos: function (videos) {
        for (var i = 0; i < videos.length; i++) {
            var view = new app.statistics.statisticsPage.StatisticsVideoDisplay({
                model: new Backbone.Model(videos[i])
            });
            this.$('[data-content="videos"]').append(view.el);
        }
    },


    render: function () {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="preview"]').attr("href", "/game-evaluation/" + this.model.get('original_id'));
        this.renderVideos([this.model.get('content')])
        return this;
    }


});

},{}],227:[function(require,module,exports){
app.pkg("statistics.statisticsPage");

app.statistics.statisticsPage.StatisticsResultsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/statistics/list'
});

},{}],228:[function(require,module,exports){
app.pkg("statistics.statisticsPage");
app.statistics.statisticsPage.StatisticsResultsView = Backbone.LazyLoadListView.extend({

    render: function () {
        this.$el.html(this.template());
        this.initScroll();
        return this;

    },

    additionalInitializeActions: function () {
        //Do not load initial data
    },

    initScroll: function () {
        var el = $('.scrollable-content'),
          view = this,
          callback = function () {
              if (!view.isLoading) {
                  view.loadNextPage();
              }
          };
        app.addScrollBar(el, this.getScrollableContentOffset(), callback, this.disableScroll);
    },

    updateScrollbar: function () {
        if ($('.mCustomScrollbar').length > 0) {
            $('.scrollable-content').mCustomScrollbar('scrollTo', 'top');
        }

    },

    getFetchParams: function () {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;

        _.extend(filters, filters, this.options.filterValues());

        return filters;
    },

    renderCollectionElement: function (model) {
        var filters = this.getFetchParams();
        var view = new this.options.listItemDisplayViewType({
            model: model,
            filters: filters
        });

        this.getCollectionElementsDisplayDiv().append(view.el);
    },

    actionsAfterRender: function () {
        var resultItem = this.getCollectionElementsDisplayDiv().find('.total-items');
        if(resultItem){
            resultItem.remove();
        }
        this.getCollectionElementsDisplayDiv().prepend('<div class="total-items" style="margin-bottom: 20px">'+'Viso: ' + this.collection.itemsCount + '</div>');
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#statistics-list');
    }

});

},{}],229:[function(require,module,exports){
app.pkg('statistics.statisticsPage');
app.statistics.statisticsPage.StatisticsVideoDisplay = Backbone.View.extend({
    template: _.template(app.templates['statistic-statisticsPage-StatisticsVideoDisplay']),
    className: "evaluation-result-display evaluation-video-display row-fluid",

    initialize: function () {
        _.bindAll(this);
        this.render();
    },

    render: function () {
        var dataRaw = this.model.attributes;
        var data = {
            comment: dataRaw.comment || '',
            decision: dataRaw.decision || '',
            evaluation: dataRaw.evaluation || '',
            period: dataRaw.period || '',
            priority: dataRaw.priority || '',
            referee: dataRaw.referee || '',
            referee_id: dataRaw.referee_id || '',
            time: dataRaw.time || ''
        };
        this.$el.html(this.template(data));
    },

});

},{}],230:[function(require,module,exports){
require('./StatisticsPageContent');
require('./StatisticsResultsCollection');
require('./StatisticsResultItemView');
require('./StatisticsResultsView');
require('./StatisticsRefereeInputView');
require('./StatisticsVideoDisplay');
require('./StatisticsPageBootstrap');







},{"./StatisticsPageBootstrap":223,"./StatisticsPageContent":224,"./StatisticsRefereeInputView":225,"./StatisticsResultItemView":226,"./StatisticsResultsCollection":227,"./StatisticsResultsView":228,"./StatisticsVideoDisplay":229}],231:[function(require,module,exports){
app.pkg("test");

app.test.AnswerDataModel = Backbone.Model.extend({
    validation: {
        answer_text: {
            required: true
        }
    }
});

},{}],232:[function(require,module,exports){
app.pkg("test");

app.test.QuestionDataModel = Backbone.Model.extend({
    validation: {
        question_text: {
            required: true
        },

        question_video: [{
            required: function(value, attr, currentValues) {
                return currentValues.question_type === 'video';
            },
        }, {
            pattern: 'url',
            msg: ''
        }]
    }
});

},{}],233:[function(require,module,exports){
app.pkg("test");

app.test.TestDataModel = Backbone.Model.extend({
    validation: {
        description: {
            required: true
        },
        title: {
            required: true
        }
    },

    urlRoot: '/api/test/data'
});

},{}],234:[function(require,module,exports){
app.pkg("test");

app.test.TestsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/test/full/list'
});
},{}],235:[function(require,module,exports){
require('./testsPage');
require('./testEditPage');
require('./testResultsPage');
require('./testAnswersPage');
require('./testSolvePage');
require('./TestDataModel');
require('./QuestionDataModel');
require('./TestsCollection');
require('./AnswerDataModel');

},{"./AnswerDataModel":231,"./QuestionDataModel":232,"./TestDataModel":233,"./TestsCollection":234,"./testAnswersPage":240,"./testEditPage":246,"./testResultsPage":253,"./testSolvePage":259,"./testsPage":263}],236:[function(require,module,exports){
app.pkg("test.testAnswersPage");

app.test.testAnswersPage.TestAnswersDataModel = Backbone.Model.extend({
    urlRoot: '/api/test/answers/data'
});

},{}],237:[function(require,module,exports){
app.pkg('test.testAnswersPage');
app.test.testAnswersPage.TestAnswersPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    if (!id) {
        app.openHomePage();
    }
    var model = new app.test.testAnswersPage.TestAnswersDataModel({
        id: id
    });

    new app.test.testAnswersPage.TestAnswersView({
        el: $('[data-content="test-results"]'),
        model: model
    });
    $('[data-main-menu-item="tests"]').addClass("active");
    $('[data-sidebar-menu-item="tests"]').addClass("active");
};

},{}],238:[function(require,module,exports){
app.pkg('test.testAnswersPage');
app.test.testAnswersPage.TestAnswersQuestionResultsItemView = Backbone.View.extend({
    template: _.template(app.templates['test-testAnswersPage-TestAnswersQuestionResultsItemView']),
    questionItemTemplate: _.template(app.templates['test-testAnswersPage-TestAnswersQuestionAnswersItemView']),

    className: "row-fluid test-question-display-item",

    events: {},

    initialize: function () {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },

    render: function () {
        this.$el.html(this.template(this.model.attributes));
        this.renderAnswers();
        if (this.model.get("question_type") === 'video') {
            this.renderVideo();
        }

        if (this.model.get("question_answer_explanation") === null || !this.model.get("question_answer_explanation").length) {
            this.$('[data-content="question_answer_explanation"]').hide();
        }

        if (this.options.test.get("test_type") === "test" || !this.model.get("comment").length) {
            this.$('[data-content="comment"]').hide();
        }
        app.addTooltips();
        return this;
    },

    renderAnswerDisplay: function (model) {
        var modelValues = model.attributes;
        var html = "";
        if (this.options.test.get("test_type") === "test") {
            modelValues.isIconVisible = (model.id === this.model.get("selected_answer"));
            html = this.questionItemTemplate(modelValues);
            if (model.id === this.model.get("selected_answer") && !model.get("correct")) {
                this.$(".test-results-item").addClass("invalid");
            }
            html = '<div data-id="' + model.id + '" class="answer-item-row ' + (model.get("correct") ? 'correct' : '') + '">' + html + '</div>';
        } else {
            modelValues.isIconVisible = false;
            correctDisplayClass = this.options.test.get("test_type") === "test" ? 'correct' : 'correct-survey';
            html = '<div data-id="' + model.id + '" class="answer-item-row ' + (model.get("correct") ? correctDisplayClass : '') + '">' + this.questionItemTemplate(modelValues) + '</div>';
        }
        this.$('[data-content="answers-display"]').append(html);


    },

    renderAnswers: function () {
        var answers = this.model.get("test_question_answers"),
            self = this;
        answers = _.sortBy(answers, 'id');

        _(answers).each(function (answer) {
            self.renderAnswerDisplay(new Backbone.Model(answer));
        }, this);
    },

    renderVideo: function () {
        this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video")));
        if (this.model.get("question_video_1") && this.model.get("question_video_1").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_1")));
        }
        if (this.model.get("question_video_2") && this.model.get("question_video_2").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_2")));
        }
        if (this.model.get("question_video_3") && this.model.get("question_video_3").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_3")));
        }
    }
});

},{}],239:[function(require,module,exports){
app.pkg('test.testAnswersPage');
app.test.testAnswersPage.TestAnswersView = Backbone.View.extend({

    template: _.template(app.templates['test-testAnswersPage-TestAnswersView']),

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderQuestions();
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    app.openTestsPage();
                }
            });
        } else {
            app.openTestsPage();
        }
    },

    renderQuestionDisplay: function(model) {
        var questionView = new app.test.testAnswersPage.TestAnswersQuestionResultsItemView({
                model: model,
                test: this.model
            }),
            self = this;
        this.$('[data-content="test-questions"]').append(questionView.el);
    },

    renderQuestions: function() {
        var questions = this.model.get("test_questions"),
            self = this;
        _(questions).each(function(question) {
            self.renderQuestionDisplay(new Backbone.Model(question));
        }, this);
    }
});

},{}],240:[function(require,module,exports){
require('./TestAnswersView');
require('./TestAnswersPageBootstrap');
require('./TestAnswersDataModel');
require('./TestAnswersQuestionResultsItemView');

},{"./TestAnswersDataModel":236,"./TestAnswersPageBootstrap":237,"./TestAnswersQuestionResultsItemView":238,"./TestAnswersView":239}],241:[function(require,module,exports){
app.pkg("test.testEditPage");

app.test.testEditPage.TestEditDataModel = Backbone.Model.extend({
    validation: {
        description: {
            required: true
        },
        title: {
            required: true
        },
        solvable_until: {
            required: true
        }
    },

    urlRoot: '/api/test/edit/data'
});

},{}],242:[function(require,module,exports){
app.pkg('test.testEditPage');
app.test.testEditPage.TestEditPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.test.testEditPage.TestEditDataModel({
        id: id
    });
    new app.test.testEditPage.TestFormView({
        el: $('[data-content="test-form"]'),
        model: model
    });
    $('[data-main-menu-item="tests"]').addClass("active");
    $('[data-sidebar-menu-item="new-test"]').addClass("active");
};

},{}],243:[function(require,module,exports){
app.pkg('test.testEditPage');
app.test.testEditPage.TestFormView = Backbone.FormView.extend({

    template: _.template(app.templates['test-testEditPage-TestFormView']),
    questionInputViews: [],
    additionalEvents: {
        'click [data-action="add-question"]': 'addQuestion',
    },

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
    },

    additionalSaveSuccess: function(wasNew) {
        if (wasNew) {
            app.openTestEditPage(this.model.id);
        }
    },

    setModelValues: function() {
        this.$('#title').val(this.model.get('title'));
        this.$('#description').val(this.model.get('description'));
        this.$('#solvable_until').val(this.model.get('solvable_until'));
        this.$('#test_type').val(this.model.get('test_type'));

        if (this.model.get('enabled')) {
            this.$('#enabled').attr('checked', 'checked');
        }
    },

    getNewModelInstance: function() {
        return new app.test.TestDataModel({
            id: null
        });
    },

    additionalRender: function() {
        this.renderQuestionInputs();
        this.renderDatePicker();
    },

    renderDatePicker: function() {
        var self = this;
        this.$('#solvable_until').datepicker({
            onSelect: function() {
                var e = jQuery.Event("blur");
                e.target = this;
                self.validateField(e);
            }
        });
    },

    addQuestion: function() {
        this.renderQuestionInput(new app.test.QuestionDataModel({}));
    },

    renderQuestionInput: function(model) {
        var questionView = new app.test.testEditPage.TestQuestionInputView({
                model: model
            }),
            self = this;
        this.$('[data-content="test-questions"]').append(questionView.el);
        this.questionInputViews.push(questionView);
        questionView.bind('destroy', function() {
            var index = self.questionInputViews.indexOf(questionView);
            if (index > -1) {
                self.questionInputViews.splice(index, 1);
            }
            questionView.remove();
        }, this);
    },

    renderQuestionInputs: function() {
        this.questionInputViews = [];
        var questions = this.model.get("test_questions"),
            self = this;
        questions = _.sortBy(questions, 'id');
        _(questions).each(function(question) {
            self.renderQuestionInput(new app.test.QuestionDataModel(question));
        }, this);
        if (!questions || !questions.length) {
            this.addQuestion();
        }
    },

    isValid: function(data) {
        var isValid = true;
        _(this.questionInputViews).each(function(questionView) {
            if (!questionView.isValid(this.$('[name="test_type"]').val())) {
                isValid = false;
            }
        }, this);
        return !this.model.validate(data) && isValid;
    },


    getFormValues: function() {
        var formVals = {
            title: this.$('[name="title"]').val(),
            description: this.$('[name="description"]').val(),
            enabled: this.$('[name="enabled"]').is(':checked'),
            solvable_until: this.$('[name="solvable_until"]').val(),
            test_type: this.$('[name="test_type"]').val()
        };
        var questions = [];
        _(this.questionInputViews).each(function(view) {
            questions.push(view.getFormValues());
        }, this);
        formVals.test_questions = questions;
        return formVals;
    },

    saveRecord: function(e) {
        e.preventDefault();
        var view = this,
            wasNew = this.model.isNew(),
            formValues = this.getFormValues();
        if (this.isValid(formValues)) {
            app.displayLoadDialog();
            this.model.save(formValues, {
                success: function(model, response, options) {
                    if (wasNew) {
                        view.displaySuccessCreateMessage();
                        app.openTestEditPage(view.model.id);
                    } else {
                        view.displaySuccessUpdateMessage();
                    }
                    app.openTestEditPage(view.model.id);
                    app.hideLoadDialog();
                },
                error: function(model, response) {
                    app.hideLoadDialog();
                    view.displayErrorMessage(response.responseText.error);
                }
            });
        }
    }
});

},{}],244:[function(require,module,exports){
app.pkg('test.testEditPage');
app.test.testEditPage.TestQuestionAnswerInputView = Backbone.FormView.extend({
    template: _.template(app.templates['test-testEditPage-TestQuestionAnswerInputView']),
    className: "question-answer-input row-fluid",

    additionalEvents: {
        'click [data-action="delete-row"]': 'removeItem',
        'click [name="correct"]': 'correctClicked'

    },

    initialize: function() {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },

    setModelValues: function() {
        this.$('#answer_text').val(this.model.get('answer_text'));
        if (this.model.get('correct')) {
            this.$('#correct').attr('checked', 'checked');
        }
    },
    getDynamicFormVals: function(formVals) {
        formVals.id = this.model.id;
        return formVals;
    },
    correctClicked: function() {
        this.trigger("correct-selected");
    },

    isValid: function() {
        return this.isModelValid(this.getFormValues());
    },

    removeItem: function() {
        this.trigger("destroy");
    }
});

},{}],245:[function(require,module,exports){
app.pkg('test.testEditPage');
app.test.testEditPage.TestQuestionInputView = Backbone.FormView.extend({
    template: _.template(app.templates['test-testEditPage-TestQuestionInputView']),
    className: "question-input row-fluid",
    additionalEvents: {
        'click [data-action="add-answer"]': 'addAnswer',
        'click [data-action="delete-question"]': 'removeItem',
        'change [name="question_type"]': 'onQuestionTypeChange'
    },

    initialize: function () {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },

    setModelValues: function () {
        this.$('[name="question_type"]').val(this.model.get('question_type'));
        this.$('[name="question_text"]').val(this.model.get('question_text'));
        this.$('[name="question_video"]').val(this.model.get('question_video'));
        this.$('[name="question_video_1"]').val(this.model.get('question_video_1'));
        this.$('[name="question_video_2"]').val(this.model.get('question_video_2'));
        this.$('[name="question_video_3"]').val(this.model.get('question_video_3'));


        this.$('[name="question_answer_explanation"]').val(this.model.get('question_answer_explanation'));
        this.showCorrectFields();
    },

    additionalRender: function () {
        this.renderAnswers();
        this.showCorrectFields();
    },

    showCorrectFields: function () {
        if (this.$('[name="question_type"]').val() === "video") {
            this.$('[data-content="video-input"]').show();
        } else {
            this.$('[data-content="video-input"]').hide();
            this.$('#question_video').val('');
        }
    },

    onQuestionTypeChange: function () {
        this.showCorrectFields();
    },


    addAnswer: function () {
        this.renderAnswerInput(new app.test.AnswerDataModel({}));
    },

    renderAnswerInput: function (model) {
        var answerView = new app.test.testEditPage.TestQuestionAnswerInputView({
                model: model
            }),
            self = this;
        this.$('[data-content="question-answers"]').append(answerView.el);
        this.answerViews.push(answerView);
        answerView.bind('correct-selected', this.isValid, this);
        answerView.bind('destroy', function () {
            var index = self.answerViews.indexOf(answerView);
            if (index > -1) {
                self.answerViews.splice(index, 1);
            }
            answerView.remove();
        }, this);
    },

    renderAnswers: function () {
        this.answerViews = [];
        var answers = this.model.get("test_question_answers"),
            self = this;
        answers = _.sortBy(answers, 'id');

        _(answers).each(function (answer) {
            self.renderAnswerInput(new app.test.AnswerDataModel(answer));
        }, this);
        if (!answers || !answers.length) {
            this.addAnswer();
            this.addAnswer();
        }
    },

    removeItem: function () {
        this.trigger("destroy");
    },

    getDynamicFormVals: function (formVals) {
        var answers = [];
        _(this.answerViews).each(function (view) {
            answers.push(view.getFormValues());
        }, this);
        formVals.test_question_answers = answers;
        formVals.id = this.model.id;


        return formVals;
    },

    isModelValid: function (data, testType) {
        var isValid = true,
            hasCorrectSelected = false;
        _(this.answerViews).each(function (answerView) {
            if (!answerView.isValid()) {
                isValid = false;
            }
        }, this);
        if (testType === "test") {
            _(data.test_question_answers).each(function (answer) {
                if (answer.correct) {
                    hasCorrectSelected = true;
                }
            }, this);

            this.$('[data-content="no-correct-answer-selected"]').toggle(!hasCorrectSelected);
        } else {
            hasCorrectSelected = true;
        }
        return !this.model.validate(data) && isValid && hasCorrectSelected;
    },

    isValid: function (testType) {
        var formValues = this.getFormValues();
        return this.isModelValid(formValues, testType);
    }
});

},{}],246:[function(require,module,exports){
require('./TestEditPageBootstrap');
require('./TestFormView');
require('./TestQuestionInputView');
require('./TestQuestionAnswerInputView');
require('./TestEditDataModel');

},{"./TestEditDataModel":241,"./TestEditPageBootstrap":242,"./TestFormView":243,"./TestQuestionAnswerInputView":244,"./TestQuestionInputView":245}],247:[function(require,module,exports){
app.pkg('test.testResultsPage');
app.test.testResultsPage.TestGroupedResultsModalView = Backbone.View.extend({

    template: _.template(app.templates['test-testResultsPage-TestGroupedResultsModalView']),
    results: [],
    initialize: function() {
        _.bindAll(this);
        var self = this;
        $.ajax({
            url: '/api/test/results/data/' + this.options.testId + '/grouped',
            type: 'GET',
            error: function(request, status, error) {
                self.closeModal();
                app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));
            }
        }).done(function(data) {
            self.results = data;
            self.render();
        });
    },


    closeModal: function() {
        this.trigger("hide-modal");
    },


    render: function() {
        this.$el.html(this.template({}));
        this.renderResults();
        return this;
    },

    renderResults: function() {
        var elementToAppend = this.$('[data-content="results-display"]');
        _(this.results).each(function(result) {
            var correct = 0,
                incorrect = 0;
            _(result.answers).each(function(answer) {
                if (answer.correct) {
                    correct++
                } else {
                    incorrect++;
                }
            }, this);
            elementToAppend.append(
                '<tr><td>' + result.user.short_name + '</td><td>' + correct + '</td><td>' + incorrect + '</td></tr>');
        }, this);
    }


});

},{}],248:[function(require,module,exports){
app.pkg('test.testResultsPage');
app.test.testResultsPage.TestResultsAnswerUsersModalView = Backbone.View.extend({

    template: _.template(app.templates['test-testResultsPage-TestResultsAnswerUsersModalView']),
    users: [],
    initialize: function() {
        _.bindAll(this);
        var self = this;
        $.ajax({
            url: '/api/test/answer-users/' + this.options.answerId,
            type: 'GET',
            error: function(request, status, error) {
                self.closeModal();
                app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));
            }
        }).done(function(data) {
            self.users = data;
            self.render();
        });
    },

    closeModal: function() {
        this.trigger("hide-modal");
    },

    render: function() {
        this.$el.html(this.template({}));
        this.renderUsers();
        return this;
    },

    renderUsers: function() {
        var elementToAppend = this.$('[data-content="users-display"]'),
            self = this;
        _(this.users).each(function(result) {
            if (self.options.test.get("test_type") === "test") {
                elementToAppend.append('<div>' + result.user.short_name + '</div>');
            } else {
                elementToAppend.append('<div class="test-results-item with-margin-top"><span class="strong">' + result.user.short_name + '</span></br><span class="strong">Komentaras:</span></br>' + result.comment + '</div>');

            }
        }, this);
    }


});

},{}],249:[function(require,module,exports){
app.pkg("test.testResultsPage");

app.test.testResultsPage.TestResultsDataModel = Backbone.Model.extend({
    urlRoot: '/api/test/results/data'
});

},{}],250:[function(require,module,exports){
app.pkg('test.testResultsPage');
app.test.testResultsPage.TestResultsPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    if (!id) {
        app.openHomePage();
    }
    var model = new app.test.testResultsPage.TestResultsDataModel({
        id: id
    });

    new app.test.testResultsPage.TestResultsView({
        el: $('[data-content="test-results"]'),
        model: model
    });
    $('[data-main-menu-item="tests"]').addClass("active");
    $('[data-sidebar-menu-item="tests"]').addClass("active");
};

},{}],251:[function(require,module,exports){
app.pkg('test.testResultsPage');
app.test.testResultsPage.TestResultsQuestionResultsItemView = Backbone.View.extend({
    template: _.template(app.templates['test-testResultsPage-TestResultsQuestionResultsItemView']),
    questionItemTemplate: _.template(app.templates['test-testResultsPage-TestResultsQuestionResultsItemAnswerView']),

    className: "row-fluid test-question-display-item",

    events: {
        'click [data-action="show-answer-users"]': 'showAnswerUsers'
    },

    initialize: function () {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },

    render: function () {
        this.$el.html(this.template(this.model.attributes));
        this.renderAnswers();
        if (this.model.get("question_type") === 'video') {
            this.renderVideo();
        }
        if (this.model.get("question_answer_explanation") === null || !this.model.get("question_answer_explanation").length) {
            this.$('[data-content="question_answer_explanation"]').hide();
        }
        app.addTooltips();
        return this;
    },

    renderAnswerDisplay: function (model) {
        var html = this.questionItemTemplate(model.attributes),
            correctDisplayClass = this.options.test.get("test_type") === "test" ? 'correct' : 'correct-survey';
        html = '<div data-id="' + model.id + '" class="answer-item-row ' + (model.get("correct") ? correctDisplayClass : '') + '">' + html + '</div>';
        this.$('[data-content="answers-display"]').append(html);

    },

    renderAnswers: function () {
        var answers = this.model.get("test_question_answers"),
            self = this;

        answers = _.sortBy(answers, 'id');

        _(answers).each(function (question) {
            self.renderAnswerDisplay(new Backbone.Model(question));
        }, this);
    },

    renderVideo: function () {
        this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video")));
        if (this.model.get("question_video_1") && this.model.get("question_video_1").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_1")));
        }
        if (this.model.get("question_video_2") && this.model.get("question_video_2").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_2")));
        }
        if (this.model.get("question_video_3") && this.model.get("question_video_3").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_3")));
        }
    },

    showAnswerUsers: function (el) {
        var answerId = $(el.target).closest(".answer-item-row").data("id");

        $('body').append(
            new app.components.modalWindow.ModalWindowView({
                contentView: app.test.testResultsPage.TestResultsAnswerUsersModalView,
                contentParams: {
                    answerId: answerId,
                    test: this.options.test
                },
                headerText: "Vartotojai pasirinkę atsakymą:"
            }).el
        );
    }
});

},{}],252:[function(require,module,exports){
app.pkg('test.testResultsPage');
app.test.testResultsPage.TestResultsView = Backbone.View.extend({

    template: _.template(app.templates['test-testResultsPage-TestResultsView']),

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },
    events: {
        'click [data-action="view-grouped-results"]': 'viewGroupedResults',
        'click [data-action="export-results"]': "exportResults"
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderQuestions();
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    app.openTestsPage();
                }
            });
        } else {
            app.openTestsPage();
        }
    },


    renderQuestionDisplay: function(model) {
        var questionView = new app.test.testResultsPage.TestResultsQuestionResultsItemView({
                model: model,
                test: this.model
            }),
            self = this;
        this.$('[data-content="test-questions"]').append(questionView.el);
    },

    renderQuestions: function() {
        var questions = this.model.get("test_questions"),
            self = this;
        questions = _.sortBy(questions, 'id');
        _(questions).each(function(question) {
            self.renderQuestionDisplay(new Backbone.Model(question));
        }, this);
    },

    viewGroupedResults: function() {
        var testId = this.model.id;

        $('body').append(
            new app.components.modalWindow.ModalWindowView({
                contentView: app.test.testResultsPage.TestGroupedResultsModalView,
                contentParams: {
                    testId: testId
                },
                headerText: app.getMessage('calculatedResults')

            }).el
        );
    },

    exportResults: function() {
        window.open("/api/tests/export/" + this.model.id);
        // app.displayLoadDialog();
        // $.ajax({
        //     url: "/api/tests/export/" + this.model.id,
        //     type: 'GET'
        // }).done(function(data) {
        //     app.hideLoadDialog();
        //     window.open("/pdf/" + data.file_name);
        // }).fail(function(jqxhr, status) {
        //     app.hideLoadDialog();
        //     app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), jqxhr.responseText);
        // });
    }
});

},{}],253:[function(require,module,exports){
require('./TestResultsView');
require('./TestResultsPageBootstrap');
require('./TestResultsDataModel');
require('./TestResultsQuestionResultsItemView');
require('./TestResultsAnswerUsersModalView');
require('./TestGroupedResultsModalView');

},{"./TestGroupedResultsModalView":247,"./TestResultsAnswerUsersModalView":248,"./TestResultsDataModel":249,"./TestResultsPageBootstrap":250,"./TestResultsQuestionResultsItemView":251,"./TestResultsView":252}],254:[function(require,module,exports){
app.pkg("test.testSolvePage");
app.test.testSolvePage.QuestionSolveDataModel = Backbone.Model.extend({
    validation: {
        selected_answer: [{
            required: true,
            msg: 'Pasirinkite atsakymą'
        }]
    }
});

},{}],255:[function(require,module,exports){
app.pkg("test.testSolvePage");

app.test.testSolvePage.TestSolveDataModel = Backbone.Model.extend({
    validation: {

    },

    urlRoot: '/api/test/solve/data'
});

},{}],256:[function(require,module,exports){
app.pkg('test.testSolvePage');
app.test.testSolvePage.TestSolveFormView = Backbone.FormView.extend({

    template: _.template(app.templates['test-testSolvePage-TestSolveFormView']),

    additionalEvents: {},

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
    },


    setModelValues: function() {},



    additionalRender: function() {
        if (!this.model.get("expired")) {
            this.renderQuestionier();
        } else {
            this.renderExpiredMessage();
        }
    },

    renderExpiredMessage: function() {
        this.$('[data-action="save-record"]').hide();
        this.$('[data-content="test-questions"]').append('<h4>Sprendimo laikas baigėsi. <a href="/tests/answers/' + this.model.id + '">Peržiūrėkite testo atsakymus</a></h4>');

    },

    renderQuestionDisplay: function(model) {
        var questionView = new app.test.testSolvePage.TestSolveItemView({
                model: model,
                test: this.model
            }),
            self = this;
        this.$('[data-content="test-questions"]').append(questionView.el);
        this.questionViews.push(questionView);
    },

    renderQuestionier: function() {
        this.questionViews = [];
        var questions = this.model.get("test_questions"),
            self = this;
        questions = _.sortBy(questions, 'id');
        _(questions).each(function(question) {
            self.renderQuestionDisplay(new app.test.testSolvePage.QuestionSolveDataModel(question));
        }, this);
    },

    isModelValid: function() {
        var isValid = true;
        _(this.questionViews).each(function(questionView) {
            if (!questionView.isValid()) {
                isValid = false;
            }
        }, this);
        return isValid;
    },

    getFormValues: function() {
        var formVals = {},
            question_answers = [];
        _(this.questionViews).each(function(questionView) {
            question_answers.push(questionView.getFormValues());
        }, this);
        return {
            question_answers: question_answers
        };
    },

    saveRecord: function(e) {
        e.preventDefault();
        var view = this;
        if (this.isModelValid()) {
            app.displayLoadDialog();
            this.model.save(this.getFormValues(), {
                success: function(model, response, options) {
                    view.displaySuccessUpdateMessage();
                    app.hideLoadDialog();
                },
                error: function(model, response) {
                    app.hideLoadDialog();

                    if (response.status === 422) {
                        view.displayErrorMessage($.parseJSON(response.responseText).responseText);
                    } else {
                        var updatedModel = {};
                        var errors = $.parseJSON(response.responseText);
                        if (errors.name === "SequelizeValidationError") {
                            for (var errorFieldIndex in errors.errors) {
                                var errorField = errors.errors[errorFieldIndex];
                                view.$('[name=' + errorField.path + ']').val('');
                                updatedModel[errorField.pat] = null;
                                Backbone.Validation.callbacks.invalid(view, errorField.path, errorField.message, "name");
                            }
                            view.displayErrorMessage(response.responseText.error);

                        } else {
                            view.displayErrorMessage(response.responseText.error);
                        }
                    }

                }
            });

        }

    },


});

},{}],257:[function(require,module,exports){
app.pkg('test.testSolvePage');
app.test.testSolvePage.TestSolveItemView = Backbone.FormView.extend({
    template: _.template(app.templates['test-testSolvePage-TestSolveItemView']),
    className: "row-fluid test-question-display-item",

    additionalEvents: {
        'click [name="answer-selection"]': 'answerSelected'
    },

    initialize: function () {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },

    setModelValues: function () {
        var self = this;
        this.$("#comment").val(this.model.get("comment"));
        if (this.model.get("selected_answer")) {
            var radioToSelect = this.$('[name="answer-selection"]').filter(function () {
                return parseInt(this.value) === parseInt(self.model.get("selected_answer"));
            });
            if (radioToSelect) {
                radioToSelect.attr('checked', 'checked');
            }
            this.$("#selected_answer").val(this.model.get("selected_answer"));
        }
    },

    additionalRender: function () {
        this.renderAnswers();
        if (this.model.get("question_type") === 'video') {
            this.renderVideo();
        }
        if (this.options.test.get("test_type") === "test") {
            this.$('[data-content="comment-display"]').hide();
        }
    },

    renderVideo: function () {
        this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video")));
        if (this.model.get("question_video_1") && this.model.get("question_video_1").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_1")));
        }
        if (this.model.get("question_video_2") && this.model.get("question_video_2").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_2")));
        }
        if (this.model.get("question_video_3") && this.model.get("question_video_3").length) {
            this.$('[data-content="question-data-display"]').append(app.getVideoIframe(this.model.get("question_video_3")));
        }
    },

    renderAnswers: function () {
        var answers = this.model.get("test_question_answers"),
            self = this;

        answers = _.sortBy(answers, 'id');
        _(answers).each(function (answer) {
            self.renderAnswerDisplay(answer);
        }, this);
    },

    renderAnswerDisplay: function (answer) {
        this.$('[data-content="answers-display"]').append('<div class="answer-item"><label><input type="radio" name="answer-selection" value="' + answer.id + '"><span class="answer-label">' + answer.answer_text + '</span></label></div>');
    },

    answerSelected: function (el) {
        this.$("#selected_answer").val(this.$('[name="answer-selection"]:checked').val());
        this.model.set("selected_answer", this.$('[name="answer-selection"]:checked').val(), {
            validate: true
        });
    },

    getDynamicFormVals: function (formVals) {
        formVals.question_id = this.model.id;
        return formVals;
    },

    isValid: function () {
        return this.isModelValid(this.getFormValues());
    },
});

},{}],258:[function(require,module,exports){
app.pkg('test.testSolvePage');
app.test.testSolvePage.TestSolvePageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.test.testSolvePage.TestSolveDataModel({
        id: id
    });

    new app.test.testSolvePage.TestSolveFormView({
        el: $('[data-content="test-form"]'),
        model: model
    });
    $('[data-main-menu-item="tests"]').addClass("active");
    $('[data-sidebar-menu-item="tests"]').addClass("active");
};

},{}],259:[function(require,module,exports){
require('./TestSolveFormView');
require('./TestSolvePageBootstrap');
require('./TestSolveDataModel');
require('./TestSolveItemView');
require('./QuestionSolveDataModel');

},{"./QuestionSolveDataModel":254,"./TestSolveDataModel":255,"./TestSolveFormView":256,"./TestSolveItemView":257,"./TestSolvePageBootstrap":258}],260:[function(require,module,exports){
app.pkg('test.testsPage');
app.test.testsPage.TestsListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['test-testsPage-TestsListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="remove-element"]': "removeTest"
    },

    onItemClick: function() {
        if (this.model.get("expired")) {
            app.openTestAnswersPage(this.model.id);
        } else {
            app.openTestSolvePage(this.model.id);
        }
    },

    removeTest: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/tests/edit/" + this.model.id);
        this.$('[data-action="test-stats"]').attr("href", "/tests/results/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        if (this.model.get("expired")) {
            this.$('[data-action="solve-test"]').remove();
        } else {
            this.$('[data-action="test-answers"]').remove();
        }
        if (!this.model.get("enabled")) {
            this.$('[data-action="solve-test"]').remove();
        }
        app.addTooltips(this.$el);
        return this;
    }



});

},{}],261:[function(require,module,exports){
app.pkg('test.testsPage');
app.test.testsPage.TestsListView = Backbone.LazyLoadListView.extend({

    getCollectionElementsDisplayDiv: function() {
        return this.$('#tests-list tbody');
    }

});

},{}],262:[function(require,module,exports){
app.pkg('test.testsPage');
app.test.testsPage.TestsPageBootstrap = function() {
    new app.test.testsPage.TestsListView({
        el: $('[data-content="tests-list"]'),
        collection: new app.test.TestsCollection(),
        listItemDisplayViewType: app.test.testsPage.TestsListItemView,
        template: app.templates['test-testsPage-TestsListView']
    });
    $('[data-main-menu-item="tests"]').addClass("active");
    $('[data-sidebar-menu-item="tests"]').addClass("active");
};

},{}],263:[function(require,module,exports){
require('./TestsListItemView');
require('./TestsListView');
require('./TestsPageBootstrap');






},{"./TestsListItemView":260,"./TestsListView":261,"./TestsPageBootstrap":262}],264:[function(require,module,exports){
app.pkg("user");

app.user.UserDataModel = Backbone.Model.extend({
    validation: {
        first_name: {
            required: true
        },
        last_name: {
            required: true
        },
        email: {
            required: true,
            pattern: 'email'
        },

        invoice_number: function (value) {
            if (value) {
                if (!value.toString().match(/^\d+$/)) {
                    return 'Sąskaitos numeris turi būti skaičius';
                }
            }
        },

        invoice_serial: {
        },

        invoice_seller_info: {
        }
    },

    urlRoot: '/api/service/user/data'
});

},{}],265:[function(require,module,exports){
app.pkg("user");
app.user.UserSuggestionsCollection = Backbone.Collection.extend({
    url: '/api/service/user/suggestions'
});

},{}],266:[function(require,module,exports){
require('./UserDataModel');
require('./UserSuggestionsCollection');
require('./userDisplayPage');
require('./userEditPage');
require('./userProfileEditPage');
require('./usersPage');
require('./userChangePasswordPage');
require('./userForgotPasswordPage');










},{"./UserDataModel":264,"./UserSuggestionsCollection":265,"./userChangePasswordPage":270,"./userDisplayPage":273,"./userEditPage":276,"./userForgotPasswordPage":280,"./userProfileEditPage":282,"./usersPage":286}],267:[function(require,module,exports){
app.pkg('user.userChangePasswordPage');
app.user.userChangePasswordPage.UserChangePasswordFormView = Backbone.FormView.extend({

    template: _.template(app.templates['user-userChangePasswordPage-UserChangePasswordFormView']),

    additionalEvents: {
        'blur input, textarea': 'onBlur'
    },
    onBlur: function() {},

    setModelValues: function() {
        this.$('#password').val(this.model.get('password'));
        this.$('#passwordRepeat').val(this.model.get('passwordRepeat'));
    },

    additionalInitializeActions: function() {
        this.model = new app.user.userChangePasswordPage.UserChangePasswordModel({
            id: app.User.id
        });
        this.render();
    },

    additionalSaveSuccess: function(wasNew) {
        this.model = new app.user.userChangePasswordPage.UserChangePasswordModel({
            id: app.User.id
        });
        this.$('#password').val("");
        this.$('#passwordRepeat').val("");
        Backbone.Validation.bind(this);
    },

    displaySuccessUpdateMessage: function() {
        app.displayAlertMessage("success", app.getMessage("successPasswordChangeMessageTitle"), app.getMessage("successPasswordChangeMessageTitle"));
    },

    displaySuccessCreateMessage: function() {
        app.displayAlertMessage("success", app.getMessage("successPasswordChangeMessageTitle"), app.getMessage("successPasswordChangeMessageTitle"));
    }
});

},{}],268:[function(require,module,exports){
app.pkg("user.userChangePasswordPage");

app.user.userChangePasswordPage.UserChangePasswordModel = Backbone.Model.extend({
    validation: {
        password: {
            required: true,
            minLength: 5

        },
        passwordRepeat: {
            required: true,
            equalTo: 'password',
            minLength: 5

        }
    },

    urlRoot: '/api/service/user/password'
});

},{}],269:[function(require,module,exports){
app.pkg('user.userChangePasswordPage');
app.user.userChangePasswordPage.UserChangePasswordPageBootstrap = function() {
    new app.user.userChangePasswordPage.UserChangePasswordFormView({
        el: $('[data-content="user-password-form"]')
    });
};

},{}],270:[function(require,module,exports){
require('./UserChangePasswordFormView');
require('./UserChangePasswordModel');
require('./UserProfileChangePasswordPageBootstrap');






},{"./UserChangePasswordFormView":267,"./UserChangePasswordModel":268,"./UserProfileChangePasswordPageBootstrap":269}],271:[function(require,module,exports){
app.pkg('user.userDisplayPage');
app.user.userDisplayPage.UserDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['user-userDisplayPage-UserDataDisplayView']),

    events: {},

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        if (this.model.get("suspended_until") === "") {
            this.$('[data-type="suspended_until"]').hide();
        }
        var self = this;

        this.$("#profile-picture-display").on('error', function() {
            $(this).attr('src', "/images/person.gif");
        }).attr("src", "/service/users/profile-picture/" + this.model.id);
        return this;
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    window.location.href = "/users";
                }
            });
        } else {
            window.location.href = "/users";
        }
    }

});

},{}],272:[function(require,module,exports){
app.pkg('user.userDisplayPage');
app.user.userDisplayPage.UserDisplayPageBootstrap = function(id) {
    if (id == 'new' || id === undefined) {
        id = null;
    }
    var model = new app.user.UserDataModel({
        id: id
    });

    new app.user.userDisplayPage.UserDataDisplayView({
        el: $('[data-content="user-data-display"]'),
        model: model
    });
    $('[data-main-menu-item="users"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-user"]').addClass("active");

    } else $('[data-sidebar-menu-item="users"]').addClass("active");
};

},{}],273:[function(require,module,exports){
require('./UserDataDisplayView');
require('./UserDisplayPageBootstrap');






},{"./UserDataDisplayView":271,"./UserDisplayPageBootstrap":272}],274:[function(require,module,exports){
app.pkg('user.userEditPage');
app.user.userEditPage.UserEditPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.user.UserDataModel({
        id: id
    });

    new app.user.userEditPage.UserFormView({
        el: $('[data-content="user-form"]'),
        model: model
    });
    $('[data-main-menu-item="users"]').addClass("active");
    if (id === null || id === undefined) {
        $('[data-sidebar-menu-item="new-user"]').addClass("active");
        $(".page-title").text("Pridėti vartotoją");

    } else $('[data-sidebar-menu-item="users"]').addClass("active");
};

},{}],275:[function(require,module,exports){
app.pkg('user.userEditPage');
app.user.userEditPage.UserFormView = Backbone.FormView.extend({

    template: _.template(app.templates['user-userEditPage-UserFormView']),

    additionalEvents: {
        "click .js-remove-picture": "removeProfilePicture"
    },

    removeProfilePicture: function() {
        var self = this;
        $.ajax({
            type: 'DELETE',
            url: '/service/users/profile-picture/' + this.model.id,
            contentType: 'application/json',
            success: function(data) {
                self.checkProfilePictureDisplay();
            },
            error: function(err, data) {
                self.displayErrorMessage(err.responseText);
            }
        });
    },

    additionalInitializeActions: function() {
        Backbone.Validation.bind(this);
    },

    checkProfilePictureDisplay: function() {
        this.$("#user-picture-display")
            .on('load', function() {
                self.$("#has-no-picture").hide();
                self.$("#has-picture").show();
            })
            .on('error', function() {
                self.$("#has-no-picture").show();
                self.$("#has-picture").hide();
            })
            .attr("src", "/service/users/profile-picture/" + this.model.id);
    },


    initProfilePictureUpload: function() {
        var self = this;
        if(this.$('#user_picture').length){
            this.uploader = new qq.FileUploader({
                element: this.$('#user_picture')[0],
                allowedExtensions: ['jpg', 'jpeg', 'png', 'gif'],
                action: '/service/users/profile-picture-upload',
                inputName: 'profile-pictrue',
                uploadButtonText: app.getMessage('userUploadPhoto'),
                params: {
                    userId: this.model.id
                },
                messages: {
                    typeError: app.getMessage('photoUploadTypeError'),
                    sizeError:app.getMessage('photoUploadSizeError'),
                    minSizeError: app.getMessage('photoUploadMinSizeError'),
                },

                showMessage: function(message) {
                    self.displayErrorMessage(message);
                },
                onComplete: function(id, fileName, responseJSON) {
                    self.checkProfilePictureDisplay();
                },
                onError: function(id, fileName, xhr) {
                    console.log(arguments);
                }
            });
        }

        this.checkProfilePictureDisplay();
    },

    setModelValues: function() {
        if (this.model.isNew()) {
            this.model.set({
                daily_mail: true
            });
        }

        this.$('#first_name').val(this.model.get('first_name'));
        this.$('#last_name').val(this.model.get('last_name'));
        this.$('#person_code').val(this.model.get('person_code'));
        this.$('#account_number').val(this.model.get('account_number'));
        this.$('#email').val(this.model.get('email'));
        this.$('#address').val(this.model.get('address'));
        this.$('#phone_number').val(this.model.get('phone_number'));
        this.$('#user_type').val(this.model.get('user_type'));
        this.$('#category').val(this.model.get('category'));
        this.$('#suspended_until').val(this.model.get('suspended_until'));
        this.$('#certificate_until').val(this.model.get('certificate_until'));

        if (this.model.get('is_association_member')) {
            this.$('#is_association_member').attr('checked', 'checked');
        }
        if (this.model.get('daily_mail')) {
            this.$('#daily_mail').attr('checked', 'checked');
        }
        this.$('#invoice_number').val(this.model.get('invoice_number'));
        this.$('#invoice_serial').val(this.model.get('invoice_serial'));
        this.$('#invoice_seller_info').val(this.model.get('invoice_seller_info'));
    },

    additionalRender: function() {
        if (!this.model.isNew()) {
            this.$('#email').attr('disabled', "disabled");
        } else {
            this.$('.js-picture-upload').hide();
        }
        var view = this;
        this.$('#suspended_until').datetimepicker({
            onSelect: function() {
                var e = jQuery.Event("blur");
                e.target = this;
                view.validateField(e);
            }
        });

        this.$('#certificate_until').datetimepicker({
            onSelect: function() {
                var e = jQuery.Event("blur");
                e.target = this;
                view.validateField(e);
            }
        });

        this.initProfilePictureUpload();
    },

    additionalSaveSuccess: function(wasNew) {
        if (wasNew)
            app.openUserEditPage(this.model.id);
    },

    getNewModelInstance: function() {
        return new app.user.UserDataModel({
            id: null
        });
    },
    displaySuccessUpdateMessage: function() {
        app.displayAlertMessage("success", app.getMessage('userSavedInfoMessage'), app.getMessage('userSavedInfoMessage'));
    },

    displaySuccessCreateMessage: function() {
        app.displayAlertMessage("success", app.getMessage('userCreatedInfoMessage'), app.getMessage('userCreatedInfoMessage'));
    }
});

},{}],276:[function(require,module,exports){
require('./UserEditPageBootstrap');
require('./UserFormView');






},{"./UserEditPageBootstrap":274,"./UserFormView":275}],277:[function(require,module,exports){
app.pkg('user.userForgotPasswordPage');
app.user.userForgotPasswordPage.UserForgotPasswordFormView = Backbone.FormView.extend({

    template: _.template(app.templates['user-userForgotPasswordPage-UserForgotPasswordFormView']),

    additionalEvents: {
        'blur input, textarea': 'onBlur'
    },
    onBlur: function() {},

    setModelValues: function() {
        this.$('#email').val(this.model.get('email'));
    },

    additionalInitializeActions: function() {
        this.model = new app.user.userForgotPasswordPage.UserForgotPasswordModel({});
        this.render();
    },

    additionalSaveSuccess: function(wasNew) {
        this.model = new app.user.userForgotPasswordPage.UserForgotPasswordModel({});
        this.$('#email').val("");
        Backbone.Validation.bind(this);
    },

    displaySuccessUpdateMessage: function() {
        app.displayAlertMessage("success", app.getMessage("passwordSentToEmail"), app.getMessage("passwordSentToEmail"));
    },

    displaySuccessCreateMessage: function() {
        app.displayAlertMessage("success", app.getMessage("passwordSentToEmail"), app.getMessage("passwordSentToEmail"));
    }
});

},{}],278:[function(require,module,exports){
app.pkg("user.userForgotPasswordPage");

app.user.userForgotPasswordPage.UserForgotPasswordModel = Backbone.Model.extend({
    validation: {
        email: {
            required: true,
            myEmailValidator: true
        }
    },

    urlRoot: '/api/user/forgot-password'
});

},{}],279:[function(require,module,exports){
app.pkg('user.userForgotPasswordPage');
app.user.userForgotPasswordPage.UserForgotPasswordPageBootstrap = function() {
    new app.user.userForgotPasswordPage.UserForgotPasswordFormView({
        el: $('[data-content="user-password-form"]')
    });
};

},{}],280:[function(require,module,exports){
require('./UserForgotPasswordFormView');
require('./UserForgotPasswordModel');
require('./UserForgotPasswordPageBootstrap');






},{"./UserForgotPasswordFormView":277,"./UserForgotPasswordModel":278,"./UserForgotPasswordPageBootstrap":279}],281:[function(require,module,exports){
app.pkg('user.userProfileEditPage');
app.user.userProfileEditPage.UserProfileEditPageBootstrap = function() {
    var model = new app.user.UserDataModel({
        id: app.User.id
    });
    new app.user.userEditPage.UserFormView({
        el: $('[data-content="user-form"]'),
        model: model
    });
};

},{}],282:[function(require,module,exports){
require('./UserProfileEditPageBootstrap');






},{"./UserProfileEditPageBootstrap":281}],283:[function(require,module,exports){
app.pkg("user.usersPage");

app.user.usersPage.UsersCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/service/users/all/paginated'
});

},{}],284:[function(require,module,exports){
app.pkg('user.usersPage');
app.user.usersPage.UsersListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['user-usersPage-UsersListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="delete-element"]': 'deleteUser',
    },

    onItemClick: function() {
        app.openUserDisplayPage(this.model.id);
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    deleteUser: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));

                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/user/edit/" + this.model.id);
        this.$('[data-action="user-list-element"]').attr("href", "/journal/custom?userId=" + this.model.id);
        this.$('[data-action="preview-element"]').attr("href", "/user/" + this.model.id);
        this.$('[data-action="user-availability"]').attr("href", "/user/availability/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        app.addTooltips(this.$el);
        return this;
    }



});

},{}],285:[function(require,module,exports){
app.pkg('user.usersPage');
app.user.usersPage.UsersPageBootstrap = function() {
    new app.components.usersList.UsersListView({
        el: $('[data-content="users-list"]'),
        collection: new app.user.usersPage.UsersCollection(),
        listItemDisplayViewType: app.user.usersPage.UsersListItemView,
        template: app.templates['user-usersPage-UsersListView']
    });
    $('[data-main-menu-item="users"]').addClass("active");
    $('[data-sidebar-menu-item="users"]').addClass("active");
};

},{}],286:[function(require,module,exports){
require('./UsersCollection');
require('./UsersListItemView');
require('./UsersPageBootstrap');







},{"./UsersCollection":283,"./UsersListItemView":284,"./UsersPageBootstrap":285}],287:[function(require,module,exports){
require('./myAvailability');
require('./userAvailability');
require('./usersAvailability');



},{"./myAvailability":294,"./userAvailability":298,"./usersAvailability":303}],288:[function(require,module,exports){
app.pkg("userAvailability.myAvailability");

app.userAvailability.myAvailability.MyAvailabilityCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/user-availability/my'
});

},{}],289:[function(require,module,exports){
app.pkg("userAvailability.myAvailability");

app.userAvailability.myAvailability.MyAvailabilityDataModel = Backbone.Model.extend({
    validation: {
        start_date: {
            required: true,
        },
        end_date: [{
            required: true,
        }, {
            fn: function(value, attr, currentValues) {
                var startDate = new Date(currentValues.start_date);
                var endDate = new Date(currentValues.end_date);

                return  startDate.getTime() > endDate.getTime() ? app.getMessage('errorStartDateShouldBeBigger'): false
            }
        }]
    },


    urlRoot: '/api/user-availability/my',

});

},{}],290:[function(require,module,exports){
const _ = require("underscore");
app.pkg('userAvailability.myAvailability');
app.userAvailability.myAvailability.MyAvailabilityFormView = Backbone.FormView.extend({

    template: _.template(app.templates['userAvailability-myAvailability-MyAvailabilityFormView']),
    selections: [],
    additionalEvents: {
        'blur input, textarea': 'onBlur',
        'click [data-action="remove-data"]': 'removeDate'
    },
    onBlur: function () {
    },

    removeDate: function (e){
        this.setSelectedDates(_.without(this.getRepeatedDates(), $(e.target).attr('data-value')));
    },

    setSelectedDates: function(currentValues){
        var self = this;
        var valuesToSave = _.uniq(currentValues);
        this.$('#repeated_dates').val(valuesToSave.join(','));
        this.$('[data-content="selected-dates"]').html('');
        valuesToSave.forEach(function(item){
            self.$('[data-content="selected-dates"]').append('<div class="flex mr-5">' + item + '<span data-action="remove-data" data-value="'+item+'" aria-hidden="true" class="close-icon">×</span> </div>')
        });
    },

    additionalRender: function () {
        var self = this;
        var onSelect  = function() {
            var e = jQuery.Event("blur");
            e.target = this;
            self.validateField(e);
        }
        if(app.isFunctionalityEnabled('availabilityRestrictions')){
            this.$('#start_date').datetimepicker({onSelect: onSelect});
            this.$('#end_date').datetimepicker({onSelect: onSelect});
        } else {
            this.$('#start_date').datepicker({onSelect: onSelect});
            this.$('#end_date').datepicker({onSelect: onSelect});
        }


        this.$('#repeat_date').datepicker({onSelect: function (){
                var val = $(this).val();
                var currentValues = self.getRepeatedDates();
                currentValues.push(val);
                self.setSelectedDates(currentValues);
                $(this).val('');
        }});

    },



    additionalInitializeActions: function () {
        this.model = this.getNewModelInstance();
        this.render();
        Backbone.Validation.bind(this);
    },


    setModelValues: function () {
        this.$('#start_date').val(this.model.get('start_date'));
        this.$('#end_date').val(this.model.get('end_date'));
        this.$('#comment').val(this.model.get('comment'));
        if (this.model.get("unavailable")) {
            this.$('#unavailable').attr('checked', 'checked');
        }
    },

    getRepeatedDates: function(){
        return  this.$('#repeated_dates').val() ? this.$('#repeated_dates').val().split(','): []
    },


    getFormValues: function() {
        return {
            start_date: this.$('[name="start_date"]').val(),
            end_date: this.$('[name="end_date"]').val(),
            comment: this.$('[name="comment"]').val(),
            unavailable: this.$('[name="unavailable"]').is(':checked'),
            repeated_dates: this.getRepeatedDates()
        };
    },

    getNewModelInstance: function () {
        return new app.userAvailability.myAvailability.MyAvailabilityDataModel(this.options.data || {
            id: null
        });
    },

    additionalSaveSuccess: function() {
        this.trigger("hide-modal");
    },

});

},{"underscore":348}],291:[function(require,module,exports){
app.pkg('userAvailability.myAvailability');
app.userAvailability.myAvailability.MyAvailabilityListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['userAvailability-myAvailability-MyAvailabilityListItemView']),

    events: {
        'click [data-action="remove-element"]': 'deleteItem',
        'click [data-action="edit-element"]': 'editItem'
    },
    initialize: function() {
        _.bindAll(this);
        this.render();

    },

    deleteItem: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));
                    view.trigger("remove-item");
                },
                error: function(e, response) {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), response.responseText);

                }
            });
        }
        return false;
    },

    editItem: function(){
        var self = this;
        var modal = new app.components.modalWindow.ModalWindowView({
            contentView: app.userAvailability.myAvailability.MyAvailabilityFormView,
            contentParams: {
                data: this.model.attributes
            },
            headerText: app.getMessage('editMyAvailability')
        });

        modal.on("modal-hide", function() {
            self.trigger("item-updated");
        });

        $('body').append(modal.el);
    },


    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        app.addTooltips(this.$el);
        return this;
    }


});

},{}],292:[function(require,module,exports){
app.pkg('userAvailability.myAvailability');
app.userAvailability.myAvailability.MyAvailabilityListView = Backbone.LazyLoadListView.extend({
    events: {
        'click [data-action="add-record"]': 'addRecord'
    },
    render: function () {
        this.$el.html(this.template());
        this.initScroll();
        return this;
    },

    getCollectionElementsDisplayDiv: function () {
        return this.$('#my-availability-list tbody');
    },

    addRecord: function(){
       var self = this;
       var modal = new app.components.modalWindow.ModalWindowView({
           contentView: app.userAvailability.myAvailability.MyAvailabilityFormView,
           contentParams: {},
           headerText: app.getMessage('addMyAvailability')
       });

        modal.on("modal-hide", function() {
          self.getNewData();
        });

        $('body').append(modal.el);
    },

  renderCollectionElement: function (model) {
    var self = this;

    var view = new this.options.listItemDisplayViewType({
      model: model
    });
    view.on("item-updated", function() {
     self.getNewData();
    });
    this.getCollectionElementsDisplayDiv().append(view.el);
  },

});

},{}],293:[function(require,module,exports){
app.pkg('userAvailability.myAvailability');
app.userAvailability.myAvailability.MyAvailabilityPageBootstrap = function() {
    new app.userAvailability.myAvailability.MyAvailabilityListView ({
        el: $('[data-content="my-availability"]'),
        collection: new app.userAvailability.myAvailability.MyAvailabilityCollection(),
        listItemDisplayViewType: app.userAvailability.myAvailability.MyAvailabilityListItemView,
        template: app.templates['userAvailability-myAvailability-MyAvailabilityListView']
    });

    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="my-availability"]').addClass("active");

};

},{}],294:[function(require,module,exports){
require('./MyAvailabilityCollection');
require('./MyAvailabilityPageBootstrap');
require('./MyAvailabilityListView');
require('./MyAvailabilityListItemView');
require('./MyAvailabilityFormView');
require('./MyAvailabilityDataModel');






},{"./MyAvailabilityCollection":288,"./MyAvailabilityDataModel":289,"./MyAvailabilityFormView":290,"./MyAvailabilityListItemView":291,"./MyAvailabilityListView":292,"./MyAvailabilityPageBootstrap":293}],295:[function(require,module,exports){
app.pkg("userAvailability.myAvailability");

app.userAvailability.userAvailability.AvailabilityCollection = Backbone.Collection.extend({
    url: '/user-availability/'
});

},{}],296:[function(require,module,exports){
app.pkg('userAvailability.userAvailability');
app.userAvailability.userAvailability.UserAvailabilityDisplayView = Backbone.View.extend({

  template: _.template(app.templates['userAvailability-userAvailability-UserAvailabilityDisplayView']),
  events: {},

  initialize: function () {
    _.bindAll(this);
    this.availabilityCollection = new app.userAvailability.userAvailability.AvailabilityCollection();
    this.fetchCollection();
  },

  render: function () {
    var self = this;
    this.$el.html(this.template());
    var userDataMap = {};
    this.availabilityCollection.models.forEach(function(item){
      app.getDaysArray(new Date(item.get('start_date')), new Date(item.get('end_date')) ).forEach(function(userDate){
        var stringDate = $.datepicker.formatDate('yy-mm-dd', userDate);
        if(userDataMap[stringDate] !== undefined){
          userDataMap[stringDate] = _.union(userDataMap[stringDate], [item]);
        } else {
          userDataMap[stringDate] = [item];
        }
      })
    });

    this.$('#picker').datepicker({
      defaultDate: self.options.selected_date,
      beforeShowDay: function(date){
        var dayRecords = userDataMap[$.datepicker.formatDate('yy-mm-dd', date)] || [];
        var cssClasses = [];
        if(dayRecords.length > 0){
          cssClasses.push('is-highlighted');
        }
        if(dayRecords.filter(function(item){return item.get('unavailable') === true}).length > 0){
          cssClasses.push('unavailable');
        }
        if(dayRecords.filter(function(item){return item.get('unavailable')===false}).length > 0){
          cssClasses.push('available');
        }
        return [cssClasses.length > 0, cssClasses.join(' ')];
      },
      onChangeMonthYear: function (year, month, inst) {
        self.options.selected_date = new Date(year, month - 1, 1)
        self.fetchCollection();
      },
      inline: true
    });
    return this;
  },

  fetchCollection: function () {
    var self = this;
    this.availabilityCollection.fetch({
      data: {
        user_id: self.options.user_id,
        month: self.options.selected_date.getMonth() + 1,
        year: self.options.selected_date.getFullYear()
      },
      success: function () {
        self.render();
      },
      error: function () {
      }
    });
  },

});

},{}],297:[function(require,module,exports){
app.pkg('userAvailability.userAvailability');
app.userAvailability.userAvailability.UserAvailabilityPageBootstrap = function(id) {

    new app.userAvailability.userAvailability.UserAvailabilityDisplayView({
        el: $('[data-content="availability-display"]'),
        user_id: id,
        selected_date: new Date()
    });

    $('[data-main-menu-item="users"]').addClass("active");
    $('[data-sidebar-menu-item="users"]').addClass("active");

};

},{}],298:[function(require,module,exports){
require('./UserAvailabilityPageBootstrap');
require('./UserAvailabilityDisplayView');
require('./AvailabilityCollection');






},{"./AvailabilityCollection":295,"./UserAvailabilityDisplayView":296,"./UserAvailabilityPageBootstrap":297}],299:[function(require,module,exports){
app.pkg('userAvailability.usersAvailability');
app.userAvailability.usersAvailability.UsersDayAvailabilityDisplayView = Backbone.View.extend({

  template: _.template(app.templates['userAvailability-usersAvailability-UsersDayAvailabilityDisplayView']),
  events: {},

  initialize: function () {
    _.bindAll(this);
    this.render();
  },

  render: function () {
    var self = this;
    this.$el.html(this.template());
    this.options.users.forEach(function(item){
      var selector = '';
      if(item.get('unavailable')){
        selector = '#unavailable-info'
      } else {
        selector = '#available-info'
      }
      self.$(selector).append([
        '<div>',
        item.get('user').short_name,
        ': ',
        item.get('comment'),
        ' - ',
        '(',
        item.get('start_date'),
        ' - ',
        item.get('end_date'),
        ')'
      ].join(''))


    })
    return this;
  },

});

},{}],300:[function(require,module,exports){
app.pkg("userAvailability.usersAvailability");

app.userAvailability.usersAvailability.UsersAvailabilityCollection = Backbone.Collection.extend({
    url: '/api/user-availability/all'
});

},{}],301:[function(require,module,exports){
app.pkg('userAvailability.usersAvailability');
app.userAvailability.usersAvailability.UsersAvailabilityDisplayView = Backbone.View.extend({

  template: _.template(app.templates['userAvailability-usersAvailability-UsersAvailabilityDisplayView']),
  events: {
    'click [data-action="export-user-availability-report"]': 'getExport',
  },

  initialize: function () {
    _.bindAll(this);
    this.availabilityCollection = new app.userAvailability.usersAvailability.UsersAvailabilityCollection();
    this.fetchCollection();
  },
  getExport: function() {

    window.open('/api/user-availability/report' + "?" + $.param({
      month: this.options.selected_date.getMonth()  + 1,
      year: this.options.selected_date.getFullYear()

    }),
      '_blank');
  },

  render: function () {
    var self = this;
    this.$el.html(this.template());

    var userDataMap = {};

    this.availabilityCollection.models.forEach(function(item){
      app.getDaysArray(new Date(item.get('start_date')), new Date(item.get('end_date')) ).forEach(function(userDate){
        var stringDate = $.datepicker.formatDate('yy-mm-dd', userDate);
        if(userDataMap[stringDate] !== undefined){
          userDataMap[stringDate] = _.union(userDataMap[stringDate], [item]);
        } else {
          userDataMap[stringDate] = [item];
        }
      })

    });

    this.$('#picker').datepicker({

      defaultDate: self.options.selected_date,
      beforeShowDay: function(date){
        var dayRecords = userDataMap[$.datepicker.formatDate('yy-mm-dd', date)] || [];
        var cssClasses = [];
        if(dayRecords.length > 0){
          cssClasses.push('is-highlighted');
        }
        if(dayRecords.filter(function(item){return item.get('unavailable') === true}).length > 0){
          cssClasses.push('unavailable');
        }
        if(dayRecords.filter(function(item){return item.get('unavailable')===false}).length > 0){
          cssClasses.push('available');
        }
        return [cssClasses.length > 0, cssClasses.join(' ')];
      },
      onSelect: function(dateText, inst) {

        new app.components.modalWindow.ModalWindowView({
          contentView: app.userAvailability.usersAvailability.UsersDayAvailabilityDisplayView,
          contentParams: {
            date: dateText,
            users: userDataMap[dateText] || []
          },
          headerText: app.getMessage('dayAvailabilityModalTitle')+ ' ' + dateText
        });

      },
      onChangeMonthYear: function (year, month, inst) {
        self.options.selected_date = new Date(year, month - 1, 1)
        self.fetchCollection();
      },
      inline: true
    });
    return this;
  },

  fetchCollection: function () {
    var self = this;
    this.availabilityCollection.fetch({
      data: {
        user_id: self.options.user_id,
        month: self.options.selected_date.getMonth() + 1,
        year: self.options.selected_date.getFullYear()
      },
      success: function () {
        self.render();
      },
      error: function () {
      }
    });
  },

});

},{}],302:[function(require,module,exports){
app.pkg('userAvailability.usersAvailability');
app.userAvailability.usersAvailability.UsersAvailabilityPageBootstrap = function(id) {

    new app.userAvailability.usersAvailability.UsersAvailabilityDisplayView({
        el: $('[data-content="availability-display"]'),
        user_id: id,
        selected_date: new Date()
    });

    $('[data-main-menu-item="schedule"]').addClass("active");
    $('[data-sidebar-menu-item="users-availability"]').addClass("active");

};

},{}],303:[function(require,module,exports){
require('./UsersAvailabilityPageBootstrap');
require('./UsersAvailabilityDisplayView');
require('./UsersAvailabilityCollection');
require('./UsersAnavailabilityDisplayView');






},{"./UsersAnavailabilityDisplayView":299,"./UsersAvailabilityCollection":300,"./UsersAvailabilityDisplayView":301,"./UsersAvailabilityPageBootstrap":302}],304:[function(require,module,exports){
Backbone.FormView = Backbone.View.extend({
    originalEvents: {
        'click [data-action="save-record"]': 'saveRecord',
        // 'blur input, textarea': 'updateModel',
        // 'change input[type="checkbox"]': 'updateModel',
        // 'change select:not(.excludable)': 'updateModel'

        'blur input, textarea': 'validateField',
        'change input[type="checkbox"], input[type="radio"]': 'validateField',
        'change select:not(.excludable)': 'validateField'
    },
    additionalEvents: {

    },

    events: function() {
        return _.extend({}, this.originalEvents, this.additionalEvents);
    },

    initialize: function() {
        _.bindAll(this);
        if (this.model) {
            this.fetchModel();
        }
        this.additionalInitializeActions();
        Backbone.Validation.bind(this);
    },

    additionalInitializeActions: function() {},

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.additionalRender();
        this.setModelValues();
        app.addTooltips(this.$el);
        if (app.User && !app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').hide();
        }
        return this;
    },

    additionalRender: function() {},

    validateField: function(el) {
        var $el = $(el.target);
        this.model.set($el.attr('name'), $el.val(), {
            validate: true
        });
    },

    updateModel: function(el) {
        if (!this.model.isNew()) {
            this.saveRecord(el);
        } else {
            this.validateField(el);
        }
    },

    setModelValues: function() {
        throw new Error("Please overide this function");
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function(model) {
                    view.model._previousAttributes = model.changedAttributes();
                    view.model.changed = {};
                    view.render();
                },
                error: function() {
                    view.invalidModelFetch();
                }
            });
        } else {
            this.render();
        }
    },

    invalidModelFetch: function() {
        app.openHomePage();
    },

    executeUpdatedEvent: function() {
        this.trigger("model-changed", this.model);
    },

    changedAttributes: function(model, diff) {
        if (!diff) {
            return model.hasChanged() ? _.clone(model.changed) : false;
        }
        var val, changed = false;
        var old = model._changing ? model._previousAttributes : model.attributes;
        for (var attr in diff) {
            if (_.isEqual(old[attr], (val = diff[attr]))) {
                continue;
            }
            (changed || (changed = {}))[attr] = val;
        }
        return changed;
    },

    hasChangedValues: function(newValues) {
        if (this.model.isNew()) {
            return true;
        }
        return this.changedAttributes(this.model, newValues);
    },

    isModelValid: function(data) {
        return !this.model.validate(data);
    },

    getFormValues: function() {
        var formVals = {};
        this.$("input[type=text], input[type=email],  input[type=password],textarea, select").each(function() {
            if ($(this).attr("name")) {
                var val = $(this).val();
                if (app.isIntFromString(val) && val !== "") {
                    val = parseInt(val);
                }
                formVals[$(this).attr("name")] = val;
            }
        });

        this.$("input[type=checkbox], input[type=radio]").each(function() {
            if ($(this).attr("name")) {
                formVals[$(this).attr("name")] = $(this).is(':checked');
            }
        });

        formVals = this.getDynamicFormVals(formVals);
        return formVals;
    },

    getDynamicFormVals: function(formVals) {
        return formVals;
    },

    getNewModelInstance: function() {
        throw new Error("Please overide this function");
    },

    saveRecord: function(e) {
        e.preventDefault();
        var view = this,
            wasNew = this.model.isNew(),
            formValues = this.getFormValues();
        if (this.isModelValid(formValues)) {
            app.displayLoadDialog();
            this.model.save(formValues, {
                success: function(model, response, options) {
                    if (wasNew) {
                        view.displaySuccessCreateMessage();
                    } else {
                        view.displaySuccessUpdateMessage();
                    }
                    view.additionalSaveSuccess(wasNew);
                    view.executeUpdatedEvent();
                    app.hideLoadDialog();
                },
                error: function(model, response) {
                    app.hideLoadDialog();
                    if (response.status == 422) {
                        view.displayErrorMessage(response.responseText);
                    } else {

                       try {
                           var errors = $.parseJSON(response.responseText);
                           if (errors.name === "SequelizeValidationError") {
                               for (var errorFieldIndex in errors.errors) {
                                   var errorField = errors.errors[errorFieldIndex];
                                   view.$('[name=' + errorField.path + ']').val('');
                                   updatedModel[errorField.pat] = null;
                                   Backbone.Validation.callbacks.invalid(view, errorField.path, errorField.message, "name");
                               }
                               view.displayErrorMessage(response.responseText.error);

                           } else {
                               view.displayErrorMessage(errors.error);
                           }
                       } catch (e){
                           view.displayErrorMessage(response.responseText);
                       }
                    }

                }
            });
        }
    },

    additionalSaveSuccess: function(wasNew) {

    },

    displaySuccessUpdateMessage: function() {
        app.displayAlertMessage("success", app.getMessage('recordSavedMessage'), app.getMessage('recordSavedMessage'));
    },

    displaySuccessCreateMessage: function() {
        app.displayAlertMessage("success", app.getMessage('recordCreatedMessage'), app.getMessage('recordCreatedMessage'));
    },
    displayErrorMessage: function(text) {
        app.displayAlertMessage("error", app.getMessage('errorOccurredGlobalMessage'), text);
    }


});

},{}],305:[function(require,module,exports){
Backbone.LazyLoadListView = Backbone.View.extend({
    disableScroll: false,

    originalEvents: {},
    additionalEvents: {},
    events: function () {
        return _.extend({}, this.originalEvents, this.additionalEvents);
    },

    initialize: function () {
        _.bindAll(this);
        var template = this.options.template !== undefined ? this.options.template : this.templateName;
        this.template = _.template(template);
        this.additionalInitializeActions();
        this.render();
    },

    additionalInitializeActions: function () {
        this.fetchCollection();
    },

    render: function () {
        this.$el.html(this.template());
        app.addTooltips(this.$el);
        this.initScroll();
        this.additionalRender();
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        return this;
    },

    additionalRender: function () {

    },

    getFetchParams: function () {
        var filters = {};
        filters.page = this.collection.pageInfo.page;
        filters.size = this.collection.pageInfo.size;
        return filters;
    },

    fetchCollection: function () {
        if (!this.isLoading) {
            var view = this;
            var filters = this.getFetchParams();
            this.isLoading = true;
            app.displayLoadDialog();
            this.collection.fetch({
                data: filters,
                success: function () {
                    view.isLoading = false;
                    view.renderCollectionElements();
                    app.hideLoadDialog();
                    view.hideLoadButton();
                    view.afterSuccessFetch();
                },
                error: function () {
                    view.isLoading = false;
                    app.hideLoadDialog();
                    view.hideLoadButton();
                }
            });
        }
    },

    afterSuccessFetch: function(){

    },

    updateScrollbar: function () {
        if (this.$('.mCustomScrollbar').length > 0) {
            this.$('.scrollable-content').mCustomScrollbar('scrollTo', 'top');
        }

    },

    resetCollection: function () {
        this.collection.resetCollection();
        this.updateScrollbar();
    },

    renderCollectionElements: function () {
        if (this.collection.pageInfo.page === 0) {
            this.getCollectionElementsDisplayDiv().empty();
            this.updateScrollbar();
        }
        var view = this;
        _(this.collection.models).each(function (model) {
            view.renderCollectionElement(model);
        }, this);
        if (this.collection.models.length === 0) {
            this.getCollectionElementsDisplayDiv().append(app.getMessage('noRecords'));
        }
        this.actionsAfterRender();
    },

    actionsAfterRender: function () {
    },

    renderCollectionElement: function (model) {
        var view = new this.options.listItemDisplayViewType({
            model: model
        });
        this.getCollectionElementsDisplayDiv().append(view.el);
    },

    getCollectionElementsDisplayDiv: function () {
        throw new Error('Please overide this function');
    },

    hideLoadButton: function () {
        if (!this.collection.isThereMoreItemsToLoad()) {
            this.$('.load-more').hide();
        } else {
            this.$('.load-more').show();
        }
    },

    loadNextPage: function () {
        this.collection.nextPage();
        if (this.collection.isThereMoreItemsToLoad()) {
            this.fetchCollection();
        }
        this.hideLoadButton();
        return false;
    },

    initScroll: function () {
        var el = this.$('.scrollable-content'),
            view = this,
            callback = function () {
                if (!view.isLoading) {
                    view.loadNextPage();
                }
            };
        app.addScrollBar(el, this.getScrollableContentOffset(), callback, this.disableScroll);
    },
    getScrollableContentOffset: function () {
        var elOffset = this.getCollectionElementsDisplayDiv().offset();
        if (elOffset !== null) {
            return this.getCollectionElementsDisplayDiv().offset().top + 25;
        } else {
            return 0;
        }
    },
    getNewData: function(){
        this.getCollectionElementsDisplayDiv().empty();
        this.resetCollection();
        this.fetchCollection();
    }
});

},{}],306:[function(require,module,exports){
require('./FormView');
require('./LazyLoadListView');








},{"./FormView":304,"./LazyLoadListView":305}],307:[function(require,module,exports){
/*! Paginator for backbone - v0.1 
 * Copyright (c) 2012 Gediminas Ubartas @ LargeCode */

Backbone.Paginator = (function(Backbone, _, $) {
    "use strict";

    var Paginator = {};
    Paginator.version = "0.1";

    // @name: Paginated collection
    //
    // @description:
    // This paginator for lazy data loading
    //
    Paginator.paginatedCollection = Backbone.Collection.extend({

        initialize: function() {
            var defaultPageInfo = {
                page: 0,
                size: 30
            };
            this.pageInfo = defaultPageInfo;
        },
        itemsCount: null,
        pageInfo: null,
        moreItemsLoadingEnabled: true,

        isThereMoreItemsToLoad: function() {
            if (this.moreItemsLoadingEnabled) {
                var currentPage = this.pageInfo.page;
                var currentCountOfItems = (currentPage === 0 ? 1 : currentPage) * this.pageInfo.size;
                if (this.itemsCount > currentCountOfItems) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },

        disableMoreItemsLoading: function() {
            this.moreItemsLoadingEnabled = false;
        },

        enableMoreItemsLoading: function() {
            this.moreItemsLoadingEnabled = true;
        },

        parse: function(resp, xhr) {
            this.itemsCount = parseInt(resp.itemsCount);
            return resp.collection;
        },

        resetCollection: function() {
            this.pageInfo.page = 0;
        },

        nextPage: function() {
            this.pageInfo.page++;
        }



    });

    return Paginator;

}(Backbone, _, jQuery));

},{}],308:[function(require,module,exports){
app.pkg("videoGroup");

app.videoGroup.VideoGroupDataModel = Backbone.Model.extend({
    // validation: {
    //     title: {
    //         required: true
    //     },
    //     description: {
    //         required: true
    //     },
    //     video_link: [{
    //         required: true
    //     }, {
    //         pattern: 'url',
    //         msg: 'Neteisingas nuorodos formatas'
    //     }]
    // },

    urlRoot: '/api/video-groups/data'
});

},{}],309:[function(require,module,exports){
require('./videoGroupsPage');
require('./videoGroupDisplayPage');
require('./VideoGroupDataModel');


require('./videoGroupEditPage');






},{"./VideoGroupDataModel":308,"./videoGroupDisplayPage":313,"./videoGroupEditPage":318,"./videoGroupsPage":323}],310:[function(require,module,exports){
app.pkg("videoGroup.videoGroupDisplayPage");

app.videoGroup.videoGroupDisplayPage.VideoDisplayView = Backbone.View.extend({

    template: _.template(app.templates['videoGroup-videoGroupDisplayPage-VideoDisplayView']),
    className: "bordered-box",
    events: {},

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderVideo()
        return this;
    },

    renderVideo: function() {
        this.$('[data-content="video-display"]').append(app.getVideoIframe(this.model.get("video_link")));
    },

    

});

},{}],311:[function(require,module,exports){
app.pkg("videoGroup.videoGroupDisplayPage");

app.videoGroup.videoGroupDisplayPage.VideoGroupDataDisplayView = Backbone.View.extend({

    template: _.template(app.templates['videoGroup-videoGroupDisplayPage-VideoGroupDataDisplayView']),

    events: {},

    initialize: function() {
        _.bindAll(this);
        this.fetchModel();
    },

    render: function() {
        this.$el.html(this.template(this.model.attributes));
        this.renderVideos();
        return this;
    },

    renderVideoElement: function(modelData) {
        var view = new app.videoGroup.videoGroupDisplayPage.VideoDisplayView({
            model: new Backbone.Model(modelData)
        });
        this.$('[data-content="videos-display"]').append(view.el);
    },

    renderVideos: function() {
        var view = this;
        _(this.model.get("videos")).each(function(model) {
            view.renderVideoElement(model);
        }, this);
    },

    fetchModel: function() {
        var view = this;
        if (!this.model.isNew()) {
            this.model.fetch({
                success: function() {
                    view.render();
                },
                error: function() {
                    window.location.href = "/video-group";
                }
            });
        } else {
            window.location.href = "/video-group";
        }
    }

});

},{}],312:[function(require,module,exports){
app.pkg("videoGroup.videoGroupDisplayPage");

app.videoGroup.videoGroupDisplayPage.VideoGroupDisplayPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.videoGroup.VideoGroupDataModel({
        id: id
    });

    new app.videoGroup.videoGroupDisplayPage.VideoGroupDataDisplayView({
        el: $('[data-content="video-data-display"]'),
        model: model
    });
    $('[data-main-menu-item="video"]').addClass("active");
    $('[data-sidebar-menu-item="videos"]').addClass("active");
};

},{}],313:[function(require,module,exports){
require('./VideoGroupDataDisplayView');
require('./VideoGroupDisplayPageBootstrap');
require('./VideoDisplayView');







},{"./VideoDisplayView":310,"./VideoGroupDataDisplayView":311,"./VideoGroupDisplayPageBootstrap":312}],314:[function(require,module,exports){
app.pkg("videoGroup.videoGroupEditPage");
app.videoGroup.videoGroupEditPage.VideoDataModel = Backbone.Model.extend({
    validation: {
        title: {
            required: true
        },
        description: {
            required: true
        },
        video_link: [{
            required: true
        }, {
            pattern: 'url',
            msg: ''
        }]
    }
});

},{}],315:[function(require,module,exports){
app.pkg("videoGroup.videoEditPage");
app.videoGroup.videoGroupEditPage.VideoFormView = Backbone.FormView.extend({

    template: _.template(app.templates['videoGroup-videoGroupEditPage-VideoFormView']),
    className: "bordered-box",

    additionalEvents: {
        'click [data-action="remove-record"]': 'removeItem',
    },


    initialize: function() {
        _.bindAll(this);
        this.render();
        Backbone.Validation.bind(this);
    },


    setModelValues: function() {
        this.$('#title').val(this.model.get('title'));
        this.$('#description').val(this.model.get('description'));
        this.$('#video_link').val(this.model.get('video_link'));
    },

    getDynamicFormVals: function(formVals) {
        formVals.id = this.model.id;
        return formVals;
    },

    isValid: function() {
        return this.isModelValid(this.getFormValues());
    },

    removeItem: function() {
        this.trigger("destroy");
    }

});

},{}],316:[function(require,module,exports){
app.pkg("videoGroup.videoGroupEditPage");

app.videoGroup.videoGroupEditPage.VideoGroupEditPageBootstrap = function(id) {
    if (id === 'new' || id === undefined) {
        id = null;
    }
    var model = new app.videoGroup.VideoGroupDataModel({
        id: id
    });

    new app.videoGroup.videoGroupEditPage.VideoGroupFormView({
        el: $('[data-content="video-form"]'),
        model: model
    });
    $('[data-main-menu-item="videos"]').addClass("active");
    $('[data-sidebar-menu-item="new-video"]').addClass("active");

    if (id === null || id === undefined) {
        $(".page-title").text("Pridėti video");
    }
};

},{}],317:[function(require,module,exports){
app.pkg("videoGroup.videoGroupEditPage");
app.videoGroup.videoGroupEditPage.VideoGroupFormView = Backbone.FormView.extend({

    template: _.template(app.templates['videoGroup-videoGroupEditPage-VideoGroupFormView']),

    additionalEvents: {
        'click [data-action="add-video"]': 'addNewVideo',
    },
    videoViews: [],

    setModelValues: function() {
        this.$('#title').val(this.model.get('title'));
        this.$('#description').val(this.model.get('description'));
        this.renderVideos();
    },

    addNewVideo: function() {
        this.renderVideoElement({});
    },

    renderVideoElement: function(modelData) {
        var videoView = new app.videoGroup.videoGroupEditPage.VideoFormView({
                model: new app.videoGroup.videoGroupEditPage.VideoDataModel(modelData)
            }),
            self = this;
        this.videoViews.push(videoView);
        videoView.bind('destroy', function() {
            var index = self.videoViews.indexOf(videoView);
            if (index > -1) {
                self.videoViews.splice(index, 1);
            }
            videoView.remove();
        }, this);
        this.$('[data-content="videos"]').append(videoView.el);
    },

    renderVideos: function() {
        var view = this;
        _(this.model.get("videos")).each(function(model) {
            view.renderVideoElement(model);
        }, this);
    },

    getNewModelInstance: function() {
        return new app.videoGroup.VideoGroupDataModel({
            id: null
        });
    },

    additionalSaveSuccess: function(wasNew) {
        if (wasNew) {
            app.openVideoGroupEditPage(this.model.id);
        }
    },

    isValid: function(data) {
        var isValid = true;
        _(this.videoViews).each(function(videoView) {
            if (!videoView.isValid()) {
                isValid = false;
            }
        }, this);
        return !this.model.validate(data) && isValid;
    },


    getFormValues: function() {
        var formVals = {
            title: this.$('[name="title"]').val(),
            description: this.$('[name="description"]').val()
        };
        var videos = [];
        _(this.videoViews).each(function(view) {
            videos.push(view.getFormValues());
        }, this);
        formVals.videos = videos;
        return formVals;
    },

    saveRecord: function(e) {
        e.preventDefault();
        var view = this,
            formValues = this.getFormValues();
        if (this.isValid(formValues)) {
            console.log(this.isValid(formValues));
            this.model.save(formValues, {
                success: function(model, response, options) {

                    view.displaySuccessCreateMessage();
                    app.openVideoGroupEditPage(view.model.id);

                    app.hideLoadDialog();
                },
                error: function(model, response) {
                    app.hideLoadDialog();
                    view.displayErrorMessage(response.responseText.error);
                }
            });
        }
    }

});

},{}],318:[function(require,module,exports){
require('./VideoGroupEditPageBootstrap');
require('./VideoGroupFormView');
require('./VideoFormView');
require('./VideoDataModel');

},{"./VideoDataModel":314,"./VideoFormView":315,"./VideoGroupEditPageBootstrap":316,"./VideoGroupFormView":317}],319:[function(require,module,exports){
app.pkg("videoGroup.videoGroupsPage");
app.videoGroup.videoGroupsPage.VideoGroupsCollection = Backbone.Paginator.paginatedCollection.extend({
    url: '/api/video-groups/all'
});

},{}],320:[function(require,module,exports){
app.pkg("videoGroup.videoGroupsPage");

app.videoGroup.videoGroupsPage.VideoGroupsListItemView = Backbone.View.extend({
    tagName: 'tr',
    template: _.template(app.templates['videoGroup-videoGroupsPage-VideoGroupsListItemView']),

    events: {
        'click': 'onItemClick',
        'click [data-action="remove-element"]': "removeLeague"
    },

    onItemClick: function() {
        app.openVideoGroupDisplayPage(this.model.id);
    },

    removeLeague: function() {
        var view = this;
        if (confirm(app.getMessage('doYouWantToRemoveConfirmation'))) {
            this.model.destroy({
                success: function(model) {
                    view.remove();
                    app.displayAlertMessage("success", app.getMessage('successRemoveMessageTitle'), app.getMessage('successRemoveMessageMessage'));

                    view.trigger("remove-item");
                },
                error: function() {
                    app.displayAlertMessage("error",  app.getMessage('errorOccurredGlobalTitle'), app.getMessage('errorOccurredGlobalMessage'));

                }
            });
        }
        return false;
    },

    initialize: function() {
        _.bindAll(this);
        this.render();
    },

    render: function() {
        this.$el.html(this.template(this.model.toJSON()));
        this.$('[data-action="edit-element"]').attr("href", "/video-group/edit/" + this.model.id);
        this.$('[data-action="preview-element"]').attr("href", "/video-group/" + this.model.id);
        if (!app.User.isAdmin) {
            this.$('[data-display-type="only-admin"]').remove();
        }
        return this;
    }



});

},{}],321:[function(require,module,exports){
app.pkg("videoGroup.videoGroupsPage");
app.videoGroup.videoGroupsPage.VideoGroupsListView = Backbone.LazyLoadListView.extend({

    getCollectionElementsDisplayDiv: function() {
        return this.$('#videos-list tbody');
    }

});

},{}],322:[function(require,module,exports){
app.pkg("videoGroup.videoGroupsPage");
app.videoGroup.videoGroupsPage.VideoGroupsPageBootstrap = function() {
    new app.videoGroup.videoGroupsPage.VideoGroupsListView({
        el: $('[data-content="videos-list"]'),
        collection: new app.videoGroup.videoGroupsPage.VideoGroupsCollection(),
        listItemDisplayViewType: app.videoGroup.videoGroupsPage.VideoGroupsListItemView,
        template: app.templates['videoGroup-videoGroupsPage-VideoGroupsListView']
    });
    $('[data-main-menu-item="videos"]').addClass("active");
    $('[data-sidebar-menu-item="videos"]').addClass("active");
};

},{}],323:[function(require,module,exports){
require('./VideoGroupsCollection');
require('./VideoGroupsListItemView');
require('./VideoGroupsListView');
require('./VideoGroupsPageBootstrap');

},{"./VideoGroupsCollection":319,"./VideoGroupsListItemView":320,"./VideoGroupsListView":321,"./VideoGroupsPageBootstrap":322}],324:[function(require,module,exports){
window.app = require('./utils.js');
require('./templates');
require('./libs');
require('./app');

},{"./app":127,"./libs":335,"./templates":344,"./utils.js":345}],325:[function(require,module,exports){
// Backbone.Validation v0.7.1
//
// Copyright (c) 2011-2012 Thomas Pedersen
// Distributed under MIT License
//
// Documentation and full license available at:
// http://thedersen.com/projects/backbone-validation
Backbone.Validation=function(e){"use strict";var t={forceUpdate:!1,selector:"name",labelFormatter:"sentenceCase",valid:Function.prototype,invalid:Function.prototype},n={formatLabel:function(e,n){return a[t.labelFormatter](e,n)},format:function(){var e=Array.prototype.slice.call(arguments),t=e.shift();return t.replace(/\{(\d+)\}/g,function(t,n){return typeof e[n]!="undefined"?e[n]:t})}},r=function(t,n,i){return n=n||{},i=i||"",e.each(t,function(e,s){t.hasOwnProperty(s)&&(!e||typeof e!="object"||e instanceof Date||e instanceof RegExp?n[i+s]=e:r(e,n,i+s+"."))}),n},i=function(){var i=function(t){return e.reduce(e.keys(t.validation||{}),function(e,t){return e[t]=void 0,e},{})},o=function(t,n){var r=t.validation?t.validation[n]||{}:{};if(e.isFunction(r)||e.isString(r))r={fn:r};return e.isArray(r)||(r=[r]),e.reduce(r,function(t,n){return e.each(e.without(e.keys(n),"msg"),function(e){t.push({fn:f[e],val:n[e],msg:n.msg})}),t},[])},u=function(t,r,i,s){return e.reduce(o(t,r),function(o,u){var a=e.extend({},n,f),l=u.fn.call(a,i,r,u.val,t,s);return l===!1||o===!1?!1:l&&!o?u.msg||l:o},"")},a=function(t,n){var i,s={},o=!0,a=e.clone(n),f=r(n);return e.each(f,function(e,n){i=u(t,n,e,a),i&&(s[n]=i,o=!1)}),{invalidAttrs:s,isValid:o}},l=function(t,n){return{preValidate:function(t,n){return u(this,t,n,e.extend({},this.attributes))},isValid:function(t){var n=r(this.attributes);return e.isString(t)?!u(this,t,n[t],e.extend({},this.attributes)):e.isArray(t)?e.reduce(t,function(t,r){return t&&!u(this,r,n[r],e.extend({},this.attributes))},!0,this):(t===!0&&this.validate(),this.validation?this._isValid:!0)},validate:function(s,o){var u=this,f=!s,l=e.extend({},n,o),c=i(u),h=e.extend({},c,u.attributes,s),p=r(s||h),d=a(u,h);u._isValid=d.isValid,e.each(c,function(e,n){var r=d.invalidAttrs.hasOwnProperty(n);r||l.valid(t,n,l.selector)}),e.each(c,function(e,n){var r=d.invalidAttrs.hasOwnProperty(n),i=p.hasOwnProperty(n);r&&(i||f)&&l.invalid(t,n,d.invalidAttrs[n],l.selector)}),e.defer(function(){u.trigger("validated",u._isValid,u,d.invalidAttrs),u.trigger("validated:"+(u._isValid?"valid":"invalid"),u,d.invalidAttrs)});if(!l.forceUpdate&&e.intersection(e.keys(d.invalidAttrs),e.keys(p)).length>0)return d.invalidAttrs}}},c=function(t,n,r){e.extend(n,l(t,r))},h=function(e){delete e.validate,delete e.preValidate,delete e.isValid},p=function(e){c(this.view,e,this.options)},d=function(e){h(e)};return{version:"0.7.1",configure:function(n){e.extend(t,n)},bind:function(n,r){var i=n.model,o=n.collection;r=e.extend({},t,s,r);if(typeof i=="undefined"&&typeof o=="undefined")throw"Before you execute the binding your view must have a model or a collection.\nSee http://thedersen.com/projects/backbone-validation/#using-form-model-validation for more information.";i?c(n,i,r):o&&(o.each(function(e){c(n,e,r)}),o.bind("add",p,{view:n,options:r}),o.bind("remove",d))},unbind:function(e){var t=e.model,n=e.collection;t&&h(e.model),n&&(n.each(function(e){h(e)}),n.unbind("add",p),n.unbind("remove",d))},mixin:l(null,t)}}(),s=i.callbacks={valid:function(e,t,n){e.$("["+n+'~="'+t+'"]').removeClass("invalid").removeAttr("data-error")},invalid:function(e,t,n,r){e.$("["+r+'~="'+t+'"]').addClass("invalid").attr("data-error",n)}},o=i.patterns={digits:/^\d+$/,number:/^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,email:/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,url:/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i},u=i.messages={required:"{0} is required",acceptance:"{0} must be accepted",min:"{0} must be greater than or equal to {1}",max:"{0} must be less than or equal to {1}",range:"{0} must be between {1} and {2}",length:"{0} must be {1} characters",minLength:"{0} must be at least {1} characters",maxLength:"{0} must be at most {1} characters",rangeLength:"{0} must be between {1} and {2} characters",oneOf:"{0} must be one of: {1}",equalTo:"{0} must be the same as {1}",pattern:"{0} must be a valid {1}"},a=i.labelFormatters={none:function(e){return e},sentenceCase:function(e){return e.replace(/(?:^\w|[A-Z]|\b\w)/g,function(e,t){return t===0?e.toUpperCase():" "+e.toLowerCase()}).replace("_"," ")},label:function(e,t){return t.labels&&t.labels[e]||a.sentenceCase(e,t)}},f=i.validators=function(){var t=String.prototype.trim?function(e){return e===null?"":String.prototype.trim.call(e)}:function(e){var t=/^\s+/,n=/\s+$/;return e===null?"":e.toString().replace(t,"").replace(n,"")},n=function(t){return e.isNumber(t)||e.isString(t)&&t.match(o.number)},r=function(n){return!(e.isNull(n)||e.isUndefined(n)||e.isString(n)&&t(n)==="")};return{fn:function(t,n,r,i,s){return e.isString(r)&&(r=i[r]),r.call(i,t,n,s)},required:function(t,n,i,s,o){var a=e.isFunction(i)?i.call(s,t,n,o):i;if(!a&&!r(t))return!1;if(a&&!r(t))return this.format(u.required,this.formatLabel(n,s))},acceptance:function(t,n,r,i){if(t!=="true"&&(!e.isBoolean(t)||t===!1))return this.format(u.acceptance,this.formatLabel(n,i))},min:function(e,t,r,i){if(!n(e)||e<r)return this.format(u.min,this.formatLabel(t,i),r)},max:function(e,t,r,i){if(!n(e)||e>r)return this.format(u.max,this.formatLabel(t,i),r)},range:function(e,t,r,i){if(!n(e)||e<r[0]||e>r[1])return this.format(u.range,this.formatLabel(t,i),r[0],r[1])},length:function(e,n,i,s){if(!r(e)||t(e).length!==i)return this.format(u.length,this.formatLabel(n,s),i)},minLength:function(e,n,i,s){if(!r(e)||t(e).length<i)return this.format(u.minLength,this.formatLabel(n,s),i)},maxLength:function(e,n,i,s){if(!r(e)||t(e).length>i)return this.format(u.maxLength,this.formatLabel(n,s),i)},rangeLength:function(e,n,i,s){if(!r(e)||t(e).length<i[0]||t(e).length>i[1])return this.format(u.rangeLength,this.formatLabel(n,s),i[0],i[1])},oneOf:function(t,n,r,i){if(!e.include(r,t))return this.format(u.oneOf,this.formatLabel(n,i),r.join(", "))},equalTo:function(e,t,n,r,i){if(e!==i[n])return this.format(u.equalTo,this.formatLabel(t,r),this.formatLabel(n,r))},pattern:function(e,t,n,i){if(!r(e)||!e.toString().match(o[n]||n))return this.format(u.pattern,this.formatLabel(t,i),n)}}}();return i}(_);
},{}],326:[function(require,module,exports){
require('./backbone-validation-min');





},{"./backbone-validation-min":325}],327:[function(require,module,exports){
_.extend(Backbone.Validation.callbacks, {
    valid: function (view, attr, selector) {
        var control = view.$('[' + selector + '=' + attr + ']');
        var group = control.parents(".game-form-item");
        group.removeClass("error");

        if (control.data("error-style") === "tooltip") {
            // CAUTION: calling tooltip("hide") on an uninitialized tooltip
            // causes bootstraps tooltips to crash somehow...
            if (control.data("tooltip"))
                control.tooltip("hide");
        }
        else if (control.data("error-style") === "inline") {
            group.find(".help-inline.error-message").remove();
        }
        else {
            group.find(".help-block.error-message").remove();
        }
    },
    invalid: function (view, attr, error, selector) {
        var control = view.$('[' + selector + '=' + attr + ']');
        var group = control.parents(".game-form-item");
        group.addClass("error");

        if (control.data("error-style") === "tooltip") {
            var position = control.data("tooltip-position") || "right";
            control.tooltip({
                placement: position,
                trigger: "manual",
                title: error
            });
            control.tooltip("show");
        }
        else if (control.data("error-style") === "inline") {
            if (group.find(".help-inline").length === 0) {
                group.find(".game-form-item-input").append("<span class=\"help-inline error-message\"></span>");
            }
            var target = group.find(".help-inline");
            target.text(error);
        }
        else {
            if (group.find(".help-block").length === 0) {
                group.find(".game-form-item-input").append("<p class=\"help-block error-message\"></p>");
            }
            var target = group.find(".help-block");
            target.text(error);
        }
    }
});

},{}],328:[function(require,module,exports){
/* ===================================================
 * bootstrap-transition.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#transitions
 * ===================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
     * ======================================================= */

    $(function () {

        $.support.transition = (function () {

            var transitionEnd = (function () {

                var el = document.createElement('bootstrap')
                    , transEndEventNames = {
                        'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd otransitionend', 'transition': 'transitionend'
                    }
                    , name

                for (name in transEndEventNames) {
                    if (el.style[name] !== undefined) {
                        return transEndEventNames[name]
                    }
                }

            }())

            return transitionEnd && {
                end: transitionEnd
            }

        })()

    })

}(window.jQuery);
/* =========================================================
 * bootstrap-modal.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#modals
 * =========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */


!function ($) {

    "use strict"; // jshint ;_;


    /* MODAL CLASS DEFINITION
     * ====================== */

    var Modal = function (element, options) {
        this.options = options
        this.$element = $(element)
            .delegate('[data-dismiss="modal"]', 'click.dismiss.modal', $.proxy(this.hide, this))
        this.options.remote && this.$element.find('.modal-body').load(this.options.remote)
    }

    Modal.prototype = {

        constructor: Modal, toggle: function () {
            return this[!this.isShown ? 'show' : 'hide']()
        }, show: function () {
            var that = this
                , e = $.Event('show')

            this.$element.trigger(e)

            if (this.isShown || e.isDefaultPrevented()) return

            this.isShown = true

            this.escape()

            this.backdrop(function () {
                var transition = $.support.transition && that.$element.hasClass('fade')

                if (!that.$element.parent().length) {
                    that.$element.appendTo(document.body) //don't move modals dom position
                }

                that.$element.show()

                if (transition) {
                    that.$element[0].offsetWidth // force reflow
                }

                that.$element
                    .addClass('in')
                    .attr('aria-hidden', false)

                that.enforceFocus()

                transition ?
                    that.$element.one($.support.transition.end, function () {
                        that.$element.focus().trigger('shown')
                    }) :
                    that.$element.focus().trigger('shown')

            })
        }, hide: function (e) {
            e && e.preventDefault()

            var that = this

            e = $.Event('hide')

            this.$element.trigger(e)

            if (!this.isShown || e.isDefaultPrevented()) return

            this.isShown = false

            this.escape()

            $(document).off('focusin.modal')

            this.$element
                .removeClass('in')
                .attr('aria-hidden', true)

            $.support.transition && this.$element.hasClass('fade') ?
                this.hideWithTransition() :
                this.hideModal()
        }, enforceFocus: function () {
            var that = this
            $(document).on('focusin.modal', function (e) {
                if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
                    that.$element.focus()
                }
            })
        }, escape: function () {
            var that = this
            if (this.isShown && this.options.keyboard) {
                this.$element.on('keyup.dismiss.modal', function (e) {
                    e.which == 27 && that.hide()
                })
            } else if (!this.isShown) {
                this.$element.off('keyup.dismiss.modal')
            }
        }, hideWithTransition: function () {
            var that = this
                , timeout = setTimeout(function () {
                    that.$element.off($.support.transition.end)
                    that.hideModal()
                }, 500)

            this.$element.one($.support.transition.end, function () {
                clearTimeout(timeout)
                that.hideModal()
            })
        }, hideModal: function () {
            var that = this
            this.$element.hide()
            this.backdrop(function () {
                that.removeBackdrop()
                that.$element.trigger('hidden')
            })
        }, removeBackdrop: function () {
            this.$backdrop && this.$backdrop.remove()
            this.$backdrop = null
        }, backdrop: function (callback) {
            var that = this
                , animate = this.$element.hasClass('fade') ? 'fade' : ''

            if (this.isShown && this.options.backdrop) {
                var doAnimate = $.support.transition && animate

                this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
                    .appendTo(document.body)

                this.$backdrop.click(
                    this.options.backdrop == 'static' ?
                        $.proxy(this.$element[0].focus, this.$element[0])
                        : $.proxy(this.hide, this)
                )

                if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

                this.$backdrop.addClass('in')

                if (!callback) return

                doAnimate ?
                    this.$backdrop.one($.support.transition.end, callback) :
                    callback()

            } else if (!this.isShown && this.$backdrop) {
                this.$backdrop.removeClass('in')

                $.support.transition && this.$element.hasClass('fade') ?
                    this.$backdrop.one($.support.transition.end, callback) :
                    callback()

            } else if (callback) {
                callback()
            }
        }
    }


    /* MODAL PLUGIN DEFINITION
     * ======================= */

    var old = $.fn.modal

    $.fn.modal = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('modal')
                , options = $.extend({}, $.fn.modal.defaults, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('modal', (data = new Modal(this, options)))
            if (typeof option == 'string') data[option]()
            else if (options.show) data.show()
        })
    }

    $.fn.modal.defaults = {
        backdrop: true, keyboard: true, show: true
    }

    $.fn.modal.Constructor = Modal


    /* MODAL NO CONFLICT
     * ================= */

    $.fn.modal.noConflict = function () {
        $.fn.modal = old
        return this
    }


    /* MODAL DATA-API
     * ============== */

    $(document).on('click.modal.data-api', '[data-toggle="modal"]', function (e) {
        var $this = $(this)
            , href = $this.attr('href')
            , $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) //strip for ie7
            , option = $target.data('modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

        e.preventDefault()

        $target
            .modal(option)
            .one('hide', function () {
                $this.focus()
            })
    })

}(window.jQuery);

/* ============================================================
 * bootstrap-dropdown.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#dropdowns
 * ============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

    "use strict"; // jshint ;_;


    /* DROPDOWN CLASS DEFINITION
     * ========================= */

    var toggle = '[data-toggle=dropdown]'
        , Dropdown = function (element) {
            var $el = $(element).on('click.dropdown.data-api', this.toggle)
            $('html').on('click.dropdown.data-api', function () {
                $el.parent().removeClass('open')
            })
        }

    Dropdown.prototype = {

        constructor: Dropdown, toggle: function (e) {
            var $this = $(this)
                , $parent
                , isActive

            if ($this.is('.disabled, :disabled')) return

            $parent = getParent($this)

            isActive = $parent.hasClass('open')

            clearMenus()

            if (!isActive) {
                if ('ontouchstart' in document.documentElement) {
                    // if mobile we we use a backdrop because click events don't delegate
                    $('<div class="dropdown-backdrop"/>').insertBefore($(this)).on('click', clearMenus)
                }
                $parent.toggleClass('open')
            }

            $this.focus()

            return false
        }, keydown: function (e) {
            var $this
                , $items
                , $active
                , $parent
                , isActive
                , index

            if (!/(38|40|27)/.test(e.keyCode)) return

            $this = $(this)

            e.preventDefault()
            e.stopPropagation()

            if ($this.is('.disabled, :disabled')) return

            $parent = getParent($this)

            isActive = $parent.hasClass('open')

            if (!isActive || (isActive && e.keyCode == 27)) {
                if (e.which == 27) $parent.find(toggle).focus()
                return $this.click()
            }

            $items = $('[role=menu] li:not(.divider):visible a', $parent)

            if (!$items.length) return

            index = $items.index($items.filter(':focus'))

            if (e.keyCode == 38 && index > 0) index--                                        // up
            if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
            if (!~index) index = 0

            $items
                .eq(index)
                .focus()
        }

    }

    function clearMenus() {
        $('.dropdown-backdrop').remove()
        $(toggle).each(function () {
            getParent($(this)).removeClass('open')
        })
    }

    function getParent($this) {
        var selector = $this.attr('data-target')
            , $parent

        if (!selector) {
            selector = $this.attr('href')
            selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
        }

        $parent = selector && $(selector)

        if (!$parent || !$parent.length) $parent = $this.parent()

        return $parent
    }


    /* DROPDOWN PLUGIN DEFINITION
     * ========================== */

    var old = $.fn.dropdown

    $.fn.dropdown = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('dropdown')
            if (!data) $this.data('dropdown', (data = new Dropdown(this)))
            if (typeof option == 'string') data[option].call($this)
        })
    }

    $.fn.dropdown.Constructor = Dropdown


    /* DROPDOWN NO CONFLICT
     * ==================== */

    $.fn.dropdown.noConflict = function () {
        $.fn.dropdown = old
        return this
    }


    /* APPLY TO STANDARD DROPDOWN ELEMENTS
     * =================================== */

    $(document)
        .on('click.dropdown.data-api', clearMenus)
        .on('click.dropdown.data-api', '.dropdown form', function (e) {
            e.stopPropagation()
        })
        .on('click.dropdown.data-api', toggle, Dropdown.prototype.toggle)
        .on('keydown.dropdown.data-api', toggle + ', [role=menu]', Dropdown.prototype.keydown)

}(window.jQuery);

/* =============================================================
 * bootstrap-scrollspy.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#scrollspy
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* SCROLLSPY CLASS DEFINITION
     * ========================== */

    function ScrollSpy(element, options) {
        var process = $.proxy(this.process, this)
            , $element = $(element).is('body') ? $(window) : $(element)
            , href
        this.options = $.extend({}, $.fn.scrollspy.defaults, options)
        this.$scrollElement = $element.on('scroll.scroll-spy.data-api', process)
        this.selector = (this.options.target
            || ((href = $(element).attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
            || '') + ' .nav li > a'
        this.$body = $('body')
        this.refresh()
        this.process()
    }

    ScrollSpy.prototype = {

        constructor: ScrollSpy, refresh: function () {
            var self = this
                , $targets

            this.offsets = $([])
            this.targets = $([])

            $targets = this.$body
                .find(this.selector)
                .map(function () {
                    var $el = $(this)
                        , href = $el.data('target') || $el.attr('href')
                        , $href = /^#\w/.test(href) && $(href)
                    return ( $href
                        && $href.length
                        && [
                        [ $href.position().top + (!$.isWindow(self.$scrollElement.get(0)) && self.$scrollElement.scrollTop()), href ]
                    ] ) || null
                })
                .sort(function (a, b) {
                    return a[0] - b[0]
                })
                .each(function () {
                    self.offsets.push(this[0])
                    self.targets.push(this[1])
                })
        }, process: function () {
            var scrollTop = this.$scrollElement.scrollTop() + this.options.offset
                , scrollHeight = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight
                , maxScroll = scrollHeight - this.$scrollElement.height()
                , offsets = this.offsets
                , targets = this.targets
                , activeTarget = this.activeTarget
                , i

            if (scrollTop >= maxScroll) {
                return activeTarget != (i = targets.last()[0])
                    && this.activate(i)
            }

            for (i = offsets.length; i--;) {
                activeTarget != targets[i]
                    && scrollTop >= offsets[i]
                    && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
                && this.activate(targets[i])
            }
        }, activate: function (target) {
            var active
                , selector

            this.activeTarget = target

            $(this.selector)
                .parent('.active')
                .removeClass('active')

            selector = this.selector
                + '[data-target="' + target + '"],'
                + this.selector + '[href="' + target + '"]'

            active = $(selector)
                .parent('li')
                .addClass('active')

            if (active.parent('.dropdown-menu').length) {
                active = active.closest('li.dropdown').addClass('active')
            }

            active.trigger('activate')
        }

    }


    /* SCROLLSPY PLUGIN DEFINITION
     * =========================== */

    var old = $.fn.scrollspy

    $.fn.scrollspy = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('scrollspy')
                , options = typeof option == 'object' && option
            if (!data) $this.data('scrollspy', (data = new ScrollSpy(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.scrollspy.Constructor = ScrollSpy

    $.fn.scrollspy.defaults = {
        offset: 10
    }


    /* SCROLLSPY NO CONFLICT
     * ===================== */

    $.fn.scrollspy.noConflict = function () {
        $.fn.scrollspy = old
        return this
    }


    /* SCROLLSPY DATA-API
     * ================== */

    $(window).on('load', function () {
        $('[data-spy="scroll"]').each(function () {
            var $spy = $(this)
            $spy.scrollspy($spy.data())
        })
    })

}(window.jQuery);
/* ========================================================
 * bootstrap-tab.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#tabs
 * ========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* TAB CLASS DEFINITION
     * ==================== */

    var Tab = function (element) {
        this.element = $(element)
    }

    Tab.prototype = {

        constructor: Tab, show: function () {
            var $this = this.element
                , $ul = $this.closest('ul:not(.dropdown-menu)')
                , selector = $this.attr('data-target')
                , previous
                , $target
                , e

            if (!selector) {
                selector = $this.attr('href')
                selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
            }

            if ($this.parent('li').hasClass('active')) return

            previous = $ul.find('.active:last a')[0]

            e = $.Event('show', {
                relatedTarget: previous
            })

            $this.trigger(e)

            if (e.isDefaultPrevented()) return

            $target = $(selector)

            this.activate($this.parent('li'), $ul)
            this.activate($target, $target.parent(), function () {
                $this.trigger({
                    type: 'shown', relatedTarget: previous
                })
            })
        }, activate: function (element, container, callback) {
            var $active = container.find('> .active')
                , transition = callback
                    && $.support.transition
                    && $active.hasClass('fade')

            function next() {
                $active
                    .removeClass('active')
                    .find('> .dropdown-menu > .active')
                    .removeClass('active')

                element.addClass('active')

                if (transition) {
                    element[0].offsetWidth // reflow for transition
                    element.addClass('in')
                } else {
                    element.removeClass('fade')
                }

                if (element.parent('.dropdown-menu')) {
                    element.closest('li.dropdown').addClass('active')
                }

                callback && callback()
            }

            transition ?
                $active.one($.support.transition.end, next) :
                next()

            $active.removeClass('in')
        }
    }


    /* TAB PLUGIN DEFINITION
     * ===================== */

    var old = $.fn.tab

    $.fn.tab = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('tab')
            if (!data) $this.data('tab', (data = new Tab(this)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.tab.Constructor = Tab


    /* TAB NO CONFLICT
     * =============== */

    $.fn.tab.noConflict = function () {
        $.fn.tab = old
        return this
    }


    /* TAB DATA-API
     * ============ */

    $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
        e.preventDefault()
        $(this).tab('show')
    })

}(window.jQuery);
/* ===========================================================
 * bootstrap-tooltip.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#tooltips
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ===========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* TOOLTIP PUBLIC CLASS DEFINITION
     * =============================== */

    var Tooltip = function (element, options) {
        this.init('tooltip', element, options)
    }

    Tooltip.prototype = {

        constructor: Tooltip, init: function (type, element, options) {
            var eventIn
                , eventOut
                , triggers
                , trigger
                , i

            this.type = type
            this.$element = $(element)
            this.options = this.getOptions(options)
            this.enabled = true

            triggers = this.options.trigger.split(' ')

            for (i = triggers.length; i--;) {
                trigger = triggers[i]
                if (trigger == 'click') {
                    this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
                } else if (trigger != 'manual') {
                    eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
                    eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'
                    this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
                    this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
                }
            }

            this.options.selector ?
                (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
                this.fixTitle()
        }, getOptions: function (options) {
            options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options)

            if (options.delay && typeof options.delay == 'number') {
                options.delay = {
                    show: options.delay, hide: options.delay
                }
            }

            return options
        }, enter: function (e) {
            var defaults = $.fn[this.type].defaults
                , options = {}
                , self

            this._options && $.each(this._options, function (key, value) {
                if (defaults[key] != value) options[key] = value
            }, this)

            self = $(e.currentTarget)[this.type](options).data(this.type)

            if (!self.options.delay || !self.options.delay.show) return self.show()

            clearTimeout(this.timeout)
            self.hoverState = 'in'
            this.timeout = setTimeout(function () {
                if (self.hoverState == 'in') self.show()
            }, self.options.delay.show)
        }, leave: function (e) {
            var self = $(e.currentTarget)[this.type](this._options).data(this.type)

            if (this.timeout) clearTimeout(this.timeout)
            if (!self.options.delay || !self.options.delay.hide) return self.hide()

            self.hoverState = 'out'
            this.timeout = setTimeout(function () {
                if (self.hoverState == 'out') self.hide()
            }, self.options.delay.hide)
        }, show: function () {
            var $tip
                , pos
                , actualWidth
                , actualHeight
                , placement
                , tp
                , e = $.Event('show')

            if (this.hasContent() && this.enabled) {
                this.$element.trigger(e)
                if (e.isDefaultPrevented()) return
                $tip = this.tip()
                this.setContent()

                if (this.options.animation) {
                    $tip.addClass('fade')
                }

                placement = typeof this.options.placement == 'function' ?
                    this.options.placement.call(this, $tip[0], this.$element[0]) :
                    this.options.placement

                $tip
                    .detach()
                    .css({ top: 0, left: 0, display: 'block' })

                this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

                pos = this.getPosition()

                actualWidth = $tip[0].offsetWidth
                actualHeight = $tip[0].offsetHeight

                switch (placement) {
                    case 'bottom':
                        tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
                        break
                    case 'top':
                        tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
                        break
                    case 'left':
                        tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
                        break
                    case 'right':
                        tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
                        break
                }

                this.applyPlacement(tp, placement)
                this.$element.trigger('shown')
            }
        }, applyPlacement: function (offset, placement) {
            var $tip = this.tip()
                , width = $tip[0].offsetWidth
                , height = $tip[0].offsetHeight
                , actualWidth
                , actualHeight
                , delta
                , replace

            $tip
                .offset(offset)
                .addClass(placement)
                .addClass('in')

            actualWidth = $tip[0].offsetWidth
            actualHeight = $tip[0].offsetHeight

            if (placement == 'top' && actualHeight != height) {
                offset.top = offset.top + height - actualHeight
                replace = true
            }

            if (placement == 'bottom' || placement == 'top') {
                delta = 0

                if (offset.left < 0) {
                    delta = offset.left * -2
                    offset.left = 0
                    $tip.offset(offset)
                    actualWidth = $tip[0].offsetWidth
                    actualHeight = $tip[0].offsetHeight
                }

                this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
            } else {
                this.replaceArrow(actualHeight - height, actualHeight, 'top')
            }

            if (replace) $tip.offset(offset)
        }, replaceArrow: function (delta, dimension, position) {
            this
                .arrow()
                .css(position, delta ? (50 * (1 - delta / dimension) + "%") : '')
        }, setContent: function () {
            var $tip = this.tip()
                , title = this.getTitle()

            $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
            $tip.removeClass('fade in top bottom left right')
        }, hide: function () {
            var that = this
                , $tip = this.tip()
                , e = $.Event('hide')

            this.$element.trigger(e)
            if (e.isDefaultPrevented()) return

            $tip.removeClass('in')

            function removeWithAnimation() {
                var timeout = setTimeout(function () {
                    $tip.off($.support.transition.end).detach()
                }, 500)

                $tip.one($.support.transition.end, function () {
                    clearTimeout(timeout)
                    $tip.detach()
                })
            }

            $.support.transition && this.$tip.hasClass('fade') ?
                removeWithAnimation() :
                $tip.detach()

            this.$element.trigger('hidden')

            return this
        }, fixTitle: function () {
            var $e = this.$element
            if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
                $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
            }
        }, hasContent: function () {
            return this.getTitle()
        }, getPosition: function () {
            var el = this.$element[0]
            return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
                width: el.offsetWidth, height: el.offsetHeight
            }, this.$element.offset())
        }, getTitle: function () {
            var title
                , $e = this.$element
                , o = this.options

            title = $e.attr('data-original-title')
                || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title)

            return title
        }, tip: function () {
            return this.$tip = this.$tip || $(this.options.template)
        }, arrow: function () {
            return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
        }, validate: function () {
            if (!this.$element[0].parentNode) {
                this.hide()
                this.$element = null
                this.options = null
            }
        }, enable: function () {
            this.enabled = true
        }, disable: function () {
            this.enabled = false
        }, toggleEnabled: function () {
            this.enabled = !this.enabled
        }, toggle: function (e) {
            var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this
            self.tip().hasClass('in') ? self.hide() : self.show()
        }, destroy: function () {
            this.hide().$element.off('.' + this.type).removeData(this.type)
        }

    }


    /* TOOLTIP PLUGIN DEFINITION
     * ========================= */

    var old = $.fn.tooltip

    $.fn.tooltip = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('tooltip')
                , options = typeof option == 'object' && option
            if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.tooltip.Constructor = Tooltip

    $.fn.tooltip.defaults = {
        animation: true, placement: 'top', selector: false, template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: 'hover focus', title: '', delay: 0, html: false, container: false
    }


    /* TOOLTIP NO CONFLICT
     * =================== */

    $.fn.tooltip.noConflict = function () {
        $.fn.tooltip = old
        return this
    }

}(window.jQuery);

/* ===========================================================
 * bootstrap-popover.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#popovers
 * ===========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* POPOVER PUBLIC CLASS DEFINITION
     * =============================== */

    var Popover = function (element, options) {
        this.init('popover', element, options)
    }


    /* NOTE: POPOVER EXTENDS BOOTSTRAP-TOOLTIP.js
     ========================================== */

    Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype, {

        constructor: Popover, setContent: function () {
            var $tip = this.tip()
                , title = this.getTitle()
                , content = this.getContent()

            $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
            $tip.find('.popover-content')[this.options.html ? 'html' : 'text'](content)

            $tip.removeClass('fade top bottom left right in')
        }, hasContent: function () {
            return this.getTitle() || this.getContent()
        }, getContent: function () {
            var content
                , $e = this.$element
                , o = this.options

            content = (typeof o.content == 'function' ? o.content.call($e[0]) : o.content)
                || $e.attr('data-content')

            return content
        }, tip: function () {
            if (!this.$tip) {
                this.$tip = $(this.options.template)
            }
            return this.$tip
        }, destroy: function () {
            this.hide().$element.off('.' + this.type).removeData(this.type)
        }

    })


    /* POPOVER PLUGIN DEFINITION
     * ======================= */

    var old = $.fn.popover

    $.fn.popover = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('popover')
                , options = typeof option == 'object' && option
            if (!data) $this.data('popover', (data = new Popover(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.popover.Constructor = Popover

    $.fn.popover.defaults = $.extend({}, $.fn.tooltip.defaults, {
        placement: 'right', trigger: 'click', content: '', template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    })


    /* POPOVER NO CONFLICT
     * =================== */

    $.fn.popover.noConflict = function () {
        $.fn.popover = old
        return this
    }

}(window.jQuery);

/* ==========================================================
 * bootstrap-affix.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#affix
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* AFFIX CLASS DEFINITION
     * ====================== */

    var Affix = function (element, options) {
        this.options = $.extend({}, $.fn.affix.defaults, options)
        this.$window = $(window)
            .on('scroll.affix.data-api', $.proxy(this.checkPosition, this))
            .on('click.affix.data-api', $.proxy(function () {
                setTimeout($.proxy(this.checkPosition, this), 1)
            }, this))
        this.$element = $(element)
        this.checkPosition()
    }

    Affix.prototype.checkPosition = function () {
        if (!this.$element.is(':visible')) return

        var scrollHeight = $(document).height()
            , scrollTop = this.$window.scrollTop()
            , position = this.$element.offset()
            , offset = this.options.offset
            , offsetBottom = offset.bottom
            , offsetTop = offset.top
            , reset = 'affix affix-top affix-bottom'
            , affix

        if (typeof offset != 'object') offsetBottom = offsetTop = offset
        if (typeof offsetTop == 'function') offsetTop = offset.top()
        if (typeof offsetBottom == 'function') offsetBottom = offset.bottom()

        affix = this.unpin != null && (scrollTop + this.unpin <= position.top) ?
            false : offsetBottom != null && (position.top + this.$element.height() >= scrollHeight - offsetBottom) ?
            'bottom' : offsetTop != null && scrollTop <= offsetTop ?
            'top' : false

        if (this.affixed === affix) return

        this.affixed = affix
        this.unpin = affix == 'bottom' ? position.top - scrollTop : null

        this.$element.removeClass(reset).addClass('affix' + (affix ? '-' + affix : ''))
    }


    /* AFFIX PLUGIN DEFINITION
     * ======================= */

    var old = $.fn.affix

    $.fn.affix = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('affix')
                , options = typeof option == 'object' && option
            if (!data) $this.data('affix', (data = new Affix(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.affix.Constructor = Affix

    $.fn.affix.defaults = {
        offset: 0
    }


    /* AFFIX NO CONFLICT
     * ================= */

    $.fn.affix.noConflict = function () {
        $.fn.affix = old
        return this
    }


    /* AFFIX DATA-API
     * ============== */

    $(window).on('load', function () {
        $('[data-spy="affix"]').each(function () {
            var $spy = $(this)
                , data = $spy.data()

            data.offset = data.offset || {}

            data.offsetBottom && (data.offset.bottom = data.offsetBottom)
            data.offsetTop && (data.offset.top = data.offsetTop)

            $spy.affix(data)
        })
    })


}(window.jQuery);
/* ==========================================================
 * bootstrap-alert.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#alerts
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* ALERT CLASS DEFINITION
     * ====================== */

    var dismiss = '[data-dismiss="alert"]'
        , Alert = function (el) {
            $(el).on('click', dismiss, this.close)
        }

    Alert.prototype.close = function (e) {
        var $this = $(this)
            , selector = $this.attr('data-target')
            , $parent

        if (!selector) {
            selector = $this.attr('href')
            selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
        }

        $parent = $(selector)

        e && e.preventDefault()

        $parent.length || ($parent = $this.hasClass('alert') ? $this : $this.parent())

        $parent.trigger(e = $.Event('close'))

        if (e.isDefaultPrevented()) return

        $parent.removeClass('in')

        function removeElement() {
            $parent
                .trigger('closed')
                .remove()
        }

        $.support.transition && $parent.hasClass('fade') ?
            $parent.on($.support.transition.end, removeElement) :
            removeElement()
    }


    /* ALERT PLUGIN DEFINITION
     * ======================= */

    var old = $.fn.alert

    $.fn.alert = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('alert')
            if (!data) $this.data('alert', (data = new Alert(this)))
            if (typeof option == 'string') data[option].call($this)
        })
    }

    $.fn.alert.Constructor = Alert


    /* ALERT NO CONFLICT
     * ================= */

    $.fn.alert.noConflict = function () {
        $.fn.alert = old
        return this
    }


    /* ALERT DATA-API
     * ============== */

    $(document).on('click.alert.data-api', dismiss, Alert.prototype.close)

}(window.jQuery);
/* ============================================================
 * bootstrap-button.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#buttons
 * ============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

    "use strict"; // jshint ;_;


    /* BUTTON PUBLIC CLASS DEFINITION
     * ============================== */

    var Button = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, $.fn.button.defaults, options)
    }

    Button.prototype.setState = function (state) {
        var d = 'disabled'
            , $el = this.$element
            , data = $el.data()
            , val = $el.is('input') ? 'val' : 'html'

        state = state + 'Text'
        data.resetText || $el.data('resetText', $el[val]())

        $el[val](data[state] || this.options[state])

        // push to event loop to allow forms to submit
        setTimeout(function () {
            state == 'loadingText' ?
                $el.addClass(d).attr(d, d) :
                $el.removeClass(d).removeAttr(d)
        }, 0)
    }

    Button.prototype.toggle = function () {
        var $parent = this.$element.closest('[data-toggle="buttons-radio"]')

        $parent && $parent
            .find('.active')
            .removeClass('active')

        this.$element.toggleClass('active')
    }


    /* BUTTON PLUGIN DEFINITION
     * ======================== */

    var old = $.fn.button

    $.fn.button = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('button')
                , options = typeof option == 'object' && option
            if (!data) $this.data('button', (data = new Button(this, options)))
            if (option == 'toggle') data.toggle()
            else if (option) data.setState(option)
        })
    }

    $.fn.button.defaults = {
        loadingText: 'loading...'
    }

    $.fn.button.Constructor = Button


    /* BUTTON NO CONFLICT
     * ================== */

    $.fn.button.noConflict = function () {
        $.fn.button = old
        return this
    }


    /* BUTTON DATA-API
     * =============== */

    $(document).on('click.button.data-api', '[data-toggle^=button]', function (e) {
        var $btn = $(e.target)
        if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
        $btn.button('toggle')
    })

}(window.jQuery);
/* =============================================================
 * bootstrap-collapse.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#collapse
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

    "use strict"; // jshint ;_;


    /* COLLAPSE PUBLIC CLASS DEFINITION
     * ================================ */

    var Collapse = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, $.fn.collapse.defaults, options)

        if (this.options.parent) {
            this.$parent = $(this.options.parent)
        }

        this.options.toggle && this.toggle()
    }

    Collapse.prototype = {

        constructor: Collapse, dimension: function () {
            var hasWidth = this.$element.hasClass('width')
            return hasWidth ? 'width' : 'height'
        }, show: function () {
            var dimension
                , scroll
                , actives
                , hasData

            if (this.transitioning || this.$element.hasClass('in')) return

            dimension = this.dimension()
            scroll = $.camelCase(['scroll', dimension].join('-'))
            actives = this.$parent && this.$parent.find('> .accordion-group > .in')

            if (actives && actives.length) {
                hasData = actives.data('collapse')
                if (hasData && hasData.transitioning) return
                actives.collapse('hide')
                hasData || actives.data('collapse', null)
            }

            this.$element[dimension](0)
            this.transition('addClass', $.Event('show'), 'shown')
            $.support.transition && this.$element[dimension](this.$element[0][scroll])
        }, hide: function () {
            var dimension
            if (this.transitioning || !this.$element.hasClass('in')) return
            dimension = this.dimension()
            this.reset(this.$element[dimension]())
            this.transition('removeClass', $.Event('hide'), 'hidden')
            this.$element[dimension](0)
        }, reset: function (size) {
            var dimension = this.dimension()

            this.$element
                .removeClass('collapse')
                [dimension](size || 'auto')
                [0].offsetWidth

            this.$element[size !== null ? 'addClass' : 'removeClass']('collapse')

            return this
        }, transition: function (method, startEvent, completeEvent) {
            var that = this
                , complete = function () {
                    if (startEvent.type == 'show') that.reset()
                    that.transitioning = 0
                    that.$element.trigger(completeEvent)
                }

            this.$element.trigger(startEvent)

            if (startEvent.isDefaultPrevented()) return

            this.transitioning = 1

            this.$element[method]('in')

            $.support.transition && this.$element.hasClass('collapse') ?
                this.$element.one($.support.transition.end, complete) :
                complete()
        }, toggle: function () {
            this[this.$element.hasClass('in') ? 'hide' : 'show']()
        }

    }


    /* COLLAPSE PLUGIN DEFINITION
     * ========================== */

    var old = $.fn.collapse

    $.fn.collapse = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('collapse')
                , options = $.extend({}, $.fn.collapse.defaults, $this.data(), typeof option == 'object' && option)
            if (!data) $this.data('collapse', (data = new Collapse(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.collapse.defaults = {
        toggle: true
    }

    $.fn.collapse.Constructor = Collapse


    /* COLLAPSE NO CONFLICT
     * ==================== */

    $.fn.collapse.noConflict = function () {
        $.fn.collapse = old
        return this
    }


    /* COLLAPSE DATA-API
     * ================= */

    $(document).on('click.collapse.data-api', '[data-toggle=collapse]', function (e) {
        var $this = $(this), href
            , target = $this.attr('data-target')
                || e.preventDefault()
                || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
            , option = $(target).data('collapse') ? 'toggle' : $this.data()
        $this[$(target).hasClass('in') ? 'addClass' : 'removeClass']('collapsed')
        $(target).collapse(option)
    })

}(window.jQuery);
/* ==========================================================
 * bootstrap-carousel.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#carousel
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

    "use strict"; // jshint ;_;


    /* CAROUSEL CLASS DEFINITION
     * ========================= */

    var Carousel = function (element, options) {
        this.$element = $(element)
        this.$indicators = this.$element.find('.carousel-indicators')
        this.options = options
        this.options.pause == 'hover' && this.$element
            .on('mouseenter', $.proxy(this.pause, this))
            .on('mouseleave', $.proxy(this.cycle, this))
    }

    Carousel.prototype = {

        cycle: function (e) {
            if (!e) this.paused = false
            if (this.interval) clearInterval(this.interval);
            this.options.interval
                && !this.paused
            && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
            return this
        }, getActiveIndex: function () {
            this.$active = this.$element.find('.item.active')
            this.$items = this.$active.parent().children()
            return this.$items.index(this.$active)
        }, to: function (pos) {
            var activeIndex = this.getActiveIndex()
                , that = this

            if (pos > (this.$items.length - 1) || pos < 0) return

            if (this.sliding) {
                return this.$element.one('slid', function () {
                    that.to(pos)
                })
            }

            if (activeIndex == pos) {
                return this.pause().cycle()
            }

            return this.slide(pos > activeIndex ? 'next' : 'prev', $(this.$items[pos]))
        }, pause: function (e) {
            if (!e) this.paused = true
            if (this.$element.find('.next, .prev').length && $.support.transition.end) {
                this.$element.trigger($.support.transition.end)
                this.cycle(true)
            }
            clearInterval(this.interval)
            this.interval = null
            return this
        }, next: function () {
            if (this.sliding) return
            return this.slide('next')
        }, prev: function () {
            if (this.sliding) return
            return this.slide('prev')
        }, slide: function (type, next) {
            var $active = this.$element.find('.item.active')
                , $next = next || $active[type]()
                , isCycling = this.interval
                , direction = type == 'next' ? 'left' : 'right'
                , fallback = type == 'next' ? 'first' : 'last'
                , that = this
                , e

            this.sliding = true

            isCycling && this.pause()

            $next = $next.length ? $next : this.$element.find('.item')[fallback]()

            e = $.Event('slide', {
                relatedTarget: $next[0], direction: direction
            })

            if ($next.hasClass('active')) return

            if (this.$indicators.length) {
                this.$indicators.find('.active').removeClass('active')
                this.$element.one('slid', function () {
                    var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()])
                    $nextIndicator && $nextIndicator.addClass('active')
                })
            }

            if ($.support.transition && this.$element.hasClass('slide')) {
                this.$element.trigger(e)
                if (e.isDefaultPrevented()) return
                $next.addClass(type)
                $next[0].offsetWidth // force reflow
                $active.addClass(direction)
                $next.addClass(direction)
                this.$element.one($.support.transition.end, function () {
                    $next.removeClass([type, direction].join(' ')).addClass('active')
                    $active.removeClass(['active', direction].join(' '))
                    that.sliding = false
                    setTimeout(function () {
                        that.$element.trigger('slid')
                    }, 0)
                })
            } else {
                this.$element.trigger(e)
                if (e.isDefaultPrevented()) return
                $active.removeClass('active')
                $next.addClass('active')
                this.sliding = false
                this.$element.trigger('slid')
            }

            isCycling && this.cycle()

            return this
        }

    }


    /* CAROUSEL PLUGIN DEFINITION
     * ========================== */

    var old = $.fn.carousel

    $.fn.carousel = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('carousel')
                , options = $.extend({}, $.fn.carousel.defaults, typeof option == 'object' && option)
                , action = typeof option == 'string' ? option : options.slide
            if (!data) $this.data('carousel', (data = new Carousel(this, options)))
            if (typeof option == 'number') data.to(option)
            else if (action) data[action]()
            else if (options.interval) data.pause().cycle()
        })
    }

    $.fn.carousel.defaults = {
        interval: 5000, pause: 'hover'
    }

    $.fn.carousel.Constructor = Carousel


    /* CAROUSEL NO CONFLICT
     * ==================== */

    $.fn.carousel.noConflict = function () {
        $.fn.carousel = old
        return this
    }

    /* CAROUSEL DATA-API
     * ================= */

    $(document).on('click.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
        var $this = $(this), href
            , $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
            , options = $.extend({}, $target.data(), $this.data())
            , slideIndex

        $target.carousel(options)

        if (slideIndex = $this.attr('data-slide-to')) {
            $target.data('carousel').pause().to(slideIndex).cycle()
        }

        e.preventDefault()
    })

}(window.jQuery);
/* =============================================================
 * bootstrap-typeahead.js v2.3.2
 * http://twitter.github.com/bootstrap/javascript.html#typeahead
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

    "use strict"; // jshint ;_;


    /* TYPEAHEAD PUBLIC CLASS DEFINITION
     * ================================= */

    var Typeahead = function (element, options) {
        this.$element = $(element)
        this.options = $.extend({}, $.fn.typeahead.defaults, options)
        this.matcher = this.options.matcher || this.matcher
        this.sorter = this.options.sorter || this.sorter
        this.highlighter = this.options.highlighter || this.highlighter
        this.updater = this.options.updater || this.updater
        this.source = this.options.source
        this.$menu = $(this.options.menu)
        this.shown = false

        //MODIFIED: to parse backbone collection
        this.listItemPropToMatch = this.options.listItemPropToMatch
        this.onselect = this.options.onselect


        this.listen()
    }

    Typeahead.prototype = {

        constructor: Typeahead, select: function () {
//           // var val = this.$menu.find('.active').attr('data-value')
//
//            var val = JSON.parse(this.$menu.find('.active').attr('data-value'))
//            this.$element
//                .val(this.updater(val))
//                .change()
//
//            //MODIFIED
//            if (typeof this.onselect == "function")
//                this.onselect(this.updater(val))

            //MODIFIED
            var val = JSON.parse(this.$menu.find('.active').attr('data-value'))
                , text

            if (!this.strings) text = val[this.options.property]
            else text = val

            this.$element.val(text)

            if (typeof this.onselect == "function")
                this.onselect(val)


            return this.hide()
        }, updater: function (item) {
            return item
        }, show: function () {
            var pos = $.extend({}, this.$element.position(), {
                height: this.$element[0].offsetHeight
            })

            this.$menu
                .insertAfter(this.$element)
                .css({
                    top: pos.top + pos.height, left: pos.left
                })
                .show()

            this.shown = true
            return this
        }, hide: function () {
            this.$menu.hide()
            this.shown = false
            return this
        }, lookup: function (event) {
            var items

            this.query = this.$element.val()

            if (!this.query || this.query.length < this.options.minLength) {
                return this.shown ? this.hide() : this
            }

            items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

            return items ? this.process(items) : this
        }, process: function (items) {
            var that = this

            //MODIFIED: to parse backbone collection

            if (items.length && typeof items[0] != "string")
                this.strings = false
            items = $.grep(items, function (item) {
                var itemString = jQuery.extend({}, item);
                if (!that.strings)
                    itemString = item[that.options.listItemPropToMatch]
                if (that.matcher(itemString)) return item
            })
            items = this.sorter(items)

            if (!items.length) {
                return this.shown ? this.hide() : this
            }
            return this.render(items.slice(0, this.options.items)).show()
        }, matcher: function (item) {
            return ~item.toLowerCase().indexOf(this.query.toLowerCase())
        }, sorter: function (items) {
            var beginswith = []
                , caseSensitive = []
                , caseInsensitive = []
                , item

            while (item = items.shift()) {
                var orgItem = jQuery.extend({}, item);
                if (!this.strings) item = item[this.options.listItemPropToMatch]
                if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(orgItem)
                else if (~item.indexOf(this.query)) caseSensitive.push(orgItem)
                else caseInsensitive.push(orgItem)
            }

            return beginswith.concat(caseSensitive, caseInsensitive)
        }, highlighter: function (item) {
            var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
            return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
                return '<strong>' + match + '</strong>'
            })
        }, render: function (items) {
            var that = this
            items = $(items).map(function (i, item) {
               //Modified
                var disabled = item.disabled
                if(item.disabled){
                    console.log(i);
                }
                i = $(that.options.item).attr('data-value', JSON.stringify(item))
                if (!that.strings){
                    item = item[that.options.listItemPropToMatch]
                }

               if(disabled){
                   i.addClass("disabled-item")
               }
                i.find('a').html(that.highlighter(item))
                return i[0]
            })

            items.first().addClass('active')
            this.$menu.html(items)
            return this
        }, next: function (event) {
            var active = this.$menu.find('.active').removeClass('active')
                , next = active.next()

            if (!next.length) {
                next = $(this.$menu.find('li')[0])
            }

            next.addClass('active')
        }, prev: function (event) {
            var active = this.$menu.find('.active').removeClass('active')
                , prev = active.prev()

            if (!prev.length) {
                prev = this.$menu.find('li').last()
            }

            prev.addClass('active')
        }, listen: function () {
            this.$element
                .on('focus', $.proxy(this.focus, this))
                .on('blur', $.proxy(this.blur, this))
                .on('keypress', $.proxy(this.keypress, this))
                .on('keyup', $.proxy(this.keyup, this))

            if (this.eventSupported('keydown')) {
                this.$element.on('keydown', $.proxy(this.keydown, this))
            }

            this.$menu
                .on('click', $.proxy(this.click, this))
                .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
                .on('mouseleave', 'li', $.proxy(this.mouseleave, this))
        }, eventSupported: function (eventName) {
            var isSupported = eventName in this.$element
            if (!isSupported) {
                this.$element.setAttribute(eventName, 'return;')
                isSupported = typeof this.$element[eventName] === 'function'
            }
            return isSupported
        }, move: function (e) {
            if (!this.shown) return

            switch (e.keyCode) {
                case 9: // tab
                case 13: // enter
                case 27: // escape
                    e.preventDefault()
                    break

                case 38: // up arrow
                    e.preventDefault()
                    this.prev()
                    break

                case 40: // down arrow
                    e.preventDefault()
                    this.next()
                    break
            }

            e.stopPropagation()
        }, keydown: function (e) {
            this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40, 38, 9, 13, 27])
            this.move(e)
        }, keypress: function (e) {
            if (this.suppressKeyPressRepeat) return
            this.move(e)
        }, keyup: function (e) {
            switch (e.keyCode) {
                case 40: // down arrow
                case 38: // up arrow
                case 16: // shift
                case 17: // ctrl
                case 18: // alt
                    break

                case 9: // tab
                case 13: // enter
                    if (!this.shown) return
                    this.select()
                    break

                case 27: // escape
                    if (!this.shown) return
                    this.hide()
                    break

                default:
                    this.lookup()
            }

            e.stopPropagation()
            e.preventDefault()
        }, focus: function (e) {
            this.focused = true
        }, blur: function (e) {
            this.focused = false
            if (!this.mousedover && this.shown) this.hide()
        }, click: function (e) {
            e.stopPropagation()
            e.preventDefault()
            this.select()
            this.$element.focus()
        }, mouseenter: function (e) {
            this.mousedover = true
            this.$menu.find('.active').removeClass('active')
            $(e.currentTarget).addClass('active')
        }, mouseleave: function (e) {
            this.mousedover = false
            if (!this.focused && this.shown) this.hide()
        }

    }


    /* TYPEAHEAD PLUGIN DEFINITION
     * =========================== */

    var old = $.fn.typeahead

    $.fn.typeahead = function (option) {
        return this.each(function () {
            var $this = $(this)
                , data = $this.data('typeahead')
                , options = typeof option == 'object' && option
            if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.typeahead.defaults = {
        source: [], items: 8, menu: '<ul class="typeahead dropdown-menu"></ul>', item: '<li><a href="#"></a></li>', minLength: 1, listItemPropToMatch:"name"
    }

    $.fn.typeahead.Constructor = Typeahead


    /* TYPEAHEAD NO CONFLICT
     * =================== */

    $.fn.typeahead.noConflict = function () {
        $.fn.typeahead = old
        return this
    }


    /* TYPEAHEAD DATA-API
     * ================== */

    $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
        var $this = $(this)
        if ($this.data('typeahead')) return
        $this.typeahead($this.data())
    })

}(window.jQuery);

},{}],329:[function(require,module,exports){
require('./bootstrap-modified');





},{"./bootstrap-modified":328}],330:[function(require,module,exports){
if(!document.createElement("canvas").getContext){(function(){var ab=Math;var n=ab.round;var l=ab.sin;var A=ab.cos;var H=ab.abs;var N=ab.sqrt;var d=10;var f=d/2;var z=+navigator.userAgent.match(/MSIE ([\d.]+)?/)[1];function y(){return this.context_||(this.context_=new D(this))}var t=Array.prototype.slice;function g(j,m,p){var i=t.call(arguments,2);return function(){return j.apply(m,i.concat(t.call(arguments)))}}function af(i){return String(i).replace(/&/g,"&amp;").replace(/"/g,"&quot;")}function Y(m,j,i){if(!m.namespaces[j]){m.namespaces.add(j,i,"#default#VML")}}function R(j){Y(j,"g_vml_","urn:schemas-microsoft-com:vml");Y(j,"g_o_","urn:schemas-microsoft-com:office:office");if(!j.styleSheets.ex_canvas_){var i=j.createStyleSheet();i.owningElement.id="ex_canvas_";i.cssText="canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}"}}R(document);var e={init:function(i){var j=i||document;j.createElement("canvas");j.attachEvent("onreadystatechange",g(this.init_,this,j))},init_:function(p){var m=p.getElementsByTagName("canvas");for(var j=0;j<m.length;j++){this.initElement(m[j])}},initElement:function(j){if(!j.getContext){j.getContext=y;R(j.ownerDocument);j.innerHTML="";j.attachEvent("onpropertychange",x);j.attachEvent("onresize",W);var i=j.attributes;if(i.width&&i.width.specified){j.style.width=i.width.nodeValue+"px"}else{j.width=j.clientWidth}if(i.height&&i.height.specified){j.style.height=i.height.nodeValue+"px"}else{j.height=j.clientHeight}}return j}};function x(j){var i=j.srcElement;switch(j.propertyName){case"width":i.getContext().clearRect();i.style.width=i.attributes.width.nodeValue+"px";i.firstChild.style.width=i.clientWidth+"px";break;case"height":i.getContext().clearRect();i.style.height=i.attributes.height.nodeValue+"px";i.firstChild.style.height=i.clientHeight+"px";break}}function W(j){var i=j.srcElement;if(i.firstChild){i.firstChild.style.width=i.clientWidth+"px";i.firstChild.style.height=i.clientHeight+"px"}}e.init();var k=[];for(var ae=0;ae<16;ae++){for(var ad=0;ad<16;ad++){k[ae*16+ad]=ae.toString(16)+ad.toString(16)}}function B(){return[[1,0,0],[0,1,0],[0,0,1]]}function J(p,m){var j=B();for(var i=0;i<3;i++){for(var ah=0;ah<3;ah++){var Z=0;for(var ag=0;ag<3;ag++){Z+=p[i][ag]*m[ag][ah]}j[i][ah]=Z}}return j}function v(j,i){i.fillStyle=j.fillStyle;i.lineCap=j.lineCap;i.lineJoin=j.lineJoin;i.lineWidth=j.lineWidth;i.miterLimit=j.miterLimit;i.shadowBlur=j.shadowBlur;i.shadowColor=j.shadowColor;i.shadowOffsetX=j.shadowOffsetX;i.shadowOffsetY=j.shadowOffsetY;i.strokeStyle=j.strokeStyle;i.globalAlpha=j.globalAlpha;i.font=j.font;i.textAlign=j.textAlign;i.textBaseline=j.textBaseline;i.arcScaleX_=j.arcScaleX_;i.arcScaleY_=j.arcScaleY_;i.lineScale_=j.lineScale_}var b={aliceblue:"#F0F8FF",antiquewhite:"#FAEBD7",aquamarine:"#7FFFD4",azure:"#F0FFFF",beige:"#F5F5DC",bisque:"#FFE4C4",black:"#000000",blanchedalmond:"#FFEBCD",blueviolet:"#8A2BE2",brown:"#A52A2A",burlywood:"#DEB887",cadetblue:"#5F9EA0",chartreuse:"#7FFF00",chocolate:"#D2691E",coral:"#FF7F50",cornflowerblue:"#6495ED",cornsilk:"#FFF8DC",crimson:"#DC143C",cyan:"#00FFFF",darkblue:"#00008B",darkcyan:"#008B8B",darkgoldenrod:"#B8860B",darkgray:"#A9A9A9",darkgreen:"#006400",darkgrey:"#A9A9A9",darkkhaki:"#BDB76B",darkmagenta:"#8B008B",darkolivegreen:"#556B2F",darkorange:"#FF8C00",darkorchid:"#9932CC",darkred:"#8B0000",darksalmon:"#E9967A",darkseagreen:"#8FBC8F",darkslateblue:"#483D8B",darkslategray:"#2F4F4F",darkslategrey:"#2F4F4F",darkturquoise:"#00CED1",darkviolet:"#9400D3",deeppink:"#FF1493",deepskyblue:"#00BFFF",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1E90FF",firebrick:"#B22222",floralwhite:"#FFFAF0",forestgreen:"#228B22",gainsboro:"#DCDCDC",ghostwhite:"#F8F8FF",gold:"#FFD700",goldenrod:"#DAA520",grey:"#808080",greenyellow:"#ADFF2F",honeydew:"#F0FFF0",hotpink:"#FF69B4",indianred:"#CD5C5C",indigo:"#4B0082",ivory:"#FFFFF0",khaki:"#F0E68C",lavender:"#E6E6FA",lavenderblush:"#FFF0F5",lawngreen:"#7CFC00",lemonchiffon:"#FFFACD",lightblue:"#ADD8E6",lightcoral:"#F08080",lightcyan:"#E0FFFF",lightgoldenrodyellow:"#FAFAD2",lightgreen:"#90EE90",lightgrey:"#D3D3D3",lightpink:"#FFB6C1",lightsalmon:"#FFA07A",lightseagreen:"#20B2AA",lightskyblue:"#87CEFA",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#B0C4DE",lightyellow:"#FFFFE0",limegreen:"#32CD32",linen:"#FAF0E6",magenta:"#FF00FF",mediumaquamarine:"#66CDAA",mediumblue:"#0000CD",mediumorchid:"#BA55D3",mediumpurple:"#9370DB",mediumseagreen:"#3CB371",mediumslateblue:"#7B68EE",mediumspringgreen:"#00FA9A",mediumturquoise:"#48D1CC",mediumvioletred:"#C71585",midnightblue:"#191970",mintcream:"#F5FFFA",mistyrose:"#FFE4E1",moccasin:"#FFE4B5",navajowhite:"#FFDEAD",oldlace:"#FDF5E6",olivedrab:"#6B8E23",orange:"#FFA500",orangered:"#FF4500",orchid:"#DA70D6",palegoldenrod:"#EEE8AA",palegreen:"#98FB98",paleturquoise:"#AFEEEE",palevioletred:"#DB7093",papayawhip:"#FFEFD5",peachpuff:"#FFDAB9",peru:"#CD853F",pink:"#FFC0CB",plum:"#DDA0DD",powderblue:"#B0E0E6",rosybrown:"#BC8F8F",royalblue:"#4169E1",saddlebrown:"#8B4513",salmon:"#FA8072",sandybrown:"#F4A460",seagreen:"#2E8B57",seashell:"#FFF5EE",sienna:"#A0522D",skyblue:"#87CEEB",slateblue:"#6A5ACD",slategray:"#708090",slategrey:"#708090",snow:"#FFFAFA",springgreen:"#00FF7F",steelblue:"#4682B4",tan:"#D2B48C",thistle:"#D8BFD8",tomato:"#FF6347",turquoise:"#40E0D0",violet:"#EE82EE",wheat:"#F5DEB3",whitesmoke:"#F5F5F5",yellowgreen:"#9ACD32"};function M(j){var p=j.indexOf("(",3);var i=j.indexOf(")",p+1);var m=j.substring(p+1,i).split(",");if(m.length!=4||j.charAt(3)!="a"){m[3]=1}return m}function c(i){return parseFloat(i)/100}function r(j,m,i){return Math.min(i,Math.max(m,j))}function I(ag){var i,ai,aj,ah,ak,Z;ah=parseFloat(ag[0])/360%360;if(ah<0){ah++}ak=r(c(ag[1]),0,1);Z=r(c(ag[2]),0,1);if(ak==0){i=ai=aj=Z}else{var j=Z<0.5?Z*(1+ak):Z+ak-Z*ak;var m=2*Z-j;i=a(m,j,ah+1/3);ai=a(m,j,ah);aj=a(m,j,ah-1/3)}return"#"+k[Math.floor(i*255)]+k[Math.floor(ai*255)]+k[Math.floor(aj*255)]}function a(j,i,m){if(m<0){m++}if(m>1){m--}if(6*m<1){return j+(i-j)*6*m}else{if(2*m<1){return i}else{if(3*m<2){return j+(i-j)*(2/3-m)*6}else{return j}}}}var C={};function F(j){if(j in C){return C[j]}var ag,Z=1;j=String(j);if(j.charAt(0)=="#"){ag=j}else{if(/^rgb/.test(j)){var p=M(j);var ag="#",ah;for(var m=0;m<3;m++){if(p[m].indexOf("%")!=-1){ah=Math.floor(c(p[m])*255)}else{ah=+p[m]}ag+=k[r(ah,0,255)]}Z=+p[3]}else{if(/^hsl/.test(j)){var p=M(j);ag=I(p);Z=p[3]}else{ag=b[j]||j}}}return C[j]={color:ag,alpha:Z}}var o={style:"normal",variant:"normal",weight:"normal",size:10,family:"sans-serif"};var L={};function E(i){if(L[i]){return L[i]}var p=document.createElement("div");var m=p.style;try{m.font=i}catch(j){}return L[i]={style:m.fontStyle||o.style,variant:m.fontVariant||o.variant,weight:m.fontWeight||o.weight,size:m.fontSize||o.size,family:m.fontFamily||o.family}}function u(m,j){var i={};for(var ah in m){i[ah]=m[ah]}var ag=parseFloat(j.currentStyle.fontSize),Z=parseFloat(m.size);if(typeof m.size=="number"){i.size=m.size}else{if(m.size.indexOf("px")!=-1){i.size=Z}else{if(m.size.indexOf("em")!=-1){i.size=ag*Z}else{if(m.size.indexOf("%")!=-1){i.size=(ag/100)*Z}else{if(m.size.indexOf("pt")!=-1){i.size=Z/0.75}else{i.size=ag}}}}}i.size*=0.981;return i}function ac(i){return i.style+" "+i.variant+" "+i.weight+" "+i.size+"px "+i.family}var s={butt:"flat",round:"round"};function S(i){return s[i]||"square"}function D(i){this.m_=B();this.mStack_=[];this.aStack_=[];this.currentPath_=[];this.strokeStyle="#000";this.fillStyle="#000";this.lineWidth=1;this.lineJoin="miter";this.lineCap="butt";this.miterLimit=d*1;this.globalAlpha=1;this.font="10px sans-serif";this.textAlign="left";this.textBaseline="alphabetic";this.canvas=i;var m="width:"+i.clientWidth+"px;height:"+i.clientHeight+"px;overflow:hidden;position:absolute";var j=i.ownerDocument.createElement("div");j.style.cssText=m;i.appendChild(j);var p=j.cloneNode(false);p.style.backgroundColor="red";p.style.filter="alpha(opacity=0)";i.appendChild(p);this.element_=j;this.arcScaleX_=1;this.arcScaleY_=1;this.lineScale_=1}var q=D.prototype;q.clearRect=function(){if(this.textMeasureEl_){this.textMeasureEl_.removeNode(true);this.textMeasureEl_=null}this.element_.innerHTML=""};q.beginPath=function(){this.currentPath_=[]};q.moveTo=function(j,i){var m=V(this,j,i);this.currentPath_.push({type:"moveTo",x:m.x,y:m.y});this.currentX_=m.x;this.currentY_=m.y};q.lineTo=function(j,i){var m=V(this,j,i);this.currentPath_.push({type:"lineTo",x:m.x,y:m.y});this.currentX_=m.x;this.currentY_=m.y};q.bezierCurveTo=function(m,j,ak,aj,ai,ag){var i=V(this,ai,ag);var ah=V(this,m,j);var Z=V(this,ak,aj);K(this,ah,Z,i)};function K(i,Z,m,j){i.currentPath_.push({type:"bezierCurveTo",cp1x:Z.x,cp1y:Z.y,cp2x:m.x,cp2y:m.y,x:j.x,y:j.y});i.currentX_=j.x;i.currentY_=j.y}q.quadraticCurveTo=function(ai,m,j,i){var ah=V(this,ai,m);var ag=V(this,j,i);var aj={x:this.currentX_+2/3*(ah.x-this.currentX_),y:this.currentY_+2/3*(ah.y-this.currentY_)};var Z={x:aj.x+(ag.x-this.currentX_)/3,y:aj.y+(ag.y-this.currentY_)/3};K(this,aj,Z,ag)};q.arc=function(al,aj,ak,ag,j,m){ak*=d;var ap=m?"at":"wa";var am=al+A(ag)*ak-f;var ao=aj+l(ag)*ak-f;var i=al+A(j)*ak-f;var an=aj+l(j)*ak-f;if(am==i&&!m){am+=0.125}var Z=V(this,al,aj);var ai=V(this,am,ao);var ah=V(this,i,an);this.currentPath_.push({type:ap,x:Z.x,y:Z.y,radius:ak,xStart:ai.x,yStart:ai.y,xEnd:ah.x,yEnd:ah.y})};q.rect=function(m,j,i,p){this.moveTo(m,j);this.lineTo(m+i,j);this.lineTo(m+i,j+p);this.lineTo(m,j+p);this.closePath()};q.strokeRect=function(m,j,i,p){var Z=this.currentPath_;this.beginPath();this.moveTo(m,j);this.lineTo(m+i,j);this.lineTo(m+i,j+p);this.lineTo(m,j+p);this.closePath();this.stroke();this.currentPath_=Z};q.fillRect=function(m,j,i,p){var Z=this.currentPath_;this.beginPath();this.moveTo(m,j);this.lineTo(m+i,j);this.lineTo(m+i,j+p);this.lineTo(m,j+p);this.closePath();this.fill();this.currentPath_=Z};q.createLinearGradient=function(j,p,i,m){var Z=new U("gradient");Z.x0_=j;Z.y0_=p;Z.x1_=i;Z.y1_=m;return Z};q.createRadialGradient=function(p,ag,m,j,Z,i){var ah=new U("gradientradial");ah.x0_=p;ah.y0_=ag;ah.r0_=m;ah.x1_=j;ah.y1_=Z;ah.r1_=i;return ah};q.drawImage=function(aq,m){var aj,ah,al,ay,ao,am,at,aA;var ak=aq.runtimeStyle.width;var ap=aq.runtimeStyle.height;aq.runtimeStyle.width="auto";aq.runtimeStyle.height="auto";var ai=aq.width;var aw=aq.height;aq.runtimeStyle.width=ak;aq.runtimeStyle.height=ap;if(arguments.length==3){aj=arguments[1];ah=arguments[2];ao=am=0;at=al=ai;aA=ay=aw}else{if(arguments.length==5){aj=arguments[1];ah=arguments[2];al=arguments[3];ay=arguments[4];ao=am=0;at=ai;aA=aw}else{if(arguments.length==9){ao=arguments[1];am=arguments[2];at=arguments[3];aA=arguments[4];aj=arguments[5];ah=arguments[6];al=arguments[7];ay=arguments[8]}else{throw Error("Invalid number of arguments")}}}var az=V(this,aj,ah);var p=at/2;var j=aA/2;var ax=[];var i=10;var ag=10;ax.push(" <g_vml_:group",' coordsize="',d*i,",",d*ag,'"',' coordorigin="0,0"',' style="width:',i,"px;height:",ag,"px;position:absolute;");if(this.m_[0][0]!=1||this.m_[0][1]||this.m_[1][1]!=1||this.m_[1][0]){var Z=[];Z.push("M11=",this.m_[0][0],",","M12=",this.m_[1][0],",","M21=",this.m_[0][1],",","M22=",this.m_[1][1],",","Dx=",n(az.x/d),",","Dy=",n(az.y/d),"");var av=az;var au=V(this,aj+al,ah);var ar=V(this,aj,ah+ay);var an=V(this,aj+al,ah+ay);av.x=ab.max(av.x,au.x,ar.x,an.x);av.y=ab.max(av.y,au.y,ar.y,an.y);ax.push("padding:0 ",n(av.x/d),"px ",n(av.y/d),"px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",Z.join(""),", sizingmethod='clip');")}else{ax.push("top:",n(az.y/d),"px;left:",n(az.x/d),"px;")}ax.push(' ">','<g_vml_:image src="',aq.src,'"',' style="width:',d*al,"px;"," height:",d*ay,'px"',' cropleft="',ao/ai,'"',' croptop="',am/aw,'"',' cropright="',(ai-ao-at)/ai,'"',' cropbottom="',(aw-am-aA)/aw,'"'," />","</g_vml_:group>");this.element_.insertAdjacentHTML("BeforeEnd",ax.join(""))};q.stroke=function(ao){var Z=10;var ap=10;var ag=5000;var ai={x:null,y:null};var an={x:null,y:null};for(var aj=0;aj<this.currentPath_.length;aj+=ag){var am=[];var ah=false;am.push("<g_vml_:shape",' filled="',!!ao,'"',' style="position:absolute;width:',Z,"px;height:",ap,'px;"',' coordorigin="0,0"',' coordsize="',d*Z,",",d*ap,'"',' stroked="',!ao,'"',' path="');var aq=false;for(var ak=aj;ak<Math.min(aj+ag,this.currentPath_.length);ak++){if(ak%ag==0&&ak>0){am.push(" m ",n(this.currentPath_[ak-1].x),",",n(this.currentPath_[ak-1].y))}var m=this.currentPath_[ak];var al;switch(m.type){case"moveTo":al=m;am.push(" m ",n(m.x),",",n(m.y));break;case"lineTo":am.push(" l ",n(m.x),",",n(m.y));break;case"close":am.push(" x ");m=null;break;case"bezierCurveTo":am.push(" c ",n(m.cp1x),",",n(m.cp1y),",",n(m.cp2x),",",n(m.cp2y),",",n(m.x),",",n(m.y));break;case"at":case"wa":am.push(" ",m.type," ",n(m.x-this.arcScaleX_*m.radius),",",n(m.y-this.arcScaleY_*m.radius)," ",n(m.x+this.arcScaleX_*m.radius),",",n(m.y+this.arcScaleY_*m.radius)," ",n(m.xStart),",",n(m.yStart)," ",n(m.xEnd),",",n(m.yEnd));break}if(m){if(ai.x==null||m.x<ai.x){ai.x=m.x}if(an.x==null||m.x>an.x){an.x=m.x}if(ai.y==null||m.y<ai.y){ai.y=m.y}if(an.y==null||m.y>an.y){an.y=m.y}}}am.push(' ">');if(!ao){w(this,am)}else{G(this,am,ai,an)}am.push("</g_vml_:shape>");this.element_.insertAdjacentHTML("beforeEnd",am.join(""))}};function w(m,ag){var j=F(m.strokeStyle);var p=j.color;var Z=j.alpha*m.globalAlpha;var i=m.lineScale_*m.lineWidth;if(i<1){Z*=i}ag.push("<g_vml_:stroke",' opacity="',Z,'"',' joinstyle="',m.lineJoin,'"',' miterlimit="',m.miterLimit,'"',' endcap="',S(m.lineCap),'"',' weight="',i,'px"',' color="',p,'" />')}function G(aq,ai,aK,ar){var aj=aq.fillStyle;var aB=aq.arcScaleX_;var aA=aq.arcScaleY_;var j=ar.x-aK.x;var p=ar.y-aK.y;if(aj instanceof U){var an=0;var aF={x:0,y:0};var ax=0;var am=1;if(aj.type_=="gradient"){var al=aj.x0_/aB;var m=aj.y0_/aA;var ak=aj.x1_/aB;var aM=aj.y1_/aA;var aJ=V(aq,al,m);var aI=V(aq,ak,aM);var ag=aI.x-aJ.x;var Z=aI.y-aJ.y;an=Math.atan2(ag,Z)*180/Math.PI;if(an<0){an+=360}if(an<0.000001){an=0}}else{var aJ=V(aq,aj.x0_,aj.y0_);aF={x:(aJ.x-aK.x)/j,y:(aJ.y-aK.y)/p};j/=aB*d;p/=aA*d;var aD=ab.max(j,p);ax=2*aj.r0_/aD;am=2*aj.r1_/aD-ax}var av=aj.colors_;av.sort(function(aN,i){return aN.offset-i.offset});var ap=av.length;var au=av[0].color;var at=av[ap-1].color;var az=av[0].alpha*aq.globalAlpha;var ay=av[ap-1].alpha*aq.globalAlpha;var aE=[];for(var aH=0;aH<ap;aH++){var ao=av[aH];aE.push(ao.offset*am+ax+" "+ao.color)}ai.push('<g_vml_:fill type="',aj.type_,'"',' method="none" focus="100%"',' color="',au,'"',' color2="',at,'"',' colors="',aE.join(","),'"',' opacity="',ay,'"',' g_o_:opacity2="',az,'"',' angle="',an,'"',' focusposition="',aF.x,",",aF.y,'" />')}else{if(aj instanceof T){if(j&&p){var ah=-aK.x;var aC=-aK.y;ai.push("<g_vml_:fill",' position="',ah/j*aB*aB,",",aC/p*aA*aA,'"',' type="tile"',' src="',aj.src_,'" />')}}else{var aL=F(aq.fillStyle);var aw=aL.color;var aG=aL.alpha*aq.globalAlpha;ai.push('<g_vml_:fill color="',aw,'" opacity="',aG,'" />')}}}q.fill=function(){this.stroke(true)};q.closePath=function(){this.currentPath_.push({type:"close"})};function V(j,Z,p){var i=j.m_;return{x:d*(Z*i[0][0]+p*i[1][0]+i[2][0])-f,y:d*(Z*i[0][1]+p*i[1][1]+i[2][1])-f}}q.save=function(){var i={};v(this,i);this.aStack_.push(i);this.mStack_.push(this.m_);this.m_=J(B(),this.m_)};q.restore=function(){if(this.aStack_.length){v(this.aStack_.pop(),this);this.m_=this.mStack_.pop()}};function h(i){return isFinite(i[0][0])&&isFinite(i[0][1])&&isFinite(i[1][0])&&isFinite(i[1][1])&&isFinite(i[2][0])&&isFinite(i[2][1])}function aa(j,i,p){if(!h(i)){return}j.m_=i;if(p){var Z=i[0][0]*i[1][1]-i[0][1]*i[1][0];j.lineScale_=N(H(Z))}}q.translate=function(m,j){var i=[[1,0,0],[0,1,0],[m,j,1]];aa(this,J(i,this.m_),false)};q.rotate=function(j){var p=A(j);var m=l(j);var i=[[p,m,0],[-m,p,0],[0,0,1]];aa(this,J(i,this.m_),false)};q.scale=function(m,j){this.arcScaleX_*=m;this.arcScaleY_*=j;var i=[[m,0,0],[0,j,0],[0,0,1]];aa(this,J(i,this.m_),true)};q.transform=function(Z,p,ah,ag,j,i){var m=[[Z,p,0],[ah,ag,0],[j,i,1]];aa(this,J(m,this.m_),true)};q.setTransform=function(ag,Z,ai,ah,p,j){var i=[[ag,Z,0],[ai,ah,0],[p,j,1]];aa(this,i,true)};q.drawText_=function(am,ak,aj,ap,ai){var ao=this.m_,at=1000,j=0,ar=at,ah={x:0,y:0},ag=[];var i=u(E(this.font),this.element_);var p=ac(i);var au=this.element_.currentStyle;var Z=this.textAlign.toLowerCase();switch(Z){case"left":case"center":case"right":break;case"end":Z=au.direction=="ltr"?"right":"left";break;case"start":Z=au.direction=="rtl"?"right":"left";break;default:Z="left"}switch(this.textBaseline){case"hanging":case"top":ah.y=i.size/1.75;break;case"middle":break;default:case null:case"alphabetic":case"ideographic":case"bottom":ah.y=-i.size/2.25;break}switch(Z){case"right":j=at;ar=0.05;break;case"center":j=ar=at/2;break}var aq=V(this,ak+ah.x,aj+ah.y);ag.push('<g_vml_:line from="',-j,' 0" to="',ar,' 0.05" ',' coordsize="100 100" coordorigin="0 0"',' filled="',!ai,'" stroked="',!!ai,'" style="position:absolute;width:1px;height:1px;">');if(ai){w(this,ag)}else{G(this,ag,{x:-j,y:0},{x:ar,y:i.size})}var an=ao[0][0].toFixed(3)+","+ao[1][0].toFixed(3)+","+ao[0][1].toFixed(3)+","+ao[1][1].toFixed(3)+",0,0";var al=n(aq.x/d)+","+n(aq.y/d);ag.push('<g_vml_:skew on="t" matrix="',an,'" ',' offset="',al,'" origin="',j,' 0" />','<g_vml_:path textpathok="true" />','<g_vml_:textpath on="true" string="',af(am),'" style="v-text-align:',Z,";font:",af(p),'" /></g_vml_:line>');this.element_.insertAdjacentHTML("beforeEnd",ag.join(""))};q.fillText=function(m,i,p,j){this.drawText_(m,i,p,j,false)};q.strokeText=function(m,i,p,j){this.drawText_(m,i,p,j,true)};q.measureText=function(m){if(!this.textMeasureEl_){var i='<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>';this.element_.insertAdjacentHTML("beforeEnd",i);this.textMeasureEl_=this.element_.lastChild}var j=this.element_.ownerDocument;this.textMeasureEl_.innerHTML="";this.textMeasureEl_.style.font=this.font;this.textMeasureEl_.appendChild(j.createTextNode(m));return{width:this.textMeasureEl_.offsetWidth}};q.clip=function(){};q.arcTo=function(){};q.createPattern=function(j,i){return new T(j,i)};function U(i){this.type_=i;this.x0_=0;this.y0_=0;this.r0_=0;this.x1_=0;this.y1_=0;this.r1_=0;this.colors_=[]}U.prototype.addColorStop=function(j,i){i=F(i);this.colors_.push({offset:j,color:i.color,alpha:i.alpha})};function T(j,i){Q(j);switch(i){case"repeat":case null:case"":this.repetition_="repeat";break;case"repeat-x":case"repeat-y":case"no-repeat":this.repetition_=i;break;default:O("SYNTAX_ERR")}this.src_=j.src;this.width_=j.width;this.height_=j.height}function O(i){throw new P(i)}function Q(i){if(!i||i.nodeType!=1||i.tagName!="IMG"){O("TYPE_MISMATCH_ERR")}if(i.readyState!="complete"){O("INVALID_STATE_ERR")}}function P(i){this.code=this[i];this.message=i+": DOM Exception "+this.code}var X=P.prototype=new Error;X.INDEX_SIZE_ERR=1;X.DOMSTRING_SIZE_ERR=2;X.HIERARCHY_REQUEST_ERR=3;X.WRONG_DOCUMENT_ERR=4;X.INVALID_CHARACTER_ERR=5;X.NO_DATA_ALLOWED_ERR=6;X.NO_MODIFICATION_ALLOWED_ERR=7;X.NOT_FOUND_ERR=8;X.NOT_SUPPORTED_ERR=9;X.INUSE_ATTRIBUTE_ERR=10;X.INVALID_STATE_ERR=11;X.SYNTAX_ERR=12;X.INVALID_MODIFICATION_ERR=13;X.NAMESPACE_ERR=14;X.INVALID_ACCESS_ERR=15;X.VALIDATION_ERR=16;X.TYPE_MISMATCH_ERR=17;G_vmlCanvasManager=e;CanvasRenderingContext2D=D;CanvasGradient=U;CanvasPattern=T;DOMException=P})()};
},{}],331:[function(require,module,exports){
require('./jquery.flot.min');
require('./jquery.flot.pie.min');
require('./jquery.flot.tooltip.min');
require('./excanvas.min');






},{"./excanvas.min":330,"./jquery.flot.min":332,"./jquery.flot.pie.min":333,"./jquery.flot.tooltip.min":334}],332:[function(require,module,exports){
/* Javascript plotting library for jQuery, version 0.8.1.

Copyright (c) 2007-2013 IOLA and Ole Laursen.
Licensed under the MIT license.

*/// first an inline dependency, jquery.colorhelpers.js, we inline it here
// for convenience
/* Plugin for jQuery for working with colors.
 *
 * Version 1.1.
 *
 * Inspiration from jQuery color animation plugin by John Resig.
 *
 * Released under the MIT license by Ole Laursen, October 2009.
 *
 * Examples:
 *
 *   $.color.parse("#fff").scale('rgb', 0.25).add('a', -0.5).toString()
 *   var c = $.color.extract($("#mydiv"), 'background-color');
 *   console.log(c.r, c.g, c.b, c.a);
 *   $.color.make(100, 50, 25, 0.4).toString() // returns "rgba(100,50,25,0.4)"
 *
 * Note that .scale() and .add() return the same modified object
 * instead of making a new one.
 *
 * V. 1.1: Fix error handling so e.g. parsing an empty string does
 * produce a color rather than just crashing.
 */(function(e){e.color={},e.color.make=function(t,n,r,i){var s={};return s.r=t||0,s.g=n||0,s.b=r||0,s.a=i!=null?i:1,s.add=function(e,t){for(var n=0;n<e.length;++n)s[e.charAt(n)]+=t;return s.normalize()},s.scale=function(e,t){for(var n=0;n<e.length;++n)s[e.charAt(n)]*=t;return s.normalize()},s.toString=function(){return s.a>=1?"rgb("+[s.r,s.g,s.b].join(",")+")":"rgba("+[s.r,s.g,s.b,s.a].join(",")+")"},s.normalize=function(){function e(e,t,n){return t<e?e:t>n?n:t}return s.r=e(0,parseInt(s.r),255),s.g=e(0,parseInt(s.g),255),s.b=e(0,parseInt(s.b),255),s.a=e(0,s.a,1),s},s.clone=function(){return e.color.make(s.r,s.b,s.g,s.a)},s.normalize()},e.color.extract=function(t,n){var r;do{r=t.css(n).toLowerCase();if(r!=""&&r!="transparent")break;t=t.parent()}while(!e.nodeName(t.get(0),"body"));return r=="rgba(0, 0, 0, 0)"&&(r="transparent"),e.color.parse(r)},e.color.parse=function(n){var r,i=e.color.make;if(r=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(n))return i(parseInt(r[1],10),parseInt(r[2],10),parseInt(r[3],10));if(r=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(n))return i(parseInt(r[1],10),parseInt(r[2],10),parseInt(r[3],10),parseFloat(r[4]));if(r=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(n))return i(parseFloat(r[1])*2.55,parseFloat(r[2])*2.55,parseFloat(r[3])*2.55);if(r=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(n))return i(parseFloat(r[1])*2.55,parseFloat(r[2])*2.55,parseFloat(r[3])*2.55,parseFloat(r[4]));if(r=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(n))return i(parseInt(r[1],16),parseInt(r[2],16),parseInt(r[3],16));if(r=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(n))return i(parseInt(r[1]+r[1],16),parseInt(r[2]+r[2],16),parseInt(r[3]+r[3],16));var s=e.trim(n).toLowerCase();return s=="transparent"?i(255,255,255,0):(r=t[s]||[0,0,0],i(r[0],r[1],r[2]))};var t={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}})(jQuery),function(e){function n(t,n){var r=n.children("."+t)[0];if(r==null){r=document.createElement("canvas"),r.className=t,e(r).css({direction:"ltr",position:"absolute",left:0,top:0}).appendTo(n);if(!r.getContext){if(!window.G_vmlCanvasManager)throw new Error("Canvas is not available. If you're using IE with a fall-back such as Excanvas, then there's either a mistake in your conditional include, or the page has no DOCTYPE and is rendering in Quirks Mode.");r=window.G_vmlCanvasManager.initElement(r)}}this.element=r;var i=this.context=r.getContext("2d"),s=window.devicePixelRatio||1,o=i.webkitBackingStorePixelRatio||i.mozBackingStorePixelRatio||i.msBackingStorePixelRatio||i.oBackingStorePixelRatio||i.backingStorePixelRatio||1;this.pixelRatio=s/o,this.resize(n.width(),n.height()),this.textContainer=null,this.text={},this._textCache={}}function r(t,r,s,o){function E(e,t){t=[w].concat(t);for(var n=0;n<e.length;++n)e[n].apply(this,t)}function S(){var t={Canvas:n};for(var r=0;r<o.length;++r){var i=o[r];i.init(w,t),i.options&&e.extend(!0,a,i.options)}}function x(n){e.extend(!0,a,n),n&&n.colors&&(a.colors=n.colors),a.xaxis.color==null&&(a.xaxis.color=e.color.parse(a.grid.color).scale("a",.22).toString()),a.yaxis.color==null&&(a.yaxis.color=e.color.parse(a.grid.color).scale("a",.22).toString()),a.xaxis.tickColor==null&&(a.xaxis.tickColor=a.grid.tickColor||a.xaxis.color),a.yaxis.tickColor==null&&(a.yaxis.tickColor=a.grid.tickColor||a.yaxis.color),a.grid.borderColor==null&&(a.grid.borderColor=a.grid.color),a.grid.tickColor==null&&(a.grid.tickColor=e.color.parse(a.grid.color).scale("a",.22).toString());var r,i,s,o={style:t.css("font-style"),size:Math.round(.8*(+t.css("font-size").replace("px","")||13)),variant:t.css("font-variant"),weight:t.css("font-weight"),family:t.css("font-family")};o.lineHeight=o.size*1.15,s=a.xaxes.length||1;for(r=0;r<s;++r)i=a.xaxes[r],i&&!i.tickColor&&(i.tickColor=i.color),i=e.extend(!0,{},a.xaxis,i),a.xaxes[r]=i,i.font&&(i.font=e.extend({},o,i.font),i.font.color||(i.font.color=i.color));s=a.yaxes.length||1;for(r=0;r<s;++r)i=a.yaxes[r],i&&!i.tickColor&&(i.tickColor=i.color),i=e.extend(!0,{},a.yaxis,i),a.yaxes[r]=i,i.font&&(i.font=e.extend({},o,i.font),i.font.color||(i.font.color=i.color));a.xaxis.noTicks&&a.xaxis.ticks==null&&(a.xaxis.ticks=a.xaxis.noTicks),a.yaxis.noTicks&&a.yaxis.ticks==null&&(a.yaxis.ticks=a.yaxis.noTicks),a.x2axis&&(a.xaxes[1]=e.extend(!0,{},a.xaxis,a.x2axis),a.xaxes[1].position="top"),a.y2axis&&(a.yaxes[1]=e.extend(!0,{},a.yaxis,a.y2axis),a.yaxes[1].position="right"),a.grid.coloredAreas&&(a.grid.markings=a.grid.coloredAreas),a.grid.coloredAreasColor&&(a.grid.markingsColor=a.grid.coloredAreasColor),a.lines&&e.extend(!0,a.series.lines,a.lines),a.points&&e.extend(!0,a.series.points,a.points),a.bars&&e.extend(!0,a.series.bars,a.bars),a.shadowSize!=null&&(a.series.shadowSize=a.shadowSize),a.highlightColor!=null&&(a.series.highlightColor=a.highlightColor);for(r=0;r<a.xaxes.length;++r)O(d,r+1).options=a.xaxes[r];for(r=0;r<a.yaxes.length;++r)O(v,r+1).options=a.yaxes[r];for(var u in b)a.hooks[u]&&a.hooks[u].length&&(b[u]=b[u].concat(a.hooks[u]));E(b.processOptions,[a])}function T(e){u=N(e),M(),_()}function N(t){var n=[];for(var r=0;r<t.length;++r){var i=e.extend(!0,{},a.series);t[r].data!=null?(i.data=t[r].data,delete t[r].data,e.extend(!0,i,t[r]),t[r].data=i.data):i.data=t[r],n.push(i)}return n}function C(e,t){var n=e[t+"axis"];return typeof n=="object"&&(n=n.n),typeof n!="number"&&(n=1),n}function k(){return e.grep(d.concat(v),function(e){return e})}function L(e){var t={},n,r;for(n=0;n<d.length;++n)r=d[n],r&&r.used&&(t["x"+r.n]=r.c2p(e.left));for(n=0;n<v.length;++n)r=v[n],r&&r.used&&(t["y"+r.n]=r.c2p(e.top));return t.x1!==undefined&&(t.x=t.x1),t.y1!==undefined&&(t.y=t.y1),t}function A(e){var t={},n,r,i;for(n=0;n<d.length;++n){r=d[n];if(r&&r.used){i="x"+r.n,e[i]==null&&r.n==1&&(i="x");if(e[i]!=null){t.left=r.p2c(e[i]);break}}}for(n=0;n<v.length;++n){r=v[n];if(r&&r.used){i="y"+r.n,e[i]==null&&r.n==1&&(i="y");if(e[i]!=null){t.top=r.p2c(e[i]);break}}}return t}function O(t,n){return t[n-1]||(t[n-1]={n:n,direction:t==d?"x":"y",options:e.extend(!0,{},t==d?a.xaxis:a.yaxis)}),t[n-1]}function M(){var t=u.length,n=-1,r;for(r=0;r<u.length;++r){var i=u[r].color;i!=null&&(t--,typeof i=="number"&&i>n&&(n=i))}t<=n&&(t=n+1);var s,o=[],f=a.colors,l=f.length,c=0;for(r=0;r<t;r++)s=e.color.parse(f[r%l]||"#666"),r%l==0&&r&&(c>=0?c<.5?c=-c-.2:c=0:c=-c),o[r]=s.scale("rgb",1+c);var h=0,p;for(r=0;r<u.length;++r){p=u[r],p.color==null?(p.color=o[h].toString(),++h):typeof p.color=="number"&&(p.color=o[p.color].toString());if(p.lines.show==null){var m,g=!0;for(m in p)if(p[m]&&p[m].show){g=!1;break}g&&(p.lines.show=!0)}p.lines.zero==null&&(p.lines.zero=!!p.lines.fill),p.xaxis=O(d,C(p,"x")),p.yaxis=O(v,C(p,"y"))}}function _(){function x(e,t,n){t<e.datamin&&t!=-r&&(e.datamin=t),n>e.datamax&&n!=r&&(e.datamax=n)}var t=Number.POSITIVE_INFINITY,n=Number.NEGATIVE_INFINITY,r=Number.MAX_VALUE,i,s,o,a,f,l,c,h,p,d,v,m,g,y,w,S;e.each(k(),function(e,r){r.datamin=t,r.datamax=n,r.used=!1});for(i=0;i<u.length;++i)l=u[i],l.datapoints={points:[]},E(b.processRawData,[l,l.data,l.datapoints]);for(i=0;i<u.length;++i){l=u[i],w=l.data,S=l.datapoints.format;if(!S){S=[],S.push({x:!0,number:!0,required:!0}),S.push({y:!0,number:!0,required:!0});if(l.bars.show||l.lines.show&&l.lines.fill){var T=!!(l.bars.show&&l.bars.zero||l.lines.show&&l.lines.zero);S.push({y:!0,number:!0,required:!1,defaultValue:0,autoscale:T}),l.bars.horizontal&&(delete S[S.length-1].y,S[S.length-1].x=!0)}l.datapoints.format=S}if(l.datapoints.pointsize!=null)continue;l.datapoints.pointsize=S.length,h=l.datapoints.pointsize,c=l.datapoints.points;var N=l.lines.show&&l.lines.steps;l.xaxis.used=l.yaxis.used=!0;for(s=o=0;s<w.length;++s,o+=h){y=w[s];var C=y==null;if(!C)for(a=0;a<h;++a)m=y[a],g=S[a],g&&(g.number&&m!=null&&(m=+m,isNaN(m)?m=null:m==Infinity?m=r:m==-Infinity&&(m=-r)),m==null&&(g.required&&(C=!0),g.defaultValue!=null&&(m=g.defaultValue))),c[o+a]=m;if(C)for(a=0;a<h;++a)m=c[o+a],m!=null&&(g=S[a],g.autoscale&&(g.x&&x(l.xaxis,m,m),g.y&&x(l.yaxis,m,m))),c[o+a]=null;else if(N&&o>0&&c[o-h]!=null&&c[o-h]!=c[o]&&c[o-h+1]!=c[o+1]){for(a=0;a<h;++a)c[o+h+a]=c[o+a];c[o+1]=c[o-h+1],o+=h}}}for(i=0;i<u.length;++i)l=u[i],E(b.processDatapoints,[l,l.datapoints]);for(i=0;i<u.length;++i){l=u[i],c=l.datapoints.points,h=l.datapoints.pointsize,S=l.datapoints.format;var L=t,A=t,O=n,M=n;for(s=0;s<c.length;s+=h){if(c[s]==null)continue;for(a=0;a<h;++a){m=c[s+a],g=S[a];if(!g||g.autoscale===!1||m==r||m==-r)continue;g.x&&(m<L&&(L=m),m>O&&(O=m)),g.y&&(m<A&&(A=m),m>M&&(M=m))}}if(l.bars.show){var _;switch(l.bars.align){case"left":_=0;break;case"right":_=-l.bars.barWidth;break;case"center":_=-l.bars.barWidth/2;break;default:throw new Error("Invalid bar alignment: "+l.bars.align)}l.bars.horizontal?(A+=_,M+=_+l.bars.barWidth):(L+=_,O+=_+l.bars.barWidth)}x(l.xaxis,L,O),x(l.yaxis,A,M)}e.each(k(),function(e,r){r.datamin==t&&(r.datamin=null),r.datamax==n&&(r.datamax=null)})}function D(){t.css("padding",0).children(":not(.flot-base,.flot-overlay)").remove(),t.css("position")=="static"&&t.css("position","relative"),f=new n("flot-base",t),l=new n("flot-overlay",t),h=f.context,p=l.context,c=e(l.element).unbind();var r=t.data("plot");r&&(r.shutdown(),l.clear()),t.data("plot",w)}function P(){a.grid.hoverable&&(c.mousemove(at),c.bind("mouseleave",ft)),a.grid.clickable&&c.click(lt),E(b.bindEvents,[c])}function H(){ot&&clearTimeout(ot),c.unbind("mousemove",at),c.unbind("mouseleave",ft),c.unbind("click",lt),E(b.shutdown,[c])}function B(e){function t(e){return e}var n,r,i=e.options.transform||t,s=e.options.inverseTransform;e.direction=="x"?(n=e.scale=g/Math.abs(i(e.max)-i(e.min)),r=Math.min(i(e.max),i(e.min))):(n=e.scale=y/Math.abs(i(e.max)-i(e.min)),n=-n,r=Math.max(i(e.max),i(e.min))),i==t?e.p2c=function(e){return(e-r)*n}:e.p2c=function(e){return(i(e)-r)*n},s?e.c2p=function(e){return s(r+e/n)}:e.c2p=function(e){return r+e/n}}function j(e){var t=e.options,n=e.ticks||[],r=t.labelWidth||0,i=t.labelHeight||0,s=r||e.direction=="x"?Math.floor(f.width/(n.length||1)):null;legacyStyles=e.direction+"Axis "+e.direction+e.n+"Axis",layer="flot-"+e.direction+"-axis flot-"+e.direction+e.n+"-axis "+legacyStyles,font=t.font||"flot-tick-label tickLabel";for(var o=0;o<n.length;++o){var u=n[o];if(!u.label)continue;var a=f.getTextInfo(layer,u.label,font,null,s);r=Math.max(r,a.width),i=Math.max(i,a.height)}e.labelWidth=t.labelWidth||r,e.labelHeight=t.labelHeight||i}function F(t){var n=t.labelWidth,r=t.labelHeight,i=t.options.position,s=t.options.tickLength,o=a.grid.axisMargin,u=a.grid.labelMargin,l=t.direction=="x"?d:v,c,h,p=e.grep(l,function(e){return e&&e.options.position==i&&e.reserveSpace});e.inArray(t,p)==p.length-1&&(o=0);if(s==null){var g=e.grep(l,function(e){return e&&e.reserveSpace});h=e.inArray(t,g)==0,h?s="full":s=5}isNaN(+s)||(u+=+s),t.direction=="x"?(r+=u,i=="bottom"?(m.bottom+=r+o,t.box={top:f.height-m.bottom,height:r}):(t.box={top:m.top+o,height:r},m.top+=r+o)):(n+=u,i=="left"?(t.box={left:m.left+o,width:n},m.left+=n+o):(m.right+=n+o,t.box={left:f.width-m.right,width:n})),t.position=i,t.tickLength=s,t.box.padding=u,t.innermost=h}function I(e){e.direction=="x"?(e.box.left=m.left-e.labelWidth/2,e.box.width=f.width-m.left-m.right+e.labelWidth):(e.box.top=m.top-e.labelHeight/2,e.box.height=f.height-m.bottom-m.top+e.labelHeight)}function q(){var t=a.grid.minBorderMargin,n={x:0,y:0},r,i;if(t==null){t=0;for(r=0;r<u.length;++r)t=Math.max(t,2*(u[r].points.radius+u[r].points.lineWidth/2))}n.x=n.y=Math.ceil(t),e.each(k(),function(e,t){var r=t.direction;t.reserveSpace&&(n[r]=Math.ceil(Math.max(n[r],(r=="x"?t.labelWidth:t.labelHeight)/2)))}),m.left=Math.max(n.x,m.left),m.right=Math.max(n.x,m.right),m.top=Math.max(n.y,m.top),m.bottom=Math.max(n.y,m.bottom)}function R(){var t,n=k(),r=a.grid.show;for(var i in m){var s=a.grid.margin||0;m[i]=typeof s=="number"?s:s[i]||0}E(b.processOffset,[m]);for(var i in m)typeof a.grid.borderWidth=="object"?m[i]+=r?a.grid.borderWidth[i]:0:m[i]+=r?a.grid.borderWidth:0;e.each(n,function(e,t){t.show=t.options.show,t.show==null&&(t.show=t.used),t.reserveSpace=t.show||t.options.reserveSpace,U(t)});if(r){var o=e.grep(n,function(e){return e.reserveSpace});e.each(o,function(e,t){z(t),W(t),X(t,t.ticks),j(t)});for(t=o.length-1;t>=0;--t)F(o[t]);q(),e.each(o,function(e,t){I(t)})}g=f.width-m.left-m.right,y=f.height-m.bottom-m.top,e.each(n,function(e,t){B(t)}),r&&G(),it()}function U(e){var t=e.options,n=+(t.min!=null?t.min:e.datamin),r=+(t.max!=null?t.max:e.datamax),i=r-n;if(i==0){var s=r==0?1:.01;t.min==null&&(n-=s);if(t.max==null||t.min!=null)r+=s}else{var o=t.autoscaleMargin;o!=null&&(t.min==null&&(n-=i*o,n<0&&e.datamin!=null&&e.datamin>=0&&(n=0)),t.max==null&&(r+=i*o,r>0&&e.datamax!=null&&e.datamax<=0&&(r=0)))}e.min=n,e.max=r}function z(t){var n=t.options,r;typeof n.ticks=="number"&&n.ticks>0?r=n.ticks:r=.3*Math.sqrt(t.direction=="x"?f.width:f.height);var s=(t.max-t.min)/r,o=-Math.floor(Math.log(s)/Math.LN10),u=n.tickDecimals;u!=null&&o>u&&(o=u);var a=Math.pow(10,-o),l=s/a,c;l<1.5?c=1:l<3?(c=2,l>2.25&&(u==null||o+1<=u)&&(c=2.5,++o)):l<7.5?c=5:c=10,c*=a,n.minTickSize!=null&&c<n.minTickSize&&(c=n.minTickSize),t.delta=s,t.tickDecimals=Math.max(0,u!=null?u:o),t.tickSize=n.tickSize||c;if(n.mode=="time"&&!t.tickGenerator)throw new Error("Time mode requires the flot.time plugin.");t.tickGenerator||(t.tickGenerator=function(e){var t=[],n=i(e.min,e.tickSize),r=0,s=Number.NaN,o;do o=s,s=n+r*e.tickSize,t.push(s),++r;while(s<e.max&&s!=o);return t},t.tickFormatter=function(e,t){var n=t.tickDecimals?Math.pow(10,t.tickDecimals):1,r=""+Math.round(e*n)/n;if(t.tickDecimals!=null){var i=r.indexOf("."),s=i==-1?0:r.length-i-1;if(s<t.tickDecimals)return(s?r:r+".")+(""+n).substr(1,t.tickDecimals-s)}return r}),e.isFunction(n.tickFormatter)&&(t.tickFormatter=function(e,t){return""+n.tickFormatter(e,t)});if(n.alignTicksWithAxis!=null){var h=(t.direction=="x"?d:v)[n.alignTicksWithAxis-1];if(h&&h.used&&h!=t){var p=t.tickGenerator(t);p.length>0&&(n.min==null&&(t.min=Math.min(t.min,p[0])),n.max==null&&p.length>1&&(t.max=Math.max(t.max,p[p.length-1]))),t.tickGenerator=function(e){var t=[],n,r;for(r=0;r<h.ticks.length;++r)n=(h.ticks[r].v-h.min)/(h.max-h.min),n=e.min+n*(e.max-e.min),t.push(n);return t};if(!t.mode&&n.tickDecimals==null){var m=Math.max(0,-Math.floor(Math.log(t.delta)/Math.LN10)+1),g=t.tickGenerator(t);g.length>1&&/\..*0$/.test((g[1]-g[0]).toFixed(m))||(t.tickDecimals=m)}}}}function W(t){var n=t.options.ticks,r=[];n==null||typeof n=="number"&&n>0?r=t.tickGenerator(t):n&&(e.isFunction(n)?r=n(t):r=n);var i,s;t.ticks=[];for(i=0;i<r.length;++i){var o=null,u=r[i];typeof u=="object"?(s=+u[0],u.length>1&&(o=u[1])):s=+u,o==null&&(o=t.tickFormatter(s,t)),isNaN(s)||t.ticks.push({v:s,label:o})}}function X(e,t){e.options.autoscaleMargin&&t.length>0&&(e.options.min==null&&(e.min=Math.min(e.min,t[0].v)),e.options.max==null&&t.length>1&&(e.max=Math.max(e.max,t[t.length-1].v)))}function V(){f.clear(),E(b.drawBackground,[h]);var e=a.grid;e.show&&e.backgroundColor&&K(),e.show&&!e.aboveData&&Q();for(var t=0;t<u.length;++t)E(b.drawSeries,[h,u[t]]),Y(u[t]);E(b.draw,[h]),e.show&&e.aboveData&&Q(),f.render(),ht()}function J(e,t){var n,r,i,s,o=k();for(var u=0;u<o.length;++u){n=o[u];if(n.direction==t){s=t+n.n+"axis",!e[s]&&n.n==1&&(s=t+"axis");if(e[s]){r=e[s].from,i=e[s].to;break}}}e[s]||(n=t=="x"?d[0]:v[0],r=e[t+"1"],i=e[t+"2"]);if(r!=null&&i!=null&&r>i){var a=r;r=i,i=a}return{from:r,to:i,axis:n}}function K(){h.save(),h.translate(m.left,m.top),h.fillStyle=bt(a.grid.backgroundColor,y,0,"rgba(255, 255, 255, 0)"),h.fillRect(0,0,g,y),h.restore()}function Q(){var t,n,r,i;h.save(),h.translate(m.left,m.top);var s=a.grid.markings;if(s){e.isFunction(s)&&(n=w.getAxes(),n.xmin=n.xaxis.min,n.xmax=n.xaxis.max,n.ymin=n.yaxis.min,n.ymax=n.yaxis.max,s=s(n));for(t=0;t<s.length;++t){var o=s[t],u=J(o,"x"),f=J(o,"y");u.from==null&&(u.from=u.axis.min),u.to==null&&(u.to=u.axis.max),f.from==null&&(f.from=f.axis.min),f.to==null&&(f.to=f.axis.max);if(u.to<u.axis.min||u.from>u.axis.max||f.to<f.axis.min||f.from>f.axis.max)continue;u.from=Math.max(u.from,u.axis.min),u.to=Math.min(u.to,u.axis.max),f.from=Math.max(f.from,f.axis.min),f.to=Math.min(f.to,f.axis.max);if(u.from==u.to&&f.from==f.to)continue;u.from=u.axis.p2c(u.from),u.to=u.axis.p2c(u.to),f.from=f.axis.p2c(f.from),f.to=f.axis.p2c(f.to),u.from==u.to||f.from==f.to?(h.beginPath(),h.strokeStyle=o.color||a.grid.markingsColor,h.lineWidth=o.lineWidth||a.grid.markingsLineWidth,h.moveTo(u.from,f.from),h.lineTo(u.to,f.to),h.stroke()):(h.fillStyle=o.color||a.grid.markingsColor,h.fillRect(u.from,f.to,u.to-u.from,f.from-f.to))}}n=k(),r=a.grid.borderWidth;for(var l=0;l<n.length;++l){var c=n[l],p=c.box,d=c.tickLength,v,b,E,S;if(!c.show||c.ticks.length==0)continue;h.lineWidth=1,c.direction=="x"?(v=0,d=="full"?b=c.position=="top"?0:y:b=p.top-m.top+(c.position=="top"?p.height:0)):(b=0,d=="full"?v=c.position=="left"?0:g:v=p.left-m.left+(c.position=="left"?p.width:0)),c.innermost||(h.strokeStyle=c.options.color,h.beginPath(),E=S=0,c.direction=="x"?E=g+1:S=y+1,h.lineWidth==1&&(c.direction=="x"?b=Math.floor(b)+.5:v=Math.floor(v)+.5),h.moveTo(v,b),h.lineTo(v+E,b+S),h.stroke()),h.strokeStyle=c.options.tickColor,h.beginPath();for(t=0;t<c.ticks.length;++t){var x=c.ticks[t].v;E=S=0;if(isNaN(x)||x<c.min||x>c.max||d=="full"&&(typeof r=="object"&&r[c.position]>0||r>0)&&(x==c.min||x==c.max))continue;c.direction=="x"?(v=c.p2c(x),S=d=="full"?-y:d,c.position=="top"&&(S=-S)):(b=c.p2c(x),E=d=="full"?-g:d,c.position=="left"&&(E=-E)),h.lineWidth==1&&(c.direction=="x"?v=Math.floor(v)+.5:b=Math.floor(b)+.5),h.moveTo(v,b),h.lineTo(v+E,b+S)}h.stroke()}r&&(i=a.grid.borderColor,typeof r=="object"||typeof i=="object"?(typeof r!="object"&&(r={top:r,right:r,bottom:r,left:r}),typeof i!="object"&&(i={top:i,right:i,bottom:i,left:i}),r.top>0&&(h.strokeStyle=i.top,h.lineWidth=r.top,h.beginPath(),h.moveTo(0-r.left,0-r.top/2),h.lineTo(g,0-r.top/2),h.stroke()),r.right>0&&(h.strokeStyle=i.right,h.lineWidth=r.right,h.beginPath(),h.moveTo(g+r.right/2,0-r.top),h.lineTo(g+r.right/2,y),h.stroke()),r.bottom>0&&(h.strokeStyle=i.bottom,h.lineWidth=r.bottom,h.beginPath(),h.moveTo(g+r.right,y+r.bottom/2),h.lineTo(0,y+r.bottom/2),h.stroke()),r.left>0&&(h.strokeStyle=i.left,h.lineWidth=r.left,h.beginPath(),h.moveTo(0-r.left/2,y+r.bottom),h.lineTo(0-r.left/2,0),h.stroke())):(h.lineWidth=r,h.strokeStyle=a.grid.borderColor,h.strokeRect(-r/2,-r/2,g+r,y+r))),h.restore()}function G(){e.each(k(),function(e,t){if(!t.show||t.ticks.length==0)return;var n=t.box,r=t.direction+"Axis "+t.direction+t.n+"Axis",i="flot-"+t.direction+"-axis flot-"+t.direction+t.n+"-axis "+r,s=t.options.font||"flot-tick-label tickLabel",o,u,a,l,c;f.removeText(i);for(var h=0;h<t.ticks.length;++h){o=t.ticks[h];if(!o.label||o.v<t.min||o.v>t.max)continue;t.direction=="x"?(l="center",u=m.left+t.p2c(o.v),t.position=="bottom"?a=n.top+n.padding:(a=n.top+n.height-n.padding,c="bottom")):(c="middle",a=m.top+t.p2c(o.v),t.position=="left"?(u=n.left+n.width-n.padding,l="right"):u=n.left+n.padding),f.addText(i,u,a,o.label,s,null,null,l,c)}})}function Y(e){e.lines.show&&Z(e),e.bars.show&&nt(e),e.points.show&&et(e)}function Z(e){function t(e,t,n,r,i){var s=e.points,o=e.pointsize,u=null,a=null;h.beginPath();for(var f=o;f<s.length;f+=o){var l=s[f-o],c=s[f-o+1],p=s[f],d=s[f+1];if(l==null||p==null)continue;if(c<=d&&c<i.min){if(d<i.min)continue;l=(i.min-c)/(d-c)*(p-l)+l,c=i.min}else if(d<=c&&d<i.min){if(c<i.min)continue;p=(i.min-c)/(d-c)*(p-l)+l,d=i.min}if(c>=d&&c>i.max){if(d>i.max)continue;l=(i.max-c)/(d-c)*(p-l)+l,c=i.max}else if(d>=c&&d>i.max){if(c>i.max)continue;p=(i.max-c)/(d-c)*(p-l)+l,d=i.max}if(l<=p&&l<r.min){if(p<r.min)continue;c=(r.min-l)/(p-l)*(d-c)+c,l=r.min}else if(p<=l&&p<r.min){if(l<r.min)continue;d=(r.min-l)/(p-l)*(d-c)+c,p=r.min}if(l>=p&&l>r.max){if(p>r.max)continue;c=(r.max-l)/(p-l)*(d-c)+c,l=r.max}else if(p>=l&&p>r.max){if(l>r.max)continue;d=(r.max-l)/(p-l)*(d-c)+c,p=r.max}(l!=u||c!=a)&&h.moveTo(r.p2c(l)+t,i.p2c(c)+n),u=p,a=d,h.lineTo(r.p2c(p)+t,i.p2c(d)+n)}h.stroke()}function n(e,t,n){var r=e.points,i=e.pointsize,s=Math.min(Math.max(0,n.min),n.max),o=0,u,a=!1,f=1,l=0,c=0;for(;;){if(i>0&&o>r.length+i)break;o+=i;var p=r[o-i],d=r[o-i+f],v=r[o],m=r[o+f];if(a){if(i>0&&p!=null&&v==null){c=o,i=-i,f=2;continue}if(i<0&&o==l+i){h.fill(),a=!1,i=-i,f=1,o=l=c+i;continue}}if(p==null||v==null)continue;if(p<=v&&p<t.min){if(v<t.min)continue;d=(t.min-p)/(v-p)*(m-d)+d,p=t.min}else if(v<=p&&v<t.min){if(p<t.min)continue;m=(t.min-p)/(v-p)*(m-d)+d,v=t.min}if(p>=v&&p>t.max){if(v>t.max)continue;d=(t.max-p)/(v-p)*(m-d)+d,p=t.max}else if(v>=p&&v>t.max){if(p>t.max)continue;m=(t.max-p)/(v-p)*(m-d)+d,v=t.max}a||(h.beginPath(),h.moveTo(t.p2c(p),n.p2c(s)),a=!0);if(d>=n.max&&m>=n.max){h.lineTo(t.p2c(p),n.p2c(n.max)),h.lineTo(t.p2c(v),n.p2c(n.max));continue}if(d<=n.min&&m<=n.min){h.lineTo(t.p2c(p),n.p2c(n.min)),h.lineTo(t.p2c(v),n.p2c(n.min));continue}var g=p,y=v;d<=m&&d<n.min&&m>=n.min?(p=(n.min-d)/(m-d)*(v-p)+p,d=n.min):m<=d&&m<n.min&&d>=n.min&&(v=(n.min-d)/(m-d)*(v-p)+p,m=n.min),d>=m&&d>n.max&&m<=n.max?(p=(n.max-d)/(m-d)*(v-p)+p,d=n.max):m>=d&&m>n.max&&d<=n.max&&(v=(n.max-d)/(m-d)*(v-p)+p,m=n.max),p!=g&&h.lineTo(t.p2c(g),n.p2c(d)),h.lineTo(t.p2c(p),n.p2c(d)),h.lineTo(t.p2c(v),n.p2c(m)),v!=y&&(h.lineTo(t.p2c(v),n.p2c(m)),h.lineTo(t.p2c(y),n.p2c(m)))}}h.save(),h.translate(m.left,m.top),h.lineJoin="round";var r=e.lines.lineWidth,i=e.shadowSize;if(r>0&&i>0){h.lineWidth=i,h.strokeStyle="rgba(0,0,0,0.1)";var s=Math.PI/18;t(e.datapoints,Math.sin(s)*(r/2+i/2),Math.cos(s)*(r/2+i/2),e.xaxis,e.yaxis),h.lineWidth=i/2,t(e.datapoints,Math.sin(s)*(r/2+i/4),Math.cos(s)*(r/2+i/4),e.xaxis,e.yaxis)}h.lineWidth=r,h.strokeStyle=e.color;var o=rt(e.lines,e.color,0,y);o&&(h.fillStyle=o,n(e.datapoints,e.xaxis,e.yaxis)),r>0&&t(e.datapoints,0,0,e.xaxis,e.yaxis),h.restore()}function et(e){function t(e,t,n,r,i,s,o,u){var a=e.points,f=e.pointsize;for(var l=0;l<a.length;l+=f){var c=a[l],p=a[l+1];if(c==null||c<s.min||c>s.max||p<o.min||p>o.max)continue;h.beginPath(),c=s.p2c(c),p=o.p2c(p)+r,u=="circle"?h.arc(c,p,t,0,i?Math.PI:Math.PI*2,!1):u(h,c,p,t,i),h.closePath(),n&&(h.fillStyle=n,h.fill()),h.stroke()}}h.save(),h.translate(m.left,m.top);var n=e.points.lineWidth,r=e.shadowSize,i=e.points.radius,s=e.points.symbol;n==0&&(n=1e-4);if(n>0&&r>0){var o=r/2;h.lineWidth=o,h.strokeStyle="rgba(0,0,0,0.1)",t(e.datapoints,i,null,o+o/2,!0,e.xaxis,e.yaxis,s),h.strokeStyle="rgba(0,0,0,0.2)",t(e.datapoints,i,null,o/2,!0,e.xaxis,e.yaxis,s)}h.lineWidth=n,h.strokeStyle=e.color,t(e.datapoints,i,rt(e.points,e.color),0,!1,e.xaxis,e.yaxis,s),h.restore()}function tt(e,t,n,r,i,s,o,u,a,f,l,c){var h,p,d,v,m,g,y,b,w;l?(b=g=y=!0,m=!1,h=n,p=e,v=t+r,d=t+i,p<h&&(w=p,p=h,h=w,m=!0,g=!1)):(m=g=y=!0,b=!1,h=e+r,p=e+i,d=n,v=t,v<d&&(w=v,v=d,d=w,b=!0,y=!1));if(p<u.min||h>u.max||v<a.min||d>a.max)return;h<u.min&&(h=u.min,m=!1),p>u.max&&(p=u.max,g=!1),d<a.min&&(d=a.min,b=!1),v>a.max&&(v=a.max,y=!1),h=u.p2c(h),d=a.p2c(d),p=u.p2c(p),v=a.p2c(v),o&&(f.beginPath(),f.moveTo(h,d),f.lineTo(h,v),f.lineTo(p,v),f.lineTo(p,d),f.fillStyle=o(d,v),f.fill()),c>0&&(m||g||y||b)&&(f.beginPath(),f.moveTo(h,d+s),m?f.lineTo(h,v+s):f.moveTo(h,v+s),y?f.lineTo(p,v+s):f.moveTo(p,v+s),g?f.lineTo(p,d+s):f.moveTo(p,d+s),b?f.lineTo(h,d+s):f.moveTo(h,d+s),f.stroke())}function nt(e){function t(t,n,r,i,s,o,u){var a=t.points,f=t.pointsize;for(var l=0;l<a.length;l+=f){if(a[l]==null)continue;tt(a[l],a[l+1],a[l+2],n,r,i,s,o,u,h,e.bars.horizontal,e.bars.lineWidth)}}h.save(),h.translate(m.left,m.top),h.lineWidth=e.bars.lineWidth,h.strokeStyle=e.color;var n;switch(e.bars.align){case"left":n=0;break;case"right":n=-e.bars.barWidth;break;case"center":n=-e.bars.barWidth/2;break;default:throw new Error("Invalid bar alignment: "+e.bars.align)}var r=e.bars.fill?function(t,n){return rt(e.bars,e.color,t,n)}:null;t(e.datapoints,n,n+e.bars.barWidth,0,r,e.xaxis,e.yaxis),h.restore()}function rt(t,n,r,i){var s=t.fill;if(!s)return null;if(t.fillColor)return bt(t.fillColor,r,i,n);var o=e.color.parse(n);return o.a=typeof s=="number"?s:.4,o.normalize(),o.toString()}function it(){t.find(".legend").remove();if(!a.legend.show)return;var n=[],r=[],i=!1,s=a.legend.labelFormatter,o,f;for(var l=0;l<u.length;++l)o=u[l],o.label&&(f=s?s(o.label,o):o.label,f&&r.push({label:f,color:o.color}));if(a.legend.sorted)if(e.isFunction(a.legend.sorted))r.sort(a.legend.sorted);else if(a.legend.sorted=="reverse")r.reverse();else{var c=a.legend.sorted!="descending";r.sort(function(e,t){return e.label==t.label?0:e.label<t.label!=c?1:-1})}for(var l=0;l<r.length;++l){var h=r[l];l%a.legend.noColumns==0&&(i&&n.push("</tr>"),n.push("<tr>"),i=!0),n.push('<td class="legendColorBox"><div style="border:1px solid '+a.legend.labelBoxBorderColor+';padding:1px"><div style="width:4px;height:0;border:5px solid '+h.color+';overflow:hidden"></div></div></td>'+'<td class="legendLabel">'+h.label+"</td>")}i&&n.push("</tr>");if(n.length==0)return;var p='<table style="font-size:smaller;color:'+a.grid.color+'">'+n.join("")+"</table>";if(a.legend.container!=null)e(a.legend.container).html(p);else{var d="",v=a.legend.position,g=a.legend.margin;g[0]==null&&(g=[g,g]),v.charAt(0)=="n"?d+="top:"+(g[1]+m.top)+"px;":v.charAt(0)=="s"&&(d+="bottom:"+(g[1]+m.bottom)+"px;"),v.charAt(1)=="e"?d+="right:"+(g[0]+m.right)+"px;":v.charAt(1)=="w"&&(d+="left:"+(g[0]+m.left)+"px;");var y=e('<div class="legend">'+p.replace('style="','style="position:absolute;'+d+";")+"</div>").appendTo(t);if(a.legend.backgroundOpacity!=0){var b=a.legend.backgroundColor;b==null&&(b=a.grid.backgroundColor,b&&typeof b=="string"?b=e.color.parse(b):b=e.color.extract(y,"background-color"),b.a=1,b=b.toString());var w=y.children();e('<div style="position:absolute;width:'+w.width()+"px;height:"+w.height()+"px;"+d+"background-color:"+b+';"> </div>').prependTo(y).css("opacity",a.legend.backgroundOpacity)}}}function ut(e,t,n){var r=a.grid.mouseActiveRadius,i=r*r+1,s=null,o=!1,f,l,c;for(f=u.length-1;f>=0;--f){if(!n(u[f]))continue;var h=u[f],p=h.xaxis,d=h.yaxis,v=h.datapoints.points,m=p.c2p(e),g=d.c2p(t),y=r/p.scale,b=r/d.scale;c=h.datapoints.pointsize,p.options.inverseTransform&&(y=Number.MAX_VALUE),d.options.inverseTransform&&(b=Number.MAX_VALUE);if(h.lines.show||h.points.show)for(l=0;l<v.length;l+=c){var w=v[l],E=v[l+1];if(w==null)continue;if(w-m>y||w-m<-y||E-g>b||E-g<-b)continue;var S=Math.abs(p.p2c(w)-e),x=Math.abs(d.p2c(E)-t),T=S*S+x*x;T<i&&(i=T,s=[f,l/c])}if(h.bars.show&&!s){var N=h.bars.align=="left"?0:-h.bars.barWidth/2,C=N+h.bars.barWidth;for(l=0;l<v.length;l+=c){var w=v[l],E=v[l+1],k=v[l+2];if(w==null)continue;if(u[f].bars.horizontal?m<=Math.max(k,w)&&m>=Math.min(k,w)&&g>=E+N&&g<=E+C:m>=w+N&&m<=w+C&&g>=Math.min(k,E)&&g<=Math.max(k,E))s=[f,l/c]}}}return s?(f=s[0],l=s[1],c=u[f].datapoints.pointsize,{datapoint:u[f].datapoints.points.slice(l*c,(l+1)*c),dataIndex:l,series:u[f],seriesIndex:f}):null}function at(e){a.grid.hoverable&&ct("plothover",e,function(e){return e["hoverable"]!=0})}function ft(e){a.grid.hoverable&&ct("plothover",e,function(e){return!1})}function lt(e){ct("plotclick",e,function(e){return e["clickable"]!=0})}function ct(e,n,r){var i=c.offset(),s=n.pageX-i.left-m.left,o=n.pageY-i.top-m.top,u=L({left:s,top:o});u.pageX=n.pageX,u.pageY=n.pageY;var f=ut(s,o,r);f&&(f.pageX=parseInt(f.series.xaxis.p2c(f.datapoint[0])+i.left+m.left,10),f.pageY=parseInt(f.series.yaxis.p2c(f.datapoint[1])+i.top+m.top,10));if(a.grid.autoHighlight){for(var l=0;l<st.length;++l){var h=st[l];h.auto==e&&(!f||h.series!=f.series||h.point[0]!=f.datapoint[0]||h.point[1]!=f.datapoint[1])&&vt(h.series,h.point)}f&&dt(f.series,f.datapoint,e)}t.trigger(e,[u,f])}function ht(){var e=a.interaction.redrawOverlayInterval;if(e==-1){pt();return}ot||(ot=setTimeout(pt,e))}function pt(){ot=null,p.save(),l.clear(),p.translate(m.left,m.top);var e,t;for(e=0;e<st.length;++e)t=st[e],t.series.bars.show?yt(t.series,t.point):gt(t.series,t.point);p.restore(),E(b.drawOverlay,[p])}function dt(e,t,n){typeof e=="number"&&(e=u[e]);if(typeof t=="number"){var r=e.datapoints.pointsize;t=e.datapoints.points.slice(r*t,r*(t+1))}var i=mt(e,t);i==-1?(st.push({series:e,point:t,auto:n}),ht()):n||(st[i].auto=!1)}function vt(e,t){if(e==null&&t==null){st=[],ht();return}typeof e=="number"&&(e=u[e]);if(typeof t=="number"){var n=e.datapoints.pointsize;t=e.datapoints.points.slice(n*t,n*(t+1))}var r=mt(e,t);r!=-1&&(st.splice(r,1),ht())}function mt(e,t){for(var n=0;n<st.length;++n){var r=st[n];if(r.series==e&&r.point[0]==t[0]&&r.point[1]==t[1])return n}return-1}function gt(t,n){var r=n[0],i=n[1],s=t.xaxis,o=t.yaxis,u=typeof t.highlightColor=="string"?t.highlightColor:e.color.parse(t.color).scale("a",.5).toString();if(r<s.min||r>s.max||i<o.min||i>o.max)return;var a=t.points.radius+t.points.lineWidth/2;p.lineWidth=a,p.strokeStyle=u;var f=1.5*a;r=s.p2c(r),i=o.p2c(i),p.beginPath(),t.points.symbol=="circle"?p.arc(r,i,f,0,2*Math.PI,!1):t.points.symbol(p,r,i,f,!1),p.closePath(),p.stroke()}function yt(t,n){var r=typeof t.highlightColor=="string"?t.highlightColor:e.color.parse(t.color).scale("a",.5).toString(),i=r,s=t.bars.align=="left"?0:-t.bars.barWidth/2;p.lineWidth=t.bars.lineWidth,p.strokeStyle=r,tt(n[0],n[1],n[2]||0,s,s+t.bars.barWidth,0,function(){return i},t.xaxis,t.yaxis,p,t.bars.horizontal,t.bars.lineWidth)}function bt(t,n,r,i){if(typeof t=="string")return t;var s=h.createLinearGradient(0,r,0,n);for(var o=0,u=t.colors.length;o<u;++o){var a=t.colors[o];if(typeof a!="string"){var f=e.color.parse(i);a.brightness!=null&&(f=f.scale("rgb",a.brightness)),a.opacity!=null&&(f.a*=a.opacity),a=f.toString()}s.addColorStop(o/(u-1),a)}return s}var u=[],a={colors:["#edc240","#afd8f8","#cb4b4b","#4da74d","#9440ed"],legend:{show:!0,noColumns:1,labelFormatter:null,labelBoxBorderColor:"#ccc",container:null,position:"ne",margin:5,backgroundColor:null,backgroundOpacity:.85,sorted:null},xaxis:{show:null,position:"bottom",mode:null,font:null,color:null,tickColor:null,transform:null,inverseTransform:null,min:null,max:null,autoscaleMargin:null,ticks:null,tickFormatter:null,labelWidth:null,labelHeight:null,reserveSpace:null,tickLength:null,alignTicksWithAxis:null,tickDecimals:null,tickSize:null,minTickSize:null},yaxis:{autoscaleMargin:.02,position:"left"},xaxes:[],yaxes:[],series:{points:{show:!1,radius:3,lineWidth:2,fill:!0,fillColor:"#ffffff",symbol:"circle"},lines:{lineWidth:2,fill:!1,fillColor:null,steps:!1},bars:{show:!1,lineWidth:2,barWidth:1,fill:!0,fillColor:null,align:"left",horizontal:!1,zero:!0},shadowSize:3,highlightColor:null},grid:{show:!0,aboveData:!1,color:"#545454",backgroundColor:null,borderColor:null,tickColor:null,margin:0,labelMargin:5,axisMargin:8,borderWidth:2,minBorderMargin:null,markings:null,markingsColor:"#f4f4f4",markingsLineWidth:2,clickable:!1,hoverable:!1,autoHighlight:!0,mouseActiveRadius:10},interaction:{redrawOverlayInterval:1e3/60},hooks:{}},f=null,l=null,c=null,h=null,p=null,d=[],v=[],m={left:0,right:0,top:0,bottom
:0},g=0,y=0,b={processOptions:[],processRawData:[],processDatapoints:[],processOffset:[],drawBackground:[],drawSeries:[],draw:[],bindEvents:[],drawOverlay:[],shutdown:[]},w=this;w.setData=T,w.setupGrid=R,w.draw=V,w.getPlaceholder=function(){return t},w.getCanvas=function(){return f.element},w.getPlotOffset=function(){return m},w.width=function(){return g},w.height=function(){return y},w.offset=function(){var e=c.offset();return e.left+=m.left,e.top+=m.top,e},w.getData=function(){return u},w.getAxes=function(){var t={},n;return e.each(d.concat(v),function(e,n){n&&(t[n.direction+(n.n!=1?n.n:"")+"axis"]=n)}),t},w.getXAxes=function(){return d},w.getYAxes=function(){return v},w.c2p=L,w.p2c=A,w.getOptions=function(){return a},w.highlight=dt,w.unhighlight=vt,w.triggerRedrawOverlay=ht,w.pointOffset=function(e){return{left:parseInt(d[C(e,"x")-1].p2c(+e.x)+m.left,10),top:parseInt(v[C(e,"y")-1].p2c(+e.y)+m.top,10)}},w.shutdown=H,w.resize=function(){var e=t.width(),n=t.height();f.resize(e,n),l.resize(e,n)},w.hooks=b,S(w),x(s),D(),T(r),R(),V(),P();var st=[],ot=null}function i(e,t){return t*Math.floor(e/t)}var t=Object.prototype.hasOwnProperty;n.prototype.resize=function(e,t){if(e<=0||t<=0)throw new Error("Invalid dimensions for plot, width = "+e+", height = "+t);var n=this.element,r=this.context,i=this.pixelRatio;this.width!=e&&(n.width=e*i,n.style.width=e+"px",this.width=e),this.height!=t&&(n.height=t*i,n.style.height=t+"px",this.height=t),r.restore(),r.save(),r.scale(i,i)},n.prototype.clear=function(){this.context.clearRect(0,0,this.width,this.height)},n.prototype.render=function(){var e=this._textCache;for(var n in e)if(t.call(e,n)){var r=this.getTextLayer(n),i=e[n];r.hide();for(var s in i)if(t.call(i,s)){var o=i[s];for(var u in o)if(t.call(o,u)){var a=o[u].positions;for(var f=0,l;l=a[f];f++)l.active?l.rendered||(r.append(l.element),l.rendered=!0):(a.splice(f--,1),l.rendered&&l.element.detach());a.length==0&&delete o[u]}}r.show()}},n.prototype.getTextLayer=function(t){var n=this.text[t];return n==null&&(this.textContainer==null&&(this.textContainer=e("<div class='flot-text'></div>").css({position:"absolute",top:0,left:0,bottom:0,right:0,"font-size":"smaller",color:"#545454"}).insertAfter(this.element)),n=this.text[t]=e("<div></div>").addClass(t).css({position:"absolute",top:0,left:0,bottom:0,right:0}).appendTo(this.textContainer)),n},n.prototype.getTextInfo=function(t,n,r,i,s){var o,u,a,f;n=""+n,typeof r=="object"?o=r.style+" "+r.variant+" "+r.weight+" "+r.size+"px/"+r.lineHeight+"px "+r.family:o=r,u=this._textCache[t],u==null&&(u=this._textCache[t]={}),a=u[o],a==null&&(a=u[o]={}),f=a[n];if(f==null){var l=e("<div></div>").html(n).css({position:"absolute","max-width":s,top:-9999}).appendTo(this.getTextLayer(t));typeof r=="object"?l.css({font:o,color:r.color}):typeof r=="string"&&l.addClass(r),f=a[n]={width:l.outerWidth(!0),height:l.outerHeight(!0),element:l,positions:[]},l.detach()}return f},n.prototype.addText=function(e,t,n,r,i,s,o,u,a){var f=this.getTextInfo(e,r,i,s,o),l=f.positions;u=="center"?t-=f.width/2:u=="right"&&(t-=f.width),a=="middle"?n-=f.height/2:a=="bottom"&&(n-=f.height);for(var c=0,h;h=l[c];c++)if(h.x==t&&h.y==n){h.active=!0;return}h={active:!0,rendered:!1,element:l.length?f.element.clone():f.element,x:t,y:n},l.push(h),h.element.css({top:Math.round(n),left:Math.round(t),"text-align":u})},n.prototype.removeText=function(e,n,r,i,s,o){if(i==null){var u=this._textCache[e];if(u!=null)for(var a in u)if(t.call(u,a)){var f=u[a];for(var l in f)if(t.call(f,l)){var c=f[l].positions;for(var h=0,p;p=c[h];h++)p.active=!1}}}else{var c=this.getTextInfo(e,i,s,o).positions;for(var h=0,p;p=c[h];h++)p.x==n&&p.y==r&&(p.active=!1)}},e.plot=function(t,n,i){var s=new r(e(t),n,i,e.plot.plugins);return s},e.plot.version="0.8.1",e.plot.plugins=[],e.fn.plot=function(t,n){return this.each(function(){e.plot(this,t,n)})}}(jQuery);
},{}],333:[function(require,module,exports){
/* Flot plugin for rendering pie charts.

Copyright (c) 2007-2013 IOLA and Ole Laursen.
Licensed under the MIT license.

The plugin assumes that each series has a single data value, and that each
value is a positive integer or zero.  Negative numbers don't make sense for a
pie chart, and have unpredictable results.  The values do NOT need to be
passed in as percentages; the plugin will calculate the total and per-slice
percentages internally.

* Created by Brian Medendorp

* Updated with contributions from btburnett3, Anthony Aragues and Xavi Ivars

The plugin supports these options:

	series: {
		pie: {
			show: true/false
			radius: 0-1 for percentage of fullsize, or a specified pixel length, or 'auto'
			innerRadius: 0-1 for percentage of fullsize or a specified pixel length, for creating a donut effect
			startAngle: 0-2 factor of PI used for starting angle (in radians) i.e 3/2 starts at the top, 0 and 2 have the same result
			tilt: 0-1 for percentage to tilt the pie, where 1 is no tilt, and 0 is completely flat (nothing will show)
			offset: {
				top: integer value to move the pie up or down
				left: integer value to move the pie left or right, or 'auto'
			},
			stroke: {
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#FFF')
				width: integer pixel width of the stroke
			},
			label: {
				show: true/false, or 'auto'
				formatter:  a user-defined function that modifies the text/style of the label text
				radius: 0-1 for percentage of fullsize, or a specified pixel length
				background: {
					color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#000')
					opacity: 0-1
				},
				threshold: 0-1 for the percentage value at which to hide labels (if they're too small)
			},
			combine: {
				threshold: 0-1 for the percentage value at which to combine slices (if they're too small)
				color: any hexidecimal color value (other formats may or may not work, so best to stick with something like '#CCC'), if null, the plugin will automatically use the color of the first slice to be combined
				label: any text value of what the combined slice should be labeled
			}
			highlight: {
				opacity: 0-1
			}
		}
	}

More detail and specific examples can be found in the included HTML file.

*/(function(e){function r(r){function p(t,n,r){l||(l=!0,s=t.getCanvas(),o=e(s).parent(),i=t.getOptions(),t.setData(d(t.getData())))}function d(t){var n=0,r=0,s=0,o=i.series.pie.combine.color,u=[];for(var a=0;a<t.length;++a){var f=t[a].data;e.isArray(f)&&f.length==1&&(f=f[0]),e.isArray(f)?!isNaN(parseFloat(f[1]))&&isFinite(f[1])?f[1]=+f[1]:f[1]=0:!isNaN(parseFloat(f))&&isFinite(f)?f=[1,+f]:f=[1,0],t[a].data=[f]}for(var a=0;a<t.length;++a)n+=t[a].data[0][1];for(var a=0;a<t.length;++a){var f=t[a].data[0][1];f/n<=i.series.pie.combine.threshold&&(r+=f,s++,o||(o=t[a].color))}for(var a=0;a<t.length;++a){var f=t[a].data[0][1];(s<2||f/n>i.series.pie.combine.threshold)&&u.push({data:[[1,f]],color:t[a].color,label:t[a].label,angle:f*Math.PI*2/n,percent:f/(n/100)})}return s>1&&u.push({data:[[1,r]],color:o,label:i.series.pie.combine.label,angle:r*Math.PI*2/n,percent:r/(n/100)}),u}function v(r,s){function y(){c.clearRect(0,0,h,p),o.children().filter(".pieLabel, .pieLabelBackground").remove()}function b(){var e=i.series.pie.shadow.left,t=i.series.pie.shadow.top,n=10,r=i.series.pie.shadow.alpha,s=i.series.pie.radius>1?i.series.pie.radius:u*i.series.pie.radius;if(s>=h/2-e||s*i.series.pie.tilt>=p/2-t||s<=n)return;c.save(),c.translate(e,t),c.globalAlpha=r,c.fillStyle="#000",c.translate(a,f),c.scale(1,i.series.pie.tilt);for(var o=1;o<=n;o++)c.beginPath(),c.arc(0,0,s,0,Math.PI*2,!1),c.fill(),s-=o;c.restore()}function w(){function l(e,t,i){if(e<=0||isNaN(e))return;i?c.fillStyle=t:(c.strokeStyle=t,c.lineJoin="round"),c.beginPath(),Math.abs(e-Math.PI*2)>1e-9&&c.moveTo(0,0),c.arc(0,0,n,r,r+e/2,!1),c.arc(0,0,n,r+e/2,r+e,!1),c.closePath(),r+=e,i?c.fill():c.stroke()}function d(){function l(t,n,s){if(t.data[0][1]==0)return!0;var u=i.legend.labelFormatter,l,c=i.series.pie.label.formatter;u?l=u(t.label,t):l=t.label,c&&(l=c(l,t));var d=(n+t.angle+n)/2,v=a+Math.round(Math.cos(d)*r),m=f+Math.round(Math.sin(d)*r)*i.series.pie.tilt,g="<span class='pieLabel' id='pieLabel"+s+"' style='position:absolute;top:"+m+"px;left:"+v+"px;'>"+l+"</span>";o.append(g);var y=o.children("#pieLabel"+s),b=m-y.height()/2,w=v-y.width()/2;y.css("top",b),y.css("left",w);if(0-b>0||0-w>0||p-(b+y.height())<0||h-(w+y.width())<0)return!1;if(i.series.pie.label.background.opacity!=0){var E=i.series.pie.label.background.color;E==null&&(E=t.color);var S="top:"+b+"px;left:"+w+"px;";e("<div class='pieLabelBackground' style='position:absolute;width:"+y.width()+"px;height:"+y.height()+"px;"+S+"background-color:"+E+";'></div>").css("opacity",i.series.pie.label.background.opacity).insertBefore(y)}return!0}var n=t,r=i.series.pie.label.radius>1?i.series.pie.label.radius:u*i.series.pie.label.radius;for(var s=0;s<v.length;++s){if(v[s].percent>=i.series.pie.label.threshold*100&&!l(v[s],n,s))return!1;n+=v[s].angle}return!0}var t=Math.PI*i.series.pie.startAngle,n=i.series.pie.radius>1?i.series.pie.radius:u*i.series.pie.radius;c.save(),c.translate(a,f),c.scale(1,i.series.pie.tilt),c.save();var r=t;for(var s=0;s<v.length;++s)v[s].startAngle=r,l(v[s].angle,v[s].color,!0);c.restore();if(i.series.pie.stroke.width>0){c.save(),c.lineWidth=i.series.pie.stroke.width,r=t;for(var s=0;s<v.length;++s)l(v[s].angle,i.series.pie.stroke.color,!1);c.restore()}return m(c),c.restore(),i.series.pie.label.show?d():!0}if(!o)return;var h=r.getPlaceholder().width(),p=r.getPlaceholder().height(),d=o.children().filter(".legend").children().width()||0;c=s,l=!1,u=Math.min(h,p/i.series.pie.tilt)/2,f=p/2+i.series.pie.offset.top,a=h/2,i.series.pie.offset.left=="auto"?i.legend.position.match("w")?a+=d/2:a-=d/2:a+=i.series.pie.offset.left,a<u?a=u:a>h-u&&(a=h-u);var v=r.getData(),g=0;do g>0&&(u*=n),g+=1,y(),i.series.pie.tilt<=.8&&b();while(!w()&&g<t);g>=t&&(y(),o.prepend("<div class='error'>Could not draw pie with labels contained inside canvas</div>")),r.setSeries&&r.insertLegend&&(r.setSeries(v),r.insertLegend())}function m(e){if(i.series.pie.innerRadius>0){e.save();var t=i.series.pie.innerRadius>1?i.series.pie.innerRadius:u*i.series.pie.innerRadius;e.globalCompositeOperation="destination-out",e.beginPath(),e.fillStyle=i.series.pie.stroke.color,e.arc(0,0,t,0,Math.PI*2,!1),e.fill(),e.closePath(),e.restore(),e.save(),e.beginPath(),e.strokeStyle=i.series.pie.stroke.color,e.arc(0,0,t,0,Math.PI*2,!1),e.stroke(),e.closePath(),e.restore()}}function g(e,t){for(var n=!1,r=-1,i=e.length,s=i-1;++r<i;s=r)(e[r][1]<=t[1]&&t[1]<e[s][1]||e[s][1]<=t[1]&&t[1]<e[r][1])&&t[0]<(e[s][0]-e[r][0])*(t[1]-e[r][1])/(e[s][1]-e[r][1])+e[r][0]&&(n=!n);return n}function y(e,t){var n=r.getData(),i=r.getOptions(),s=i.series.pie.radius>1?i.series.pie.radius:u*i.series.pie.radius,o,l;for(var h=0;h<n.length;++h){var p=n[h];if(p.pie.show){c.save(),c.beginPath(),c.moveTo(0,0),c.arc(0,0,s,p.startAngle,p.startAngle+p.angle/2,!1),c.arc(0,0,s,p.startAngle+p.angle/2,p.startAngle+p.angle,!1),c.closePath(),o=e-a,l=t-f;if(c.isPointInPath){if(c.isPointInPath(e-a,t-f))return c.restore(),{datapoint:[p.percent,p.data],dataIndex:0,series:p,seriesIndex:h}}else{var d=s*Math.cos(p.startAngle),v=s*Math.sin(p.startAngle),m=s*Math.cos(p.startAngle+p.angle/4),y=s*Math.sin(p.startAngle+p.angle/4),b=s*Math.cos(p.startAngle+p.angle/2),w=s*Math.sin(p.startAngle+p.angle/2),E=s*Math.cos(p.startAngle+p.angle/1.5),S=s*Math.sin(p.startAngle+p.angle/1.5),x=s*Math.cos(p.startAngle+p.angle),T=s*Math.sin(p.startAngle+p.angle),N=[[0,0],[d,v],[m,y],[b,w],[E,S],[x,T]],C=[o,l];if(g(N,C))return c.restore(),{datapoint:[p.percent,p.data],dataIndex:0,series:p,seriesIndex:h}}c.restore()}}return null}function b(e){E("plothover",e)}function w(e){E("plotclick",e)}function E(e,t){var n=r.offset(),s=parseInt(t.pageX-n.left),u=parseInt(t.pageY-n.top),a=y(s,u);if(i.grid.autoHighlight)for(var f=0;f<h.length;++f){var l=h[f];l.auto==e&&(!a||l.series!=a.series)&&x(l.series)}a&&S(a.series,e);var c={pageX:t.pageX,pageY:t.pageY};o.trigger(e,[c,a])}function S(e,t){var n=T(e);n==-1?(h.push({series:e,auto:t}),r.triggerRedrawOverlay()):t||(h[n].auto=!1)}function x(e){e==null&&(h=[],r.triggerRedrawOverlay());var t=T(e);t!=-1&&(h.splice(t,1),r.triggerRedrawOverlay())}function T(e){for(var t=0;t<h.length;++t){var n=h[t];if(n.series==e)return t}return-1}function N(e,t){function s(e){if(e.angle<=0||isNaN(e.angle))return;t.fillStyle="rgba(255, 255, 255, "+n.series.pie.highlight.opacity+")",t.beginPath(),Math.abs(e.angle-Math.PI*2)>1e-9&&t.moveTo(0,0),t.arc(0,0,r,e.startAngle,e.startAngle+e.angle/2,!1),t.arc(0,0,r,e.startAngle+e.angle/2,e.startAngle+e.angle,!1),t.closePath(),t.fill()}var n=e.getOptions(),r=n.series.pie.radius>1?n.series.pie.radius:u*n.series.pie.radius;t.save(),t.translate(a,f),t.scale(1,n.series.pie.tilt);for(var i=0;i<h.length;++i)s(h[i].series);m(t),t.restore()}var s=null,o=null,u=null,a=null,f=null,l=!1,c=null,h=[];r.hooks.processOptions.push(function(e,t){t.series.pie.show&&(t.grid.show=!1,t.series.pie.label.show=="auto"&&(t.legend.show?t.series.pie.label.show=!1:t.series.pie.label.show=!0),t.series.pie.radius=="auto"&&(t.series.pie.label.show?t.series.pie.radius=.75:t.series.pie.radius=1),t.series.pie.tilt>1?t.series.pie.tilt=1:t.series.pie.tilt<0&&(t.series.pie.tilt=0))}),r.hooks.bindEvents.push(function(e,t){var n=e.getOptions();n.series.pie.show&&(n.grid.hoverable&&t.unbind("mousemove").mousemove(b),n.grid.clickable&&t.unbind("click").click(w))}),r.hooks.processDatapoints.push(function(e,t,n,r){var i=e.getOptions();i.series.pie.show&&p(e,t,n,r)}),r.hooks.drawOverlay.push(function(e,t){var n=e.getOptions();n.series.pie.show&&N(e,t)}),r.hooks.draw.push(function(e,t){var n=e.getOptions();n.series.pie.show&&v(e,t)})}var t=10,n=.95,i={series:{pie:{show:!1,radius:"auto",innerRadius:0,startAngle:1.5,tilt:1,shadow:{left:5,top:15,alpha:.02},offset:{top:0,left:"auto"},stroke:{color:"#fff",width:1},label:{show:"auto",formatter:function(e,t){return"<div style='font-size:x-small;text-align:center;padding:2px;color:"+t.color+";'>"+e+"<br/>"+Math.round(t.percent)+"%</div>"},radius:1,background:{color:null,opacity:0},threshold:0},combine:{threshold:-1,color:null,label:"Other"},highlight:{opacity:.5}}}};e.plot.plugins.push({init:r,options:i,name:"pie",version:"1.1"})})(jQuery);
},{}],334:[function(require,module,exports){
/*
 * jquery.flot.tooltip
 *
 * desc:  create tooltip with values of hovered point on the graph,
 support many series, time mode, stacking and pie charts
 you can set custom tip content (also with use of HTML tags) and precision of values
 * version: 0.4.4
 * author:  Krzysztof Urbas @krzysu [myviews.pl] with help of @ismyrnow
 * website: https://github.com/krzysu/flot.tooltip
 *
 * released under MIT License, 2012
 */

(function(a){var b={tooltip:false,tooltipOpts:{content:"%s | X: %x | Y: %y.2",dateFormat:"%y-%0m-%0d",shifts:{x:10,y:20},defaultTheme:true}};var c=function(b){var c={x:0,y:0};var d=b.getOptions();var e=function(a){c.x=a.x;c.y=a.y};var f=function(a){var b={x:0,y:0};b.x=a.pageX;b.y=a.pageY;e(b)};var g=function(b){var c=new Date(b);return a.plot.formatDate(c,d.tooltipOpts.dateFormat)};b.hooks.bindEvents.push(function(b,e){var i=d.tooltipOpts;var j=b.getPlaceholder();var k;if(d.tooltip===false)return;if(a("#flotTip").length>0){k=a("#flotTip")}else{k=a("<div />").attr("id","flotTip");k.appendTo("body").hide().css({position:"absolute"});if(i.defaultTheme){k.css({background:"#fff","z-index":"100",padding:"0.4em 0.6em","border-radius":"0.5em","font-size":"0.8em",border:"1px solid #111"})}}a(j).bind("plothover",function(a,b,e){if(e){var f;if(d.xaxis.mode==="time"||d.xaxes[0].mode==="time"){f=h(i.content,e,g)}else{f=h(i.content,e)}k.html(f).css({left:c.x+i.shifts.x,top:c.y+i.shifts.y}).show()}else{k.hide().html("")}});e.mousemove(f)});var h=function(a,b,c){var d=/%p\.{0,1}(\d{0,})/;var e=/%s/;var f=/%x\.{0,1}(\d{0,})/;var g=/%y\.{0,1}(\d{0,})/;if(typeof b.series.percent!=="undefined"){a=i(d,a,b.series.percent)}if(typeof b.series.label!=="undefined"){a=a.replace(e,b.series.label)}if(typeof c==="function"){a=a.replace(f,c(b.series.data[b.dataIndex][0]))}else if(typeof b.series.data[b.dataIndex][0]==="number"){a=i(f,a,b.series.data[b.dataIndex][0])}if(typeof b.series.data[b.dataIndex][1]==="number"){a=i(g,a,b.series.data[b.dataIndex][1])}return a};var i=function(a,b,c){var d;if(b.match(a)!=="null"){if(RegExp.$1!==""){d=RegExp.$1;c=c.toFixed(d)}b=b.replace(a,c)}return b}};a.plot.plugins.push({init:c,options:b,name:"tooltip",version:"0.4.4"})})(jQuery)
},{}],335:[function(require,module,exports){
require('./backbone-validation-0.7.1');
require('./backbone.validation.bootstrap');
require('./jquery-ui-timepicker-addon');
require('./mousewheel');
require('./pnotify');
require('./jquery.mCustomScrollbar');
require('./bootstrap');
require('./flot');
require('./jquery.blockUI');
require('./select2-3.5.1');
require('./pace');






},{"./backbone-validation-0.7.1":326,"./backbone.validation.bootstrap":327,"./bootstrap":329,"./flot":331,"./jquery-ui-timepicker-addon":336,"./jquery.blockUI":337,"./jquery.mCustomScrollbar":338,"./mousewheel":339,"./pace":340,"./pnotify":341,"./select2-3.5.1":343}],336:[function(require,module,exports){
/*! jQuery Timepicker Addon - v1.6.3 - 2016-04-20
* http://trentrichardson.com/examples/timepicker
* Copyright (c) 2016 Trent Richardson; Licensed MIT */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery', 'jquery-ui'], factory);
    } else {
        factory(jQuery);
    }
}(function ($) {

    /*
    * Lets not redefine timepicker, Prevent "Uncaught RangeError: Maximum call stack size exceeded"
    */
    $.ui.timepicker = $.ui.timepicker || {};
    if ($.ui.timepicker.version) {
        return;
    }

    /*
    * Extend jQueryUI, get it started with our version number
    */
    $.extend($.ui, {
        timepicker: {
            version: "1.6.3"
        }
    });

    /*
    * Timepicker manager.
    * Use the singleton instance of this class, $.timepicker, to interact with the time picker.
    * Settings for (groups of) time pickers are maintained in an instance object,
    * allowing multiple different settings on the same page.
    */
    var Timepicker = function () {
        this.regional = []; // Available regional settings, indexed by language code
        this.regional[''] = { // Default regional settings
            currentText: 'Now',
            closeText: 'Done',
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            timeFormat: 'HH:mm',
            timeSuffix: '',
            timeOnlyTitle: 'Choose Time',
            timeText: 'Time',
            hourText: 'Hour',
            minuteText: 'Minute',
            secondText: 'Second',
            millisecText: 'Millisecond',
            microsecText: 'Microsecond',
            timezoneText: 'Time Zone',
            isRTL: false
        };
        this._defaults = { // Global defaults for all the datetime picker instances
            showButtonPanel: true,
            timeOnly: false,
            timeOnlyShowDate: false,
            showHour: null,
            showMinute: null,
            showSecond: null,
            showMillisec: null,
            showMicrosec: null,
            showTimezone: null,
            showTime: true,
            stepHour: 1,
            stepMinute: 1,
            stepSecond: 1,
            stepMillisec: 1,
            stepMicrosec: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisec: 0,
            microsec: 0,
            timezone: null,
            hourMin: 0,
            minuteMin: 0,
            secondMin: 0,
            millisecMin: 0,
            microsecMin: 0,
            hourMax: 23,
            minuteMax: 59,
            secondMax: 59,
            millisecMax: 999,
            microsecMax: 999,
            minDateTime: null,
            maxDateTime: null,
            maxTime: null,
            minTime: null,
            onSelect: null,
            hourGrid: 0,
            minuteGrid: 0,
            secondGrid: 0,
            millisecGrid: 0,
            microsecGrid: 0,
            alwaysSetTime: true,
            separator: ' ',
            altFieldTimeOnly: true,
            altTimeFormat: null,
            altSeparator: null,
            altTimeSuffix: null,
            altRedirectFocus: true,
            pickerTimeFormat: null,
            pickerTimeSuffix: null,
            showTimepicker: true,
            timezoneList: null,
            addSliderAccess: false,
            sliderAccessArgs: null,
            controlType: 'slider',
            oneLine: false,
            defaultValue: null,
            parse: 'strict',
            afterInject: null
        };
        $.extend(this._defaults, this.regional['']);
    };

    $.extend(Timepicker.prototype, {
        $input: null,
        $altInput: null,
        $timeObj: null,
        inst: null,
        hour_slider: null,
        minute_slider: null,
        second_slider: null,
        millisec_slider: null,
        microsec_slider: null,
        timezone_select: null,
        maxTime: null,
        minTime: null,
        hour: 0,
        minute: 0,
        second: 0,
        millisec: 0,
        microsec: 0,
        timezone: null,
        hourMinOriginal: null,
        minuteMinOriginal: null,
        secondMinOriginal: null,
        millisecMinOriginal: null,
        microsecMinOriginal: null,
        hourMaxOriginal: null,
        minuteMaxOriginal: null,
        secondMaxOriginal: null,
        millisecMaxOriginal: null,
        microsecMaxOriginal: null,
        ampm: '',
        formattedDate: '',
        formattedTime: '',
        formattedDateTime: '',
        timezoneList: null,
        units: ['hour', 'minute', 'second', 'millisec', 'microsec'],
        support: {},
        control: null,

        /*
        * Override the default settings for all instances of the time picker.
        * @param  {Object} settings  object - the new settings to use as defaults (anonymous object)
        * @return {Object} the manager object
        */
        setDefaults: function (settings) {
            extendRemove(this._defaults, settings || {});
            return this;
        },

        /*
        * Create a new Timepicker instance
        */
        _newInst: function ($input, opts) {
            var tp_inst = new Timepicker(),
              inlineSettings = {},
              fns = {},
              overrides, i;

            for (var attrName in this._defaults) {
                if (this._defaults.hasOwnProperty(attrName)) {
                    var attrValue = $input.attr('time:' + attrName);
                    if (attrValue) {
                        try {
                            inlineSettings[attrName] = eval(attrValue);
                        } catch (err) {
                            inlineSettings[attrName] = attrValue;
                        }
                    }
                }
            }

            overrides = {
                beforeShow: function (input, dp_inst) {
                    if ($.isFunction(tp_inst._defaults.evnts.beforeShow)) {
                        return tp_inst._defaults.evnts.beforeShow.call($input[0], input, dp_inst, tp_inst);
                    }
                },
                onChangeMonthYear: function (year, month, dp_inst) {
                    // Update the time as well : this prevents the time from disappearing from the $input field.
                    // tp_inst._updateDateTime(dp_inst);
                    if ($.isFunction(tp_inst._defaults.evnts.onChangeMonthYear)) {
                        tp_inst._defaults.evnts.onChangeMonthYear.call($input[0], year, month, dp_inst, tp_inst);
                    }
                },
                onClose: function (dateText, dp_inst) {
                    if (tp_inst.timeDefined === true && $input.val() !== '') {
                        tp_inst._updateDateTime(dp_inst);
                    }
                    if ($.isFunction(tp_inst._defaults.evnts.onClose)) {
                        tp_inst._defaults.evnts.onClose.call($input[0], dateText, dp_inst, tp_inst);
                    }
                }
            };
            for (i in overrides) {
                if (overrides.hasOwnProperty(i)) {
                    fns[i] = opts[i] || this._defaults[i] || null;
                }
            }

            tp_inst._defaults = $.extend({}, this._defaults, inlineSettings, opts, overrides, {
                evnts: fns,
                timepicker: tp_inst // add timepicker as a property of datepicker: $.datepicker._get(dp_inst, 'timepicker');
            });
            tp_inst.amNames = $.map(tp_inst._defaults.amNames, function (val) {
                return val.toUpperCase();
            });
            tp_inst.pmNames = $.map(tp_inst._defaults.pmNames, function (val) {
                return val.toUpperCase();
            });

            // detect which units are supported
            tp_inst.support = detectSupport(
              tp_inst._defaults.timeFormat +
              (tp_inst._defaults.pickerTimeFormat ? tp_inst._defaults.pickerTimeFormat : '') +
              (tp_inst._defaults.altTimeFormat ? tp_inst._defaults.altTimeFormat : ''));

            // controlType is string - key to our this._controls
            if (typeof(tp_inst._defaults.controlType) === 'string') {
                if (tp_inst._defaults.controlType === 'slider' && typeof($.ui.slider) === 'undefined') {
                    tp_inst._defaults.controlType = 'select';
                }
                tp_inst.control = tp_inst._controls[tp_inst._defaults.controlType];
            }
            // controlType is an object and must implement create, options, value methods
            else {
                tp_inst.control = tp_inst._defaults.controlType;
            }

            // prep the timezone options
            var timezoneList = [-720, -660, -600, -570, -540, -480, -420, -360, -300, -270, -240, -210, -180, -120, -60,
                0, 60, 120, 180, 210, 240, 270, 300, 330, 345, 360, 390, 420, 480, 525, 540, 570, 600, 630, 660, 690, 720, 765, 780, 840];
            if (tp_inst._defaults.timezoneList !== null) {
                timezoneList = tp_inst._defaults.timezoneList;
            }
            var tzl = timezoneList.length, tzi = 0, tzv = null;
            if (tzl > 0 && typeof timezoneList[0] !== 'object') {
                for (; tzi < tzl; tzi++) {
                    tzv = timezoneList[tzi];
                    timezoneList[tzi] = { value: tzv, label: $.timepicker.timezoneOffsetString(tzv, tp_inst.support.iso8601) };
                }
            }
            tp_inst._defaults.timezoneList = timezoneList;

            // set the default units
            tp_inst.timezone = tp_inst._defaults.timezone !== null ? $.timepicker.timezoneOffsetNumber(tp_inst._defaults.timezone) :
              ((new Date()).getTimezoneOffset() * -1);
            tp_inst.hour = tp_inst._defaults.hour < tp_inst._defaults.hourMin ? tp_inst._defaults.hourMin :
              tp_inst._defaults.hour > tp_inst._defaults.hourMax ? tp_inst._defaults.hourMax : tp_inst._defaults.hour;
            tp_inst.minute = tp_inst._defaults.minute < tp_inst._defaults.minuteMin ? tp_inst._defaults.minuteMin :
              tp_inst._defaults.minute > tp_inst._defaults.minuteMax ? tp_inst._defaults.minuteMax : tp_inst._defaults.minute;
            tp_inst.second = tp_inst._defaults.second < tp_inst._defaults.secondMin ? tp_inst._defaults.secondMin :
              tp_inst._defaults.second > tp_inst._defaults.secondMax ? tp_inst._defaults.secondMax : tp_inst._defaults.second;
            tp_inst.millisec = tp_inst._defaults.millisec < tp_inst._defaults.millisecMin ? tp_inst._defaults.millisecMin :
              tp_inst._defaults.millisec > tp_inst._defaults.millisecMax ? tp_inst._defaults.millisecMax : tp_inst._defaults.millisec;
            tp_inst.microsec = tp_inst._defaults.microsec < tp_inst._defaults.microsecMin ? tp_inst._defaults.microsecMin :
              tp_inst._defaults.microsec > tp_inst._defaults.microsecMax ? tp_inst._defaults.microsecMax : tp_inst._defaults.microsec;
            tp_inst.ampm = '';
            tp_inst.$input = $input;

            if (tp_inst._defaults.altField) {
                tp_inst.$altInput = $(tp_inst._defaults.altField);
                if (tp_inst._defaults.altRedirectFocus === true) {
                    tp_inst.$altInput.css({
                        cursor: 'pointer'
                    }).focus(function () {
                        $input.trigger("focus");
                    });
                }
            }

            if (tp_inst._defaults.minDate === 0 || tp_inst._defaults.minDateTime === 0) {
                tp_inst._defaults.minDate = new Date();
            }
            if (tp_inst._defaults.maxDate === 0 || tp_inst._defaults.maxDateTime === 0) {
                tp_inst._defaults.maxDate = new Date();
            }

            // datepicker needs minDate/maxDate, timepicker needs minDateTime/maxDateTime..
            if (tp_inst._defaults.minDate !== undefined && tp_inst._defaults.minDate instanceof Date) {
                tp_inst._defaults.minDateTime = new Date(tp_inst._defaults.minDate.getTime());
            }
            if (tp_inst._defaults.minDateTime !== undefined && tp_inst._defaults.minDateTime instanceof Date) {
                tp_inst._defaults.minDate = new Date(tp_inst._defaults.minDateTime.getTime());
            }
            if (tp_inst._defaults.maxDate !== undefined && tp_inst._defaults.maxDate instanceof Date) {
                tp_inst._defaults.maxDateTime = new Date(tp_inst._defaults.maxDate.getTime());
            }
            if (tp_inst._defaults.maxDateTime !== undefined && tp_inst._defaults.maxDateTime instanceof Date) {
                tp_inst._defaults.maxDate = new Date(tp_inst._defaults.maxDateTime.getTime());
            }
            tp_inst.$input.bind('focus', function () {
                tp_inst._onFocus();
            });

            return tp_inst;
        },

        /*
        * add our sliders to the calendar
        */
        _addTimePicker: function (dp_inst) {
            var currDT = $.trim((this.$altInput && this._defaults.altFieldTimeOnly) ? this.$input.val() + ' ' + this.$altInput.val() : this.$input.val());

            this.timeDefined = this._parseTime(currDT);
            this._limitMinMaxDateTime(dp_inst, false);
            this._injectTimePicker();
            this._afterInject();
        },

        /*
        * parse the time string from input value or _setTime
        */
        _parseTime: function (timeString, withDate) {
            if (!this.inst) {
                this.inst = $.datepicker._getInst(this.$input[0]);
            }

            if (withDate || !this._defaults.timeOnly) {
                var dp_dateFormat = $.datepicker._get(this.inst, 'dateFormat');
                try {
                    var parseRes = parseDateTimeInternal(dp_dateFormat, this._defaults.timeFormat, timeString, $.datepicker._getFormatConfig(this.inst), this._defaults);
                    if (!parseRes.timeObj) {
                        return false;
                    }
                    $.extend(this, parseRes.timeObj);
                } catch (err) {
                    $.timepicker.log("Error parsing the date/time string: " + err +
                      "\ndate/time string = " + timeString +
                      "\ntimeFormat = " + this._defaults.timeFormat +
                      "\ndateFormat = " + dp_dateFormat);
                    return false;
                }
                return true;
            } else {
                var timeObj = $.datepicker.parseTime(this._defaults.timeFormat, timeString, this._defaults);
                if (!timeObj) {
                    return false;
                }
                $.extend(this, timeObj);
                return true;
            }
        },

        /*
        * Handle callback option after injecting timepicker
        */
        _afterInject: function() {
            var o = this.inst.settings;
            if ($.isFunction(o.afterInject)) {
                o.afterInject.call(this);
            }
        },

        /*
        * generate and inject html for timepicker into ui datepicker
        */
        _injectTimePicker: function () {
            var $dp = this.inst.dpDiv,
              o = this.inst.settings,
              tp_inst = this,
              litem = '',
              uitem = '',
              show = null,
              max = {},
              gridSize = {},
              size = null,
              i = 0,
              l = 0;

            // Prevent displaying twice
            if ($dp.find("div.ui-timepicker-div").length === 0 && o.showTimepicker) {
                var noDisplay = ' ui_tpicker_unit_hide',
                  html = '<div class="ui-timepicker-div' + (o.isRTL ? ' ui-timepicker-rtl' : '') + (o.oneLine && o.controlType === 'select' ? ' ui-timepicker-oneLine' : '') + '"><dl>' + '<dt class="ui_tpicker_time_label' + ((o.showTime) ? '' : noDisplay) + '">' + o.timeText + '</dt>' +
                    '<dd class="ui_tpicker_time '+ ((o.showTime) ? '' : noDisplay) + '"><input class="ui_tpicker_time_input" ' + (o.timeInput ? '' : 'disabled') + '/></dd>';

                // Create the markup
                for (i = 0, l = this.units.length; i < l; i++) {
                    litem = this.units[i];
                    uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
                    show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

                    // Added by Peter Medeiros:
                    // - Figure out what the hour/minute/second max should be based on the step values.
                    // - Example: if stepMinute is 15, then minMax is 45.
                    max[litem] = parseInt((o[litem + 'Max'] - ((o[litem + 'Max'] - o[litem + 'Min']) % o['step' + uitem])), 10);
                    gridSize[litem] = 0;

                    html += '<dt class="ui_tpicker_' + litem + '_label' + (show ? '' : noDisplay) + '">' + o[litem + 'Text'] + '</dt>' +
                      '<dd class="ui_tpicker_' + litem + (show ? '' : noDisplay) + '"><div class="ui_tpicker_' + litem + '_slider' + (show ? '' : noDisplay) + '"></div>';

                    if (show && o[litem + 'Grid'] > 0) {
                        html += '<div style="padding-left: 1px"><table class="ui-tpicker-grid-label"><tr>';

                        if (litem === 'hour') {
                            for (var h = o[litem + 'Min']; h <= max[litem]; h += parseInt(o[litem + 'Grid'], 10)) {
                                gridSize[litem]++;
                                var tmph = $.datepicker.formatTime(this.support.ampm ? 'hht' : 'HH', {hour: h}, o);
                                html += '<td data-for="' + litem + '">' + tmph + '</td>';
                            }
                        }
                        else {
                            for (var m = o[litem + 'Min']; m <= max[litem]; m += parseInt(o[litem + 'Grid'], 10)) {
                                gridSize[litem]++;
                                html += '<td data-for="' + litem + '">' + ((m < 10) ? '0' : '') + m + '</td>';
                            }
                        }

                        html += '</tr></table></div>';
                    }
                    html += '</dd>';
                }

                // Timezone
                var showTz = o.showTimezone !== null ? o.showTimezone : this.support.timezone;
                html += '<dt class="ui_tpicker_timezone_label' + (showTz ? '' : noDisplay) + '">' + o.timezoneText + '</dt>';
                html += '<dd class="ui_tpicker_timezone' + (showTz ? '' : noDisplay) + '"></dd>';

                // Create the elements from string
                html += '</dl></div>';
                var $tp = $(html);

                // if we only want time picker...
                if (o.timeOnly === true) {
                    $tp.prepend('<div class="ui-widget-header ui-helper-clearfix ui-corner-all">' + '<div class="ui-datepicker-title">' + o.timeOnlyTitle + '</div>' + '</div>');
                    $dp.find('.ui-datepicker-header, .ui-datepicker-calendar').hide();
                }

                // add sliders, adjust grids, add events
                for (i = 0, l = tp_inst.units.length; i < l; i++) {
                    litem = tp_inst.units[i];
                    uitem = litem.substr(0, 1).toUpperCase() + litem.substr(1);
                    show = o['show' + uitem] !== null ? o['show' + uitem] : this.support[litem];

                    // add the slider
                    tp_inst[litem + '_slider'] = tp_inst.control.create(tp_inst, $tp.find('.ui_tpicker_' + litem + '_slider'), litem, tp_inst[litem], o[litem + 'Min'], max[litem], o['step' + uitem]);

                    // adjust the grid and add click event
                    if (show && o[litem + 'Grid'] > 0) {
                        size = 100 * gridSize[litem] * o[litem + 'Grid'] / (max[litem] - o[litem + 'Min']);
                        $tp.find('.ui_tpicker_' + litem + ' table').css({
                            width: size + "%",
                            marginLeft: o.isRTL ? '0' : ((size / (-2 * gridSize[litem])) + "%"),
                            marginRight: o.isRTL ? ((size / (-2 * gridSize[litem])) + "%") : '0',
                            borderCollapse: 'collapse'
                        }).find("td").click(function (e) {
                            var $t = $(this),
                              h = $t.html(),
                              n = parseInt(h.replace(/[^0-9]/g), 10),
                              ap = h.replace(/[^apm]/ig),
                              f = $t.data('for'); // loses scope, so we use data-for

                            if (f === 'hour') {
                                if (ap.indexOf('p') !== -1 && n < 12) {
                                    n += 12;
                                }
                                else {
                                    if (ap.indexOf('a') !== -1 && n === 12) {
                                        n = 0;
                                    }
                                }
                            }

                            tp_inst.control.value(tp_inst, tp_inst[f + '_slider'], litem, n);

                            tp_inst._onTimeChange();
                            tp_inst._onSelectHandler();
                        }).css({
                            cursor: 'pointer',
                            width: (100 / gridSize[litem]) + '%',
                            textAlign: 'center',
                            overflow: 'hidden'
                        });
                    } // end if grid > 0
                } // end for loop

                // Add timezone options
                this.timezone_select = $tp.find('.ui_tpicker_timezone').append('<select></select>').find("select");
                $.fn.append.apply(this.timezone_select,
                  $.map(o.timezoneList, function (val, idx) {
                      return $("<option />").val(typeof val === "object" ? val.value : val).text(typeof val === "object" ? val.label : val);
                  }));
                if (typeof(this.timezone) !== "undefined" && this.timezone !== null && this.timezone !== "") {
                    var local_timezone = (new Date(this.inst.selectedYear, this.inst.selectedMonth, this.inst.selectedDay, 12)).getTimezoneOffset() * -1;
                    if (local_timezone === this.timezone) {
                        selectLocalTimezone(tp_inst);
                    } else {
                        this.timezone_select.val(this.timezone);
                    }
                } else {
                    if (typeof(this.hour) !== "undefined" && this.hour !== null && this.hour !== "") {
                        this.timezone_select.val(o.timezone);
                    } else {
                        selectLocalTimezone(tp_inst);
                    }
                }
                this.timezone_select.change(function () {
                    tp_inst._onTimeChange();
                    tp_inst._onSelectHandler();
                    tp_inst._afterInject();
                });
                // End timezone options

                // inject timepicker into datepicker
                var $buttonPanel = $dp.find('.ui-datepicker-buttonpane');
                if ($buttonPanel.length) {
                    $buttonPanel.before($tp);
                } else {
                    $dp.append($tp);
                }

                this.$timeObj = $tp.find('.ui_tpicker_time_input');
                this.$timeObj.change(function () {
                    var timeFormat = tp_inst.inst.settings.timeFormat;
                    var parsedTime = $.datepicker.parseTime(timeFormat, this.value);
                    var update = new Date();
                    if (parsedTime) {
                        update.setHours(parsedTime.hour);
                        update.setMinutes(parsedTime.minute);
                        update.setSeconds(parsedTime.second);
                        $.datepicker._setTime(tp_inst.inst, update);
                    } else {
                        this.value = tp_inst.formattedTime;
                        this.blur();
                    }
                });

                if (this.inst !== null) {
                    var timeDefined = this.timeDefined;
                    this._onTimeChange();
                    this.timeDefined = timeDefined;
                }

                // slideAccess integration: http://trentrichardson.com/2011/11/11/jquery-ui-sliders-and-touch-accessibility/
                if (this._defaults.addSliderAccess) {
                    var sliderAccessArgs = this._defaults.sliderAccessArgs,
                      rtl = this._defaults.isRTL;
                    sliderAccessArgs.isRTL = rtl;

                    setTimeout(function () { // fix for inline mode
                        if ($tp.find('.ui-slider-access').length === 0) {
                            $tp.find('.ui-slider:visible').sliderAccess(sliderAccessArgs);

                            // fix any grids since sliders are shorter
                            var sliderAccessWidth = $tp.find('.ui-slider-access:eq(0)').outerWidth(true);
                            if (sliderAccessWidth) {
                                $tp.find('table:visible').each(function () {
                                    var $g = $(this),
                                      oldWidth = $g.outerWidth(),
                                      oldMarginLeft = $g.css(rtl ? 'marginRight' : 'marginLeft').toString().replace('%', ''),
                                      newWidth = oldWidth - sliderAccessWidth,
                                      newMarginLeft = ((oldMarginLeft * newWidth) / oldWidth) + '%',
                                      css = { width: newWidth, marginRight: 0, marginLeft: 0 };
                                    css[rtl ? 'marginRight' : 'marginLeft'] = newMarginLeft;
                                    $g.css(css);
                                });
                            }
                        }
                    }, 10);
                }
                // end slideAccess integration

                tp_inst._limitMinMaxDateTime(this.inst, true);
            }
        },

        /*
        * This function tries to limit the ability to go outside the
        * min/max date range
        */
        _limitMinMaxDateTime: function (dp_inst, adjustSliders) {
            var o = this._defaults,
              dp_date = new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay);

            if (!this._defaults.showTimepicker) {
                return;
            } // No time so nothing to check here

            if ($.datepicker._get(dp_inst, 'minDateTime') !== null && $.datepicker._get(dp_inst, 'minDateTime') !== undefined && dp_date) {
                var minDateTime = $.datepicker._get(dp_inst, 'minDateTime'),
                  minDateTimeDate = new Date(minDateTime.getFullYear(), minDateTime.getMonth(), minDateTime.getDate(), 0, 0, 0, 0);

                if (this.hourMinOriginal === null || this.minuteMinOriginal === null || this.secondMinOriginal === null || this.millisecMinOriginal === null || this.microsecMinOriginal === null) {
                    this.hourMinOriginal = o.hourMin;
                    this.minuteMinOriginal = o.minuteMin;
                    this.secondMinOriginal = o.secondMin;
                    this.millisecMinOriginal = o.millisecMin;
                    this.microsecMinOriginal = o.microsecMin;
                }

                if (dp_inst.settings.timeOnly || minDateTimeDate.getTime() === dp_date.getTime()) {
                    this._defaults.hourMin = minDateTime.getHours();
                    if (this.hour <= this._defaults.hourMin) {
                        this.hour = this._defaults.hourMin;
                        this._defaults.minuteMin = minDateTime.getMinutes();
                        if (this.minute <= this._defaults.minuteMin) {
                            this.minute = this._defaults.minuteMin;
                            this._defaults.secondMin = minDateTime.getSeconds();
                            if (this.second <= this._defaults.secondMin) {
                                this.second = this._defaults.secondMin;
                                this._defaults.millisecMin = minDateTime.getMilliseconds();
                                if (this.millisec <= this._defaults.millisecMin) {
                                    this.millisec = this._defaults.millisecMin;
                                    this._defaults.microsecMin = minDateTime.getMicroseconds();
                                } else {
                                    if (this.microsec < this._defaults.microsecMin) {
                                        this.microsec = this._defaults.microsecMin;
                                    }
                                    this._defaults.microsecMin = this.microsecMinOriginal;
                                }
                            } else {
                                this._defaults.millisecMin = this.millisecMinOriginal;
                                this._defaults.microsecMin = this.microsecMinOriginal;
                            }
                        } else {
                            this._defaults.secondMin = this.secondMinOriginal;
                            this._defaults.millisecMin = this.millisecMinOriginal;
                            this._defaults.microsecMin = this.microsecMinOriginal;
                        }
                    } else {
                        this._defaults.minuteMin = this.minuteMinOriginal;
                        this._defaults.secondMin = this.secondMinOriginal;
                        this._defaults.millisecMin = this.millisecMinOriginal;
                        this._defaults.microsecMin = this.microsecMinOriginal;
                    }
                } else {
                    this._defaults.hourMin = this.hourMinOriginal;
                    this._defaults.minuteMin = this.minuteMinOriginal;
                    this._defaults.secondMin = this.secondMinOriginal;
                    this._defaults.millisecMin = this.millisecMinOriginal;
                    this._defaults.microsecMin = this.microsecMinOriginal;
                }
            }

            if ($.datepicker._get(dp_inst, 'maxDateTime') !== null && $.datepicker._get(dp_inst, 'maxDateTime') !== undefined && dp_date) {
                var maxDateTime = $.datepicker._get(dp_inst, 'maxDateTime'),
                  maxDateTimeDate = new Date(maxDateTime.getFullYear(), maxDateTime.getMonth(), maxDateTime.getDate(), 0, 0, 0, 0);

                if (this.hourMaxOriginal === null || this.minuteMaxOriginal === null || this.secondMaxOriginal === null || this.millisecMaxOriginal === null) {
                    this.hourMaxOriginal = o.hourMax;
                    this.minuteMaxOriginal = o.minuteMax;
                    this.secondMaxOriginal = o.secondMax;
                    this.millisecMaxOriginal = o.millisecMax;
                    this.microsecMaxOriginal = o.microsecMax;
                }

                if (dp_inst.settings.timeOnly || maxDateTimeDate.getTime() === dp_date.getTime()) {
                    this._defaults.hourMax = maxDateTime.getHours();
                    if (this.hour >= this._defaults.hourMax) {
                        this.hour = this._defaults.hourMax;
                        this._defaults.minuteMax = maxDateTime.getMinutes();
                        if (this.minute >= this._defaults.minuteMax) {
                            this.minute = this._defaults.minuteMax;
                            this._defaults.secondMax = maxDateTime.getSeconds();
                            if (this.second >= this._defaults.secondMax) {
                                this.second = this._defaults.secondMax;
                                this._defaults.millisecMax = maxDateTime.getMilliseconds();
                                if (this.millisec >= this._defaults.millisecMax) {
                                    this.millisec = this._defaults.millisecMax;
                                    this._defaults.microsecMax = maxDateTime.getMicroseconds();
                                } else {
                                    if (this.microsec > this._defaults.microsecMax) {
                                        this.microsec = this._defaults.microsecMax;
                                    }
                                    this._defaults.microsecMax = this.microsecMaxOriginal;
                                }
                            } else {
                                this._defaults.millisecMax = this.millisecMaxOriginal;
                                this._defaults.microsecMax = this.microsecMaxOriginal;
                            }
                        } else {
                            this._defaults.secondMax = this.secondMaxOriginal;
                            this._defaults.millisecMax = this.millisecMaxOriginal;
                            this._defaults.microsecMax = this.microsecMaxOriginal;
                        }
                    } else {
                        this._defaults.minuteMax = this.minuteMaxOriginal;
                        this._defaults.secondMax = this.secondMaxOriginal;
                        this._defaults.millisecMax = this.millisecMaxOriginal;
                        this._defaults.microsecMax = this.microsecMaxOriginal;
                    }
                } else {
                    this._defaults.hourMax = this.hourMaxOriginal;
                    this._defaults.minuteMax = this.minuteMaxOriginal;
                    this._defaults.secondMax = this.secondMaxOriginal;
                    this._defaults.millisecMax = this.millisecMaxOriginal;
                    this._defaults.microsecMax = this.microsecMaxOriginal;
                }
            }

            if (dp_inst.settings.minTime!==null) {
                var tempMinTime=new Date("01/01/1970 " + dp_inst.settings.minTime);
                if (this.hour<tempMinTime.getHours()) {
                    this.hour=this._defaults.hourMin=tempMinTime.getHours();
                    this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
                } else if (this.hour===tempMinTime.getHours() && this.minute<tempMinTime.getMinutes()) {
                    this.minute=this._defaults.minuteMin=tempMinTime.getMinutes();
                } else {
                    if (this._defaults.hourMin<tempMinTime.getHours()) {
                        this._defaults.hourMin=tempMinTime.getHours();
                        this._defaults.minuteMin=tempMinTime.getMinutes();
                    } else if (this._defaults.hourMin===tempMinTime.getHours()===this.hour && this._defaults.minuteMin<tempMinTime.getMinutes()) {
                        this._defaults.minuteMin=tempMinTime.getMinutes();
                    } else {
                        this._defaults.minuteMin=0;
                    }
                }
            }

            if (dp_inst.settings.maxTime!==null) {
                var tempMaxTime=new Date("01/01/1970 " + dp_inst.settings.maxTime);
                if (this.hour>tempMaxTime.getHours()) {
                    this.hour=this._defaults.hourMax=tempMaxTime.getHours();
                    this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
                } else if (this.hour===tempMaxTime.getHours() && this.minute>tempMaxTime.getMinutes()) {
                    this.minute=this._defaults.minuteMax=tempMaxTime.getMinutes();
                } else {
                    if (this._defaults.hourMax>tempMaxTime.getHours()) {
                        this._defaults.hourMax=tempMaxTime.getHours();
                        this._defaults.minuteMax=tempMaxTime.getMinutes();
                    } else if (this._defaults.hourMax===tempMaxTime.getHours()===this.hour && this._defaults.minuteMax>tempMaxTime.getMinutes()) {
                        this._defaults.minuteMax=tempMaxTime.getMinutes();
                    } else {
                        this._defaults.minuteMax=59;
                    }
                }
            }

            if (adjustSliders !== undefined && adjustSliders === true) {
                var hourMax = parseInt((this._defaults.hourMax - ((this._defaults.hourMax - this._defaults.hourMin) % this._defaults.stepHour)), 10),
                  minMax = parseInt((this._defaults.minuteMax - ((this._defaults.minuteMax - this._defaults.minuteMin) % this._defaults.stepMinute)), 10),
                  secMax = parseInt((this._defaults.secondMax - ((this._defaults.secondMax - this._defaults.secondMin) % this._defaults.stepSecond)), 10),
                  millisecMax = parseInt((this._defaults.millisecMax - ((this._defaults.millisecMax - this._defaults.millisecMin) % this._defaults.stepMillisec)), 10),
                  microsecMax = parseInt((this._defaults.microsecMax - ((this._defaults.microsecMax - this._defaults.microsecMin) % this._defaults.stepMicrosec)), 10);

                if (this.hour_slider) {
                    this.control.options(this, this.hour_slider, 'hour', { min: this._defaults.hourMin, max: hourMax, step: this._defaults.stepHour });
                    this.control.value(this, this.hour_slider, 'hour', this.hour - (this.hour % this._defaults.stepHour));
                }
                if (this.minute_slider) {
                    this.control.options(this, this.minute_slider, 'minute', { min: this._defaults.minuteMin, max: minMax, step: this._defaults.stepMinute });
                    this.control.value(this, this.minute_slider, 'minute', this.minute - (this.minute % this._defaults.stepMinute));
                }
                if (this.second_slider) {
                    this.control.options(this, this.second_slider, 'second', { min: this._defaults.secondMin, max: secMax, step: this._defaults.stepSecond });
                    this.control.value(this, this.second_slider, 'second', this.second - (this.second % this._defaults.stepSecond));
                }
                if (this.millisec_slider) {
                    this.control.options(this, this.millisec_slider, 'millisec', { min: this._defaults.millisecMin, max: millisecMax, step: this._defaults.stepMillisec });
                    this.control.value(this, this.millisec_slider, 'millisec', this.millisec - (this.millisec % this._defaults.stepMillisec));
                }
                if (this.microsec_slider) {
                    this.control.options(this, this.microsec_slider, 'microsec', { min: this._defaults.microsecMin, max: microsecMax, step: this._defaults.stepMicrosec });
                    this.control.value(this, this.microsec_slider, 'microsec', this.microsec - (this.microsec % this._defaults.stepMicrosec));
                }
            }

        },

        /*
        * when a slider moves, set the internal time...
        * on time change is also called when the time is updated in the text field
        */
        _onTimeChange: function () {
            if (!this._defaults.showTimepicker) {
                return;
            }
            var hour = (this.hour_slider) ? this.control.value(this, this.hour_slider, 'hour') : false,
              minute = (this.minute_slider) ? this.control.value(this, this.minute_slider, 'minute') : false,
              second = (this.second_slider) ? this.control.value(this, this.second_slider, 'second') : false,
              millisec = (this.millisec_slider) ? this.control.value(this, this.millisec_slider, 'millisec') : false,
              microsec = (this.microsec_slider) ? this.control.value(this, this.microsec_slider, 'microsec') : false,
              timezone = (this.timezone_select) ? this.timezone_select.val() : false,
              o = this._defaults,
              pickerTimeFormat = o.pickerTimeFormat || o.timeFormat,
              pickerTimeSuffix = o.pickerTimeSuffix || o.timeSuffix;

            if (typeof(hour) === 'object') {
                hour = false;
            }
            if (typeof(minute) === 'object') {
                minute = false;
            }
            if (typeof(second) === 'object') {
                second = false;
            }
            if (typeof(millisec) === 'object') {
                millisec = false;
            }
            if (typeof(microsec) === 'object') {
                microsec = false;
            }
            if (typeof(timezone) === 'object') {
                timezone = false;
            }

            if (hour !== false) {
                hour = parseInt(hour, 10);
            }
            if (minute !== false) {
                minute = parseInt(minute, 10);
            }
            if (second !== false) {
                second = parseInt(second, 10);
            }
            if (millisec !== false) {
                millisec = parseInt(millisec, 10);
            }
            if (microsec !== false) {
                microsec = parseInt(microsec, 10);
            }
            if (timezone !== false) {
                timezone = timezone.toString();
            }

            var ampm = o[hour < 12 ? 'amNames' : 'pmNames'][0];

            // If the update was done in the input field, the input field should not be updated.
            // If the update was done using the sliders, update the input field.
            var hasChanged = (
              hour !== parseInt(this.hour,10) || // sliders should all be numeric
              minute !== parseInt(this.minute,10) ||
              second !== parseInt(this.second,10) ||
              millisec !== parseInt(this.millisec,10) ||
              microsec !== parseInt(this.microsec,10) ||
              (this.ampm.length > 0 && (hour < 12) !== ($.inArray(this.ampm.toUpperCase(), this.amNames) !== -1)) ||
              (this.timezone !== null && timezone !== this.timezone.toString()) // could be numeric or "EST" format, so use toString()
            );

            if (hasChanged) {

                if (hour !== false) {
                    this.hour = hour;
                }
                if (minute !== false) {
                    this.minute = minute;
                }
                if (second !== false) {
                    this.second = second;
                }
                if (millisec !== false) {
                    this.millisec = millisec;
                }
                if (microsec !== false) {
                    this.microsec = microsec;
                }
                if (timezone !== false) {
                    this.timezone = timezone;
                }

                if (!this.inst) {
                    this.inst = $.datepicker._getInst(this.$input[0]);
                }

                this._limitMinMaxDateTime(this.inst, true);
            }
            if (this.support.ampm) {
                this.ampm = ampm;
            }

            // Updates the time within the timepicker
            this.formattedTime = $.datepicker.formatTime(o.timeFormat, this, o);
            if (this.$timeObj) {
                if (pickerTimeFormat === o.timeFormat) {
                    this.$timeObj.val(this.formattedTime + pickerTimeSuffix);
                }
                else {
                    this.$timeObj.val($.datepicker.formatTime(pickerTimeFormat, this, o) + pickerTimeSuffix);
                }
                if (this.$timeObj[0].setSelectionRange) {
                    var sPos = this.$timeObj[0].selectionStart;
                    var ePos = this.$timeObj[0].selectionEnd;
                    this.$timeObj[0].setSelectionRange(sPos, ePos);
                }
            }

            this.timeDefined = true;
            if (hasChanged) {
                this._updateDateTime();
                //this.$input.focus(); // may automatically open the picker on setDate
            }
        },

        /*
        * call custom onSelect.
        * bind to sliders slidestop, and grid click.
        */
        _onSelectHandler: function () {
            var onSelect = this._defaults.onSelect || this.inst.settings.onSelect;
            var inputEl = this.$input ? this.$input[0] : null;
            if (onSelect && inputEl) {
                onSelect.apply(inputEl, [this.formattedDateTime, this]);
            }
        },

        /*
        * update our input with the new date time..
        */
        _updateDateTime: function (dp_inst) {
            dp_inst = this.inst || dp_inst;
            var dtTmp = (dp_inst.currentYear > 0?
                new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay) :
                new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
              dt = $.datepicker._daylightSavingAdjust(dtTmp),
              //dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.selectedYear, dp_inst.selectedMonth, dp_inst.selectedDay)),
              //dt = $.datepicker._daylightSavingAdjust(new Date(dp_inst.currentYear, dp_inst.currentMonth, dp_inst.currentDay)),
              dateFmt = $.datepicker._get(dp_inst, 'dateFormat'),
              formatCfg = $.datepicker._getFormatConfig(dp_inst),
              timeAvailable = dt !== null && this.timeDefined;
            this.formattedDate = $.datepicker.formatDate(dateFmt, (dt === null ? new Date() : dt), formatCfg);
            var formattedDateTime = this.formattedDate;

            // if a slider was changed but datepicker doesn't have a value yet, set it
            if (dp_inst.lastVal === "") {
                dp_inst.currentYear = dp_inst.selectedYear;
                dp_inst.currentMonth = dp_inst.selectedMonth;
                dp_inst.currentDay = dp_inst.selectedDay;
            }

            /*
            * remove following lines to force every changes in date picker to change the input value
            * Bug descriptions: when an input field has a default value, and click on the field to pop up the date picker.
            * If the user manually empty the value in the input field, the date picker will never change selected value.
            */
            //if (dp_inst.lastVal !== undefined && (dp_inst.lastVal.length > 0 && this.$input.val().length === 0)) {
            //	return;
            //}

            if (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === false) {
                formattedDateTime = this.formattedTime;
            } else if ((this._defaults.timeOnly !== true && (this._defaults.alwaysSetTime || timeAvailable)) || (this._defaults.timeOnly === true && this._defaults.timeOnlyShowDate === true)) {
                formattedDateTime += this._defaults.separator + this.formattedTime + this._defaults.timeSuffix;
            }

            this.formattedDateTime = formattedDateTime;

            if (!this._defaults.showTimepicker) {
                this.$input.val(this.formattedDate);
            } else if (this.$altInput && this._defaults.timeOnly === false && this._defaults.altFieldTimeOnly === true) {
                this.$altInput.val(this.formattedTime);
                this.$input.val(this.formattedDate);
            } else if (this.$altInput) {
                this.$input.val(formattedDateTime);
                var altFormattedDateTime = '',
                  altSeparator = this._defaults.altSeparator !== null ? this._defaults.altSeparator : this._defaults.separator,
                  altTimeSuffix = this._defaults.altTimeSuffix !== null ? this._defaults.altTimeSuffix : this._defaults.timeSuffix;

                if (!this._defaults.timeOnly) {
                    if (this._defaults.altFormat) {
                        altFormattedDateTime = $.datepicker.formatDate(this._defaults.altFormat, (dt === null ? new Date() : dt), formatCfg);
                    }
                    else {
                        altFormattedDateTime = this.formattedDate;
                    }

                    if (altFormattedDateTime) {
                        altFormattedDateTime += altSeparator;
                    }
                }

                if (this._defaults.altTimeFormat !== null) {
                    altFormattedDateTime += $.datepicker.formatTime(this._defaults.altTimeFormat, this, this._defaults) + altTimeSuffix;
                }
                else {
                    altFormattedDateTime += this.formattedTime + altTimeSuffix;
                }
                this.$altInput.val(altFormattedDateTime);
            } else {
                this.$input.val(formattedDateTime);
            }

            this.$input.trigger("change");
        },

        _onFocus: function () {
            if (!this.$input.val() && this._defaults.defaultValue) {
                this.$input.val(this._defaults.defaultValue);
                var inst = $.datepicker._getInst(this.$input.get(0)),
                  tp_inst = $.datepicker._get(inst, 'timepicker');
                if (tp_inst) {
                    if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
                        try {
                            $.datepicker._updateDatepicker(inst);
                        } catch (err) {
                            $.timepicker.log(err);
                        }
                    }
                }
            }
        },

        /*
        * Small abstraction to control types
        * We can add more, just be sure to follow the pattern: create, options, value
        */
        _controls: {
            // slider methods
            slider: {
                create: function (tp_inst, obj, unit, val, min, max, step) {
                    var rtl = tp_inst._defaults.isRTL; // if rtl go -60->0 instead of 0->60
                    return obj.prop('slide', null).slider({
                        orientation: "horizontal",
                        value: rtl ? val * -1 : val,
                        min: rtl ? max * -1 : min,
                        max: rtl ? min * -1 : max,
                        step: step,
                        slide: function (event, ui) {
                            tp_inst.control.value(tp_inst, $(this), unit, rtl ? ui.value * -1 : ui.value);
                            tp_inst._onTimeChange();
                        },
                        stop: function (event, ui) {
                            tp_inst._onSelectHandler();
                        }
                    });
                },
                options: function (tp_inst, obj, unit, opts, val) {
                    if (tp_inst._defaults.isRTL) {
                        if (typeof(opts) === 'string') {
                            if (opts === 'min' || opts === 'max') {
                                if (val !== undefined) {
                                    return obj.slider(opts, val * -1);
                                }
                                return Math.abs(obj.slider(opts));
                            }
                            return obj.slider(opts);
                        }
                        var min = opts.min,
                          max = opts.max;
                        opts.min = opts.max = null;
                        if (min !== undefined) {
                            opts.max = min * -1;
                        }
                        if (max !== undefined) {
                            opts.min = max * -1;
                        }
                        return obj.slider(opts);
                    }
                    if (typeof(opts) === 'string' && val !== undefined) {
                        return obj.slider(opts, val);
                    }
                    return obj.slider(opts);
                },
                value: function (tp_inst, obj, unit, val) {
                    if (tp_inst._defaults.isRTL) {
                        if (val !== undefined) {
                            return obj.slider('value', val * -1);
                        }
                        return Math.abs(obj.slider('value'));
                    }
                    if (val !== undefined) {
                        return obj.slider('value', val);
                    }
                    return obj.slider('value');
                }
            },
            // select methods
            select: {
                create: function (tp_inst, obj, unit, val, min, max, step) {
                    var sel = '<select class="ui-timepicker-select ui-state-default ui-corner-all" data-unit="' + unit + '" data-min="' + min + '" data-max="' + max + '" data-step="' + step + '">',
                      format = tp_inst._defaults.pickerTimeFormat || tp_inst._defaults.timeFormat;

                    for (var i = min; i <= max; i += step) {
                        sel += '<option value="' + i + '"' + (i === val ? ' selected' : '') + '>';
                        if (unit === 'hour') {
                            sel += $.datepicker.formatTime($.trim(format.replace(/[^ht ]/ig, '')), {hour: i}, tp_inst._defaults);
                        }
                        else if (unit === 'millisec' || unit === 'microsec' || i >= 10) { sel += i; }
                        else {sel += '0' + i.toString(); }
                        sel += '</option>';
                    }
                    sel += '</select>';

                    obj.children('select').remove();

                    $(sel).appendTo(obj).change(function (e) {
                        tp_inst._onTimeChange();
                        tp_inst._onSelectHandler();
                        tp_inst._afterInject();
                    });

                    return obj;
                },
                options: function (tp_inst, obj, unit, opts, val) {
                    var o = {},
                      $t = obj.children('select');
                    if (typeof(opts) === 'string') {
                        if (val === undefined) {
                            return $t.data(opts);
                        }
                        o[opts] = val;
                    }
                    else { o = opts; }
                    return tp_inst.control.create(tp_inst, obj, $t.data('unit'), $t.val(), o.min>=0 ? o.min : $t.data('min'), o.max || $t.data('max'), o.step || $t.data('step'));
                },
                value: function (tp_inst, obj, unit, val) {
                    var $t = obj.children('select');
                    if (val !== undefined) {
                        return $t.val(val);
                    }
                    return $t.val();
                }
            }
        } // end _controls

    });

    $.fn.extend({
        /*
        * shorthand just to use timepicker.
        */
        timepicker: function (o) {
            o = o || {};
            var tmp_args = Array.prototype.slice.call(arguments);

            if (typeof o === 'object') {
                tmp_args[0] = $.extend(o, {
                    timeOnly: true
                });
            }

            return $(this).each(function () {
                $.fn.datetimepicker.apply($(this), tmp_args);
            });
        },

        /*
        * extend timepicker to datepicker
        */
        datetimepicker: function (o) {
            o = o || {};
            var tmp_args = arguments;

            if (typeof(o) === 'string') {
                if (o === 'getDate'  || (o === 'option' && tmp_args.length === 2 && typeof (tmp_args[1]) === 'string')) {
                    return $.fn.datepicker.apply($(this[0]), tmp_args);
                } else {
                    return this.each(function () {
                        var $t = $(this);
                        $t.datepicker.apply($t, tmp_args);
                    });
                }
            } else {
                return this.each(function () {
                    var $t = $(this);
                    $t.datepicker($.timepicker._newInst($t, o)._defaults);
                });
            }
        }
    });

    /*
    * Public Utility to parse date and time
    */
    $.datepicker.parseDateTime = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
        var parseRes = parseDateTimeInternal(dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings);
        if (parseRes.timeObj) {
            var t = parseRes.timeObj;
            parseRes.date.setHours(t.hour, t.minute, t.second, t.millisec);
            parseRes.date.setMicroseconds(t.microsec);
        }

        return parseRes.date;
    };

    /*
    * Public utility to parse time
    */
    $.datepicker.parseTime = function (timeFormat, timeString, options) {
        var o = extendRemove(extendRemove({}, $.timepicker._defaults), options || {}),
          iso8601 = (timeFormat.replace(/\'.*?\'/g, '').indexOf('Z') !== -1);

        // Strict parse requires the timeString to match the timeFormat exactly
        var strictParse = function (f, s, o) {

            // pattern for standard and localized AM/PM markers
            var getPatternAmpm = function (amNames, pmNames) {
                var markers = [];
                if (amNames) {
                    $.merge(markers, amNames);
                }
                if (pmNames) {
                    $.merge(markers, pmNames);
                }
                markers = $.map(markers, function (val) {
                    return val.replace(/[.*+?|()\[\]{}\\]/g, '\\$&');
                });
                return '(' + markers.join('|') + ')?';
            };

            // figure out position of time elements.. cause js cant do named captures
            var getFormatPositions = function (timeFormat) {
                var finds = timeFormat.toLowerCase().match(/(h{1,2}|m{1,2}|s{1,2}|l{1}|c{1}|t{1,2}|z|'.*?')/g),
                  orders = {
                      h: -1,
                      m: -1,
                      s: -1,
                      l: -1,
                      c: -1,
                      t: -1,
                      z: -1
                  };

                if (finds) {
                    for (var i = 0; i < finds.length; i++) {
                        if (orders[finds[i].toString().charAt(0)] === -1) {
                            orders[finds[i].toString().charAt(0)] = i + 1;
                        }
                    }
                }
                return orders;
            };

            var regstr = '^' + f.toString()
                  .replace(/([hH]{1,2}|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
                      var ml = match.length;
                      switch (match.charAt(0).toLowerCase()) {
                          case 'h':
                              return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
                          case 'm':
                              return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
                          case 's':
                              return ml === 1 ? '(\\d?\\d)' : '(\\d{' + ml + '})';
                          case 'l':
                              return '(\\d?\\d?\\d)';
                          case 'c':
                              return '(\\d?\\d?\\d)';
                          case 'z':
                              return '(z|[-+]\\d\\d:?\\d\\d|\\S+)?';
                          case 't':
                              return getPatternAmpm(o.amNames, o.pmNames);
                          default:    // literal escaped in quotes
                              return '(' + match.replace(/\'/g, "").replace(/(\.|\$|\^|\\|\/|\(|\)|\[|\]|\?|\+|\*)/g, function (m) { return "\\" + m; }) + ')?';
                      }
                  })
                  .replace(/\s/g, '\\s?') +
                o.timeSuffix + '$',
              order = getFormatPositions(f),
              ampm = '',
              treg;

            treg = s.match(new RegExp(regstr, 'i'));

            var resTime = {
                hour: 0,
                minute: 0,
                second: 0,
                millisec: 0,
                microsec: 0
            };

            if (treg) {
                if (order.t !== -1) {
                    if (treg[order.t] === undefined || treg[order.t].length === 0) {
                        ampm = '';
                        resTime.ampm = '';
                    } else {
                        ampm = $.inArray(treg[order.t].toUpperCase(), $.map(o.amNames, function (x,i) { return x.toUpperCase(); })) !== -1 ? 'AM' : 'PM';
                        resTime.ampm = o[ampm === 'AM' ? 'amNames' : 'pmNames'][0];
                    }
                }

                if (order.h !== -1) {
                    if (ampm === 'AM' && treg[order.h] === '12') {
                        resTime.hour = 0; // 12am = 0 hour
                    } else {
                        if (ampm === 'PM' && treg[order.h] !== '12') {
                            resTime.hour = parseInt(treg[order.h], 10) + 12; // 12pm = 12 hour, any other pm = hour + 12
                        } else {
                            resTime.hour = Number(treg[order.h]);
                        }
                    }
                }

                if (order.m !== -1) {
                    resTime.minute = Number(treg[order.m]);
                }
                if (order.s !== -1) {
                    resTime.second = Number(treg[order.s]);
                }
                if (order.l !== -1) {
                    resTime.millisec = Number(treg[order.l]);
                }
                if (order.c !== -1) {
                    resTime.microsec = Number(treg[order.c]);
                }
                if (order.z !== -1 && treg[order.z] !== undefined) {
                    resTime.timezone = $.timepicker.timezoneOffsetNumber(treg[order.z]);
                }


                return resTime;
            }
            return false;
        };// end strictParse

        // First try JS Date, if that fails, use strictParse
        var looseParse = function (f, s, o) {
            try {
                var d = new Date('2012-01-01 ' + s);
                if (isNaN(d.getTime())) {
                    d = new Date('2012-01-01T' + s);
                    if (isNaN(d.getTime())) {
                        d = new Date('01/01/2012 ' + s);
                        if (isNaN(d.getTime())) {
                            throw "Unable to parse time with native Date: " + s;
                        }
                    }
                }

                return {
                    hour: d.getHours(),
                    minute: d.getMinutes(),
                    second: d.getSeconds(),
                    millisec: d.getMilliseconds(),
                    microsec: d.getMicroseconds(),
                    timezone: d.getTimezoneOffset() * -1
                };
            }
            catch (err) {
                try {
                    return strictParse(f, s, o);
                }
                catch (err2) {
                    $.timepicker.log("Unable to parse \ntimeString: " + s + "\ntimeFormat: " + f);
                }
            }
            return false;
        }; // end looseParse

        if (typeof o.parse === "function") {
            return o.parse(timeFormat, timeString, o);
        }
        if (o.parse === 'loose') {
            return looseParse(timeFormat, timeString, o);
        }
        return strictParse(timeFormat, timeString, o);
    };

    /**
     * Public utility to format the time
     * @param {string} format format of the time
     * @param {Object} time Object not a Date for timezones
     * @param {Object} [options] essentially the regional[].. amNames, pmNames, ampm
     * @returns {string} the formatted time
     */
    $.datepicker.formatTime = function (format, time, options) {
        options = options || {};
        options = $.extend({}, $.timepicker._defaults, options);
        time = $.extend({
            hour: 0,
            minute: 0,
            second: 0,
            millisec: 0,
            microsec: 0,
            timezone: null
        }, time);

        var tmptime = format,
          ampmName = options.amNames[0],
          hour = parseInt(time.hour, 10);

        if (hour > 11) {
            ampmName = options.pmNames[0];
        }

        tmptime = tmptime.replace(/(?:HH?|hh?|mm?|ss?|[tT]{1,2}|[zZ]|[lc]|'.*?')/g, function (match) {
            switch (match) {
                case 'HH':
                    return ('0' + hour).slice(-2);
                case 'H':
                    return hour;
                case 'hh':
                    return ('0' + convert24to12(hour)).slice(-2);
                case 'h':
                    return convert24to12(hour);
                case 'mm':
                    return ('0' + time.minute).slice(-2);
                case 'm':
                    return time.minute;
                case 'ss':
                    return ('0' + time.second).slice(-2);
                case 's':
                    return time.second;
                case 'l':
                    return ('00' + time.millisec).slice(-3);
                case 'c':
                    return ('00' + time.microsec).slice(-3);
                case 'z':
                    return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, false);
                case 'Z':
                    return $.timepicker.timezoneOffsetString(time.timezone === null ? options.timezone : time.timezone, true);
                case 'T':
                    return ampmName.charAt(0).toUpperCase();
                case 'TT':
                    return ampmName.toUpperCase();
                case 't':
                    return ampmName.charAt(0).toLowerCase();
                case 'tt':
                    return ampmName.toLowerCase();
                default:
                    return match.replace(/'/g, "");
            }
        });

        return tmptime;
    };

    /*
    * the bad hack :/ override datepicker so it doesn't close on select
    // inspired: http://stackoverflow.com/questions/1252512/jquery-datepicker-prevent-closing-picker-when-clicking-a-date/1762378#1762378
    */
    $.datepicker._base_selectDate = $.datepicker._selectDate;
    $.datepicker._selectDate = function (id, dateStr) {
        var inst = this._getInst($(id)[0]),
          tp_inst = this._get(inst, 'timepicker'),
          was_inline;

        if (tp_inst && inst.settings.showTimepicker) {
            tp_inst._limitMinMaxDateTime(inst, true);
            was_inline = inst.inline;
            inst.inline = inst.stay_open = true;
            //This way the onSelect handler called from calendarpicker get the full dateTime
            this._base_selectDate(id, dateStr);
            inst.inline = was_inline;
            inst.stay_open = false;
            this._notifyChange(inst);
            this._updateDatepicker(inst);
        } else {
            this._base_selectDate(id, dateStr);
        }
    };

    /*
    * second bad hack :/ override datepicker so it triggers an event when changing the input field
    * and does not redraw the datepicker on every selectDate event
    */
    $.datepicker._base_updateDatepicker = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function (inst) {

        // don't popup the datepicker if there is another instance already opened
        var input = inst.input[0];
        if ($.datepicker._curInst && $.datepicker._curInst !== inst && $.datepicker._datepickerShowing && $.datepicker._lastInput !== input) {
            return;
        }

        if (typeof(inst.stay_open) !== 'boolean' || inst.stay_open === false) {

            this._base_updateDatepicker(inst);

            // Reload the time control when changing something in the input text field.
            var tp_inst = this._get(inst, 'timepicker');
            if (tp_inst) {
                tp_inst._addTimePicker(inst);
            }
        }
    };

    /*
    * third bad hack :/ override datepicker so it allows spaces and colon in the input field
    */
    $.datepicker._base_doKeyPress = $.datepicker._doKeyPress;
    $.datepicker._doKeyPress = function (event) {
        var inst = $.datepicker._getInst(event.target),
          tp_inst = $.datepicker._get(inst, 'timepicker');

        if (tp_inst) {
            if ($.datepicker._get(inst, 'constrainInput')) {
                var ampm = tp_inst.support.ampm,
                  tz = tp_inst._defaults.showTimezone !== null ? tp_inst._defaults.showTimezone : tp_inst.support.timezone,
                  dateChars = $.datepicker._possibleChars($.datepicker._get(inst, 'dateFormat')),
                  datetimeChars = tp_inst._defaults.timeFormat.toString()
                      .replace(/[hms]/g, '')
                      .replace(/TT/g, ampm ? 'APM' : '')
                      .replace(/Tt/g, ampm ? 'AaPpMm' : '')
                      .replace(/tT/g, ampm ? 'AaPpMm' : '')
                      .replace(/T/g, ampm ? 'AP' : '')
                      .replace(/tt/g, ampm ? 'apm' : '')
                      .replace(/t/g, ampm ? 'ap' : '') +
                    " " + tp_inst._defaults.separator +
                    tp_inst._defaults.timeSuffix +
                    (tz ? tp_inst._defaults.timezoneList.join('') : '') +
                    (tp_inst._defaults.amNames.join('')) + (tp_inst._defaults.pmNames.join('')) +
                    dateChars,
                  chr = String.fromCharCode(event.charCode === undefined ? event.keyCode : event.charCode);
                return event.ctrlKey || (chr < ' ' || !dateChars || datetimeChars.indexOf(chr) > -1);
            }
        }

        return $.datepicker._base_doKeyPress(event);
    };

    /*
    * Fourth bad hack :/ override _updateAlternate function used in inline mode to init altField
    * Update any alternate field to synchronise with the main field.
    */
    $.datepicker._base_updateAlternate = $.datepicker._updateAlternate;
    $.datepicker._updateAlternate = function (inst) {
        var tp_inst = this._get(inst, 'timepicker');
        if (tp_inst) {
            var altField = tp_inst._defaults.altField;
            if (altField) { // update alternate field too
                var altFormat = tp_inst._defaults.altFormat || tp_inst._defaults.dateFormat,
                  date = this._getDate(inst),
                  formatCfg = $.datepicker._getFormatConfig(inst),
                  altFormattedDateTime = '',
                  altSeparator = tp_inst._defaults.altSeparator ? tp_inst._defaults.altSeparator : tp_inst._defaults.separator,
                  altTimeSuffix = tp_inst._defaults.altTimeSuffix ? tp_inst._defaults.altTimeSuffix : tp_inst._defaults.timeSuffix,
                  altTimeFormat = tp_inst._defaults.altTimeFormat !== null ? tp_inst._defaults.altTimeFormat : tp_inst._defaults.timeFormat;

                altFormattedDateTime += $.datepicker.formatTime(altTimeFormat, tp_inst, tp_inst._defaults) + altTimeSuffix;
                if (!tp_inst._defaults.timeOnly && !tp_inst._defaults.altFieldTimeOnly && date !== null) {
                    if (tp_inst._defaults.altFormat) {
                        altFormattedDateTime = $.datepicker.formatDate(tp_inst._defaults.altFormat, date, formatCfg) + altSeparator + altFormattedDateTime;
                    }
                    else {
                        altFormattedDateTime = tp_inst.formattedDate + altSeparator + altFormattedDateTime;
                    }
                }
                $(altField).val( inst.input.val() ? altFormattedDateTime : "");
            }
        }
        else {
            $.datepicker._base_updateAlternate(inst);
        }
    };

    /*
    * Override key up event to sync manual input changes.
    */
    $.datepicker._base_doKeyUp = $.datepicker._doKeyUp;
    $.datepicker._doKeyUp = function (event) {
        var inst = $.datepicker._getInst(event.target),
          tp_inst = $.datepicker._get(inst, 'timepicker');

        if (tp_inst) {
            if (tp_inst._defaults.timeOnly && (inst.input.val() !== inst.lastVal)) {
                try {
                    $.datepicker._updateDatepicker(inst);
                } catch (err) {
                    $.timepicker.log(err);
                }
            }
        }

        return $.datepicker._base_doKeyUp(event);
    };

    /*
    * override "Today" button to also grab the time and set it to input field.
    */
    $.datepicker._base_gotoToday = $.datepicker._gotoToday;
    $.datepicker._gotoToday = function (id) {
        var inst = this._getInst($(id)[0]);
        this._base_gotoToday(id);
        var tp_inst = this._get(inst, 'timepicker');
        if (!tp_inst) {
            return;
        }

        var tzoffset = $.timepicker.timezoneOffsetNumber(tp_inst.timezone);
        var now = new Date();
        now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + parseInt(tzoffset, 10));
        this._setTime(inst, now);
        this._setDate(inst, now);
        tp_inst._onSelectHandler();
    };

    /*
    * Disable & enable the Time in the datetimepicker
    */
    $.datepicker._disableTimepickerDatepicker = function (target) {
        var inst = this._getInst(target);
        if (!inst) {
            return;
        }

        var tp_inst = this._get(inst, 'timepicker');
        $(target).datepicker('getDate'); // Init selected[Year|Month|Day]
        if (tp_inst) {
            inst.settings.showTimepicker = false;
            tp_inst._defaults.showTimepicker = false;
            tp_inst._updateDateTime(inst);
        }
    };

    $.datepicker._enableTimepickerDatepicker = function (target) {
        var inst = this._getInst(target);
        if (!inst) {
            return;
        }

        var tp_inst = this._get(inst, 'timepicker');
        $(target).datepicker('getDate'); // Init selected[Year|Month|Day]
        if (tp_inst) {
            inst.settings.showTimepicker = true;
            tp_inst._defaults.showTimepicker = true;
            tp_inst._addTimePicker(inst); // Could be disabled on page load
            tp_inst._updateDateTime(inst);
        }
    };

    /*
    * Create our own set time function
    */
    $.datepicker._setTime = function (inst, date) {
        var tp_inst = this._get(inst, 'timepicker');
        if (tp_inst) {
            var defaults = tp_inst._defaults;

            // calling _setTime with no date sets time to defaults
            tp_inst.hour = date ? date.getHours() : defaults.hour;
            tp_inst.minute = date ? date.getMinutes() : defaults.minute;
            tp_inst.second = date ? date.getSeconds() : defaults.second;
            tp_inst.millisec = date ? date.getMilliseconds() : defaults.millisec;
            tp_inst.microsec = date ? date.getMicroseconds() : defaults.microsec;

            //check if within min/max times..
            tp_inst._limitMinMaxDateTime(inst, true);

            tp_inst._onTimeChange();
            tp_inst._updateDateTime(inst);
        }
    };

    /*
    * Create new public method to set only time, callable as $().datepicker('setTime', date)
    */
    $.datepicker._setTimeDatepicker = function (target, date, withDate) {
        var inst = this._getInst(target);
        if (!inst) {
            return;
        }

        var tp_inst = this._get(inst, 'timepicker');

        if (tp_inst) {
            this._setDateFromField(inst);
            var tp_date;
            if (date) {
                if (typeof date === "string") {
                    tp_inst._parseTime(date, withDate);
                    tp_date = new Date();
                    tp_date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
                    tp_date.setMicroseconds(tp_inst.microsec);
                } else {
                    tp_date = new Date(date.getTime());
                    tp_date.setMicroseconds(date.getMicroseconds());
                }
                if (tp_date.toString() === 'Invalid Date') {
                    tp_date = undefined;
                }
                this._setTime(inst, tp_date);
            }
        }

    };

    /*
    * override setDate() to allow setting time too within Date object
    */
    $.datepicker._base_setDateDatepicker = $.datepicker._setDateDatepicker;
    $.datepicker._setDateDatepicker = function (target, _date) {
        var inst = this._getInst(target);
        var date = _date;
        if (!inst) {
            return;
        }

        if (typeof(_date) === 'string') {
            date = new Date(_date);
            if (!date.getTime()) {
                this._base_setDateDatepicker.apply(this, arguments);
                date = $(target).datepicker('getDate');
            }
        }

        var tp_inst = this._get(inst, 'timepicker');
        var tp_date;
        if (date instanceof Date) {
            tp_date = new Date(date.getTime());
            tp_date.setMicroseconds(date.getMicroseconds());
        } else {
            tp_date = date;
        }

        // This is important if you are using the timezone option, javascript's Date
        // object will only return the timezone offset for the current locale, so we
        // adjust it accordingly.  If not using timezone option this won't matter..
        // If a timezone is different in tp, keep the timezone as is
        if (tp_inst && tp_date) {
            // look out for DST if tz wasn't specified
            if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
                tp_inst.timezone = tp_date.getTimezoneOffset() * -1;
            }
            date = $.timepicker.timezoneAdjust(date, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()), tp_inst.timezone);
            tp_date = $.timepicker.timezoneAdjust(tp_date, $.timepicker.timezoneOffsetString(-tp_date.getTimezoneOffset()), tp_inst.timezone);
        }

        this._updateDatepicker(inst);
        this._base_setDateDatepicker.apply(this, arguments);
        this._setTimeDatepicker(target, tp_date, true);
    };

    /*
    * override getDate() to allow getting time too within Date object
    */
    $.datepicker._base_getDateDatepicker = $.datepicker._getDateDatepicker;
    $.datepicker._getDateDatepicker = function (target, noDefault) {
        var inst = this._getInst(target);
        if (!inst) {
            return;
        }

        var tp_inst = this._get(inst, 'timepicker');

        if (tp_inst) {
            // if it hasn't yet been defined, grab from field
            if (inst.lastVal === undefined) {
                this._setDateFromField(inst, noDefault);
            }

            var date = this._getDate(inst);

            var currDT = null;

            if (tp_inst.$altInput && tp_inst._defaults.altFieldTimeOnly) {
                currDT = tp_inst.$input.val() + ' ' + tp_inst.$altInput.val();
            }
            else if (tp_inst.$input.get(0).tagName !== 'INPUT' && tp_inst.$altInput) {
                /**
                 * in case the datetimepicker has been applied to a non-input tag for inline UI,
                 * and the user has not configured the plugin to display only time in altInput,
                 * pick current date time from the altInput (and hope for the best, for now, until "ER1" is applied)
                 *
                 * @todo ER1. Since altInput can have a totally difference format, convert it to standard format by reading input format from "altFormat" and "altTimeFormat" option values
                 */
                currDT = tp_inst.$altInput.val();
            }
            else {
                currDT = tp_inst.$input.val();
            }

            if (date && tp_inst._parseTime(currDT, !inst.settings.timeOnly)) {
                date.setHours(tp_inst.hour, tp_inst.minute, tp_inst.second, tp_inst.millisec);
                date.setMicroseconds(tp_inst.microsec);

                // This is important if you are using the timezone option, javascript's Date
                // object will only return the timezone offset for the current locale, so we
                // adjust it accordingly.  If not using timezone option this won't matter..
                if (tp_inst.timezone != null) {
                    // look out for DST if tz wasn't specified
                    if (!tp_inst.support.timezone && tp_inst._defaults.timezone === null) {
                        tp_inst.timezone = date.getTimezoneOffset() * -1;
                    }
                    date = $.timepicker.timezoneAdjust(date, tp_inst.timezone, $.timepicker.timezoneOffsetString(-date.getTimezoneOffset()));
                }
            }
            return date;
        }
        return this._base_getDateDatepicker(target, noDefault);
    };

    /*
    * override parseDate() because UI 1.8.14 throws an error about "Extra characters"
    * An option in datapicker to ignore extra format characters would be nicer.
    */
    $.datepicker._base_parseDate = $.datepicker.parseDate;
    $.datepicker.parseDate = function (format, value, settings) {
        var date;
        try {
            date = this._base_parseDate(format, value, settings);
        } catch (err) {
            // Hack!  The error message ends with a colon, a space, and
            // the "extra" characters.  We rely on that instead of
            // attempting to perfectly reproduce the parsing algorithm.
            if (err.indexOf(":") >= 0) {
                date = this._base_parseDate(format, value.substring(0, value.length - (err.length - err.indexOf(':') - 2)), settings);
                $.timepicker.log("Error parsing the date string: " + err + "\ndate string = " + value + "\ndate format = " + format);
            } else {
                throw err;
            }
        }
        return date;
    };

    /*
    * override formatDate to set date with time to the input
    */
    $.datepicker._base_formatDate = $.datepicker._formatDate;
    $.datepicker._formatDate = function (inst, day, month, year) {
        var tp_inst = this._get(inst, 'timepicker');
        if (tp_inst) {
            tp_inst._updateDateTime(inst);
            return tp_inst.$input.val();
        }
        return this._base_formatDate(inst);
    };

    /*
    * override options setter to add time to maxDate(Time) and minDate(Time). MaxDate
    */
    $.datepicker._base_optionDatepicker = $.datepicker._optionDatepicker;
    $.datepicker._optionDatepicker = function (target, name, value) {
        var inst = this._getInst(target),
          name_clone;
        if (!inst) {
            return null;
        }

        var tp_inst = this._get(inst, 'timepicker');
        if (tp_inst) {
            var min = null,
              max = null,
              onselect = null,
              overrides = tp_inst._defaults.evnts,
              fns = {},
              prop,
              ret,
              oldVal,
              $target;
            if (typeof name === 'string') { // if min/max was set with the string
                if (name === 'minDate' || name === 'minDateTime') {
                    min = value;
                } else if (name === 'maxDate' || name === 'maxDateTime') {
                    max = value;
                } else if (name === 'onSelect') {
                    onselect = value;
                } else if (overrides.hasOwnProperty(name)) {
                    if (typeof (value) === 'undefined') {
                        return overrides[name];
                    }
                    fns[name] = value;
                    name_clone = {}; //empty results in exiting function after overrides updated
                }
            } else if (typeof name === 'object') { //if min/max was set with the JSON
                if (name.minDate) {
                    min = name.minDate;
                } else if (name.minDateTime) {
                    min = name.minDateTime;
                } else if (name.maxDate) {
                    max = name.maxDate;
                } else if (name.maxDateTime) {
                    max = name.maxDateTime;
                }
                for (prop in overrides) {
                    if (overrides.hasOwnProperty(prop) && name[prop]) {
                        fns[prop] = name[prop];
                    }
                }
            }
            for (prop in fns) {
                if (fns.hasOwnProperty(prop)) {
                    overrides[prop] = fns[prop];
                    if (!name_clone) { name_clone = $.extend({}, name); }
                    delete name_clone[prop];
                }
            }
            if (name_clone && isEmptyObject(name_clone)) { return; }
            if (min) { //if min was set
                if (min === 0) {
                    min = new Date();
                } else {
                    min = new Date(min);
                }
                tp_inst._defaults.minDate = min;
                tp_inst._defaults.minDateTime = min;
            } else if (max) { //if max was set
                if (max === 0) {
                    max = new Date();
                } else {
                    max = new Date(max);
                }
                tp_inst._defaults.maxDate = max;
                tp_inst._defaults.maxDateTime = max;
            } else if (onselect) {
                tp_inst._defaults.onSelect = onselect;
            }

            // Datepicker will override our date when we call _base_optionDatepicker when
            // calling minDate/maxDate, so we will first grab the value, call
            // _base_optionDatepicker, then set our value back.
            if(min || max){
                $target = $(target);
                oldVal = $target.datetimepicker('getDate');
                ret = this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
                $target.datetimepicker('setDate', oldVal);
                return ret;
            }
        }
        if (value === undefined) {
            return this._base_optionDatepicker.call($.datepicker, target, name);
        }
        return this._base_optionDatepicker.call($.datepicker, target, name_clone || name, value);
    };

    /*
    * jQuery isEmptyObject does not check hasOwnProperty - if someone has added to the object prototype,
    * it will return false for all objects
    */
    var isEmptyObject = function (obj) {
        var prop;
        for (prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    };

    /*
    * jQuery extend now ignores nulls!
    */
    var extendRemove = function (target, props) {
        $.extend(target, props);
        for (var name in props) {
            if (props[name] === null || props[name] === undefined) {
                target[name] = props[name];
            }
        }
        return target;
    };

    /*
    * Determine by the time format which units are supported
    * Returns an object of booleans for each unit
    */
    var detectSupport = function (timeFormat) {
        var tf = timeFormat.replace(/'.*?'/g, '').toLowerCase(), // removes literals
          isIn = function (f, t) { // does the format contain the token?
              return f.indexOf(t) !== -1 ? true : false;
          };
        return {
            hour: isIn(tf, 'h'),
            minute: isIn(tf, 'm'),
            second: isIn(tf, 's'),
            millisec: isIn(tf, 'l'),
            microsec: isIn(tf, 'c'),
            timezone: isIn(tf, 'z'),
            ampm: isIn(tf, 't') && isIn(timeFormat, 'h'),
            iso8601: isIn(timeFormat, 'Z')
        };
    };

    /*
    * Converts 24 hour format into 12 hour
    * Returns 12 hour without leading 0
    */
    var convert24to12 = function (hour) {
        hour %= 12;

        if (hour === 0) {
            hour = 12;
        }

        return String(hour);
    };

    var computeEffectiveSetting = function (settings, property) {
        return settings && settings[property] ? settings[property] : $.timepicker._defaults[property];
    };

    /*
    * Splits datetime string into date and time substrings.
    * Throws exception when date can't be parsed
    * Returns {dateString: dateString, timeString: timeString}
    */
    var splitDateTime = function (dateTimeString, timeSettings) {
        // The idea is to get the number separator occurrences in datetime and the time format requested (since time has
        // fewer unknowns, mostly numbers and am/pm). We will use the time pattern to split.
        var separator = computeEffectiveSetting(timeSettings, 'separator'),
          format = computeEffectiveSetting(timeSettings, 'timeFormat'),
          timeParts = format.split(separator), // how many occurrences of separator may be in our format?
          timePartsLen = timeParts.length,
          allParts = dateTimeString.split(separator),
          allPartsLen = allParts.length;

        if (allPartsLen > 1) {
            return {
                dateString: allParts.splice(0, allPartsLen - timePartsLen).join(separator),
                timeString: allParts.splice(0, timePartsLen).join(separator)
            };
        }

        return {
            dateString: dateTimeString,
            timeString: ''
        };
    };

    /*
    * Internal function to parse datetime interval
    * Returns: {date: Date, timeObj: Object}, where
    *   date - parsed date without time (type Date)
    *   timeObj = {hour: , minute: , second: , millisec: , microsec: } - parsed time. Optional
    */
    var parseDateTimeInternal = function (dateFormat, timeFormat, dateTimeString, dateSettings, timeSettings) {
        var date,
          parts,
          parsedTime;

        parts = splitDateTime(dateTimeString, timeSettings);
        date = $.datepicker._base_parseDate(dateFormat, parts.dateString, dateSettings);

        if (parts.timeString === '') {
            return {
                date: date
            };
        }

        parsedTime = $.datepicker.parseTime(timeFormat, parts.timeString, timeSettings);

        if (!parsedTime) {
            throw 'Wrong time format';
        }

        return {
            date: date,
            timeObj: parsedTime
        };
    };

    /*
    * Internal function to set timezone_select to the local timezone
    */
    var selectLocalTimezone = function (tp_inst, date) {
        if (tp_inst && tp_inst.timezone_select) {
            var now = date || new Date();
            tp_inst.timezone_select.val(-now.getTimezoneOffset());
        }
    };

    /*
    * Create a Singleton Instance
    */
    $.timepicker = new Timepicker();

    /**
     * Get the timezone offset as string from a date object (eg '+0530' for UTC+5.5)
     * @param {number} tzMinutes if not a number, less than -720 (-1200), or greater than 840 (+1400) this value is returned
     * @param {boolean} iso8601 if true formats in accordance to iso8601 "+12:45"
     * @return {string}
     */
    $.timepicker.timezoneOffsetString = function (tzMinutes, iso8601) {
        if (isNaN(tzMinutes) || tzMinutes > 840 || tzMinutes < -720) {
            return tzMinutes;
        }

        var off = tzMinutes,
          minutes = off % 60,
          hours = (off - minutes) / 60,
          iso = iso8601 ? ':' : '',
          tz = (off >= 0 ? '+' : '-') + ('0' + Math.abs(hours)).slice(-2) + iso + ('0' + Math.abs(minutes)).slice(-2);

        if (tz === '+00:00') {
            return 'Z';
        }
        return tz;
    };

    /**
     * Get the number in minutes that represents a timezone string
     * @param  {string} tzString formatted like "+0500", "-1245", "Z"
     * @return {number} the offset minutes or the original string if it doesn't match expectations
     */
    $.timepicker.timezoneOffsetNumber = function (tzString) {
        var normalized = tzString.toString().replace(':', ''); // excuse any iso8601, end up with "+1245"

        if (normalized.toUpperCase() === 'Z') { // if iso8601 with Z, its 0 minute offset
            return 0;
        }

        if (!/^(\-|\+)\d{4}$/.test(normalized)) { // possibly a user defined tz, so just give it back
            return parseInt(tzString, 10);
        }

        return ((normalized.substr(0, 1) === '-' ? -1 : 1) * // plus or minus
          ((parseInt(normalized.substr(1, 2), 10) * 60) + // hours (converted to minutes)
            parseInt(normalized.substr(3, 2), 10))); // minutes
    };

    /**
     * No way to set timezone in js Date, so we must adjust the minutes to compensate. (think setDate, getDate)
     * @param  {Date} date
     * @param  {string} fromTimezone formatted like "+0500", "-1245"
     * @param  {string} toTimezone formatted like "+0500", "-1245"
     * @return {Date}
     */
    $.timepicker.timezoneAdjust = function (date, fromTimezone, toTimezone) {
        var fromTz = $.timepicker.timezoneOffsetNumber(fromTimezone);
        var toTz = $.timepicker.timezoneOffsetNumber(toTimezone);
        if (!isNaN(toTz)) {
            date.setMinutes(date.getMinutes() + (-fromTz) - (-toTz));
        }
        return date;
    };

    /**
     * Calls `timepicker()` on the `startTime` and `endTime` elements, and configures them to
     * enforce date range limits.
     * n.b. The input value must be correctly formatted (reformatting is not supported)
     * @param  {Element} startTime
     * @param  {Element} endTime
     * @param  {Object} options Options for the timepicker() call
     * @return {jQuery}
     */
    $.timepicker.timeRange = function (startTime, endTime, options) {
        return $.timepicker.handleRange('timepicker', startTime, endTime, options);
    };

    /**
     * Calls `datetimepicker` on the `startTime` and `endTime` elements, and configures them to
     * enforce date range limits.
     * @param  {Element} startTime
     * @param  {Element} endTime
     * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
     *   a boolean value that can be used to reformat the input values to the `dateFormat`.
     * @param  {string} method Can be used to specify the type of picker to be added
     * @return {jQuery}
     */
    $.timepicker.datetimeRange = function (startTime, endTime, options) {
        $.timepicker.handleRange('datetimepicker', startTime, endTime, options);
    };

    /**
     * Calls `datepicker` on the `startTime` and `endTime` elements, and configures them to
     * enforce date range limits.
     * @param  {Element} startTime
     * @param  {Element} endTime
     * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
     *   a boolean value that can be used to reformat the input values to the `dateFormat`.
     * @return {jQuery}
     */
    $.timepicker.dateRange = function (startTime, endTime, options) {
        $.timepicker.handleRange('datepicker', startTime, endTime, options);
    };

    /**
     * Calls `method` on the `startTime` and `endTime` elements, and configures them to
     * enforce date range limits.
     * @param  {string} method Can be used to specify the type of picker to be added
     * @param  {Element} startTime
     * @param  {Element} endTime
     * @param  {Object} options Options for the `timepicker()` call. Also supports `reformat`,
     *   a boolean value that can be used to reformat the input values to the `dateFormat`.
     * @return {jQuery}
     */
    $.timepicker.handleRange = function (method, startTime, endTime, options) {
        options = $.extend({}, {
            minInterval: 0, // min allowed interval in milliseconds
            maxInterval: 0, // max allowed interval in milliseconds
            start: {},      // options for start picker
            end: {}         // options for end picker
        }, options);

        // for the mean time this fixes an issue with calling getDate with timepicker()
        var timeOnly = false;
        if(method === 'timepicker'){
            timeOnly = true;
            method = 'datetimepicker';
        }

        function checkDates(changed, other) {
            var startdt = startTime[method]('getDate'),
              enddt = endTime[method]('getDate'),
              changeddt = changed[method]('getDate');

            if (startdt !== null) {
                var minDate = new Date(startdt.getTime()),
                  maxDate = new Date(startdt.getTime());

                minDate.setMilliseconds(minDate.getMilliseconds() + options.minInterval);
                maxDate.setMilliseconds(maxDate.getMilliseconds() + options.maxInterval);

                if (options.minInterval > 0 && minDate > enddt) { // minInterval check
                    endTime[method]('setDate', minDate);
                }
                else if (options.maxInterval > 0 && maxDate < enddt) { // max interval check
                    endTime[method]('setDate', maxDate);
                }
                else if (startdt > enddt) {
                    other[method]('setDate', changeddt);
                }
            }
        }

        function selected(changed, other, option) {
            if (!changed.val()) {
                return;
            }
            var date = changed[method].call(changed, 'getDate');
            if (date !== null && options.minInterval > 0) {
                if (option === 'minDate') {
                    date.setMilliseconds(date.getMilliseconds() + options.minInterval);
                }
                if (option === 'maxDate') {
                    date.setMilliseconds(date.getMilliseconds() - options.minInterval);
                }
            }

            if (date.getTime) {
                other[method].call(other, 'option', option, date);
            }
        }

        $.fn[method].call(startTime, $.extend({
            timeOnly: timeOnly,
            onClose: function (dateText, inst) {
                checkDates($(this), endTime);
            },
            onSelect: function (selectedDateTime) {
                selected($(this), endTime, 'minDate');
            }
        }, options, options.start));
        $.fn[method].call(endTime, $.extend({
            timeOnly: timeOnly,
            onClose: function (dateText, inst) {
                checkDates($(this), startTime);
            },
            onSelect: function (selectedDateTime) {
                selected($(this), startTime, 'maxDate');
            }
        }, options, options.end));

        checkDates(startTime, endTime);

        selected(startTime, endTime, 'minDate');
        selected(endTime, startTime, 'maxDate');

        return $([startTime.get(0), endTime.get(0)]);
    };

    /**
     * Log error or data to the console during error or debugging
     * @param  {Object} err pass any type object to log to the console during error or debugging
     * @return {void}
     */
    $.timepicker.log = function () {
        // Older IE (9, maybe 10) throw error on accessing `window.console.log.apply`, so check first.
        if (window.console && window.console.log && window.console.log.apply) {
            window.console.log.apply(window.console, Array.prototype.slice.call(arguments));
        }
    };

    /*
     * Add util object to allow access to private methods for testability.
     */
    $.timepicker._util = {
        _extendRemove: extendRemove,
        _isEmptyObject: isEmptyObject,
        _convert24to12: convert24to12,
        _detectSupport: detectSupport,
        _selectLocalTimezone: selectLocalTimezone,
        _computeEffectiveSetting: computeEffectiveSetting,
        _splitDateTime: splitDateTime,
        _parseDateTimeInternal: parseDateTimeInternal
    };

    /*
    * Microsecond support
    */
    if (!Date.prototype.getMicroseconds) {
        Date.prototype.microseconds = 0;
        Date.prototype.getMicroseconds = function () { return this.microseconds; };
        Date.prototype.setMicroseconds = function (m) {
            this.setMilliseconds(this.getMilliseconds() + Math.floor(m / 1000));
            this.microseconds = m % 1000;
            return this;
        };
    }

    /*
    * Keep up with the version
    */
    $.timepicker.version = "1.6.3";

}));

},{}],337:[function(require,module,exports){
/*!
 * jQuery blockUI plugin
 * Version 2.65.0-2013.09.02
 * Requires jQuery v1.7 or later
 *
 * Examples at: http://malsup.com/jquery/block/
 * Copyright (c) 2007-2013 M. Alsup
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
 */

;
(function () {
    /*jshint eqeqeq:false curly:false latedef:false */
    "use strict";

    function setup($) {
        $.fn._fadeIn = $.fn.fadeIn;

        var noOp = $.noop || function () {
        };

        // this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
        // confusing userAgent strings on Vista)
        var msie = /MSIE/.test(navigator.userAgent);
        var ie6 = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent);
        var mode = document.documentMode || 0;
        var setExpr = $.isFunction(document.createElement('div').style.setExpression);

        // global $ methods for blocking/unblocking the entire page
        $.blockUI = function (opts) {
            install(window, opts);
        };
        $.unblockUI = function (opts) {
            remove(window, opts);
        };

        // convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
        $.growlUI = function (title, message, timeout, onClose) {
            var $m = $('<div class="growlUI"></div>');
            if (title) $m.append('<h1>' + title + '</h1>');
            if (message) $m.append('<h2>' + message + '</h2>');
            if (timeout === undefined) timeout = 3000;

            // Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
            var callBlock = function (opts) {
                opts = opts || {};

                $.blockUI({
                    message: $m,
                    fadeIn: typeof opts.fadeIn !== 'undefined' ? opts.fadeIn : 700,
                    fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
                    timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
                    centerY: false,
                    showOverlay: false,
                    onUnblock: onClose,
                    css: $.blockUI.defaults.growlCSS
                });
            };

            callBlock();
            var nonmousedOpacity = $m.css('opacity');
            $m.mouseover(function () {
                callBlock({
                    fadeIn: 0,
                    timeout: 30000
                });

                var displayBlock = $('.blockMsg');
                displayBlock.stop(); // cancel fadeout if it has started
                displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
            }).mouseout(function () {
                    $('.blockMsg').fadeOut(1000);
                });
            // End konapun additions
        };

        // plugin method for blocking element content
        $.fn.block = function (opts) {
            if (this[0] === window) {
                $.blockUI(opts);
                return this;
            }
            var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
            this.each(function () {
                var $el = $(this);
                if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked'))
                    return;
                $el.unblock({ fadeOut: 0 });
            });

            return this.each(function () {
                if ($.css(this, 'position') == 'static') {
                    this.style.position = 'relative';
                    $(this).data('blockUI.static', true);
                }
                this.style.zoom = 1; // force 'hasLayout' in ie
                install(this, opts);
            });
        };

        // plugin method for unblocking element content
        $.fn.unblock = function (opts) {
            if (this[0] === window) {
                $.unblockUI(opts);
                return this;
            }
            return this.each(function () {
                remove(this, opts);
            });
        };

        $.blockUI.version = 2.65; // 2nd generation blocking at no extra cost!

        // override these in your code to change the default behavior and style
        $.blockUI.defaults = {
            // message displayed when blocking (use null for no message)
            message: '<h1>Please wait...</h1>',

            title: null,		// title string; only used when theme == true
            draggable: true,	// only used when theme == true (requires jquery-ui.js to be loaded)

            theme: false, // set to true to use with jQuery UI themes

            // styles for the message when blocking; if you wish to disable
            // these and use an external stylesheet then do this in your code:
            // $.blockUI.defaults.css = {};
            css: {
                padding: 0,
                margin: 0,
                width: '30%',
                top: '40%',
                left: '35%',
                textAlign: 'center',
                color: '#000',
                border: '3px solid #aaa',
                backgroundColor: '#fff',
                cursor: 'wait'
            },

            // minimal style set used when themes are used
            themedCSS: {
                width: '30%',
                top: '40%',
                left: '35%'
            },

            // styles for the overlay
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.6,
                cursor: 'wait'
            },

            // style to replace wait cursor before unblocking to correct issue
            // of lingering wait cursor
            cursorReset: 'default',

            // styles applied when using $.growlUI
            growlCSS: {
                width: '350px',
                top: '10px',
                left: '',
                right: '10px',
                border: 'none',
                padding: '5px',
                opacity: 0.6,
                cursor: 'default',
                color: '#fff',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                'border-radius': '10px'
            },

            // IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
            // (hat tip to Jorge H. N. de Vasconcelos)
            /*jshint scripturl:true */
            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',

            // force usage of iframe in non-IE browsers (handy for blocking applets)
            forceIframe: false,

            // z-index for the blocking overlay
            baseZ: 1000,

            // set these to true to have the message automatically centered
            centerX: true, // <-- only effects element blocking (page block controlled via css above)
            centerY: true,

            // allow body element to be stetched in ie6; this makes blocking look better
            // on "short" pages.  disable if you wish to prevent changes to the body height
            allowBodyStretch: true,

            // enable if you want key and mouse events to be disabled for content that is blocked
            bindEvents: true,

            // be default blockUI will supress tab navigation from leaving blocking content
            // (if bindEvents is true)
            constrainTabKey: true,

            // fadeIn time in millis; set to 0 to disable fadeIn on block
            fadeIn: 200,

            // fadeOut time in millis; set to 0 to disable fadeOut on unblock
            fadeOut: 400,

            // time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
            timeout: 0,

            // disable if you don't want to show the overlay
            showOverlay: true,

            // if true, focus will be placed in the first available input field when
            // page blocking
            focusInput: true,

            // elements that can receive focus
            focusableElements: ':input:enabled:visible',

            // suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
            // no longer needed in 2012
            // applyPlatformOpacityRules: true,

            // callback method invoked when fadeIn has completed and blocking message is visible
            onBlock: null,

            // callback method invoked when unblocking has completed; the callback is
            // passed the element that has been unblocked (which is the window object for page
            // blocks) and the options that were passed to the unblock call:
            //	onUnblock(element, options)
            onUnblock: null,

            // callback method invoked when the overlay area is clicked.
            // setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
            onOverlayClick: null,

            // don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
            quirksmodeOffsetHack: 4,

            // class name of the message block
            blockMsgClass: 'blockMsg',

            // if it is already blocked, then ignore it (don't unblock and reblock)
            ignoreIfBlocked: false
        };

        // private data and functions follow...

        var pageBlock = null;
        var pageBlockEls = [];

        function install(el, opts) {
            var css, themedCSS;
            var full = (el == window);
            var msg = (opts && opts.message !== undefined ? opts.message : undefined);
            opts = $.extend({}, $.blockUI.defaults, opts || {});

            if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked'))
                return;

            opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
            css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
            if (opts.onOverlayClick)
                opts.overlayCSS.cursor = 'pointer';

            themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
            msg = msg === undefined ? opts.message : msg;

            // remove the current block (if there is one)
            if (full && pageBlock)
                remove(window, {fadeOut: 0});

            // if an existing element is being used as the blocking content then we capture
            // its current place in the DOM (and current display style) so we can restore
            // it when we unblock
            if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
                var node = msg.jquery ? msg[0] : msg;
                var data = {};
                $(el).data('blockUI.history', data);
                data.el = node;
                data.parent = node.parentNode;
                data.display = node.style.display;
                data.position = node.style.position;
                if (data.parent)
                    data.parent.removeChild(node);
            }

            $(el).data('blockUI.onUnblock', opts.onUnblock);
            var z = opts.baseZ;

            // blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
            // layer1 is the iframe layer which is used to supress bleed through of underlying content
            // layer2 is the overlay layer which has opacity and a wait cursor (by default)
            // layer3 is the message content that is displayed while blocking
            var lyr1, lyr2, lyr3, s;
            if (msie || opts.forceIframe)
                lyr1 = $('<iframe class="blockUI" style="z-index:' + (z++) + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + opts.iframeSrc + '"></iframe>');
            else
                lyr1 = $('<div class="blockUI" style="display:none"></div>');

            if (opts.theme)
                lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + (z++) + ';display:none"></div>');
            else
                lyr2 = $('<div class="blockUI blockOverlay" style="z-index:' + (z++) + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');

            if (opts.theme && full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:fixed">';
                if (opts.title) {
                    s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
                }
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += '</div>';
            }
            else if (opts.theme) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:absolute">';
                if (opts.title) {
                    s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
                }
                s += '<div class="ui-widget-content ui-dialog-content"></div>';
                s += '</div>';
            }
            else if (full) {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:' + (z + 10) + ';display:none;position:fixed"></div>';
            }
            else {
                s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:' + (z + 10) + ';display:none;position:absolute"></div>';
            }
            lyr3 = $(s);

            // if we have a message, style it
            if (msg) {
                if (opts.theme) {
                    lyr3.css(themedCSS);
                    lyr3.addClass('ui-widget-content');
                }
                else
                    lyr3.css(css);
            }

            // style the overlay
            if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/)
                lyr2.css(opts.overlayCSS);
            lyr2.css('position', full ? 'fixed' : 'absolute');

            // make iframe layer transparent in IE
            if (msie || opts.forceIframe)
                lyr1.css('opacity', 0.0);

            //$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
            var layers = [lyr1, lyr2, lyr3], $par = full ? $('body') : $(el);
            $.each(layers, function () {
                this.appendTo($par);
            });

            if (opts.theme && opts.draggable && $.fn.draggable) {
                lyr3.draggable({
                    handle: '.ui-dialog-titlebar',
                    cancel: 'li'
                });
            }

            // ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
            var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
            if (ie6 || expr) {
                // give body 100% height
                if (full && opts.allowBodyStretch && $.support.boxModel)
                    $('html,body').css('height', '100%');

                // fix ie6 issue when blocked element has a border width
                if ((ie6 || !$.support.boxModel) && !full) {
                    var t = sz(el, 'borderTopWidth'), l = sz(el, 'borderLeftWidth');
                    var fixT = t ? '(0 - ' + t + ')' : 0;
                    var fixL = l ? '(0 - ' + l + ')' : 0;
                }

                // simulate fixed position
                $.each(layers, function (i, o) {
                    var s = o[0].style;
                    s.position = 'absolute';
                    if (i < 2) {
                        if (full)
                            s.setExpression('height', 'Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:' + opts.quirksmodeOffsetHack + ') + "px"');
                        else
                            s.setExpression('height', 'this.parentNode.offsetHeight + "px"');
                        if (full)
                            s.setExpression('width', 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
                        else
                            s.setExpression('width', 'this.parentNode.offsetWidth + "px"');
                        if (fixL) s.setExpression('left', fixL);
                        if (fixT) s.setExpression('top', fixT);
                    }
                    else if (opts.centerY) {
                        if (full) s.setExpression('top', '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
                        s.marginTop = 0;
                    }
                    else if (!opts.centerY && full) {
                        var top = (opts.css && opts.css.top) ? parseInt(opts.css.top, 10) : 0;
                        var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + ' + top + ') + "px"';
                        s.setExpression('top', expression);
                    }
                });
            }

            // show the message
            if (msg) {
                if (opts.theme)
                    lyr3.find('.ui-widget-content').append(msg);
                else
                    lyr3.append(msg);
                if (msg.jquery || msg.nodeType)
                    $(msg).show();
            }

            if ((msie || opts.forceIframe) && opts.showOverlay)
                lyr1.show(); // opacity is zero
            if (opts.fadeIn) {
                var cb = opts.onBlock ? opts.onBlock : noOp;
                var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
                var cb2 = msg ? cb : noOp;
                if (opts.showOverlay)
                    lyr2._fadeIn(opts.fadeIn, cb1);
                if (msg)
                    lyr3._fadeIn(opts.fadeIn, cb2);
            }
            else {
                if (opts.showOverlay)
                    lyr2.show();
                if (msg)
                    lyr3.show();
                if (opts.onBlock)
                    opts.onBlock();
            }

            // bind key and mouse events
            bind(1, el, opts);

            if (full) {
                pageBlock = lyr3[0];
                pageBlockEls = $(opts.focusableElements, pageBlock);
                if (opts.focusInput)
                    setTimeout(focus, 20);
            }
            else
                center(lyr3[0], opts.centerX, opts.centerY);

            if (opts.timeout) {
                // auto-unblock
                var to = setTimeout(function () {
                    if (full)
                        $.unblockUI(opts);
                    else
                        $(el).unblock(opts);
                }, opts.timeout);
                $(el).data('blockUI.timeout', to);
            }
        }

        // remove the block
        function remove(el, opts) {
            var count;
            var full = (el == window);
            var $el = $(el);
            var data = $el.data('blockUI.history');
            var to = $el.data('blockUI.timeout');
            if (to) {
                clearTimeout(to);
                $el.removeData('blockUI.timeout');
            }
            opts = $.extend({}, $.blockUI.defaults, opts || {});
            bind(0, el, opts); // unbind events

            if (opts.onUnblock === null) {
                opts.onUnblock = $el.data('blockUI.onUnblock');
                $el.removeData('blockUI.onUnblock');
            }

            var els;
            if (full) // crazy selector to handle odd field errors in ie6/7
                els = $('body').children().filter('.blockUI').add('body > .blockUI');
            else
                els = $el.find('>.blockUI');

            // fix cursor issue
            if (opts.cursorReset) {
                if (els.length > 1)
                    els[1].style.cursor = opts.cursorReset;
                if (els.length > 2)
                    els[2].style.cursor = opts.cursorReset;
            }

            if (full)
                pageBlock = pageBlockEls = null;

            if (opts.fadeOut) {
                count = els.length;
                els.stop().fadeOut(opts.fadeOut, function () {
                    if (--count === 0)
                        reset(els, data, opts, el);
                });
            }
            else
                reset(els, data, opts, el);
        }

        // move blocking element back into the DOM where it started
        function reset(els, data, opts, el) {
            var $el = $(el);
            if ($el.data('blockUI.isBlocked'))
                return;

            els.each(function (i, o) {
                // remove via DOM calls so we don't lose event handlers
                if (this.parentNode)
                    this.parentNode.removeChild(this);
            });

            if (data && data.el) {
                data.el.style.display = data.display;
                data.el.style.position = data.position;
                if (data.parent)
                    data.parent.appendChild(data.el);
                $el.removeData('blockUI.history');
            }

            if ($el.data('blockUI.static')) {
                $el.css('position', 'static'); // #22
            }

            if (typeof opts.onUnblock == 'function')
                opts.onUnblock(el, opts);

            // fix issue in Safari 6 where block artifacts remain until reflow
            var body = $(document.body), w = body.width(), cssW = body[0].style.width;
            body.width(w - 1).width(w);
            body[0].style.width = cssW;
        }

        // bind/unbind the handler
        function bind(b, el, opts) {
            var full = el == window, $el = $(el);

            // don't bother unbinding if there is nothing to unbind
            if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
                return;

            $el.data('blockUI.isBlocked', b);

            // don't bind events when overlay is not in use or if bindEvents is false
            if (!full || !opts.bindEvents || (b && !opts.showOverlay))
                return;

            // bind anchors and inputs for mouse and key events
            var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
            if (b)
                $(document).bind(events, opts, handler);
            else
                $(document).unbind(events, handler);

            // former impl...
            //		var $e = $('a,:input');
            //		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
        }

        // event handler to suppress keyboard/mouse events when blocking
        function handler(e) {
            // allow tab navigation (conditionally)
            if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
                if (pageBlock && e.data.constrainTabKey) {
                    var els = pageBlockEls;
                    var fwd = !e.shiftKey && e.target === els[els.length - 1];
                    var back = e.shiftKey && e.target === els[0];
                    if (fwd || back) {
                        setTimeout(function () {
                            focus(back);
                        }, 10);
                        return false;
                    }
                }
            }
            var opts = e.data;
            var target = $(e.target);
            if (target.hasClass('blockOverlay') && opts.onOverlayClick)
                opts.onOverlayClick();

            // allow events within the message content
            if (target.parents('div.' + opts.blockMsgClass).length > 0)
                return true;

            // allow events for content that is not being blocked
            return target.parents().children().filter('div.blockUI').length === 0;
        }

        function focus(back) {
            if (!pageBlockEls)
                return;
            var e = pageBlockEls[back === true ? pageBlockEls.length - 1 : 0];
            if (e)
                e.focus();
        }

        function center(el, x, y) {
            var p = el.parentNode, s = el.style;
            var l = ((p.offsetWidth - el.offsetWidth) / 2) - sz(p, 'borderLeftWidth');
            var t = ((p.offsetHeight - el.offsetHeight) / 2) - sz(p, 'borderTopWidth');
            if (x) s.left = l > 0 ? (l + 'px') : '0';
            if (y) s.top = t > 0 ? (t + 'px') : '0';
        }

        function sz(el, p) {
            return parseInt($.css(el, p), 10) || 0;
        }

    }


    /*global define:true */
    if (typeof define === 'function' && define.amd && define.amd.jQuery) {
        define(['jquery'], setup);
    } else {
        setup(jQuery);
    }

})();
},{}],338:[function(require,module,exports){
/*
 == malihu jquery custom scrollbars plugin ==
 version: 2.8.2
 author: malihu (http://manos.malihu.gr)
 plugin home: http://manos.malihu.gr/jquery-custom-content-scroller
 */

/*
 Copyright 2010-2013 Manos Malihutsakis

 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 any later version.

 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with this program.  If not, see http://www.gnu.org/licenses/lgpl.html.
 */
(function($){
    /*plugin script*/
    var methods={
            init:function(options){
                var defaults={
                        set_width:false, /*optional element width: boolean, pixels, percentage*/
                        set_height:false, /*optional element height: boolean, pixels, percentage*/
                        horizontalScroll:false, /*scroll horizontally: boolean*/
                        scrollInertia:950, /*scrolling inertia: integer (milliseconds)*/
                        mouseWheel:true, /*mousewheel support: boolean*/
                        mouseWheelPixels:"auto", /*mousewheel pixels amount: integer, "auto"*/
                        autoDraggerLength:true, /*auto-adjust scrollbar dragger length: boolean*/
                        autoHideScrollbar:false, /*auto-hide scrollbar when idle*/
                        snapAmount:null, /* optional element always snaps to a multiple of this number in pixels */
                        snapOffset:0, /* when snapping, snap with this number in pixels as an offset */
                        scrollButtons:{ /*scroll buttons*/
                            enable:false, /*scroll buttons support: boolean*/
                            scrollType:"continuous", /*scroll buttons scrolling type: "continuous", "pixels"*/
                            scrollSpeed:"auto", /*scroll buttons continuous scrolling speed: integer, "auto"*/
                            scrollAmount:40 /*scroll buttons pixels scroll amount: integer (pixels)*/
                        },
                        advanced:{
                            updateOnBrowserResize:true, /*update scrollbars on browser resize (for layouts based on percentages): boolean*/
                            updateOnContentResize:false, /*auto-update scrollbars on content resize (for dynamic content): boolean*/
                            autoExpandHorizontalScroll:false, /*auto-expand width for horizontal scrolling: boolean*/
                            autoScrollOnFocus:true, /*auto-scroll on focused elements: boolean*/
                            normalizeMouseWheelDelta:false /*normalize mouse-wheel delta (-1/1)*/
                        },
                        contentTouchScroll:true, /*scrolling by touch-swipe content: boolean*/
                        callbacks:{
                            onScrollStart:function(){}, /*user custom callback function on scroll start event*/
                            onScroll:function(){}, /*user custom callback function on scroll event*/
                            onTotalScroll:function(){}, /*user custom callback function on scroll end reached event*/
                            onTotalScrollBack:function(){}, /*user custom callback function on scroll begin reached event*/
                            onTotalScrollOffset:0, /*scroll end reached offset: integer (pixels)*/
                            onTotalScrollBackOffset:0, /*scroll begin reached offset: integer (pixels)*/
                            whileScrolling:function(){} /*user custom callback function on scrolling event*/
                        },
                        theme:"light" /*"light", "dark", "light-2", "dark-2", "light-thick", "dark-thick", "light-thin", "dark-thin"*/
                    },
                    options=$.extend(true,defaults,options);
                return this.each(function(){
                    var $this=$(this);
                    /*set element width/height, create markup for custom scrollbars, add classes*/
                    if(options.set_width){
                        $this.css("width",options.set_width);
                    }
                    if(options.set_height){
                        $this.css("height",options.set_height);
                    }
                    if(!$(document).data("mCustomScrollbar-index")){
                        $(document).data("mCustomScrollbar-index","1");
                    }else{
                        var mCustomScrollbarIndex=parseInt($(document).data("mCustomScrollbar-index"));
                        $(document).data("mCustomScrollbar-index",mCustomScrollbarIndex+1);
                    }
                    $this.wrapInner("<div class='mCustomScrollBox"+" mCS-"+options.theme+"' id='mCSB_"+$(document).data("mCustomScrollbar-index")+"' style='position:relative; height:100%; overflow:hidden; max-width:100%;' />").addClass("mCustomScrollbar _mCS_"+$(document).data("mCustomScrollbar-index"));
                    var mCustomScrollBox=$this.children(".mCustomScrollBox");
                    if(options.horizontalScroll){
                        mCustomScrollBox.addClass("mCSB_horizontal").wrapInner("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />");
                        var mCSB_h_wrapper=mCustomScrollBox.children(".mCSB_h_wrapper");
                        mCSB_h_wrapper.wrapInner("<div class='mCSB_container' style='position:absolute; left:0;' />").children(".mCSB_container").css({"width":mCSB_h_wrapper.children().outerWidth(),"position":"relative"}).unwrap();
                    }else{
                        mCustomScrollBox.wrapInner("<div class='mCSB_container' style='position:relative; top:0;' />");
                    }
                    var mCSB_container=mCustomScrollBox.children(".mCSB_container");
                    if($.support.touch){
                        mCSB_container.addClass("mCS_touch");
                    }
                    mCSB_container.after("<div class='mCSB_scrollTools' style='position:absolute;'><div class='mCSB_draggerContainer'><div class='mCSB_dragger' style='position:absolute;' oncontextmenu='return false;'><div class='mCSB_dragger_bar' style='position:relative;'></div></div><div class='mCSB_draggerRail'></div></div></div>");
                    var mCSB_scrollTools=mCustomScrollBox.children(".mCSB_scrollTools"),
                        mCSB_draggerContainer=mCSB_scrollTools.children(".mCSB_draggerContainer"),
                        mCSB_dragger=mCSB_draggerContainer.children(".mCSB_dragger");
                    if(options.horizontalScroll){
                        mCSB_dragger.data("minDraggerWidth",mCSB_dragger.width());
                    }else{
                        mCSB_dragger.data("minDraggerHeight",mCSB_dragger.height());
                    }
                    if(options.scrollButtons.enable){
                        if(options.horizontalScroll){
                            mCSB_scrollTools.prepend("<a class='mCSB_buttonLeft' oncontextmenu='return false;'></a>").append("<a class='mCSB_buttonRight' oncontextmenu='return false;'></a>");
                        }else{
                            mCSB_scrollTools.prepend("<a class='mCSB_buttonUp' oncontextmenu='return false;'></a>").append("<a class='mCSB_buttonDown' oncontextmenu='return false;'></a>");
                        }
                    }
                    /*mCustomScrollBox scrollTop and scrollLeft is always 0 to prevent browser focus scrolling*/
                    mCustomScrollBox.bind("scroll",function(){
                        if(!$this.is(".mCS_disabled")){ /*native focus scrolling for disabled scrollbars*/
                            mCustomScrollBox.scrollTop(0).scrollLeft(0);
                        }
                    });
                    /*store options, global vars/states, intervals*/
                    $this.data({
                        /*init state*/
                        "mCS_Init":true,
                        /*instance index*/
                        "mCustomScrollbarIndex":$(document).data("mCustomScrollbar-index"),
                        /*option parameters*/
                        "horizontalScroll":options.horizontalScroll,
                        "scrollInertia":options.scrollInertia,
                        "scrollEasing":"mcsEaseOut",
                        "mouseWheel":options.mouseWheel,
                        "mouseWheelPixels":options.mouseWheelPixels,
                        "autoDraggerLength":options.autoDraggerLength,
                        "autoHideScrollbar":options.autoHideScrollbar,
                        "snapAmount":options.snapAmount,
                        "snapOffset":options.snapOffset,
                        "scrollButtons_enable":options.scrollButtons.enable,
                        "scrollButtons_scrollType":options.scrollButtons.scrollType,
                        "scrollButtons_scrollSpeed":options.scrollButtons.scrollSpeed,
                        "scrollButtons_scrollAmount":options.scrollButtons.scrollAmount,
                        "autoExpandHorizontalScroll":options.advanced.autoExpandHorizontalScroll,
                        "autoScrollOnFocus":options.advanced.autoScrollOnFocus,
                        "normalizeMouseWheelDelta":options.advanced.normalizeMouseWheelDelta,
                        "contentTouchScroll":options.contentTouchScroll,
                        "onScrollStart_Callback":options.callbacks.onScrollStart,
                        "onScroll_Callback":options.callbacks.onScroll,
                        "onTotalScroll_Callback":options.callbacks.onTotalScroll,
                        "onTotalScrollBack_Callback":options.callbacks.onTotalScrollBack,
                        "onTotalScroll_Offset":options.callbacks.onTotalScrollOffset,
                        "onTotalScrollBack_Offset":options.callbacks.onTotalScrollBackOffset,
                        "whileScrolling_Callback":options.callbacks.whileScrolling,
                        /*events binding state*/
                        "bindEvent_scrollbar_drag":false,
                        "bindEvent_content_touch":false,
                        "bindEvent_scrollbar_click":false,
                        "bindEvent_mousewheel":false,
                        "bindEvent_buttonsContinuous_y":false,
                        "bindEvent_buttonsContinuous_x":false,
                        "bindEvent_buttonsPixels_y":false,
                        "bindEvent_buttonsPixels_x":false,
                        "bindEvent_focusin":false,
                        "bindEvent_autoHideScrollbar":false,
                        /*buttons intervals*/
                        "mCSB_buttonScrollRight":false,
                        "mCSB_buttonScrollLeft":false,
                        "mCSB_buttonScrollDown":false,
                        "mCSB_buttonScrollUp":false
                    });
                    /*max-width/max-height*/
                    if(options.horizontalScroll){
                        if($this.css("max-width")!=="none"){
                            if(!options.advanced.updateOnContentResize){ /*needs updateOnContentResize*/
                                options.advanced.updateOnContentResize=true;
                            }
                        }
                    }else{
                        if($this.css("max-height")!=="none"){
                            var percentage=false,maxHeight=parseInt($this.css("max-height"));
                            if($this.css("max-height").indexOf("%")>=0){
                                percentage=maxHeight,
                                    maxHeight=$this.parent().height()*percentage/100;
                            }
                            $this.css("overflow","hidden");
                            mCustomScrollBox.css("max-height",maxHeight);
                        }
                    }
                    $this.mCustomScrollbar("update");
                    /*window resize fn (for layouts based on percentages)*/
                    if(options.advanced.updateOnBrowserResize){
                        var mCSB_resizeTimeout,currWinWidth=$(window).width(),currWinHeight=$(window).height();
                        $(window).bind("resize."+$this.data("mCustomScrollbarIndex"),function(){
                            if(mCSB_resizeTimeout){
                                clearTimeout(mCSB_resizeTimeout);
                            }
                            mCSB_resizeTimeout=setTimeout(function(){
                                if(!$this.is(".mCS_disabled") && !$this.is(".mCS_destroyed")){
                                    var winWidth=$(window).width(),winHeight=$(window).height();
                                    if(currWinWidth!==winWidth || currWinHeight!==winHeight){ /*ie8 fix*/
                                        if($this.css("max-height")!=="none" && percentage){
                                            mCustomScrollBox.css("max-height",$this.parent().height()*percentage/100);
                                        }
                                        $this.mCustomScrollbar("update");
                                        currWinWidth=winWidth; currWinHeight=winHeight;
                                    }
                                }
                            },150);
                        });
                    }
                    /*content resize fn (for dynamically generated content)*/
                    if(options.advanced.updateOnContentResize){
                        var mCSB_onContentResize;
                        if(options.horizontalScroll){
                            var mCSB_containerOldSize=mCSB_container.outerWidth();
                        }else{
                            var mCSB_containerOldSize=mCSB_container.outerHeight();
                        }
                        mCSB_onContentResize=setInterval(function(){
                            if(options.horizontalScroll){
                                if(options.advanced.autoExpandHorizontalScroll){
                                    mCSB_container.css({"position":"absolute","width":"auto"}).wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />").css({"width":mCSB_container.outerWidth(),"position":"relative"}).unwrap();
                                }
                                var mCSB_containerNewSize=mCSB_container.outerWidth();
                            }else{
                                var mCSB_containerNewSize=mCSB_container.outerHeight();
                            }
                            if(mCSB_containerNewSize!=mCSB_containerOldSize){
                                $this.mCustomScrollbar("update");
                                mCSB_containerOldSize=mCSB_containerNewSize;
                            }
                        },300);
                    }
                });
            },
            update:function(){
                var $this=$(this),
                    mCustomScrollBox=$this.children(".mCustomScrollBox"),
                    mCSB_container=mCustomScrollBox.children(".mCSB_container");
                mCSB_container.removeClass("mCS_no_scrollbar");
                $this.removeClass("mCS_disabled mCS_destroyed");
                mCustomScrollBox.scrollTop(0).scrollLeft(0); /*reset scrollTop/scrollLeft to prevent browser focus scrolling*/
                var mCSB_scrollTools=mCustomScrollBox.children(".mCSB_scrollTools"),
                    mCSB_draggerContainer=mCSB_scrollTools.children(".mCSB_draggerContainer"),
                    mCSB_dragger=mCSB_draggerContainer.children(".mCSB_dragger");
                if($this.data("horizontalScroll")){
                    var mCSB_buttonLeft=mCSB_scrollTools.children(".mCSB_buttonLeft"),
                        mCSB_buttonRight=mCSB_scrollTools.children(".mCSB_buttonRight"),
                        mCustomScrollBoxW=mCustomScrollBox.width();
                    if($this.data("autoExpandHorizontalScroll")){
                        mCSB_container.css({"position":"absolute","width":"auto"}).wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />").css({"width":mCSB_container.outerWidth(),"position":"relative"}).unwrap();
                    }
                    var mCSB_containerW=mCSB_container.outerWidth();
                }else{
                    var mCSB_buttonUp=mCSB_scrollTools.children(".mCSB_buttonUp"),
                        mCSB_buttonDown=mCSB_scrollTools.children(".mCSB_buttonDown"),
                        mCustomScrollBoxH=mCustomScrollBox.height(),
                        mCSB_containerH=mCSB_container.outerHeight();
                }
                if(mCSB_containerH>mCustomScrollBoxH && !$this.data("horizontalScroll")){ /*content needs vertical scrolling*/
                    mCSB_scrollTools.css("display","block");
                    var mCSB_draggerContainerH=mCSB_draggerContainer.height();
                    /*auto adjust scrollbar dragger length analogous to content*/
                    if($this.data("autoDraggerLength")){
                        var draggerH=Math.round(mCustomScrollBoxH/mCSB_containerH*mCSB_draggerContainerH),
                            minDraggerH=mCSB_dragger.data("minDraggerHeight");
                        if(draggerH<=minDraggerH){ /*min dragger height*/
                            mCSB_dragger.css({"height":minDraggerH});
                        }else if(draggerH>=mCSB_draggerContainerH-10){ /*max dragger height*/
                            var mCSB_draggerContainerMaxH=mCSB_draggerContainerH-10;
                            mCSB_dragger.css({"height":mCSB_draggerContainerMaxH});
                        }else{
                            mCSB_dragger.css({"height":draggerH});
                        }
                        mCSB_dragger.children(".mCSB_dragger_bar").css({"line-height":mCSB_dragger.height()+"px"});
                    }
                    var mCSB_draggerH=mCSB_dragger.height(),
                    /*calculate and store scroll amount, add scrolling*/
                        scrollAmount=(mCSB_containerH-mCustomScrollBoxH)/(mCSB_draggerContainerH-mCSB_draggerH);
                    $this.data("scrollAmount",scrollAmount).mCustomScrollbar("scrolling",mCustomScrollBox,mCSB_container,mCSB_draggerContainer,mCSB_dragger,mCSB_buttonUp,mCSB_buttonDown,mCSB_buttonLeft,mCSB_buttonRight);
                    /*scroll*/
                    var mCSB_containerP=Math.abs(mCSB_container.position().top);
                    $this.mCustomScrollbar("scrollTo",mCSB_containerP,{scrollInertia:0,trigger:"internal"});
                }else if(mCSB_containerW>mCustomScrollBoxW && $this.data("horizontalScroll")){ /*content needs horizontal scrolling*/
                    mCSB_scrollTools.css("display","block");
                    var mCSB_draggerContainerW=mCSB_draggerContainer.width();
                    /*auto adjust scrollbar dragger length analogous to content*/
                    if($this.data("autoDraggerLength")){
                        var draggerW=Math.round(mCustomScrollBoxW/mCSB_containerW*mCSB_draggerContainerW),
                            minDraggerW=mCSB_dragger.data("minDraggerWidth");
                        if(draggerW<=minDraggerW){ /*min dragger height*/
                            mCSB_dragger.css({"width":minDraggerW});
                        }else if(draggerW>=mCSB_draggerContainerW-10){ /*max dragger height*/
                            var mCSB_draggerContainerMaxW=mCSB_draggerContainerW-10;
                            mCSB_dragger.css({"width":mCSB_draggerContainerMaxW});
                        }else{
                            mCSB_dragger.css({"width":draggerW});
                        }
                    }
                    var mCSB_draggerW=mCSB_dragger.width(),
                    /*calculate and store scroll amount, add scrolling*/
                        scrollAmount=(mCSB_containerW-mCustomScrollBoxW)/(mCSB_draggerContainerW-mCSB_draggerW);
                    $this.data("scrollAmount",scrollAmount).mCustomScrollbar("scrolling",mCustomScrollBox,mCSB_container,mCSB_draggerContainer,mCSB_dragger,mCSB_buttonUp,mCSB_buttonDown,mCSB_buttonLeft,mCSB_buttonRight);
                    /*scroll*/
                    var mCSB_containerP=Math.abs(mCSB_container.position().left);
                    $this.mCustomScrollbar("scrollTo",mCSB_containerP,{scrollInertia:0,trigger:"internal"});
                }else{ /*content does not need scrolling*/
                    /*unbind events, reset content position, hide scrollbars, remove classes*/
                    mCustomScrollBox.unbind("mousewheel focusin");
                    if($this.data("horizontalScroll")){
                        mCSB_dragger.add(mCSB_container).css("left",0);
                    }else{
                        mCSB_dragger.add(mCSB_container).css("top",0);
                    }
                    mCSB_scrollTools.css("display","none");
                    mCSB_container.addClass("mCS_no_scrollbar");
                    $this.data({"bindEvent_mousewheel":false,"bindEvent_focusin":false});
                }
            },
            scrolling:function(mCustomScrollBox,mCSB_container,mCSB_draggerContainer,mCSB_dragger,mCSB_buttonUp,mCSB_buttonDown,mCSB_buttonLeft,mCSB_buttonRight){
                var $this=$(this);
                /*scrollbar drag scrolling*/
                if(!$this.data("bindEvent_scrollbar_drag")){
                    var mCSB_draggerDragY,mCSB_draggerDragX;
                    if($.support.msPointer){ /*MSPointer*/
                        mCSB_dragger.bind("MSPointerDown",function(e){
                            e.preventDefault();
                            $this.data({"on_drag":true}); mCSB_dragger.addClass("mCSB_dragger_onDrag");
                            var elem=$(this),
                                elemOffset=elem.offset(),
                                x=e.originalEvent.pageX-elemOffset.left,
                                y=e.originalEvent.pageY-elemOffset.top;
                            if(x<elem.width() && x>0 && y<elem.height() && y>0){
                                mCSB_draggerDragY=y;
                                mCSB_draggerDragX=x;
                            }
                        });
                        $(document).bind("MSPointerMove."+$this.data("mCustomScrollbarIndex"),function(e){
                            e.preventDefault();
                            if($this.data("on_drag")){
                                var elem=mCSB_dragger,
                                    elemOffset=elem.offset(),
                                    x=e.originalEvent.pageX-elemOffset.left,
                                    y=e.originalEvent.pageY-elemOffset.top;
                                scrollbarDrag(mCSB_draggerDragY,mCSB_draggerDragX,y,x);
                            }
                        }).bind("MSPointerUp."+$this.data("mCustomScrollbarIndex"),function(e){
                                $this.data({"on_drag":false}); mCSB_dragger.removeClass("mCSB_dragger_onDrag");
                            });
                    }else{ /*mouse/touch*/
                        mCSB_dragger.bind("mousedown touchstart",function(e){
                            e.preventDefault(); e.stopImmediatePropagation();
                            var	elem=$(this),elemOffset=elem.offset(),x,y;
                            if(e.type==="touchstart"){
                                var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                                x=touch.pageX-elemOffset.left; y=touch.pageY-elemOffset.top;
                            }else{
                                $this.data({"on_drag":true}); mCSB_dragger.addClass("mCSB_dragger_onDrag");
                                x=e.pageX-elemOffset.left; y=e.pageY-elemOffset.top;
                            }
                            if(x<elem.width() && x>0 && y<elem.height() && y>0){
                                mCSB_draggerDragY=y; mCSB_draggerDragX=x;
                            }
                        }).bind("touchmove",function(e){
                                e.preventDefault(); e.stopImmediatePropagation();
                                var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
                                    elem=$(this),
                                    elemOffset=elem.offset(),
                                    x=touch.pageX-elemOffset.left,
                                    y=touch.pageY-elemOffset.top;
                                scrollbarDrag(mCSB_draggerDragY,mCSB_draggerDragX,y,x);
                            });
                        $(document).bind("mousemove."+$this.data("mCustomScrollbarIndex"),function(e){
                            if($this.data("on_drag")){
                                var elem=mCSB_dragger,
                                    elemOffset=elem.offset(),
                                    x=e.pageX-elemOffset.left,
                                    y=e.pageY-elemOffset.top;
                                scrollbarDrag(mCSB_draggerDragY,mCSB_draggerDragX,y,x);
                            }
                        }).bind("mouseup."+$this.data("mCustomScrollbarIndex"),function(e){
                                $this.data({"on_drag":false}); mCSB_dragger.removeClass("mCSB_dragger_onDrag");
                            });
                    }
                    $this.data({"bindEvent_scrollbar_drag":true});
                }
                function scrollbarDrag(mCSB_draggerDragY,mCSB_draggerDragX,y,x){
                    if($this.data("horizontalScroll")){
                        $this.mCustomScrollbar("scrollTo",(mCSB_dragger.position().left-(mCSB_draggerDragX))+x,{moveDragger:true,trigger:"internal"});
                    }else{
                        $this.mCustomScrollbar("scrollTo",(mCSB_dragger.position().top-(mCSB_draggerDragY))+y,{moveDragger:true,trigger:"internal"});
                    }
                }
                /*content touch-drag*/
                if($.support.touch && $this.data("contentTouchScroll")){
                    if(!$this.data("bindEvent_content_touch")){
                        var touch,
                            elem,elemOffset,y,x,mCSB_containerTouchY,mCSB_containerTouchX;
                        mCSB_container.bind("touchstart",function(e){
                            e.stopImmediatePropagation();
                            touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            elem=$(this);
                            elemOffset=elem.offset();
                            x=touch.pageX-elemOffset.left;
                            y=touch.pageY-elemOffset.top;
                            mCSB_containerTouchY=y;
                            mCSB_containerTouchX=x;
                        });
                        mCSB_container.bind("touchmove",function(e){
                            e.preventDefault(); e.stopImmediatePropagation();
                            touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                            elem=$(this).parent();
                            elemOffset=elem.offset();
                            x=touch.pageX-elemOffset.left;
                            y=touch.pageY-elemOffset.top;
                            if($this.data("horizontalScroll")){
                                $this.mCustomScrollbar("scrollTo",mCSB_containerTouchX-x,{trigger:"internal"});
                            }else{
                                $this.mCustomScrollbar("scrollTo",mCSB_containerTouchY-y,{trigger:"internal"});
                            }
                        });
                    }
                }
                /*dragger rail click scrolling*/
                if(!$this.data("bindEvent_scrollbar_click")){
                    mCSB_draggerContainer.bind("click",function(e){
                        var scrollToPos=(e.pageY-mCSB_draggerContainer.offset().top)*$this.data("scrollAmount"),target=$(e.target);
                        if($this.data("horizontalScroll")){
                            scrollToPos=(e.pageX-mCSB_draggerContainer.offset().left)*$this.data("scrollAmount");
                        }
                        if(target.hasClass("mCSB_draggerContainer") || target.hasClass("mCSB_draggerRail")){
                            $this.mCustomScrollbar("scrollTo",scrollToPos,{trigger:"internal",scrollEasing:"draggerRailEase"});
                        }
                    });
                    $this.data({"bindEvent_scrollbar_click":true});
                }
                /*mousewheel scrolling*/
                if($this.data("mouseWheel")){
                    if(!$this.data("bindEvent_mousewheel")){
                        mCustomScrollBox.bind("mousewheel",function(e,delta){
                            var scrollTo,mouseWheelPixels=$this.data("mouseWheelPixels"),absPos=Math.abs(mCSB_container.position().top),
                                draggerPos=mCSB_dragger.position().top,limit=mCSB_draggerContainer.height()-mCSB_dragger.height();
                            if($this.data("normalizeMouseWheelDelta")){
                                if(delta<0){delta=-1;}else{delta=1;}
                            }
                            if(mouseWheelPixels==="auto"){
                                mouseWheelPixels=100+Math.round($this.data("scrollAmount")/2);
                            }
                            if($this.data("horizontalScroll")){
                                draggerPos=mCSB_dragger.position().left;
                                limit=mCSB_draggerContainer.width()-mCSB_dragger.width();
                                absPos=Math.abs(mCSB_container.position().left);
                            }
                            if((delta>0 && draggerPos!==0) || (delta<0 && draggerPos!==limit)){e.preventDefault(); e.stopImmediatePropagation();}
                            scrollTo=absPos-(delta*mouseWheelPixels);
                            $this.mCustomScrollbar("scrollTo",scrollTo,{trigger:"internal"});
                        });
                        $this.data({"bindEvent_mousewheel":true});
                    }
                }
                /*buttons scrolling*/
                if($this.data("scrollButtons_enable")){
                    if($this.data("scrollButtons_scrollType")==="pixels"){ /*scroll by pixels*/
                        if($this.data("horizontalScroll")){
                            mCSB_buttonRight.add(mCSB_buttonLeft).unbind("mousedown touchstart MSPointerDown mouseup MSPointerUp mouseout MSPointerOut touchend",mCSB_buttonRight_stop,mCSB_buttonLeft_stop);
                            $this.data({"bindEvent_buttonsContinuous_x":false});
                            if(!$this.data("bindEvent_buttonsPixels_x")){
                                /*scroll right*/
                                mCSB_buttonRight.bind("click",function(e){
                                    e.preventDefault();
                                    PixelsScrollTo(Math.abs(mCSB_container.position().left)+$this.data("scrollButtons_scrollAmount"));
                                });
                                /*scroll left*/
                                mCSB_buttonLeft.bind("click",function(e){
                                    e.preventDefault();
                                    PixelsScrollTo(Math.abs(mCSB_container.position().left)-$this.data("scrollButtons_scrollAmount"));
                                });
                                $this.data({"bindEvent_buttonsPixels_x":true});
                            }
                        }else{
                            mCSB_buttonDown.add(mCSB_buttonUp).unbind("mousedown touchstart MSPointerDown mouseup MSPointerUp mouseout MSPointerOut touchend",mCSB_buttonRight_stop,mCSB_buttonLeft_stop);
                            $this.data({"bindEvent_buttonsContinuous_y":false});
                            if(!$this.data("bindEvent_buttonsPixels_y")){
                                /*scroll down*/
                                mCSB_buttonDown.bind("click",function(e){
                                    e.preventDefault();
                                    PixelsScrollTo(Math.abs(mCSB_container.position().top)+$this.data("scrollButtons_scrollAmount"));
                                });
                                /*scroll up*/
                                mCSB_buttonUp.bind("click",function(e){
                                    e.preventDefault();
                                    PixelsScrollTo(Math.abs(mCSB_container.position().top)-$this.data("scrollButtons_scrollAmount"));
                                });
                                $this.data({"bindEvent_buttonsPixels_y":true});
                            }
                        }
                        function PixelsScrollTo(to){
                            if(!mCSB_dragger.data("preventAction")){
                                mCSB_dragger.data("preventAction",true);
                                $this.mCustomScrollbar("scrollTo",to,{trigger:"internal"});
                            }
                        }
                    }else{ /*continuous scrolling*/
                        if($this.data("horizontalScroll")){
                            mCSB_buttonRight.add(mCSB_buttonLeft).unbind("click");
                            $this.data({"bindEvent_buttonsPixels_x":false});
                            if(!$this.data("bindEvent_buttonsContinuous_x")){
                                /*scroll right*/
                                mCSB_buttonRight.bind("mousedown touchstart MSPointerDown",function(e){
                                    e.preventDefault();
                                    var scrollButtonsSpeed=ScrollButtonsSpeed();
                                    $this.data({"mCSB_buttonScrollRight":setInterval(function(){
                                        $this.mCustomScrollbar("scrollTo",Math.abs(mCSB_container.position().left)+scrollButtonsSpeed,{trigger:"internal",scrollEasing:"easeOutCirc"});
                                    },17)});
                                });
                                var mCSB_buttonRight_stop=function(e){
                                    e.preventDefault(); clearInterval($this.data("mCSB_buttonScrollRight"));
                                }
                                mCSB_buttonRight.bind("mouseup touchend MSPointerUp mouseout MSPointerOut",mCSB_buttonRight_stop);
                                /*scroll left*/
                                mCSB_buttonLeft.bind("mousedown touchstart MSPointerDown",function(e){
                                    e.preventDefault();
                                    var scrollButtonsSpeed=ScrollButtonsSpeed();
                                    $this.data({"mCSB_buttonScrollLeft":setInterval(function(){
                                        $this.mCustomScrollbar("scrollTo",Math.abs(mCSB_container.position().left)-scrollButtonsSpeed,{trigger:"internal",scrollEasing:"easeOutCirc"});
                                    },17)});
                                });
                                var mCSB_buttonLeft_stop=function(e){
                                    e.preventDefault(); clearInterval($this.data("mCSB_buttonScrollLeft"));
                                }
                                mCSB_buttonLeft.bind("mouseup touchend MSPointerUp mouseout MSPointerOut",mCSB_buttonLeft_stop);
                                $this.data({"bindEvent_buttonsContinuous_x":true});
                            }
                        }else{
                            mCSB_buttonDown.add(mCSB_buttonUp).unbind("click");
                            $this.data({"bindEvent_buttonsPixels_y":false});
                            if(!$this.data("bindEvent_buttonsContinuous_y")){
                                /*scroll down*/
                                mCSB_buttonDown.bind("mousedown touchstart MSPointerDown",function(e){
                                    e.preventDefault();
                                    var scrollButtonsSpeed=ScrollButtonsSpeed();
                                    $this.data({"mCSB_buttonScrollDown":setInterval(function(){
                                        $this.mCustomScrollbar("scrollTo",Math.abs(mCSB_container.position().top)+scrollButtonsSpeed,{trigger:"internal",scrollEasing:"easeOutCirc"});
                                    },17)});
                                });
                                var mCSB_buttonDown_stop=function(e){
                                    e.preventDefault(); clearInterval($this.data("mCSB_buttonScrollDown"));
                                }
                                mCSB_buttonDown.bind("mouseup touchend MSPointerUp mouseout MSPointerOut",mCSB_buttonDown_stop);
                                /*scroll up*/
                                mCSB_buttonUp.bind("mousedown touchstart MSPointerDown",function(e){
                                    e.preventDefault();
                                    var scrollButtonsSpeed=ScrollButtonsSpeed();
                                    $this.data({"mCSB_buttonScrollUp":setInterval(function(){
                                        $this.mCustomScrollbar("scrollTo",Math.abs(mCSB_container.position().top)-scrollButtonsSpeed,{trigger:"internal",scrollEasing:"easeOutCirc"});
                                    },17)});
                                });
                                var mCSB_buttonUp_stop=function(e){
                                    e.preventDefault(); clearInterval($this.data("mCSB_buttonScrollUp"));
                                }
                                mCSB_buttonUp.bind("mouseup touchend MSPointerUp mouseout MSPointerOut",mCSB_buttonUp_stop);
                                $this.data({"bindEvent_buttonsContinuous_y":true});
                            }
                        }
                        function ScrollButtonsSpeed(){
                            var speed=$this.data("scrollButtons_scrollSpeed");
                            if($this.data("scrollButtons_scrollSpeed")==="auto"){
                                speed=Math.round(($this.data("scrollInertia")+100)/40);
                            }
                            return speed;
                        }
                    }
                }
                /*scrolling on element focus (e.g. via TAB key)*/
                if($this.data("autoScrollOnFocus")){
                    if(!$this.data("bindEvent_focusin")){
                        mCustomScrollBox.bind("focusin",function(){
                            mCustomScrollBox.scrollTop(0).scrollLeft(0);
                            var focusedElem=$(document.activeElement);
                            if(focusedElem.is("input,textarea,select,button,a[tabindex],area,object")){
                                var mCSB_containerPos=mCSB_container.position().top,
                                    focusedElemPos=focusedElem.position().top,
                                    visibleLimit=mCustomScrollBox.height()-focusedElem.outerHeight();
                                if($this.data("horizontalScroll")){
                                    mCSB_containerPos=mCSB_container.position().left;
                                    focusedElemPos=focusedElem.position().left;
                                    visibleLimit=mCustomScrollBox.width()-focusedElem.outerWidth();
                                }
                                if(mCSB_containerPos+focusedElemPos<0 || mCSB_containerPos+focusedElemPos>visibleLimit){
                                    $this.mCustomScrollbar("scrollTo",focusedElemPos,{trigger:"internal"});
                                }
                            }
                        });
                        $this.data({"bindEvent_focusin":true});
                    }
                }
                /*auto-hide scrollbar*/
                if($this.data("autoHideScrollbar")){
                    if(!$this.data("bindEvent_autoHideScrollbar")){
                        mCustomScrollBox.bind("mouseenter",function(e){
                            mCustomScrollBox.addClass("mCS-mouse-over");
                            functions.showScrollbar.call(mCustomScrollBox.children(".mCSB_scrollTools"));
                        }).bind("mouseleave touchend",function(e){
                                mCustomScrollBox.removeClass("mCS-mouse-over");
                                if(e.type==="mouseleave"){functions.hideScrollbar.call(mCustomScrollBox.children(".mCSB_scrollTools"));}
                            });
                        $this.data({"bindEvent_autoHideScrollbar":true});
                    }
                }
            },
            scrollTo:function(scrollTo,options){
                var $this=$(this),
                    defaults={
                        moveDragger:false,
                        trigger:"external",
                        callbacks:true,
                        scrollInertia:$this.data("scrollInertia"),
                        scrollEasing:$this.data("scrollEasing")
                    },
                    options=$.extend(defaults,options),
                    draggerScrollTo,
                    mCustomScrollBox=$this.children(".mCustomScrollBox"),
                    mCSB_container=mCustomScrollBox.children(".mCSB_container"),
                    mCSB_scrollTools=mCustomScrollBox.children(".mCSB_scrollTools"),
                    mCSB_draggerContainer=mCSB_scrollTools.children(".mCSB_draggerContainer"),
                    mCSB_dragger=mCSB_draggerContainer.children(".mCSB_dragger"),
                    contentSpeed=draggerSpeed=options.scrollInertia,
                    scrollBeginning,scrollBeginningOffset,totalScroll,totalScrollOffset;
                if(!mCSB_container.hasClass("mCS_no_scrollbar")){
                    $this.data({"mCS_trigger":options.trigger});
                    if($this.data("mCS_Init")){options.callbacks=false;}
                    if(scrollTo || scrollTo===0){
                        if(typeof(scrollTo)==="number"){ /*if integer, scroll by number of pixels*/
                            if(options.moveDragger){ /*scroll dragger*/
                                draggerScrollTo=scrollTo;
                                if($this.data("horizontalScroll")){
                                    scrollTo=mCSB_dragger.position().left*$this.data("scrollAmount");
                                }else{
                                    scrollTo=mCSB_dragger.position().top*$this.data("scrollAmount");
                                }
                                draggerSpeed=0;
                            }else{ /*scroll content by default*/
                                draggerScrollTo=scrollTo/$this.data("scrollAmount");
                            }
                        }else if(typeof(scrollTo)==="string"){ /*if string, scroll by element position*/
                            var target;
                            if(scrollTo==="top"){ /*scroll to top*/
                                target=0;
                            }else if(scrollTo==="bottom" && !$this.data("horizontalScroll")){ /*scroll to bottom*/
                                target=mCSB_container.outerHeight()-mCustomScrollBox.height();
                            }else if(scrollTo==="left"){ /*scroll to left*/
                                target=0;
                            }else if(scrollTo==="right" && $this.data("horizontalScroll")){ /*scroll to right*/
                                target=mCSB_container.outerWidth()-mCustomScrollBox.width();
                            }else if(scrollTo==="first"){ /*scroll to first element position*/
                                target=$this.find(".mCSB_container").find(":first");
                            }else if(scrollTo==="last"){ /*scroll to last element position*/
                                target=$this.find(".mCSB_container").find(":last");
                            }else{ /*scroll to element position*/
                                target=$this.find(scrollTo);
                            }
                            if(target.length===1){ /*if such unique element exists, scroll to it*/
                                if($this.data("horizontalScroll")){
                                    scrollTo=target.position().left;
                                }else{
                                    scrollTo=target.position().top;
                                }
                                draggerScrollTo=scrollTo/$this.data("scrollAmount");
                            }else{
                                draggerScrollTo=scrollTo=target;
                            }
                        }
                        /*scroll to*/
                        if($this.data("horizontalScroll")){
                            if($this.data("onTotalScrollBack_Offset")){ /*scroll beginning offset*/
                                scrollBeginningOffset=-$this.data("onTotalScrollBack_Offset");
                            }
                            if($this.data("onTotalScroll_Offset")){ /*total scroll offset*/
                                totalScrollOffset=mCustomScrollBox.width()-mCSB_container.outerWidth()+$this.data("onTotalScroll_Offset");
                            }
                            if(draggerScrollTo<0){ /*scroll start position*/
                                draggerScrollTo=scrollTo=0; clearInterval($this.data("mCSB_buttonScrollLeft"));
                                if(!scrollBeginningOffset){scrollBeginning=true;}
                            }else if(draggerScrollTo>=mCSB_draggerContainer.width()-mCSB_dragger.width()){ /*scroll end position*/
                                draggerScrollTo=mCSB_draggerContainer.width()-mCSB_dragger.width();
                                scrollTo=mCustomScrollBox.width()-mCSB_container.outerWidth(); clearInterval($this.data("mCSB_buttonScrollRight"));
                                if(!totalScrollOffset){totalScroll=true;}
                            }else{scrollTo=-scrollTo;}
                            var snapAmount = $this.data("snapAmount");
                            if (snapAmount) {
                                scrollTo = Math.round(scrollTo / snapAmount) * snapAmount - $this.data("snapOffset");
                            }
                            /*scrolling animation*/
                            functions.mTweenAxis.call(this,mCSB_dragger[0],"left",Math.round(draggerScrollTo),draggerSpeed,options.scrollEasing);
                            functions.mTweenAxis.call(this,mCSB_container[0],"left",Math.round(scrollTo),contentSpeed,options.scrollEasing,{
                                onStart:function(){
                                    if(options.callbacks && !$this.data("mCS_tweenRunning")){callbacks("onScrollStart");}
                                    if($this.data("autoHideScrollbar")){functions.showScrollbar.call(mCSB_scrollTools);}
                                },
                                onUpdate:function(){
                                    if(options.callbacks){callbacks("whileScrolling");}
                                },
                                onComplete:function(){
                                    if(options.callbacks){
                                        callbacks("onScroll");
                                        if(scrollBeginning || (scrollBeginningOffset && mCSB_container.position().left>=scrollBeginningOffset)){callbacks("onTotalScrollBack");}
                                        if(totalScroll || (totalScrollOffset && mCSB_container.position().left<=totalScrollOffset)){callbacks("onTotalScroll");}
                                    }
                                    mCSB_dragger.data("preventAction",false); $this.data("mCS_tweenRunning",false);
                                    if($this.data("autoHideScrollbar")){if(!mCustomScrollBox.hasClass("mCS-mouse-over")){functions.hideScrollbar.call(mCSB_scrollTools);}}
                                }
                            });
                        }else{
                            if($this.data("onTotalScrollBack_Offset")){ /*scroll beginning offset*/
                                scrollBeginningOffset=-$this.data("onTotalScrollBack_Offset");
                            }
                            if($this.data("onTotalScroll_Offset")){ /*total scroll offset*/
                                totalScrollOffset=mCustomScrollBox.height()-mCSB_container.outerHeight()+$this.data("onTotalScroll_Offset");
                            }
                            if(draggerScrollTo<0){ /*scroll start position*/
                                draggerScrollTo=scrollTo=0; clearInterval($this.data("mCSB_buttonScrollUp"));
                                if(!scrollBeginningOffset){scrollBeginning=true;}
                            }else if(draggerScrollTo>=mCSB_draggerContainer.height()-mCSB_dragger.height()){ /*scroll end position*/
                                draggerScrollTo=mCSB_draggerContainer.height()-mCSB_dragger.height();
                                scrollTo=mCustomScrollBox.height()-mCSB_container.outerHeight(); clearInterval($this.data("mCSB_buttonScrollDown"));
                                if(!totalScrollOffset){totalScroll=true;}
                            }else{scrollTo=-scrollTo;}
                            var snapAmount = $this.data("snapAmount");
                            if (snapAmount) {
                                scrollTo = Math.round(scrollTo / snapAmount) * snapAmount - $this.data("snapOffset");
                            }
                            /*scrolling animation*/
                            functions.mTweenAxis.call(this,mCSB_dragger[0],"top",Math.round(draggerScrollTo),draggerSpeed,options.scrollEasing);
                            functions.mTweenAxis.call(this,mCSB_container[0],"top",Math.round(scrollTo),contentSpeed,options.scrollEasing,{
                                onStart:function(){
                                    if(options.callbacks && !$this.data("mCS_tweenRunning")){callbacks("onScrollStart");}
                                    if($this.data("autoHideScrollbar")){functions.showScrollbar.call(mCSB_scrollTools);}
                                },
                                onUpdate:function(){
                                    if(options.callbacks){callbacks("whileScrolling");}
                                },
                                onComplete:function(){
                                    if(options.callbacks){
                                        callbacks("onScroll");
                                        if(scrollBeginning || (scrollBeginningOffset && mCSB_container.position().top>=scrollBeginningOffset)){callbacks("onTotalScrollBack");}
                                        if(totalScroll || (totalScrollOffset && mCSB_container.position().top<=totalScrollOffset)){callbacks("onTotalScroll");}
                                    }
                                    mCSB_dragger.data("preventAction",false); $this.data("mCS_tweenRunning",false);
                                    if($this.data("autoHideScrollbar")){if(!mCustomScrollBox.hasClass("mCS-mouse-over")){functions.hideScrollbar.call(mCSB_scrollTools);}}
                                }
                            });
                        }
                        if($this.data("mCS_Init")){$this.data({"mCS_Init":false});}
                    }
                }
                /*callbacks*/
                function callbacks(cb){
                    this.mcs={
                        top:mCSB_container.position().top,left:mCSB_container.position().left,
                        draggerTop:mCSB_dragger.position().top,draggerLeft:mCSB_dragger.position().left,
                        topPct:Math.round((100*Math.abs(mCSB_container.position().top))/Math.abs(mCSB_container.outerHeight()-mCustomScrollBox.height())),
                        leftPct:Math.round((100*Math.abs(mCSB_container.position().left))/Math.abs(mCSB_container.outerWidth()-mCustomScrollBox.width()))
                    };
                    switch(cb){
                        /*start scrolling callback*/
                        case "onScrollStart":
                            $this.data("mCS_tweenRunning",true).data("onScrollStart_Callback").call($this,this.mcs);
                            break;
                        case "whileScrolling":
                            $this.data("whileScrolling_Callback").call($this,this.mcs);
                            break;
                        case "onScroll":
                            $this.data("onScroll_Callback").call($this,this.mcs);
                            break;
                        case "onTotalScrollBack":
                            $this.data("onTotalScrollBack_Callback").call($this,this.mcs);
                            break;
                        case "onTotalScroll":
                            $this.data("onTotalScroll_Callback").call($this,this.mcs);
                            break;
                    }
                }
            },
            stop:function(){
                var $this=$(this),
                    mCSB_container=$this.children().children(".mCSB_container"),
                    mCSB_dragger=$this.children().children().children().children(".mCSB_dragger");
                functions.mTweenAxisStop.call(this,mCSB_container[0]);
                functions.mTweenAxisStop.call(this,mCSB_dragger[0]);
            },
            disable:function(resetScroll){
                var $this=$(this),
                    mCustomScrollBox=$this.children(".mCustomScrollBox"),
                    mCSB_container=mCustomScrollBox.children(".mCSB_container"),
                    mCSB_scrollTools=mCustomScrollBox.children(".mCSB_scrollTools"),
                    mCSB_dragger=mCSB_scrollTools.children().children(".mCSB_dragger");
                mCustomScrollBox.unbind("mousewheel focusin mouseenter mouseleave touchend");
                mCSB_container.unbind("touchstart touchmove")
                if(resetScroll){
                    if($this.data("horizontalScroll")){
                        mCSB_dragger.add(mCSB_container).css("left",0);
                    }else{
                        mCSB_dragger.add(mCSB_container).css("top",0);
                    }
                }
                mCSB_scrollTools.css("display","none");
                mCSB_container.addClass("mCS_no_scrollbar");
                $this.data({"bindEvent_mousewheel":false,"bindEvent_focusin":false,"bindEvent_content_touch":false,"bindEvent_autoHideScrollbar":false}).addClass("mCS_disabled");
            },
            destroy:function(){
                var $this=$(this);
                $this.removeClass("mCustomScrollbar _mCS_"+$this.data("mCustomScrollbarIndex")).addClass("mCS_destroyed").children().children(".mCSB_container").unwrap().children().unwrap().siblings(".mCSB_scrollTools").remove();
                $(document).unbind("mousemove."+$this.data("mCustomScrollbarIndex")+" mouseup."+$this.data("mCustomScrollbarIndex")+" MSPointerMove."+$this.data("mCustomScrollbarIndex")+" MSPointerUp."+$this.data("mCustomScrollbarIndex"));
                $(window).unbind("resize."+$this.data("mCustomScrollbarIndex"));
            }
        },
        functions={
            /*hide/show scrollbar*/
            showScrollbar:function(){
                this.stop().animate({opacity:1},"fast");
            },
            hideScrollbar:function(){
                this.stop().animate({opacity:0},"fast");
            },
            /*js animation tween*/
            mTweenAxis:function(el,prop,to,duration,easing,callbacks){
                var callbacks=callbacks || {},
                    onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){};
                var startTime=_getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style;
                if(prop==="left"){from=el.offsetLeft;}
                var diff=to-from;
                _cancelTween();
                _startTween();
                function _getTime(){
                    if(window.performance && window.performance.now){
                        return window.performance.now();
                    }else{
                        if(window.performance && window.performance.webkitNow){
                            return window.performance.webkitNow();
                        }else{
                            if(Date.now){return Date.now();}else{return new Date().getTime();}
                        }
                    }
                }
                function _step(){
                    if(!progress){onStart.call();}
                    progress=_getTime()-startTime;
                    _tween();
                    if(progress>=el._time){
                        el._time=(progress>el._time) ? progress+_delay-(progress- el._time) : progress+_delay-1;
                        if(el._time<progress+1){el._time=progress+1;}
                    }
                    if(el._time<duration){el._id=_request(_step);}else{onComplete.call();}
                }
                function _tween(){
                    if(duration>0){
                        el.currVal=_ease(el._time,from,diff,duration,easing);
                        elStyle[prop]=Math.round(el.currVal)+"px";
                    }else{
                        elStyle[prop]=to+"px";
                    }
                    onUpdate.call();
                }
                function _startTween(){
                    _delay=1000/60;
                    el._time=progress+_delay;
                    _request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
                    el._id=_request(_step);
                }
                function _cancelTween(){
                    if(el._id==null){return;}
                    if(!window.requestAnimationFrame){clearTimeout(el._id);
                    }else{window.cancelAnimationFrame(el._id);}
                    el._id=null;
                }
                function _ease(t,b,c,d,type){
                    switch(type){
                        case "linear":
                            return c*t/d + b;
                            break;
                        case "easeOutQuad":
                            t /= d; return -c * t*(t-2) + b;
                            break;
                        case "easeInOutQuad":
                            t /= d/2;
                            if (t < 1) return c/2*t*t + b;
                            t--;
                            return -c/2 * (t*(t-2) - 1) + b;
                            break;
                        case "easeOutCubic":
                            t /= d; t--; return c*(t*t*t + 1) + b;
                            break;
                        case "easeOutQuart":
                            t /= d; t--; return -c * (t*t*t*t - 1) + b;
                            break;
                        case "easeOutQuint":
                            t /= d; t--; return c*(t*t*t*t*t + 1) + b;
                            break;
                        case "easeOutCirc":
                            t /= d; t--; return c * Math.sqrt(1 - t*t) + b;
                            break;
                        case "easeOutSine":
                            return c * Math.sin(t/d * (Math.PI/2)) + b;
                            break;
                        case "easeOutExpo":
                            return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
                            break;
                        case "mcsEaseOut":
                            var ts=(t/=d)*t,tc=ts*t;
                            return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
                            break;
                        case "draggerRailEase":
                            t /= d/2;
                            if (t < 1) return c/2*t*t*t + b;
                            t -= 2;
                            return c/2*(t*t*t + 2) + b;
                            break;
                    }
                }
            },
            /*stop js animation tweens*/
            mTweenAxisStop:function(el){
                if(el._id==null){return;}
                if(!window.requestAnimationFrame){clearTimeout(el._id);
                }else{window.cancelAnimationFrame(el._id);}
                el._id=null;
            },
            /*detect requestAnimationFrame and polyfill*/
            rafPolyfill:function(){
                var pfx=["ms","moz","webkit","o"],i=pfx.length;
                while(--i > -1 && !window.requestAnimationFrame){
                    window.requestAnimationFrame=window[pfx[i]+"RequestAnimationFrame"];
                    window.cancelAnimationFrame=window[pfx[i]+"CancelAnimationFrame"] || window[pfx[i]+"CancelRequestAnimationFrame"];
                }
            }
        }
    /*detect features*/
    functions.rafPolyfill.call(); /*requestAnimationFrame*/
    $.support.touch=!!('ontouchstart' in window); /*touch*/
    $.support.msPointer=window.navigator.msPointerEnabled; /*MSPointer support*/
    /*plugin dependencies*/
    var _dlp=("https:"==document.location.protocol) ? "https:" : "http:";
    $.event.special.mousewheel || document.write('<script src="'+_dlp+'//cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.0.6/jquery.mousewheel.min.js"><\/script>');
    /*plugin fn*/
    $.fn.mCustomScrollbar=function(method){
        if(methods[method]){
            return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
        }else if(typeof method==="object" || !method){
            return methods.init.apply(this,arguments);
        }else{
            $.error("Method "+method+" does not exist");
        }
    };
})(jQuery);
},{}],339:[function(require,module,exports){
/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 *
 * Requires: 1.2.2+
 */

(function($) {

    var types = ['DOMMouseScroll', 'mousewheel'];

    if ($.event.fixHooks) {
        for ( var i=types.length; i; ) {
            $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
        }
    }

    $.event.special.mousewheel = {
        setup: function() {
            if ( this.addEventListener ) {
                for ( var i=types.length; i; ) {
                    this.addEventListener( types[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i=types.length; i; ) {
                    this.removeEventListener( types[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
        },

        unmousewheel: function(fn) {
            return this.unbind("mousewheel", fn);
        }
    });                                              /*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 *
 * Requires: 1.2.2+
 */

(function($) {

var types = ['DOMMouseScroll', 'mousewheel'];

if ($.event.fixHooks) {
    for ( var i=types.length; i; ) {
        $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
    }
}

$.event.special.mousewheel = {
    setup: function() {
        if ( this.addEventListener ) {
            for ( var i=types.length; i; ) {
                this.addEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = handler;
        }
    },

    teardown: function() {
        if ( this.removeEventListener ) {
            for ( var i=types.length; i; ) {
                this.removeEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = null;
        }
    }
};

$.fn.extend({
    mousewheel: function(fn) {
        return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },

    unmousewheel: function(fn) {
        return this.unbind("mousewheel", fn);
    }
});


function handler(event) {
    var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";

    // Old school scrollwheel delta
    if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
    if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }

    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;

    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
        deltaY = 0;
        deltaX = -1*delta;
    }

    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
}

})(jQuery);


    function handler(event) {
        var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
        event = $.event.fix(orgEvent);
        event.type = "mousewheel";

        // Old school scrollwheel delta
        if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
        if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }

        // New school multidimensional scroll (touchpads) deltas
        deltaY = delta;

        // Gecko
        if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaY = 0;
            deltaX = -1*delta;
        }

        // Webkit
        if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
        if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

})(jQuery);
},{}],340:[function(require,module,exports){
/*! pace 0.4.10 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K,L=[].slice,M={}.hasOwnProperty,N=function(a,b){function c(){this.constructor=a}for(var d in b)M.call(b,d)&&(a[d]=b[d]);return c.prototype=b.prototype,a.prototype=new c,a.__super__=b.prototype,a},O=[].indexOf||function(a){for(var b=0,c=this.length;c>b;b++)if(b in this&&this[b]===a)return b;return-1};q={catchupTime:500,initialRate:.03,minTime:500,ghostTime:250,maxProgressPerFrame:10,easeFactor:1.25,startOnPageLoad:!0,restartOnPushState:!0,restartOnBackboneRoute:!0,target:"body",elements:{checkInterval:100,selectors:["body"]},eventLag:{minSamples:10},ajax:{trackMethods:["GET"],trackWebSockets:!0}},y=function(){var a;return null!=(a="undefined"!=typeof performance&&null!==performance?"function"==typeof performance.now?performance.now():void 0:void 0)?a:+new Date},A=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,p=window.cancelAnimationFrame||window.mozCancelAnimationFrame,null==A&&(A=function(a){return setTimeout(a,50)},p=function(a){return clearTimeout(a)}),C=function(a){var b,c;return b=y(),c=function(){var d;return d=y()-b,b=y(),a(d,function(){return A(c)})},c()},B=function(){var a,b,c;return c=arguments[0],b=arguments[1],a=3<=arguments.length?L.call(arguments,2):[],"function"==typeof c[b]?c[b].apply(c,a):c[b]},r=function(){var a,b,c,d,e,f,g;for(b=arguments[0],d=2<=arguments.length?L.call(arguments,1):[],f=0,g=d.length;g>f;f++)if(c=d[f])for(a in c)M.call(c,a)&&(e=c[a],null!=b[a]&&"object"==typeof b[a]&&null!=e&&"object"==typeof e?r(b[a],e):b[a]=e);return b},u=function(a,b){var c,d,e;if(null==a&&(a="options"),null==b&&(b=!0),e=document.querySelector("[data-pace-"+a+"]")){if(c=e.getAttribute("data-pace-"+a),!b)return c;try{return JSON.parse(c)}catch(f){return d=f,"undefined"!=typeof console&&null!==console?console.error("Error parsing inline pace options",d):void 0}}},null==window.Pace&&(window.Pace={}),z=Pace.options=r(q,window.paceOptions,u()),b=function(){function a(){this.progress=0}return a.prototype.getElement=function(){var a;return null==this.el&&(this.el=document.createElement("div"),this.el.className="pace pace-active",this.el.innerHTML='<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>',a=document.querySelector(z.target),null!=a.firstChild?a.insertBefore(this.el,a.firstChild):a.appendChild(this.el)),this.el},a.prototype.finish=function(){var a;return a=this.getElement(),a.className=a.className.replace("pace-active",""),a.className+=" pace-inactive"},a.prototype.update=function(a){return this.progress=a,this.render()},a.prototype.destroy=function(){return this.getElement().parentNode.removeChild(this.getElement()),this.el=void 0},a.prototype.render=function(){var a,b;return null==document.querySelector(z.target)?!1:(a=this.getElement(),a.children[0].style.width=""+this.progress+"%",(!this.lastRenderedProgress||0|(this.lastRenderedProgress|0!==this.progress))&&(a.setAttribute("data-progress-text",""+(0|this.progress)+"%"),this.progress>=100?b="99":(b=this.progress<10?"0":"",b+=0|this.progress),a.setAttribute("data-progress",""+b)),this.lastRenderedProgress=this.progress)},a.prototype.done=function(){return this.progress>=100},a}(),g=function(){function a(){this.bindings={}}return a.prototype.trigger=function(a,b){var c,d,e,f,g;if(null!=this.bindings[a]){for(f=this.bindings[a],g=[],d=0,e=f.length;e>d;d++)c=f[d],g.push(c.call(this,b));return g}},a.prototype.on=function(a,b){var c;return null==(c=this.bindings)[a]&&(c[a]=[]),this.bindings[a].push(b)},a}(),I=window.XMLHttpRequest,H=window.XDomainRequest,G=window.WebSocket,s=function(a,b){var c,d,e,f;f=[];for(d in b.prototype)try{e=b.prototype[d],null==a[d]&&"function"!=typeof e?f.push(a[d]=e):f.push(void 0)}catch(g){c=g}return f},h=function(a){function b(){var a,c=this;b.__super__.constructor.apply(this,arguments),a=function(a){var b;return b=a.open,a.open=function(d,e){var f;return f=(null!=d?d:"GET").toUpperCase(),O.call(z.ajax.trackMethods,f)>=0&&c.trigger("request",{type:d,url:e,request:a}),b.apply(a,arguments)}},window.XMLHttpRequest=function(b){var c;return c=new I(b),a(c),c},s(window.XMLHttpRequest,I),null!=H&&(window.XDomainRequest=function(){var b;return b=new H,a(b),b},s(window.XDomainRequest,H)),null!=G&&z.ajax.trackWebSockets&&(window.WebSocket=function(a,b){var d;return d=new G(a,b),c.trigger("request",{type:"socket",url:a,protocols:b,request:d}),d},s(window.WebSocket,G))}return N(b,a),b}(g),x=new h,a=function(){function a(){var a=this;this.elements=[],x.on("request",function(){return a.watch.apply(a,arguments)})}return a.prototype.watch=function(a){var b,c,d;return d=a.type,b=a.request,c="socket"===d?new k(b):new l(b),this.elements.push(c)},a}(),l=function(){function a(a){var b,c,d,e,f,g,h=this;if(this.progress=0,null!=window.ProgressEvent)for(c=null,a.addEventListener("progress",function(a){return h.progress=a.lengthComputable?100*a.loaded/a.total:h.progress+(100-h.progress)/2}),g=["load","abort","timeout","error"],d=0,e=g.length;e>d;d++)b=g[d],a.addEventListener(b,function(){return h.progress=100});else f=a.onreadystatechange,a.onreadystatechange=function(){var b;return 0===(b=a.readyState)||4===b?h.progress=100:3===a.readyState&&(h.progress=50),"function"==typeof f?f.apply(null,arguments):void 0}}return a}(),k=function(){function a(a){var b,c,d,e,f=this;for(this.progress=0,e=["error","open"],c=0,d=e.length;d>c;c++)b=e[c],a.addEventListener(b,function(){return f.progress=100})}return a}(),d=function(){function a(a){var b,c,d,f;for(null==a&&(a={}),this.elements=[],null==a.selectors&&(a.selectors=[]),f=a.selectors,c=0,d=f.length;d>c;c++)b=f[c],this.elements.push(new e(b))}return a}(),e=function(){function a(a){this.selector=a,this.progress=0,this.check()}return a.prototype.check=function(){var a=this;return document.querySelector(this.selector)?this.done():setTimeout(function(){return a.check()},z.elements.checkInterval)},a.prototype.done=function(){return this.progress=100},a}(),c=function(){function a(){var a,b,c=this;this.progress=null!=(b=this.states[document.readyState])?b:100,a=document.onreadystatechange,document.onreadystatechange=function(){return null!=c.states[document.readyState]&&(c.progress=c.states[document.readyState]),"function"==typeof a?a.apply(null,arguments):void 0}}return a.prototype.states={loading:0,interactive:50,complete:100},a}(),f=function(){function a(){var a,b,c,d=this;this.progress=0,a=0,c=0,b=y(),setInterval(function(){var e;return e=y()-b-50,b=y(),a+=(e-a)/15,c++>z.eventLag.minSamples&&Math.abs(a)<3&&(a=0),d.progress=100*(3/(a+3))},50)}return a}(),j=function(){function a(a){this.source=a,this.last=this.sinceLastUpdate=0,this.rate=z.initialRate,this.catchup=0,this.progress=this.lastProgress=0,null!=this.source&&(this.progress=B(this.source,"progress"))}return a.prototype.tick=function(a,b){var c;return null==b&&(b=B(this.source,"progress")),b>=100&&(this.done=!0),b===this.last?this.sinceLastUpdate+=a:(this.sinceLastUpdate&&(this.rate=(b-this.last)/this.sinceLastUpdate),this.catchup=(b-this.progress)/z.catchupTime,this.sinceLastUpdate=0,this.last=b),b>this.progress&&(this.progress+=this.catchup*a),c=1-Math.pow(this.progress/100,z.easeFactor),this.progress+=c*this.rate*a,this.progress=Math.min(this.lastProgress+z.maxProgressPerFrame,this.progress),this.progress=Math.max(0,this.progress),this.progress=Math.min(100,this.progress),this.lastProgress=this.progress,this.progress},a}(),E=null,D=null,n=null,F=null,m=null,o=null,v=function(){return z.restartOnPushState?Pace.restart():void 0},null!=window.history.pushState&&(J=window.history.pushState,window.history.pushState=function(){return v(),J.apply(window.history,arguments)}),null!=window.history.replaceState&&(K=window.history.replaceState,window.history.replaceState=function(){return v(),K.apply(window.history,arguments)}),t=!0,z.restartOnBackboneRoute&&setTimeout(function(){return null!=window.Backbone?Backbone.history.on("route",function(a,b){var c,d,e,f,g;if(d=z.restartOnBackboneRoute){if(t)return t=!1,void 0;if("object"==typeof d){for(g=[],e=0,f=d.length;f>e;e++)if(c=d[e],c===b){Pace.restart();break}return g}return Pace.restart()}}):void 0},0),i={ajax:a,elements:d,document:c,eventLag:f},(w=function(){var a,c,d,e,f,g,h,k,l;for(Pace.sources=E=[],h=["ajax","elements","document","eventLag"],d=0,f=h.length;f>d;d++)c=h[d],z[c]!==!1&&E.push(new i[c](z[c]));for(l=null!=(k=z.extraSources)?k:[],e=0,g=l.length;g>e;e++)a=l[e],E.push(new a(z));return Pace.bar=n=new b,D=[],F=new j})(),Pace.stop=function(){return n.destroy(),o=!0,null!=m&&("function"==typeof p&&p(m),m=null),w()},Pace.restart=function(){return Pace.stop(),Pace.go()},Pace.go=function(){return n.render(),o=!1,m=C(function(a,b){var c,d,e,f,g,h,i,k,l,m,p,q,r,s,t,u,v,w;for(k=100-n.progress,d=r=0,e=!0,h=s=0,u=E.length;u>s;h=++s)for(p=E[h],m=null!=D[h]?D[h]:D[h]=[],g=null!=(w=p.elements)?w:[p],i=t=0,v=g.length;v>t;i=++t)f=g[i],l=null!=m[i]?m[i]:m[i]=new j(f),e&=l.done,l.done||(d++,r+=l.tick(a));return c=r/d,n.update(F.tick(a,c)),q=y(),n.done()||e||o?(n.update(100),setTimeout(function(){return n.finish()},Math.max(z.ghostTime,Math.min(z.minTime,y()-q)))):b()})},Pace.start=function(a){return r(z,a),n.render(),document.querySelector(".pace")?Pace.go():setTimeout(Pace.start,50)},"function"==typeof define&&define.amd?define(function(){return Pace}):"object"==typeof exports?module.exports=Pace:z.startOnPageLoad&&Pace.start()}).call(this);



},{}],341:[function(require,module,exports){
require('./jquery.pnotify.min');





},{"./jquery.pnotify.min":342}],342:[function(require,module,exports){
/*
 * jQuery Pines Notify (pnotify) Plugin 1.2.0
 *
 * http://pinesframework.org/pnotify/
 * Copyright (c) 2009-2012 Hunter Perrin
 *
 * Triple license under the GPL, LGPL, and MPL:
 *	  http://www.gnu.org/licenses/gpl.html
 *	  http://www.gnu.org/licenses/lgpl.html
 *	  http://www.mozilla.org/MPL/MPL-1.1.html
 */
(function(d){var q,j,r,i=d(window),u={jqueryui:{container:"ui-widget ui-widget-content ui-corner-all",notice:"ui-state-highlight",notice_icon:"ui-icon ui-icon-info",info:"",info_icon:"ui-icon ui-icon-info",success:"ui-state-default",success_icon:"ui-icon ui-icon-circle-check",error:"ui-state-error",error_icon:"ui-icon ui-icon-alert",closer:"ui-icon ui-icon-close",pin_up:"ui-icon ui-icon-pin-w",pin_down:"ui-icon ui-icon-pin-s",hi_menu:"ui-state-default ui-corner-bottom",hi_btn:"ui-state-default ui-corner-all",
hi_btnhov:"ui-state-hover",hi_hnd:"ui-icon ui-icon-grip-dotted-horizontal"},bootstrap:{container:"alert",notice:"",notice_icon:"icon-exclamation-sign",info:"alert-info",info_icon:"icon-info-sign",success:"alert-success",success_icon:"icon-ok-sign",error:"alert-error",error_icon:"icon-warning-sign",closer:"icon-remove",pin_up:"icon-pause",pin_down:"icon-play",hi_menu:"well",hi_btn:"btn",hi_btnhov:"",hi_hnd:"icon-chevron-down"}},s=function(){r=d("body");i=d(window);i.bind("resize",function(){j&&clearTimeout(j);
j=setTimeout(d.pnotify_position_all,10)})};document.body?s():d(s);d.extend({pnotify_remove_all:function(){var e=i.data("pnotify");e&&e.length&&d.each(e,function(){this.pnotify_remove&&this.pnotify_remove()})},pnotify_position_all:function(){j&&clearTimeout(j);j=null;var e=i.data("pnotify");e&&e.length&&(d.each(e,function(){var d=this.opts.stack;if(d)d.nextpos1=d.firstpos1,d.nextpos2=d.firstpos2,d.addpos2=0,d.animation=true}),d.each(e,function(){this.pnotify_position()}))},pnotify:function(e){var g,
a;typeof e!="object"?(a=d.extend({},d.pnotify.defaults),a.text=e):a=d.extend({},d.pnotify.defaults,e);for(var p in a)typeof p=="string"&&p.match(/^pnotify_/)&&(a[p.replace(/^pnotify_/,"")]=a[p]);if(a.before_init&&a.before_init(a)===false)return null;var k,o=function(a,c){b.css("display","none");var f=document.elementFromPoint(a.clientX,a.clientY);b.css("display","block");var e=d(f),g=e.css("cursor");b.css("cursor",g!="auto"?g:"default");if(!k||k.get(0)!=f)k&&(n.call(k.get(0),"mouseleave",a.originalEvent),
n.call(k.get(0),"mouseout",a.originalEvent)),n.call(f,"mouseenter",a.originalEvent),n.call(f,"mouseover",a.originalEvent);n.call(f,c,a.originalEvent);k=e},f=u[a.styling],b=d("<div />",{"class":"ui-pnotify "+a.addclass,css:{display:"none"},mouseenter:function(l){a.nonblock&&l.stopPropagation();a.mouse_reset&&g=="out"&&(b.stop(true),g="in",b.css("height","auto").animate({width:a.width,opacity:a.nonblock?a.nonblock_opacity:a.opacity},"fast"));a.nonblock&&b.animate({opacity:a.nonblock_opacity},"fast");
a.hide&&a.mouse_reset&&b.pnotify_cancel_remove();a.sticker&&!a.nonblock&&b.sticker.trigger("pnotify_icon").css("visibility","visible");a.closer&&!a.nonblock&&b.closer.css("visibility","visible")},mouseleave:function(l){a.nonblock&&l.stopPropagation();k=null;b.css("cursor","auto");a.nonblock&&g!="out"&&b.animate({opacity:a.opacity},"fast");a.hide&&a.mouse_reset&&b.pnotify_queue_remove();a.sticker_hover&&b.sticker.css("visibility","hidden");a.closer_hover&&b.closer.css("visibility","hidden");d.pnotify_position_all()},
mouseover:function(b){a.nonblock&&b.stopPropagation()},mouseout:function(b){a.nonblock&&b.stopPropagation()},mousemove:function(b){a.nonblock&&(b.stopPropagation(),o(b,"onmousemove"))},mousedown:function(b){a.nonblock&&(b.stopPropagation(),b.preventDefault(),o(b,"onmousedown"))},mouseup:function(b){a.nonblock&&(b.stopPropagation(),b.preventDefault(),o(b,"onmouseup"))},click:function(b){a.nonblock&&(b.stopPropagation(),o(b,"onclick"))},dblclick:function(b){a.nonblock&&(b.stopPropagation(),o(b,"ondblclick"))}});
b.opts=a;b.container=d("<div />",{"class":f.container+" ui-pnotify-container "+(a.type=="error"?f.error:a.type=="info"?f.info:a.type=="success"?f.success:f.notice)}).appendTo(b);a.cornerclass!=""&&b.container.removeClass("ui-corner-all").addClass(a.cornerclass);a.shadow&&b.container.addClass("ui-pnotify-shadow");b.pnotify_version="1.2.0";b.pnotify=function(l){var c=a;typeof l=="string"?a.text=l:a=d.extend({},a,l);for(var e in a)typeof e=="string"&&e.match(/^pnotify_/)&&(a[e.replace(/^pnotify_/,"")]=
a[e]);b.opts=a;a.cornerclass!=c.cornerclass&&b.container.removeClass("ui-corner-all").addClass(a.cornerclass);a.shadow!=c.shadow&&(a.shadow?b.container.addClass("ui-pnotify-shadow"):b.container.removeClass("ui-pnotify-shadow"));a.addclass===false?b.removeClass(c.addclass):a.addclass!==c.addclass&&b.removeClass(c.addclass).addClass(a.addclass);a.title===false?b.title_container.slideUp("fast"):a.title!==c.title&&(a.title_escape?b.title_container.text(a.title).slideDown(200):b.title_container.html(a.title).slideDown(200));
a.text===false?b.text_container.slideUp("fast"):a.text!==c.text&&(a.text_escape?b.text_container.text(a.text).slideDown(200):b.text_container.html(a.insert_brs?String(a.text).replace(/\n/g,"<br />"):a.text).slideDown(200));b.pnotify_history=a.history;b.pnotify_hide=a.hide;a.type!=c.type&&b.container.removeClass(f.error+" "+f.notice+" "+f.success+" "+f.info).addClass(a.type=="error"?f.error:a.type=="info"?f.info:a.type=="success"?f.success:f.notice);if(a.icon!==c.icon||a.icon===true&&a.type!=c.type)b.container.find("div.ui-pnotify-icon").remove(),
a.icon!==false&&d("<div />",{"class":"ui-pnotify-icon"}).append(d("<span />",{"class":a.icon===true?a.type=="error"?f.error_icon:a.type=="info"?f.info_icon:a.type=="success"?f.success_icon:f.notice_icon:a.icon})).prependTo(b.container);a.width!==c.width&&b.animate({width:a.width});a.min_height!==c.min_height&&b.container.animate({minHeight:a.min_height});a.opacity!==c.opacity&&b.fadeTo(a.animate_speed,a.opacity);!a.closer||a.nonblock?b.closer.css("display","none"):b.closer.css("display","block");
!a.sticker||a.nonblock?b.sticker.css("display","none"):b.sticker.css("display","block");b.sticker.trigger("pnotify_icon");a.sticker_hover?b.sticker.css("visibility","hidden"):a.nonblock||b.sticker.css("visibility","visible");a.closer_hover?b.closer.css("visibility","hidden"):a.nonblock||b.closer.css("visibility","visible");a.hide?c.hide||b.pnotify_queue_remove():b.pnotify_cancel_remove();b.pnotify_queue_position();return b};b.pnotify_position=function(a){var c=b.opts.stack;if(c){if(!c.nextpos1)c.nextpos1=
c.firstpos1;if(!c.nextpos2)c.nextpos2=c.firstpos2;if(!c.addpos2)c.addpos2=0;var d=b.css("display")=="none";if(!d||a){var f,e={},g;switch(c.dir1){case "down":g="top";break;case "up":g="bottom";break;case "left":g="right";break;case "right":g="left"}a=parseInt(b.css(g));isNaN(a)&&(a=0);if(typeof c.firstpos1=="undefined"&&!d)c.firstpos1=a,c.nextpos1=c.firstpos1;var h;switch(c.dir2){case "down":h="top";break;case "up":h="bottom";break;case "left":h="right";break;case "right":h="left"}f=parseInt(b.css(h));
isNaN(f)&&(f=0);if(typeof c.firstpos2=="undefined"&&!d)c.firstpos2=f,c.nextpos2=c.firstpos2;if(c.dir1=="down"&&c.nextpos1+b.height()>i.height()||c.dir1=="up"&&c.nextpos1+b.height()>i.height()||c.dir1=="left"&&c.nextpos1+b.width()>i.width()||c.dir1=="right"&&c.nextpos1+b.width()>i.width())c.nextpos1=c.firstpos1,c.nextpos2+=c.addpos2+(typeof c.spacing2=="undefined"?25:c.spacing2),c.addpos2=0;if(c.animation&&c.nextpos2<f)switch(c.dir2){case "down":e.top=c.nextpos2+"px";break;case "up":e.bottom=c.nextpos2+
"px";break;case "left":e.right=c.nextpos2+"px";break;case "right":e.left=c.nextpos2+"px"}else b.css(h,c.nextpos2+"px");switch(c.dir2){case "down":case "up":if(b.outerHeight(true)>c.addpos2)c.addpos2=b.height();break;case "left":case "right":if(b.outerWidth(true)>c.addpos2)c.addpos2=b.width()}if(c.nextpos1)if(c.animation&&(a>c.nextpos1||e.top||e.bottom||e.right||e.left))switch(c.dir1){case "down":e.top=c.nextpos1+"px";break;case "up":e.bottom=c.nextpos1+"px";break;case "left":e.right=c.nextpos1+"px";
break;case "right":e.left=c.nextpos1+"px"}else b.css(g,c.nextpos1+"px");(e.top||e.bottom||e.right||e.left)&&b.animate(e,{duration:500,queue:false});switch(c.dir1){case "down":case "up":c.nextpos1+=b.height()+(typeof c.spacing1=="undefined"?25:c.spacing1);break;case "left":case "right":c.nextpos1+=b.width()+(typeof c.spacing1=="undefined"?25:c.spacing1)}}}};b.pnotify_queue_position=function(a){j&&clearTimeout(j);a||(a=10);j=setTimeout(d.pnotify_position_all,a)};b.pnotify_display=function(){b.parent().length||
b.appendTo(r);a.before_open&&a.before_open(b)===false||(a.stack.push!="top"&&b.pnotify_position(true),a.animation=="fade"||a.animation.effect_in=="fade"?b.show().fadeTo(0,0).hide():a.opacity!=1&&b.show().fadeTo(0,a.opacity).hide(),b.animate_in(function(){a.after_open&&a.after_open(b);b.pnotify_queue_position();a.hide&&b.pnotify_queue_remove()}))};b.pnotify_remove=function(){if(b.timer)window.clearTimeout(b.timer),b.timer=null;a.before_close&&a.before_close(b)===false||b.animate_out(function(){a.after_close&&
a.after_close(b)===false||(b.pnotify_queue_position(),a.remove&&b.detach())})};b.animate_in=function(d){g="in";var c;c=typeof a.animation.effect_in!="undefined"?a.animation.effect_in:a.animation;c=="none"?(b.show(),d()):c=="show"?b.show(a.animate_speed,d):c=="fade"?b.show().fadeTo(a.animate_speed,a.opacity,d):c=="slide"?b.slideDown(a.animate_speed,d):typeof c=="function"?c("in",d,b):b.show(c,typeof a.animation.options_in=="object"?a.animation.options_in:{},a.animate_speed,d)};b.animate_out=function(d){g=
"out";var c;c=typeof a.animation.effect_out!="undefined"?a.animation.effect_out:a.animation;c=="none"?(b.hide(),d()):c=="show"?b.hide(a.animate_speed,d):c=="fade"?b.fadeOut(a.animate_speed,d):c=="slide"?b.slideUp(a.animate_speed,d):typeof c=="function"?c("out",d,b):b.hide(c,typeof a.animation.options_out=="object"?a.animation.options_out:{},a.animate_speed,d)};b.pnotify_cancel_remove=function(){b.timer&&window.clearTimeout(b.timer)};b.pnotify_queue_remove=function(){b.pnotify_cancel_remove();b.timer=
window.setTimeout(function(){b.pnotify_remove()},isNaN(a.delay)?0:a.delay)};b.closer=d("<div />",{"class":"ui-pnotify-closer",css:{cursor:"pointer",visibility:a.closer_hover?"hidden":"visible"},click:function(){b.pnotify_remove();b.sticker.css("visibility","hidden");b.closer.css("visibility","hidden")}}).append(d("<span />",{"class":f.closer})).appendTo(b.container);(!a.closer||a.nonblock)&&b.closer.css("display","none");b.sticker=d("<div />",{"class":"ui-pnotify-sticker",css:{cursor:"pointer",visibility:a.sticker_hover?
"hidden":"visible"},click:function(){a.hide=!a.hide;a.hide?b.pnotify_queue_remove():b.pnotify_cancel_remove();d(this).trigger("pnotify_icon")}}).bind("pnotify_icon",function(){d(this).children().removeClass(f.pin_up+" "+f.pin_down).addClass(a.hide?f.pin_up:f.pin_down)}).append(d("<span />",{"class":f.pin_up})).appendTo(b.container);(!a.sticker||a.nonblock)&&b.sticker.css("display","none");a.icon!==false&&d("<div />",{"class":"ui-pnotify-icon"}).append(d("<span />",{"class":a.icon===true?a.type=="error"?
f.error_icon:a.type=="info"?f.info_icon:a.type=="success"?f.success_icon:f.notice_icon:a.icon})).prependTo(b.container);b.title_container=d("<h4 />",{"class":"ui-pnotify-title"}).appendTo(b.container);a.title===false?b.title_container.hide():a.title_escape?b.title_container.text(a.title):b.title_container.html(a.title);b.text_container=d("<div />",{"class":"ui-pnotify-text"}).appendTo(b.container);a.text===false?b.text_container.hide():a.text_escape?b.text_container.text(a.text):b.text_container.html(a.insert_brs?
String(a.text).replace(/\n/g,"<br />"):a.text);typeof a.width=="string"&&b.css("width",a.width);typeof a.min_height=="string"&&b.container.css("min-height",a.min_height);b.pnotify_history=a.history;b.pnotify_hide=a.hide;var h=i.data("pnotify");if(h==null||typeof h!="object")h=[];h=a.stack.push=="top"?d.merge([b],h):d.merge(h,[b]);i.data("pnotify",h);a.stack.push=="top"&&b.pnotify_queue_position(1);a.after_init&&a.after_init(b);if(a.history){var m=i.data("pnotify_history");typeof m=="undefined"&&(m=
d("<div />",{"class":"ui-pnotify-history-container "+f.hi_menu,mouseleave:function(){m.animate({top:"-"+q+"px"},{duration:100,queue:false})}}).append(d("<div />",{"class":"ui-pnotify-history-header",text:"Redisplay"})).append(d("<button />",{"class":"ui-pnotify-history-all "+f.hi_btn,text:"All",mouseenter:function(){d(this).addClass(f.hi_btnhov)},mouseleave:function(){d(this).removeClass(f.hi_btnhov)},click:function(){d.each(h,function(){this.pnotify_history&&(this.is(":visible")?this.pnotify_hide&&
this.pnotify_queue_remove():this.pnotify_display&&this.pnotify_display())});return false}})).append(d("<button />",{"class":"ui-pnotify-history-last "+f.hi_btn,text:"Last",mouseenter:function(){d(this).addClass(f.hi_btnhov)},mouseleave:function(){d(this).removeClass(f.hi_btnhov)},click:function(){var a=-1,b;do{b=a==-1?h.slice(a):h.slice(a,a+1);if(!b[0])break;a--}while(!b[0].pnotify_history||b[0].is(":visible"));if(!b[0])return false;b[0].pnotify_display&&b[0].pnotify_display();return false}})).appendTo(r),
q=d("<span />",{"class":"ui-pnotify-history-pulldown "+f.hi_hnd,mouseenter:function(){m.animate({top:"0"},{duration:100,queue:false})}}).appendTo(m).offset().top+2,m.css({top:"-"+q+"px"}),i.data("pnotify_history",m))}a.stack.animation=false;b.pnotify_display();return b}});var t=/^on/,v=/^(dbl)?click$|^mouse(move|down|up|over|out|enter|leave)$|^contextmenu$/,w=/^(focus|blur|select|change|reset)$|^key(press|down|up)$/,x=/^(scroll|resize|(un)?load|abort|error)$/,n=function(e,g){var a,e=e.toLowerCase();
document.createEvent&&this.dispatchEvent?(e=e.replace(t,""),e.match(v)?(d(this).offset(),a=document.createEvent("MouseEvents"),a.initMouseEvent(e,g.bubbles,g.cancelable,g.view,g.detail,g.screenX,g.screenY,g.clientX,g.clientY,g.ctrlKey,g.altKey,g.shiftKey,g.metaKey,g.button,g.relatedTarget)):e.match(w)?(a=document.createEvent("UIEvents"),a.initUIEvent(e,g.bubbles,g.cancelable,g.view,g.detail)):e.match(x)&&(a=document.createEvent("HTMLEvents"),a.initEvent(e,g.bubbles,g.cancelable)),a&&this.dispatchEvent(a)):
(e.match(t)||(e="on"+e),a=document.createEventObject(g),this.fireEvent(e,a))};d.pnotify.defaults={title:false,title_escape:false,text:false,text_escape:false,styling:"bootstrap",addclass:"",cornerclass:"",nonblock:false,nonblock_opacity:0.2,history:true,width:"300px",min_height:"16px",type:"notice",icon:true,animation:"fade",animate_speed:"slow",opacity:1,shadow:true,closer:true,closer_hover:true,sticker:true,sticker_hover:true,hide:true,delay:8E3,mouse_reset:true,remove:true,insert_brs:true,stack:{dir1:"down",
dir2:"left",push:"bottom",spacing1:25,spacing2:25}}})(jQuery);

},{}],343:[function(require,module,exports){
/*
Copyright 2012 Igor Vaynberg

Version: 3.5.1 Timestamp: Tue Jul 22 18:58:56 EDT 2014

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

    http://www.apache.org/licenses/LICENSE-2.0
    http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the
Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
the specific language governing permissions and limitations under the Apache License and the GPL License.
*/
(function ($) {
    if(typeof $.fn.each2 == "undefined") {
        $.extend($.fn, {
            /*
            * 4-10 times faster .each replacement
            * use it carefully, as it overrides jQuery context of element on each iteration
            */
            each2 : function (c) {
                var j = $([0]), i = -1, l = this.length;
                while (
                    ++i < l
                    && (j.context = j[0] = this[i])
                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
                );
                return this;
            }
        });
    }
})(jQuery);

(function ($, undefined) {
    "use strict";
    /*global document, window, jQuery, console */

    if (window.Select2 !== undefined) {
        return;
    }

    var KEY, AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,

    KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
            case KEY.LEFT:
            case KEY.RIGHT:
            case KEY.UP:
            case KEY.DOWN:
                return true;
            }
            return false;
        },
        isControl: function (e) {
            var k = e.which;
            switch (k) {
            case KEY.SHIFT:
            case KEY.CTRL:
            case KEY.ALT:
                return true;
            }

            if (e.metaKey) return true;

            return false;
        },
        isFunctionKey: function (k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        }
    },
    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",

    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038A":"\u0399","\u03AA":"\u0399","\u038C":"\u039F","\u038E":"\u03A5","\u03AB":"\u03A5","\u038F":"\u03A9","\u03AC":"\u03B1","\u03AD":"\u03B5","\u03AE":"\u03B7","\u03AF":"\u03B9","\u03CA":"\u03B9","\u0390":"\u03B9","\u03CC":"\u03BF","\u03CD":"\u03C5","\u03CB":"\u03C5","\u03B0":"\u03C5","\u03C9":"\u03C9","\u03C2":"\u03C3"};

    $document = $(document);

    nextUid=(function() { var counter=1; return function() { return counter++; }; }());


    function reinsertElement(element) {
        var placeholder = $(document.createTextNode(''));

        element.before(placeholder);
        placeholder.before(element);
        placeholder.remove();
    }

    function stripDiacritics(str) {
        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
        function match(a) {
            return DIACRITICS[a] || a;
        }

        return str.replace(/[^\u0000-\u007E]/g, match);
    }

    function indexOf(value, array) {
        var i = 0, l = array.length;
        for (; i < l; i = i + 1) {
            if (equal(value, array[i])) return i;
        }
        return -1;
    }

    function measureScrollbar () {
        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
        $template.appendTo('body');

        var dim = {
            width: $template.width() - $template[0].clientWidth,
            height: $template.height() - $template[0].clientHeight
        };
        $template.remove();

        return dim;
    }

    /**
     * Compares equality of a and b
     * @param a
     * @param b
     */
    function equal(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if (a === null || b === null) return false;
        // Check whether 'a' or 'b' is a string (primitive or object).
        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
        return false;
    }

    /**
     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
     * strings
     * @param string
     * @param separator
     */
    function splitVal(string, separator) {
        var val, i, l;
        if (string === null || string.length < 1) return [];
        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = $.trim(val[i]);
        return val;
    }

    function getSideBorderPadding(element) {
        return element.outerWidth(false) - element.width();
    }

    function installKeyUpChangeEvent(element) {
        var key="keyup-change-value";
        element.on("keydown", function () {
            if ($.data(element, key) === undefined) {
                $.data(element, key, element.val());
            }
        });
        element.on("keyup", function () {
            var val= $.data(element, key);
            if (val !== undefined && element.val() !== val) {
                $.removeData(element, key);
                element.trigger("keyup-change");
            }
        });
    }


    /**
     * filters mouse events so an event is fired only if the mouse moved.
     *
     * filters out mouse events that occur when mouse is stationary but
     * the elements under the pointer are scrolled.
     */
    function installFilteredMouseMove(element) {
        element.on("mousemove", function (e) {
            var lastpos = lastMousePosition;
            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
                $(e.target).trigger("mousemove-filtered", e);
            }
        });
    }

    /**
     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
     * within the last quietMillis milliseconds.
     *
     * @param quietMillis number of milliseconds to wait before invoking fn
     * @param fn function to be debounced
     * @param ctx object to be used as this reference within fn
     * @return debounced version of fn
     */
    function debounce(quietMillis, fn, ctx) {
        ctx = ctx || undefined;
        var timeout;
        return function () {
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                fn.apply(ctx, args);
            }, quietMillis);
        };
    }

    function installDebouncedScroll(threshold, element) {
        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
        element.on("scroll", function (e) {
            if (indexOf(e.target, element.get()) >= 0) notify(e);
        });
    }

    function focus($el) {
        if ($el[0] === document.activeElement) return;

        /* set the focus in a 0 timeout - that way the focus is set after the processing
            of the current event has finished - which seems like the only reliable way
            to set focus */
        window.setTimeout(function() {
            var el=$el[0], pos=$el.val().length, range;

            $el.focus();

            /* make sure el received focus so we do not error out when trying to manipulate the caret.
                sometimes modals or others listeners may steal it after its set */
            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
            if (isVisible && el === document.activeElement) {

                /* after the focus is set move the caret to the end, necessary when we val()
                    just before setting focus */
                if(el.setSelectionRange)
                {
                    el.setSelectionRange(pos, pos);
                }
                else if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }
        }, 0);
    }

    function getCursorInfo(el) {
        el = $(el)[0];
        var offset = 0;
        var length = 0;
        if ('selectionStart' in el) {
            offset = el.selectionStart;
            length = el.selectionEnd - offset;
        } else if ('selection' in document) {
            el.focus();
            var sel = document.selection.createRange();
            length = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            offset = sel.text.length - length;
        }
        return { offset: offset, length: length };
    }

    function killEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    function killEventImmediately(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    function measureTextWidth(e) {
        if (!sizer){
            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
            sizer = $(document.createElement("div")).css({
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
                display: "none",
                fontSize: style.fontSize,
                fontFamily: style.fontFamily,
                fontStyle: style.fontStyle,
                fontWeight: style.fontWeight,
                letterSpacing: style.letterSpacing,
                textTransform: style.textTransform,
                whiteSpace: "nowrap"
            });
            sizer.attr("class","select2-sizer");
            $("body").append(sizer);
        }
        sizer.text(e.val());
        return sizer.width();
    }

    function syncCssClasses(dest, src, adapter) {
        var classes, replacements = [], adapted;

        classes = $.trim(dest.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") === 0) {
                    replacements.push(this);
                }
            });
        }

        classes = $.trim(src.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") !== 0) {
                    adapted = adapter(this);

                    if (adapted) {
                        replacements.push(adapted);
                    }
                }
            });
        }

        dest.attr("class", replacements.join(" "));
    }


    function markMatch(text, term, markup, escapeMarkup) {
        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
            tl=term.length;

        if (match<0) {
            markup.push(escapeMarkup(text));
            return;
        }

        markup.push(escapeMarkup(text.substring(0, match)));
        markup.push("<span class='select2-match'>");
        markup.push(escapeMarkup(text.substring(match, match + tl)));
        markup.push("</span>");
        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
    }

    function defaultEscapeMarkup(markup) {
        var replace_map = {
            '\\': '&#92;',
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#47;'
        };

        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
            return replace_map[match];
        });
    }

    /**
     * Produces an ajax-based query function
     *
     * @param options object containing configuration parameters
     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
     * @param options.url url for the data
     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
     *      The expected format is an object containing the following keys:
     *      results array of objects that will be used as choices
     *      more (optional) boolean indicating whether there are more results available
     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
     */
    function ajax(options) {
        var timeout, // current scheduled but not yet executed request
            handler = null,
            quietMillis = options.quietMillis || 100,
            ajaxUrl = options.url,
            self = this;

        return function (query) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                var data = options.data, // ajax data function
                    url = ajaxUrl, // ajax url string or function
                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
                    // deprecated - to be removed in 4.0  - use params instead
                    deprecated = {
                        type: options.type || 'GET', // set type of request (GET or POST)
                        cache: options.cache || false,
                        jsonpCallback: options.jsonpCallback||undefined,
                        dataType: options.dataType||"json"
                    },
                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

                data = data ? data.call(self, query.term, query.page, query.context) : null;
                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;

                if (handler && typeof handler.abort === "function") { handler.abort(); }

                if (options.params) {
                    if ($.isFunction(options.params)) {
                        $.extend(params, options.params.call(self));
                    } else {
                        $.extend(params, options.params);
                    }
                }

                $.extend(params, {
                    url: url,
                    dataType: options.dataType,
                    data: data,
                    success: function (data) {
                        // TODO - replace query.page with query so users have access to term, page, etc.
                        // added query as third paramter to keep backwards compatibility
                        var results = options.results(data, query.page, query);
                        query.callback(results);
                    },
                    error: function(jqXHR, textStatus, errorThrown){
                        var results = {
                            hasError: true,
                            jqXHR: jqXHR,
                            textStatus: textStatus,
                            errorThrown: errorThrown,
                        };

                        query.callback(results);
                    }
                });
                handler = transport.call(self, params);
            }, quietMillis);
        };
    }

    /**
     * Produces a query function that works with a local array
     *
     * @param options object containing configuration parameters. The options parameter can either be an array or an
     * object.
     *
     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
     *
     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
     * the text.
     */
    function local(options) {
        var data = options, // data elements
            dataText,
            tmp,
            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search

         if ($.isArray(data)) {
            tmp = data;
            data = { results: tmp };
        }

         if ($.isFunction(data) === false) {
            tmp = data;
            data = function() { return tmp; };
        }

        var dataItem = data();
        if (dataItem.text) {
            text = dataItem.text;
            // if text is not a function we assume it to be a key name
            if (!$.isFunction(text)) {
                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
                text = function (item) { return item[dataText]; };
            }
        }

        return function (query) {
            var t = query.term, filtered = { results: [] }, process;
            if (t === "") {
                query.callback(data());
                return;
            }

            process = function(datum, collection) {
                var group, attr;
                datum = datum[0];
                if (datum.children) {
                    group = {};
                    for (attr in datum) {
                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
                    }
                    group.children=[];
                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
                    if (group.children.length || query.matcher(t, text(group), datum)) {
                        collection.push(group);
                    }
                } else {
                    if (query.matcher(t, text(datum), datum)) {
                        collection.push(datum);
                    }
                }
            };

            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
            query.callback(filtered);
        };
    }

    // TODO javadoc
    function tags(data) {
        var isFunc = $.isFunction(data);
        return function (query) {
            var t = query.term, filtered = {results: []};
            var result = isFunc ? data(query) : data;
            if ($.isArray(result)) {
                $(result).each(function () {
                    var isObject = this.text !== undefined,
                        text = isObject ? this.text : this;
                    if (t === "" || query.matcher(t, text)) {
                        filtered.results.push(isObject ? this : {id: this, text: this});
                    }
                });
                query.callback(filtered);
            }
        };
    }

    /**
     * Checks if the formatter function should be used.
     *
     * Throws an error if it is not a function. Returns true if it should be used,
     * false if no formatting should be performed.
     *
     * @param formatter
     */
    function checkFormatter(formatter, formatterName) {
        if ($.isFunction(formatter)) return true;
        if (!formatter) return false;
        if (typeof(formatter) === 'string') return true;
        throw new Error(formatterName +" must be a string, function, or falsy value");
    }

  /**
   * Returns a given value
   * If given a function, returns its output
   *
   * @param val string|function
   * @param context value of "this" to be passed to function
   * @returns {*}
   */
    function evaluate(val, context) {
        if ($.isFunction(val)) {
            var args = Array.prototype.slice.call(arguments, 2);
            return val.apply(context, args);
        }
        return val;
    }

    function countResults(results) {
        var count = 0;
        $.each(results, function(i, item) {
            if (item.children) {
                count += countResults(item.children);
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * Default tokenizer. This function uses breaks the input on substring match of any string from the
     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
     * two options have to be defined in order for the tokenizer to work.
     *
     * @param input text user has typed so far or pasted into the search field
     * @param selection currently selected choices
     * @param selectCallback function(choice) callback tho add the choice to selection
     * @param opts select2's opts
     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
     */
    function defaultTokenizer(input, selection, selectCallback, opts) {
        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
            token, // token
            index, // position at which the separator was found
            i, l, // looping variables
            separator; // the matched separator

        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

        while (true) {
            index = -1;

            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
                separator = opts.tokenSeparators[i];
                index = input.indexOf(separator);
                if (index >= 0) break;
            }

            if (index < 0) break; // did not find any token separator in the input string, bail

            token = input.substring(0, index);
            input = input.substring(index + separator.length);

            if (token.length > 0) {
                token = opts.createSearchChoice.call(this, token, selection);
                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
                    dupe = false;
                    for (i = 0, l = selection.length; i < l; i++) {
                        if (equal(opts.id(token), opts.id(selection[i]))) {
                            dupe = true; break;
                        }
                    }

                    if (!dupe) selectCallback(token);
                }
            }
        }

        if (original!==input) return input;
    }

    function cleanupJQueryElements() {
        var self = this;

        $.each(arguments, function (i, element) {
            self[element].remove();
            self[element] = null;
        });
    }

    /**
     * Creates a new class
     *
     * @param superClass
     * @param methods
     */
    function clazz(SuperClass, methods) {
        var constructor = function () {};
        constructor.prototype = new SuperClass;
        constructor.prototype.constructor = constructor;
        constructor.prototype.parent = SuperClass.prototype;
        constructor.prototype = $.extend(constructor.prototype, methods);
        return constructor;
    }

    AbstractSelect2 = clazz(Object, {

        // abstract
        bind: function (func) {
            var self = this;
            return function () {
                func.apply(self, arguments);
            };
        },

        // abstract
        init: function (opts) {
            var results, search, resultsSelector = ".select2-results";

            // prepare options
            this.opts = opts = this.prepareOpts(opts);

            this.id=opts.id;

            // destroy if called on an existing component
            if (opts.element.data("select2") !== undefined &&
                opts.element.data("select2") !== null) {
                opts.element.data("select2").destroy();
            }

            this.container = this.createContainer();

            this.liveRegion = $("<span>", {
                    role: "status",
                    "aria-live": "polite"
                })
                .addClass("select2-hidden-accessible")
                .appendTo(document.body);

            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
            this.containerEventName= this.containerId
                .replace(/([.])/g, '_')
                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
            this.container.attr("id", this.containerId);

            this.container.attr("title", opts.element.attr("title"));

            this.body = $("body");

            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

            this.container.attr("style", opts.element.attr("style"));
            this.container.css(evaluate(opts.containerCss, this.opts.element));
            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));

            this.elementTabIndex = this.opts.element.attr("tabindex");

            // swap container for the element
            this.opts.element
                .data("select2", this)
                .attr("tabindex", "-1")
                .before(this.container)
                .on("click.select2", killEvent); // do not leak click events

            this.container.data("select2", this);

            this.dropdown = this.container.find(".select2-drop");

            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);

            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
            this.dropdown.data("select2", this);
            this.dropdown.on("click", killEvent);

            this.results = results = this.container.find(resultsSelector);
            this.search = search = this.container.find("input.select2-input");

            this.queryCount = 0;
            this.resultsPage = 0;
            this.context = null;

            // initialize the container
            this.initContainer();

            this.container.on("click", killEvent);

            installFilteredMouseMove(this.results);

            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
                this._touchEvent = true;
                this.highlightUnderEvent(event);
            }));
            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));

            // Waiting for a click event on touch devices to select option and hide dropdown
            // otherwise click will be triggered on an underlying element
            this.dropdown.on('click', this.bind(function (event) {
                if (this._touchEvent) {
                    this._touchEvent = false;
                    this.selectHighlighted();
                }
            }));

            installDebouncedScroll(80, this.results);
            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

            // do not propagate change event from the search field out of the component
            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});

            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
            if ($.fn.mousewheel) {
                results.mousewheel(function (e, delta, deltaX, deltaY) {
                    var top = results.scrollTop();
                    if (deltaY > 0 && top - deltaY <= 0) {
                        results.scrollTop(0);
                        killEvent(e);
                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
                        results.scrollTop(results.get(0).scrollHeight - results.height());
                        killEvent(e);
                    }
                });
            }

            installKeyUpChangeEvent(search);
            search.on("keyup-change input paste", this.bind(this.updateResults));
            search.on("focus", function () { search.addClass("select2-focused"); });
            search.on("blur", function () { search.removeClass("select2-focused");});

            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
                if ($(e.target).closest(".select2-result-selectable").length > 0) {
                    this.highlightUnderEvent(e);
                    this.selectHighlighted(e);
                }
            }));

            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
            // dom it will trigger the popup close, which is not what we want
            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });

            this.nextSearchTerm = undefined;

            if ($.isFunction(this.opts.initSelection)) {
                // initialize selection based on the current value of the source element
                this.initSelection();

                // if the user has provided a function that can set selection based on the value of the source element
                // we monitor the change event on the element and trigger it, allowing for two way synchronization
                this.monitorSource();
            }

            if (opts.maximumInputLength !== null) {
                this.search.attr("maxlength", opts.maximumInputLength);
            }

            var disabled = opts.element.prop("disabled");
            if (disabled === undefined) disabled = false;
            this.enable(!disabled);

            var readonly = opts.element.prop("readonly");
            if (readonly === undefined) readonly = false;
            this.readonly(readonly);

            // Calculate size of scrollbar
            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

            this.autofocus = opts.element.prop("autofocus");
            opts.element.prop("autofocus", false);
            if (this.autofocus) this.focus();

            this.search.attr("placeholder", opts.searchInputPlaceholder);
        },

        // abstract
        destroy: function () {
            var element=this.opts.element, select2 = element.data("select2"), self = this;

            this.close();

            if (element.length && element[0].detachEvent) {
                element.each(function () {
                    this.detachEvent("onpropertychange", self._sync);
                });
            }
            if (this.propertyObserver) {
                this.propertyObserver.disconnect();
                this.propertyObserver = null;
            }
            this._sync = null;

            if (select2 !== undefined) {
                select2.container.remove();
                select2.liveRegion.remove();
                select2.dropdown.remove();
                element
                    .removeClass("select2-offscreen")
                    .removeData("select2")
                    .off(".select2")
                    .prop("autofocus", this.autofocus || false);
                if (this.elementTabIndex) {
                    element.attr({tabindex: this.elementTabIndex});
                } else {
                    element.removeAttr("tabindex");
                }
                element.show();
            }

            cleanupJQueryElements.call(this,
                "container",
                "liveRegion",
                "dropdown",
                "results",
                "search"
            );
        },

        // abstract
        optionToData: function(element) {
            if (element.is("option")) {
                return {
                    id:element.prop("value"),
                    text:element.text(),
                    element: element.get(),
                    css: element.attr("class"),
                    disabled: element.prop("disabled"),
                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
                };
            } else if (element.is("optgroup")) {
                return {
                    text:element.attr("label"),
                    children:[],
                    element: element.get(),
                    css: element.attr("class")
                };
            }
        },

        // abstract
        prepareOpts: function (opts) {
            var element, select, idKey, ajaxUrl, self = this;

            element = opts.element;

            if (element.get(0).tagName.toLowerCase() === "select") {
                this.select = select = opts.element;
            }

            if (select) {
                // these options are not allowed when attached to a select because they are picked up off the element itself
                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
                    if (this in opts) {
                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
                    }
                });
            }

            opts = $.extend({}, {
                populateResults: function(container, results, query) {
                    var populate, id=this.opts.id, liveRegion=this.liveRegion;

                    populate=function(results, container, depth) {

                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

                        results = opts.sortResults(results, container, query);

                        // collect the created nodes for bulk append
                        var nodes = [];
                        for (i = 0, l = results.length; i < l; i = i + 1) {

                            result=results[i];

                            disabled = (result.disabled === true);
                            selectable = (!disabled) && (id(result) !== undefined);

                            compound=result.children && result.children.length > 0;

                            node=$("<li></li>");
                            node.addClass("select2-results-dept-"+depth);
                            node.addClass("select2-result");
                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
                            if (disabled) { node.addClass("select2-disabled"); }
                            if (compound) { node.addClass("select2-result-with-children"); }
                            node.addClass(self.opts.formatResultCssClass(result));
                            node.attr("role", "presentation");

                            label=$(document.createElement("div"));
                            label.addClass("select2-result-label");
                            label.attr("id", "select2-result-label-" + nextUid());
                            label.attr("role", "option");

                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
                            if (formatted!==undefined) {
                                label.html(formatted);
                                node.append(label);
                            }


                            if (compound) {

                                innerContainer=$("<ul></ul>");
                                innerContainer.addClass("select2-result-sub");
                                populate(result.children, innerContainer, depth+1);
                                node.append(innerContainer);
                            }

                            node.data("select2-data", result);
                            nodes.push(node[0]);
                        }

                        // bulk append the created nodes
                        container.append(nodes);
                        liveRegion.text(opts.formatMatches(results.length));
                    };

                    populate(results, container, 0);
                }
            }, $.fn.select2.defaults, opts);

            if (typeof(opts.id) !== "function") {
                idKey = opts.id;
                opts.id = function (e) { return e[idKey]; };
            }

            if ($.isArray(opts.element.data("select2Tags"))) {
                if ("tags" in opts) {
                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
                }
                opts.tags=opts.element.data("select2Tags");
            }

            if (select) {
                opts.query = this.bind(function (query) {
                    var data = { results: [], more: false },
                        term = query.term,
                        children, placeholderOption, process;

                    process=function(element, collection) {
                        var group;
                        if (element.is("option")) {
                            if (query.matcher(term, element.text(), element)) {
                                collection.push(self.optionToData(element));
                            }
                        } else if (element.is("optgroup")) {
                            group=self.optionToData(element);
                            element.children().each2(function(i, elm) { process(elm, group.children); });
                            if (group.children.length>0) {
                                collection.push(group);
                            }
                        }
                    };

                    children=element.children();

                    // ignore the placeholder option if there is one
                    if (this.getPlaceholder() !== undefined && children.length > 0) {
                        placeholderOption = this.getPlaceholderOption();
                        if (placeholderOption) {
                            children=children.not(placeholderOption);
                        }
                    }

                    children.each2(function(i, elm) { process(elm, data.results); });

                    query.callback(data);
                });
                // this is needed because inside val() we construct choices from options and their id is hardcoded
                opts.id=function(e) { return e.id; };
            } else {
                if (!("query" in opts)) {

                    if ("ajax" in opts) {
                        ajaxUrl = opts.element.data("ajax-url");
                        if (ajaxUrl && ajaxUrl.length > 0) {
                            opts.ajax.url = ajaxUrl;
                        }
                        opts.query = ajax.call(opts.element, opts.ajax);
                    } else if ("data" in opts) {
                        opts.query = local(opts.data);
                    } else if ("tags" in opts) {
                        opts.query = tags(opts.tags);
                        if (opts.createSearchChoice === undefined) {
                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
                        }
                        if (opts.initSelection === undefined) {
                            opts.initSelection = function (element, callback) {
                                var data = [];
                                $(splitVal(element.val(), opts.separator)).each(function () {
                                    var obj = { id: this, text: this },
                                        tags = opts.tags;
                                    if ($.isFunction(tags)) tags=tags();
                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
                                    data.push(obj);
                                });

                                callback(data);
                            };
                        }
                    }
                }
            }
            if (typeof(opts.query) !== "function") {
                throw "query function not defined for Select2 " + opts.element.attr("id");
            }

            if (opts.createSearchChoicePosition === 'top') {
                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
            }
            else if (opts.createSearchChoicePosition === 'bottom') {
                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
            }
            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
            }

            return opts;
        },

        /**
         * Monitor the original element for changes and update select2 accordingly
         */
        // abstract
        monitorSource: function () {
            var el = this.opts.element, observer, self = this;

            el.on("change.select2", this.bind(function (e) {
                if (this.opts.element.data("select2-change-triggered") !== true) {
                    this.initSelection();
                }
            }));

            this._sync = this.bind(function () {

                // sync enabled state
                var disabled = el.prop("disabled");
                if (disabled === undefined) disabled = false;
                this.enable(!disabled);

                var readonly = el.prop("readonly");
                if (readonly === undefined) readonly = false;
                this.readonly(readonly);

                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
                this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));

                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));

            });

            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
            if (el.length && el[0].attachEvent) {
                el.each(function() {
                    this.attachEvent("onpropertychange", self._sync);
                });
            }

            // safari, chrome, firefox, IE11
            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
            if (observer !== undefined) {
                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
                this.propertyObserver = new observer(function (mutations) {
                    $.each(mutations, self._sync);
                });
                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
            }
        },

        // abstract
        triggerSelect: function(data) {
            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
            this.opts.element.trigger(evt);
            return !evt.isDefaultPrevented();
        },

        /**
         * Triggers the change event on the source element
         */
        // abstract
        triggerChange: function (details) {

            details = details || {};
            details= $.extend({}, details, { type: "change", val: this.val() });
            // prevents recursive triggering
            this.opts.element.data("select2-change-triggered", true);
            this.opts.element.trigger(details);
            this.opts.element.data("select2-change-triggered", false);

            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
            // so here we trigger the click event manually
            this.opts.element.click();

            // ValidationEngine ignores the change event and listens instead to blur
            // so here we trigger the blur event manually if so desired
            if (this.opts.blurOnChange)
                this.opts.element.blur();
        },

        //abstract
        isInterfaceEnabled: function()
        {
            return this.enabledInterface === true;
        },

        // abstract
        enableInterface: function() {
            var enabled = this._enabled && !this._readonly,
                disabled = !enabled;

            if (enabled === this.enabledInterface) return false;

            this.container.toggleClass("select2-container-disabled", disabled);
            this.close();
            this.enabledInterface = enabled;

            return true;
        },

        // abstract
        enable: function(enabled) {
            if (enabled === undefined) enabled = true;
            if (this._enabled === enabled) return;
            this._enabled = enabled;

            this.opts.element.prop("disabled", !enabled);
            this.enableInterface();
        },

        // abstract
        disable: function() {
            this.enable(false);
        },

        // abstract
        readonly: function(enabled) {
            if (enabled === undefined) enabled = false;
            if (this._readonly === enabled) return;
            this._readonly = enabled;

            this.opts.element.prop("readonly", enabled);
            this.enableInterface();
        },

        // abstract
        opened: function () {
            return (this.container) ? this.container.hasClass("select2-dropdown-open") : false;
        },

        // abstract
        positionDropdown: function() {
            var $dropdown = this.dropdown,
                offset = this.container.offset(),
                height = this.container.outerHeight(false),
                width = this.container.outerWidth(false),
                dropHeight = $dropdown.outerHeight(false),
                $window = $(window),
                windowWidth = $window.width(),
                windowHeight = $window.height(),
                viewPortRight = $window.scrollLeft() + windowWidth,
                viewportBottom = $window.scrollTop() + windowHeight,
                dropTop = offset.top + height,
                dropLeft = offset.left,
                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
                dropWidth = $dropdown.outerWidth(false),
                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
                aboveNow = $dropdown.hasClass("select2-drop-above"),
                bodyOffset,
                above,
                changeDirection,
                css,
                resultsListNode;

            // always prefer the current above/below alignment, unless there is not enough room
            if (aboveNow) {
                above = true;
                if (!enoughRoomAbove && enoughRoomBelow) {
                    changeDirection = true;
                    above = false;
                }
            } else {
                above = false;
                if (!enoughRoomBelow && enoughRoomAbove) {
                    changeDirection = true;
                    above = true;
                }
            }

            //if we are changing direction we need to get positions when dropdown is hidden;
            if (changeDirection) {
                $dropdown.hide();
                offset = this.container.offset();
                height = this.container.outerHeight(false);
                width = this.container.outerWidth(false);
                dropHeight = $dropdown.outerHeight(false);
                viewPortRight = $window.scrollLeft() + windowWidth;
                viewportBottom = $window.scrollTop() + windowHeight;
                dropTop = offset.top + height;
                dropLeft = offset.left;
                dropWidth = $dropdown.outerWidth(false);
                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
                $dropdown.show();

                // fix so the cursor does not move to the left within the search-textbox in IE
                this.focusSearch();
            }

            if (this.opts.dropdownAutoWidth) {
                resultsListNode = $('.select2-results', $dropdown)[0];
                $dropdown.addClass('select2-drop-auto-width');
                $dropdown.css('width', '');
                // Add scrollbar width to dropdown if vertical scrollbar is present
                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
                dropWidth > width ? width = dropWidth : dropWidth = width;
                dropHeight = $dropdown.outerHeight(false);
                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
            }
            else {
                this.container.removeClass('select2-drop-auto-width');
            }

            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);

            // fix positioning when body has an offset and is not position: static
            if (this.body.css('position') !== 'static') {
                bodyOffset = this.body.offset();
                dropTop -= bodyOffset.top;
                dropLeft -= bodyOffset.left;
            }

            if (!enoughRoomOnRight) {
                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
            }

            css =  {
                left: dropLeft,
                width: width
            };

            if (above) {
                css.top = offset.top - dropHeight;
                css.bottom = 'auto';
                this.container.addClass("select2-drop-above");
                $dropdown.addClass("select2-drop-above");
            }
            else {
                css.top = dropTop;
                css.bottom = 'auto';
                this.container.removeClass("select2-drop-above");
                $dropdown.removeClass("select2-drop-above");
            }
            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));

            $dropdown.css(css);
        },

        // abstract
        shouldOpen: function() {
            var event;

            if (this.opened()) return false;

            if (this._enabled === false || this._readonly === true) return false;

            event = $.Event("select2-opening");
            this.opts.element.trigger(event);
            return !event.isDefaultPrevented();
        },

        // abstract
        clearDropdownAlignmentPreference: function() {
            // clear the classes used to figure out the preference of where the dropdown should be opened
            this.container.removeClass("select2-drop-above");
            this.dropdown.removeClass("select2-drop-above");
        },

        /**
         * Opens the dropdown
         *
         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
         */
        // abstract
        open: function () {

            if (!this.shouldOpen()) return false;

            this.opening();

            // Only bind the document mousemove when the dropdown is visible
            $document.on("mousemove.select2Event", function (e) {
                lastMousePosition.x = e.pageX;
                lastMousePosition.y = e.pageY;
            });

            return true;
        },

        /**
         * Performs the opening of the dropdown
         */
        // abstract
        opening: function() {
            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid,
                mask;

            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

            this.clearDropdownAlignmentPreference();

            if(this.dropdown[0] !== this.body.children().last()[0]) {
                this.dropdown.detach().appendTo(this.body);
            }

            // create the dropdown mask if doesn't already exist
            mask = $("#select2-drop-mask");
            if (mask.length == 0) {
                mask = $(document.createElement("div"));
                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
                mask.hide();
                mask.appendTo(this.body);
                mask.on("mousedown touchstart click", function (e) {
                    // Prevent IE from generating a click event on the body
                    reinsertElement(mask);

                    var dropdown = $("#select2-drop"), self;
                    if (dropdown.length > 0) {
                        self=dropdown.data("select2");
                        if (self.opts.selectOnBlur) {
                            self.selectHighlighted({noFocus: true});
                        }
                        self.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }

            // ensure the mask is always right before the dropdown
            if (this.dropdown.prev()[0] !== mask[0]) {
                this.dropdown.before(mask);
            }

            // move the global id to the correct dropdown
            $("#select2-drop").removeAttr("id");
            this.dropdown.attr("id", "select2-drop");

            // show the elements
            mask.show();

            this.positionDropdown();
            this.dropdown.show();
            this.positionDropdown();

            this.dropdown.addClass("select2-drop-active");

            // attach listeners to events that can change the position of the container and thus require
            // the position of the dropdown to be updated as well so it does not come unglued from the container
            var that = this;
            this.container.parents().add(window).each(function () {
                $(this).on(resize+" "+scroll+" "+orient, function (e) {
                    if (that.opened()) that.positionDropdown();
                });
            });


        },

        // abstract
        close: function () {
            if (!this.opened()) return;

            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid;

            // unbind event listeners
            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });

            this.clearDropdownAlignmentPreference();

            $("#select2-drop-mask").hide();
            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
            this.dropdown.hide();
            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
            this.results.empty();

            // Now that the dropdown is closed, unbind the global document mousemove event
            $document.off("mousemove.select2Event");

            this.clearSearch();
            this.search.removeClass("select2-active");
            this.opts.element.trigger($.Event("select2-close"));
        },

        /**
         * Opens control, sets input value, and updates results.
         */
        // abstract
        externalSearch: function (term) {
            this.open();
            this.search.val(term);
            this.updateResults(false);
        },

        // abstract
        clearSearch: function () {

        },

        //abstract
        getMaximumSelectionSize: function() {
            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
        },

        // abstract
        ensureHighlightVisible: function () {
            var results = this.results, children, index, child, hb, rb, y, more, topOffset;

            index = this.highlight();

            if (index < 0) return;

            if (index == 0) {

                // if the first element is highlighted scroll all the way to the top,
                // that way any unselectable headers above it will also be scrolled
                // into view

                results.scrollTop(0);
                return;
            }

            children = this.findHighlightableChoices().find('.select2-result-label');

            child = $(children[index]);

            topOffset = (child.offset() || {}).top || 0;

            hb = topOffset + child.outerHeight(true);

            // if this is the last child lets also make sure select2-more-results is visible
            if (index === children.length - 1) {
                more = results.find("li.select2-more-results");
                if (more.length > 0) {
                    hb = more.offset().top + more.outerHeight(true);
                }
            }

            rb = results.offset().top + results.outerHeight(true);
            if (hb > rb) {
                results.scrollTop(results.scrollTop() + (hb - rb));
            }
            y = topOffset - results.offset().top;

            // make sure the top of the element is visible
            if (y < 0 && child.css('display') != 'none' ) {
                results.scrollTop(results.scrollTop() + y); // y is negative
            }
        },

        // abstract
        findHighlightableChoices: function() {
            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
        },

        // abstract
        moveHighlight: function (delta) {
            var choices = this.findHighlightableChoices(),
                index = this.highlight();

            while (index > -1 && index < choices.length) {
                index += delta;
                var choice = $(choices[index]);
                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
                    this.highlight(index);
                    break;
                }
            }
        },

        // abstract
        highlight: function (index) {
            var choices = this.findHighlightableChoices(),
                choice,
                data;

            if (arguments.length === 0) {
                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
            }

            if (index >= choices.length) index = choices.length - 1;
            if (index < 0) index = 0;

            this.removeHighlight();

            choice = $(choices[index]);
            choice.addClass("select2-highlighted");

            // ensure assistive technology can determine the active choice
            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));

            this.ensureHighlightVisible();

            this.liveRegion.text(choice.text());

            data = choice.data("select2-data");
            if (data) {
                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
            }
        },

        removeHighlight: function() {
            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
        },

        touchMoved: function() {
            this._touchMoved = true;
        },

        clearTouchMoved: function() {
          this._touchMoved = false;
        },

        // abstract
        countSelectableResults: function() {
            return this.findHighlightableChoices().length;
        },

        // abstract
        highlightUnderEvent: function (event) {
            var el = $(event.target).closest(".select2-result-selectable");
            if (el.length > 0 && !el.is(".select2-highlighted")) {
                var choices = this.findHighlightableChoices();
                this.highlight(choices.index(el));
            } else if (el.length == 0) {
                // if we are over an unselectable item remove all highlights
                this.removeHighlight();
            }
        },

        // abstract
        loadMoreIfNeeded: function () {
            var results = this.results,
                more = results.find("li.select2-more-results"),
                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
                page = this.resultsPage + 1,
                self=this,
                term=this.search.val(),
                context=this.context;

            if (more.length === 0) return;
            below = more.offset().top - results.offset().top - results.height();

            if (below <= this.opts.loadMorePadding) {
                more.addClass("select2-active");
                this.opts.query({
                        element: this.opts.element,
                        term: term,
                        page: page,
                        context: context,
                        matcher: this.opts.matcher,
                        callback: this.bind(function (data) {

                    // ignore a response if the select2 has been closed before it was received
                    if (!self.opened()) return;


                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
                    self.postprocessResults(data, false, false);

                    if (data.more===true) {
                        more.detach().appendTo(results).text(evaluate(self.opts.formatLoadMore, self.opts.element, page+1));
                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                    } else {
                        more.remove();
                    }
                    self.positionDropdown();
                    self.resultsPage = page;
                    self.context = data.context;
                    this.opts.element.trigger({ type: "select2-loaded", items: data });
                })});
            }
        },

        /**
         * Default tokenizer function which does nothing
         */
        tokenize: function() {

        },

        /**
         * @param initial whether or not this is the call to this method right after the dropdown has been opened
         */
        // abstract
        updateResults: function (initial) {
            var search = this.search,
                results = this.results,
                opts = this.opts,
                data,
                self = this,
                input,
                term = search.val(),
                lastTerm = $.data(this.container, "select2-last-term"),
                // sequence number used to drop out-of-order responses
                queryNumber;

            // prevent duplicate queries against the same term
            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

            $.data(this.container, "select2-last-term", term);

            // if the search is currently hidden we do not alter the results
            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
                return;
            }

            function postRender() {
                search.removeClass("select2-active");
                self.positionDropdown();
                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
                    self.liveRegion.text(results.text());
                }
                else {
                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable').length));
                }
            }

            function render(html) {
                results.html(html);
                postRender();
            }

            queryNumber = ++this.queryCount;

            var maxSelSize = this.getMaximumSelectionSize();
            if (maxSelSize >=1) {
                data = this.data();
                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
                    return;
                }
            }

            if (search.val().length < opts.minimumInputLength) {
                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
                } else {
                    render("");
                }
                if (initial && this.showSearch) this.showSearch(true);
                return;
            }

            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
                } else {
                    render("");
                }
                return;
            }

            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
            }

            search.addClass("select2-active");

            this.removeHighlight();

            // give the tokenizer a chance to pre-process the input
            input = this.tokenize();
            if (input != undefined && input != null) {
                search.val(input);
            }

            this.resultsPage = 1;

            opts.query({
                element: opts.element,
                    term: search.val(),
                    page: this.resultsPage,
                    context: null,
                    matcher: opts.matcher,
                    callback: this.bind(function (data) {
                var def; // default choice

                // ignore old responses
                if (queryNumber != this.queryCount) {
                  return;
                }

                // ignore a response if the select2 has been closed before it was received
                if (!this.opened()) {
                    this.search.removeClass("select2-active");
                    return;
                }

                // handle ajax error
                if(data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
                    render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
                    return;
                }

                // save context, if any
                this.context = (data.context===undefined) ? null : data.context;
                // create a default choice and prepend it to the list
                if (this.opts.createSearchChoice && search.val() !== "") {
                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
                        if ($(data.results).filter(
                            function () {
                                return equal(self.id(this), self.id(def));
                            }).length === 0) {
                            this.opts.createSearchChoicePosition(data.results, def);
                        }
                    }
                }

                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
                    return;
                }

                results.empty();
                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});

                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
                    results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                }

                this.postprocessResults(data, initial);

                postRender();

                this.opts.element.trigger({ type: "select2-loaded", items: data });
            })});
        },

        // abstract
        cancel: function () {
            this.close();
        },

        // abstract
        blur: function () {
            // if selectOnBlur == true, select the currently highlighted option
            if (this.opts.selectOnBlur)
                this.selectHighlighted({noFocus: true});

            this.close();
            this.container.removeClass("select2-container-active");
            // synonymous to .is(':focus'), which is available in jquery >= 1.6
            if (this.search[0] === document.activeElement) { this.search.blur(); }
            this.clearSearch();
            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
        },

        // abstract
        focusSearch: function () {
            focus(this.search);
        },

        // abstract
        selectHighlighted: function (options) {
            if (this._touchMoved) {
              this.clearTouchMoved();
              return;
            }
            var index=this.highlight(),
                highlighted=this.results.find(".select2-highlighted"),
                data = highlighted.closest('.select2-result').data("select2-data");

            if (data) {
                this.highlight(index);
                this.onSelect(data, options);
            } else if (options && options.noFocus) {
                this.close();
            }
        },

        // abstract
        getPlaceholder: function () {
            var placeholderOption;
            return this.opts.element.attr("placeholder") ||
                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
                this.opts.element.data("placeholder") ||
                this.opts.placeholder ||
                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
        },

        // abstract
        getPlaceholderOption: function() {
            if (this.select) {
                var firstOption = this.select.children('option').first();
                if (this.opts.placeholderOption !== undefined ) {
                    //Determine the placeholder option based on the specified placeholderOption setting
                    return (this.opts.placeholderOption === "first" && firstOption) ||
                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
                    //No explicit placeholder option specified, use the first if it's blank
                    return firstOption;
                }
            }
        },

        /**
         * Get the desired width for the container element.  This is
         * derived first from option `width` passed to select2, then
         * the inline 'style' on the original element, and finally
         * falls back to the jQuery calculated element width.
         */
        // abstract
        initContainerWidth: function () {
            function resolveContainerWidth() {
                var style, attrs, matches, i, l, attr;

                if (this.opts.width === "off") {
                    return null;
                } else if (this.opts.width === "element"){
                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
                    // check if there is inline style on the element that contains width
                    style = this.opts.element.attr('style');
                    if (style !== undefined) {
                        attrs = style.split(';');
                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
                            attr = attrs[i].replace(/\s/g, '');
                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (matches !== null && matches.length >= 1)
                                return matches[1];
                        }
                    }

                    if (this.opts.width === "resolve") {
                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
                        // when attached to input type=hidden or elements hidden via css
                        style = this.opts.element.css('width');
                        if (style.indexOf("%") > 0) return style;

                        // finally, fallback on the calculated width of the element
                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
                    }

                    return null;
                } else if ($.isFunction(this.opts.width)) {
                    return this.opts.width();
                } else {
                    return this.opts.width;
               }
            };

            var width = resolveContainerWidth.call(this);
            if (width !== null) {
                this.container.css("width", width);
            }
        }
    });

    SingleSelect2 = clazz(AbstractSelect2, {

        // single

        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container"
            }).html([
                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
                "</a>",
                "<label for='' class='select2-offscreen'></label>",
                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
                "<div class='select2-drop select2-display-none'>",
                "   <div class='select2-search'>",
                "       <label for='' class='select2-offscreen'></label>",
                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
                "       aria-autocomplete='list' />",
                "   </div>",
                "   <ul class='select2-results' role='listbox'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // single
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.focusser.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // single
        opening: function () {
            var el, range, len;

            if (this.opts.minimumResultsForSearch >= 0) {
                this.showSearch(true);
            }

            this.parent.opening.apply(this, arguments);

            if (this.showSearchInput !== false) {
                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
                // all other browsers handle this just fine

                this.search.val(this.focusser.val());
            }
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
                // move the cursor to the end after focussing, otherwise it will be at the beginning and
                // new text will appear *before* focusser.val()
                el = this.search.get(0);
                if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                } else if (el.setSelectionRange) {
                    len = this.search.val().length;
                    el.setSelectionRange(len, len);
                }
            }

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.focusser.prop("disabled", true).val("");
            this.updateResults(true);
            this.opts.element.trigger($.Event("select2-open"));
        },

        // single
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);

            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        focus: function () {
            if (this.opened()) {
                this.close();
            } else {
                this.focusser.prop("disabled", false);
                if (this.opts.shouldFocusInput(this)) {
                    this.focusser.focus();
                }
            }
        },

        // single
        isFocused: function () {
            return this.container.hasClass("select2-container-active");
        },

        // single
        cancel: function () {
            this.parent.cancel.apply(this, arguments);
            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        destroy: function() {
            $("label[for='" + this.focusser.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "selection",
                "focusser"
            );
        },

        // single
        initContainer: function () {

            var selection,
                container = this.container,
                dropdown = this.dropdown,
                idSuffix = nextUid(),
                elementLabel;

            if (this.opts.minimumResultsForSearch < 0) {
                this.showSearch(false);
            } else {
                this.showSearch(true);
            }

            this.selection = selection = container.find(".select2-choice");

            this.focusser = container.find(".select2-focusser");

            // add aria associations
            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
            this.results.attr("id", "select2-results-"+idSuffix);
            this.search.attr("aria-owns", "select2-results-"+idSuffix);

            // rewrite labels from original element to focusser
            this.focusser.attr("id", "s2id_autogen"+idSuffix);

            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");

            this.focusser.prev()
                .text(elementLabel.text())
                .attr('for', this.focusser.attr('id'));

            // Ensure the original element retains an accessible name
            var originalTitle = this.opts.element.attr("title");
            this.opts.element.attr("title", (originalTitle || elementLabel.text()));

            this.focusser.attr("tabindex", this.elementTabIndex);

            // write label for search field using the label from the focusser element
            this.search.attr("id", this.focusser.attr('id') + '_search');

            this.search.prev()
                .text($("label[for='" + this.focusser.attr('id') + "']").text())
                .attr('for', this.search.attr('id'));

            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                // filter 229 keyCodes (input method editor is processing key input)
                if (229 == e.keyCode) return;

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                    return;
                }

                switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus: true});
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                }
            }));

            this.search.on("blur", this.bind(function(e) {
                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
                // without this the search field loses focus which is annoying
                if (document.activeElement === this.body.get(0)) {
                    window.setTimeout(this.bind(function() {
                        if (this.opened()) {
                            this.search.focus();
                        }
                    }), 0);
                }
            }));

            this.focusser.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
                    return;
                }

                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DOWN || e.which == KEY.UP
                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {

                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

                    this.open();
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
                    if (this.opts.allowClear) {
                        this.clear();
                    }
                    killEvent(e);
                    return;
                }
            }));


            installKeyUpChangeEvent(this.focusser);
            this.focusser.on("keyup-change input", this.bind(function(e) {
                if (this.opts.minimumResultsForSearch >= 0) {
                    e.stopPropagation();
                    if (this.opened()) return;
                    this.open();
                }
            }));

            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                this.clear();
                killEventImmediately(e);
                this.close();
                this.selection.focus();
            }));

            selection.on("mousedown touchstart", this.bind(function (e) {
                // Prevent IE from generating a click event on the body
                reinsertElement(selection);

                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }

                if (this.opened()) {
                    this.close();
                } else if (this.isInterfaceEnabled()) {
                    this.open();
                }

                killEvent(e);
            }));

            dropdown.on("mousedown touchstart", this.bind(function() {
                if (this.opts.shouldFocusInput(this)) {
                    this.search.focus();
                }
            }));

            selection.on("focus", this.bind(function(e) {
                killEvent(e);
            }));

            this.focusser.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            })).on("blur", this.bind(function() {
                if (!this.opened()) {
                    this.container.removeClass("select2-container-active");
                    this.opts.element.trigger($.Event("select2-blur"));
                }
            }));
            this.search.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            }));

            this.initContainerWidth();
            this.opts.element.addClass("select2-offscreen");
            this.setPlaceholder();

        },

        // single
        clear: function(triggerChange) {
            var data=this.selection.data("select2-data");
            if (data) { // guard against queued quick consecutive clicks
                var evt = $.Event("select2-clearing");
                this.opts.element.trigger(evt);
                if (evt.isDefaultPrevented()) {
                    return;
                }
                var placeholderOption = this.getPlaceholderOption();
                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
                this.selection.find(".select2-chosen").empty();
                this.selection.removeData("select2-data");
                this.setPlaceholder();

                if (triggerChange !== false){
                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
                    this.triggerChange({removed:data});
                }
            }
        },

        /**
         * Sets selection based on source element's value
         */
        // single
        initSelection: function () {
            var selected;
            if (this.isPlaceholderOptionSelected()) {
                this.updateSelection(null);
                this.close();
                this.setPlaceholder();
            } else {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(selected){
                    if (selected !== undefined && selected !== null) {
                        self.updateSelection(selected);
                        self.close();
                        self.setPlaceholder();
                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
                    }
                });
            }
        },

        isPlaceholderOptionSelected: function() {
            var placeholderOption;
            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
                || (this.opts.element.val() === "")
                || (this.opts.element.val() === undefined)
                || (this.opts.element.val() === null);
        },

        // single
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {
                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
                    // a single select box always has a value, no need to null check 'selected'
                    callback(self.optionToData(selected));
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var id = element.val();
                    //search in data by id, storing the actual matching item
                    var match = null;
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = equal(id, opts.id(el));
                            if (is_match) {
                                match = el;
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            callback(match);
                        }
                    });
                };
            }

            return opts;
        },

        // single
        getPlaceholder: function() {
            // if a placeholder is specified on a single select without a valid placeholder option ignore it
            if (this.select) {
                if (this.getPlaceholderOption() === undefined) {
                    return undefined;
                }
            }

            return this.parent.getPlaceholder.apply(this, arguments);
        },

        // single
        setPlaceholder: function () {
            var placeholder = this.getPlaceholder();

            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

                // check for a placeholder option if attached to a select
                if (this.select && this.getPlaceholderOption() === undefined) return;

                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));

                this.selection.addClass("select2-default");

                this.container.removeClass("select2-allowclear");
            }
        },

        // single
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var selected = 0, self = this, showSearchInput = true;

            // find the selected element in the result list

            this.findHighlightableChoices().each2(function (i, elm) {
                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
                    selected = i;
                    return false;
                }
            });

            // and highlight it
            if (noHighlightUpdate !== false) {
                if (initial === true && selected >= 0) {
                    this.highlight(selected);
                } else {
                    this.highlight(0);
                }
            }

            // hide the search box if this is the first we got the results and there are enough of them for search

            if (initial === true) {
                var min = this.opts.minimumResultsForSearch;
                if (min >= 0) {
                    this.showSearch(countResults(data.results) >= min);
                }
            }
        },

        // single
        showSearch: function(showSearchInput) {
            if (this.showSearchInput === showSearchInput) return;

            this.showSearchInput = showSearchInput;

            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
            //add "select2-with-searchbox" to the container if search box is shown
            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
        },

        // single
        onSelect: function (data, options) {

            if (!this.triggerSelect(data)) { return; }

            var old = this.opts.element.val(),
                oldData = this.data();

            this.opts.element.val(this.id(data));
            this.updateSelection(data);

            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
            this.close();

            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }

            if (!equal(old, this.id(data))) {
                this.triggerChange({ added: data, removed: oldData });
            }
        },

        // single
        updateSelection: function (data) {

            var container=this.selection.find(".select2-chosen"), formatted, cssClass;

            this.selection.data("select2-data", data);

            container.empty();
            if (data !== null) {
                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
            }
            if (formatted !== undefined) {
                container.append(formatted);
            }
            cssClass=this.opts.formatSelectionCssClass(data, container);
            if (cssClass !== undefined) {
                container.addClass(cssClass);
            }

            this.selection.removeClass("select2-default");

            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
                this.container.addClass("select2-allowclear");
            }
        },

        // single
        val: function () {
            var val,
                triggerChange = false,
                data = null,
                self = this,
                oldData = this.data();

            if (arguments.length === 0) {
                return this.opts.element.val();
            }

            val = arguments[0];

            if (arguments.length > 1) {
                triggerChange = arguments[1];
            }

            if (this.select) {
                this.select
                    .val(val)
                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
                        data = self.optionToData(elm);
                        return false;
                    });
                this.updateSelection(data);
                this.setPlaceholder();
                if (triggerChange) {
                    this.triggerChange({added: data, removed:oldData});
                }
            } else {
                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
                if (!val && val !== 0) {
                    this.clear(triggerChange);
                    return;
                }
                if (this.opts.initSelection === undefined) {
                    throw new Error("cannot call val() if initSelection() is not defined");
                }
                this.opts.element.val(val);
                this.opts.initSelection(this.opts.element, function(data){
                    self.opts.element.val(!data ? "" : self.id(data));
                    self.updateSelection(data);
                    self.setPlaceholder();
                    if (triggerChange) {
                        self.triggerChange({added: data, removed:oldData});
                    }
                });
            }
        },

        // single
        clearSearch: function () {
            this.search.val("");
            this.focusser.val("");
        },

        // single
        data: function(value) {
            var data,
                triggerChange = false;

            if (arguments.length === 0) {
                data = this.selection.data("select2-data");
                if (data == undefined) data = null;
                return data;
            } else {
                if (arguments.length > 1) {
                    triggerChange = arguments[1];
                }
                if (!value) {
                    this.clear(triggerChange);
                } else {
                    data = this.data();
                    this.opts.element.val(!value ? "" : this.id(value));
                    this.updateSelection(value);
                    if (triggerChange) {
                        this.triggerChange({added: value, removed:data});
                    }
                }
            }
        }
    });

    MultiSelect2 = clazz(AbstractSelect2, {

        // multi
        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container select2-container-multi"
            }).html([
                "<ul class='select2-choices'>",
                "  <li class='select2-search-field'>",
                "    <label for='' class='select2-offscreen'></label>",
                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
                "  </li>",
                "</ul>",
                "<div class='select2-drop select2-drop-multi select2-display-none'>",
                "   <ul class='select2-results'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // multi
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            // TODO validate placeholder is a string if specified

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {

                    var data = [];

                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
                        data.push(self.optionToData(elm));
                    });
                    callback(data);
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var ids = splitVal(element.val(), opts.separator);
                    //search in data by array of ids, storing matching items in a list
                    var matches = [];
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = $.grep(ids, function(id) {
                                return equal(id, opts.id(el));
                            }).length;
                            if (is_match) {
                                matches.push(el);
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            // reorder matches based on the order they appear in the ids array because right now
                            // they are in the order in which they appear in data array
                            var ordered = [];
                            for (var i = 0; i < ids.length; i++) {
                                var id = ids[i];
                                for (var j = 0; j < matches.length; j++) {
                                    var match = matches[j];
                                    if (equal(id, opts.id(match))) {
                                        ordered.push(match);
                                        matches.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                            callback(ordered);
                        }
                    });
                };
            }

            return opts;
        },

        // multi
        selectChoice: function (choice) {

            var selected = this.container.find(".select2-search-choice-focus");
            if (selected.length && choice && choice[0] == selected[0]) {

            } else {
                if (selected.length) {
                    this.opts.element.trigger("choice-deselected", selected);
                }
                selected.removeClass("select2-search-choice-focus");
                if (choice && choice.length) {
                    this.close();
                    choice.addClass("select2-search-choice-focus");
                    this.opts.element.trigger("choice-selected", choice);
                }
            }
        },

        // multi
        destroy: function() {
            $("label[for='" + this.search.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "searchContainer",
                "selection"
            );
        },

        // multi
        initContainer: function () {

            var selector = ".select2-choices", selection;

            this.searchContainer = this.container.find(".select2-search-field");
            this.selection = selection = this.container.find(selector);

            var _this = this;
            this.selection.on("click", ".select2-search-choice:not(.select2-locked)", function (e) {
                //killEvent(e);
                _this.search[0].focus();
                _this.selectChoice($(this));
            });

            // rewrite labels from original element to focusser
            this.search.attr("id", "s2id_autogen"+nextUid());

            this.search.prev()
                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
                .attr('for', this.search.attr('id'));

            this.search.on("input paste", this.bind(function() {
                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
                if (!this.isInterfaceEnabled()) return;
                if (!this.opened()) {
                    this.open();
                }
            }));

            this.search.attr("tabindex", this.elementTabIndex);

            this.keydowns = 0;
            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                ++this.keydowns;
                var selected = selection.find(".select2-search-choice-focus");
                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
                var next = selected.next(".select2-search-choice:not(.select2-locked)");
                var pos = getCursorInfo(this.search);

                if (selected.length &&
                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
                    var selectedChoice = selected;
                    if (e.which == KEY.LEFT && prev.length) {
                        selectedChoice = prev;
                    }
                    else if (e.which == KEY.RIGHT) {
                        selectedChoice = next.length ? next : null;
                    }
                    else if (e.which === KEY.BACKSPACE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = prev.length ? prev : next;
                        }
                    } else if (e.which == KEY.DELETE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = next.length ? next : null;
                        }
                    } else if (e.which == KEY.ENTER) {
                        selectedChoice = null;
                    }

                    this.selectChoice(selectedChoice);
                    killEvent(e);
                    if (!selectedChoice || !selectedChoice.length) {
                        this.open();
                    }
                    return;
                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {

                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
                    killEvent(e);
                    return;
                } else {
                    this.selectChoice(null);
                }

                if (this.opened()) {
                    switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus:true});
                        this.close();
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                    }
                }

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
                    return;
                }

                if (e.which === KEY.ENTER) {
                    if (this.opts.openOnEnter === false) {
                        return;
                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                        return;
                    }
                }

                this.open();

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                }

                if (e.which === KEY.ENTER) {
                    // prevent form from being submitted
                    killEvent(e);
                }

            }));

            this.search.on("keyup", this.bind(function (e) {
                this.keydowns = 0;
                this.resizeSearch();
            })
            );

            this.search.on("blur", this.bind(function(e) {
                this.container.removeClass("select2-container-active");
                this.search.removeClass("select2-focused");
                this.selectChoice(null);
                if (!this.opened()) this.clearSearch();
                e.stopImmediatePropagation();
                this.opts.element.trigger($.Event("select2-blur"));
            }));

            this.container.on("click", selector, this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                if ($(e.target).closest(".select2-search-choice").length > 0) {
                    // clicked inside a select2 search choice, do not open
                    return;
                }
                this.selectChoice(null);
                this.clearPlaceholder();
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.open();
                this.focusSearch();
                e.preventDefault();
            }));

            this.container.on("focus", selector, this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
                this.dropdown.addClass("select2-drop-active");
                this.clearPlaceholder();
            }));

            this.initContainerWidth();
            this.opts.element.addClass("select2-offscreen");

            // set the placeholder if necessary
            this.clearSearch();
        },

        // multi
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.search.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // multi
        initSelection: function () {
            var data;
            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
                this.updateSelection([]);
                this.close();
                // set the placeholder if necessary
                this.clearSearch();
            }
            if (this.select || this.opts.element.val() !== "") {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(data){
                    if (data !== undefined && data !== null) {
                        self.updateSelection(data);
                        self.close();
                        // set the placeholder if necessary
                        self.clearSearch();
                    }
                });
            }
        },

        // multi
        clearSearch: function () {
            var placeholder = this.getPlaceholder(),
                maxWidth = this.getMaxSearchWidth();

            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
                this.search.val(placeholder).addClass("select2-default");
                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
            } else {
                this.search.val("").width(10);
            }
        },

        // multi
        clearPlaceholder: function () {
            if (this.search.hasClass("select2-default")) {
                this.search.val("").removeClass("select2-default");
            }
        },

        // multi
        opening: function () {
            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
            this.resizeSearch();

            this.parent.opening.apply(this, arguments);

            this.focusSearch();

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.updateResults(true);
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
            }
            this.opts.element.trigger($.Event("select2-open"));
        },

        // multi
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
        },

        // multi
        focus: function () {
            this.close();
            this.search.focus();
        },

        // multi
        isFocused: function () {
            return this.search.hasClass("select2-focused");
        },

        // multi
        updateSelection: function (data) {
            var ids = [], filtered = [], self = this;

            // filter out duplicates
            $(data).each(function () {
                if (indexOf(self.id(this), ids) < 0) {
                    ids.push(self.id(this));
                    filtered.push(this);
                }
            });
            data = filtered;

            this.selection.find(".select2-search-choice").remove();
            $(data).each(function () {
                self.addSelectedChoice(this);
            });
            self.postprocessResults();
        },

        // multi
        tokenize: function() {
            var input = this.search.val();
            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
            if (input != null && input != undefined) {
                this.search.val(input);
                if (input.length > 0) {
                    this.open();
                }
            }

        },

        // multi
        onSelect: function (data, options) {

            if (!this.triggerSelect(data) || data.text === "") { return; }

            this.addSelectedChoice(data);

            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

            // keep track of the search's value before it gets cleared
            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());

            this.clearSearch();
            this.updateResults();

            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);

            if (this.opts.closeOnSelect) {
                this.close();
                this.search.width(10);
            } else {
                if (this.countSelectableResults()>0) {
                    this.search.width(10);
                    this.resizeSearch();
                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
                        // if we reached max selection size repaint the results so choices
                        // are replaced with the max selection reached message
                        this.updateResults(true);
                    } else {
                        // initializes search's value with nextSearchTerm and update search result
                        if(this.nextSearchTerm != undefined){
                            this.search.val(this.nextSearchTerm);
                            this.updateResults();
                            this.search.select();
                        }
                    }
                    this.positionDropdown();
                } else {
                    // if nothing left to select close
                    this.close();
                    this.search.width(10);
                }
            }

            // since its not possible to select an element that has already been
            // added we do not need to check if this is a new element before firing change
            this.triggerChange({ added: data });

            if (!options || !options.noFocus)
                this.focusSearch();
        },

        // multi
        cancel: function () {
            this.close();
            this.focusSearch();
        },

        addSelectedChoice: function (data) {
            var enableChoice = !data.locked,
                enabledItem = $(
                    "<li class='select2-search-choice'>" +
                    "    <div></div>" +
                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
                    "</li>"),
                disabledItem = $(
                    "<li class='select2-search-choice select2-locked'>" +
                    "<div></div>" +
                    "</li>");
            var choice = enableChoice ? enabledItem : disabledItem,
                id = this.id(data),
                val = this.getVal(),
                formatted,
                cssClass;

            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
            if (formatted != undefined) {
                choice.find("div").replaceWith("<div>"+formatted+"</div>");
            }
            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
            if (cssClass != undefined) {
                choice.addClass(cssClass);
            }

            if(enableChoice){
              choice.find(".select2-search-choice-close")
                  .on("mousedown", killEvent)
                  .on("click dblclick", this.bind(function (e) {
                  if (!this.isInterfaceEnabled()) return;

                  this.unselect($(e.target));
                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
                  killEvent(e);
                  this.close();
                  this.focusSearch();
              })).on("focus", this.bind(function () {
                  if (!this.isInterfaceEnabled()) return;
                  this.container.addClass("select2-container-active");
                  this.dropdown.addClass("select2-drop-active");
              }));
            }

            choice.data("select2-data", data);
            choice.insertBefore(this.searchContainer);

            val.push(id);
            this.setVal(val);
        },

        // multi
        unselect: function (selected) {
            var val = this.getVal(),
                data,
                index;
            selected = selected.closest(".select2-search-choice");

            if (selected.length === 0) {
                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
            }

            data = selected.data("select2-data");

            if (!data) {
                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
                // and invoked on an element already removed
                return;
            }

            var evt = $.Event("select2-removing");
            evt.val = this.id(data);
            evt.choice = data;
            this.opts.element.trigger(evt);

            if (evt.isDefaultPrevented()) {
                return false;
            }

            while((index = indexOf(this.id(data), val)) >= 0) {
                val.splice(index, 1);
                this.setVal(val);
                if (this.select) this.postprocessResults();
            }

            selected.remove();

            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
            this.triggerChange({ removed: data });

            return true;
        },

        // multi
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var val = this.getVal(),
                choices = this.results.find(".select2-result"),
                compound = this.results.find(".select2-result-with-children"),
                self = this;

            choices.each2(function (i, choice) {
                var id = self.id(choice.data("select2-data"));
                if (indexOf(id, val) >= 0) {
                    choice.addClass("select2-selected");
                    // mark all children of the selected parent as selected
                    choice.find(".select2-result-selectable").addClass("select2-selected");
                }
            });

            compound.each2(function(i, choice) {
                // hide an optgroup if it doesn't have any selectable children
                if (!choice.is('.select2-result-selectable')
                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
                    choice.addClass("select2-selected");
                }
            });

            if (this.highlight() == -1 && noHighlightUpdate !== false){
                self.highlight(0);
            }

            //If all results are chosen render formatNoMatches
            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
                    }
                }
            }

        },

        // multi
        getMaxSearchWidth: function() {
            return this.selection.width() - getSideBorderPadding(this.search);
        },

        // multi
        resizeSearch: function () {
            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
                sideBorderPadding = getSideBorderPadding(this.search);

            minimumWidth = measureTextWidth(this.search) + 10;

            left = this.search.offset().left;

            maxWidth = this.selection.width();
            containerLeft = this.selection.offset().left;

            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

            if (searchWidth < minimumWidth) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth < 40) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth <= 0) {
              searchWidth = minimumWidth;
            }

            this.search.width(Math.floor(searchWidth));
        },

        // multi
        getVal: function () {
            var val;
            if (this.select) {
                val = this.select.val();
                return val === null ? [] : val;
            } else {
                val = this.opts.element.val();
                return splitVal(val, this.opts.separator);
            }
        },

        // multi
        setVal: function (val) {
            var unique;
            if (this.select) {
                this.select.val(val);
            } else {
                unique = [];
                // filter out duplicates
                $(val).each(function () {
                    if (indexOf(this, unique) < 0) unique.push(this);
                });
                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
            }
        },

        // multi
        buildChangeDetails: function (old, current) {
            var current = current.slice(0),
                old = old.slice(0);

            // remove intersection from each array
            for (var i = 0; i < current.length; i++) {
                for (var j = 0; j < old.length; j++) {
                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
                        current.splice(i, 1);
                        if(i>0){
                        	i--;
                        }
                        old.splice(j, 1);
                        j--;
                    }
                }
            }

            return {added: current, removed: old};
        },


        // multi
        val: function (val, triggerChange) {
            var oldData, self=this;

            if (arguments.length === 0) {
                return this.getVal();
            }

            oldData=this.data();
            if (!oldData.length) oldData=[];

            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
            if (!val && val !== 0) {
                this.opts.element.val("");
                this.updateSelection([]);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange({added: this.data(), removed: oldData});
                }
                return;
            }

            // val is a list of ids
            this.setVal(val);

            if (this.select) {
                this.opts.initSelection(this.select, this.bind(this.updateSelection));
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
                }
            } else {
                if (this.opts.initSelection === undefined) {
                    throw new Error("val() cannot be called if initSelection() is not defined");
                }

                this.opts.initSelection(this.opts.element, function(data){
                    var ids=$.map(data, self.id);
                    self.setVal(ids);
                    self.updateSelection(data);
                    self.clearSearch();
                    if (triggerChange) {
                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
                    }
                });
            }
            this.clearSearch();
        },

        // multi
        onSortStart: function() {
            if (this.select) {
                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
            }

            // collapse search field into 0 width so its container can be collapsed as well
            this.search.width(0);
            // hide the container
            this.searchContainer.hide();
        },

        // multi
        onSortEnd:function() {

            var val=[], self=this;

            // show search and move it to the end of the list
            this.searchContainer.show();
            // make sure the search container is the last item in the list
            this.searchContainer.appendTo(this.searchContainer.parent());
            // since we collapsed the width in dragStarted, we resize it here
            this.resizeSearch();

            // update selection
            this.selection.find(".select2-search-choice").each(function() {
                val.push(self.opts.id($(this).data("select2-data")));
            });
            this.setVal(val);
            this.triggerChange();
        },

        // multi
        data: function(values, triggerChange) {
            var self=this, ids, old;
            if (arguments.length === 0) {
                 return this.selection
                     .children(".select2-search-choice")
                     .map(function() { return $(this).data("select2-data"); })
                     .get();
            } else {
                old = this.data();
                if (!values) { values = []; }
                ids = $.map(values, function(e) { return self.opts.id(e); });
                this.setVal(ids);
                this.updateSelection(values);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(old, this.data()));
                }
            }
        }
    });

    $.fn.select2 = function () {

        var args = Array.prototype.slice.call(arguments, 0),
            opts,
            select2,
            method, value, multiple,
            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
            valueMethods = ["opened", "isFocused", "container", "dropdown"],
            propertyMethods = ["val", "data"],
            methodsMap = { search: "externalSearch" };

        this.each(function () {
            if (args.length === 0 || typeof(args[0]) === "object") {
                opts = args.length === 0 ? {} : $.extend({}, args[0]);
                opts.element = $(this);

                if (opts.element.get(0).tagName.toLowerCase() === "select") {
                    multiple = opts.element.prop("multiple");
                } else {
                    multiple = opts.multiple || false;
                    if ("tags" in opts) {opts.multiple = multiple = true;}
                }

                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
                select2.init(opts);
            } else if (typeof(args[0]) === "string") {

                if (indexOf(args[0], allowedMethods) < 0) {
                    throw "Unknown method: " + args[0];
                }

                value = undefined;
                select2 = $(this).data("select2");
                if (select2 === undefined) return;

                method=args[0];

                if (method === "container") {
                    value = select2.container;
                } else if (method === "dropdown") {
                    value = select2.dropdown;
                } else {
                    if (methodsMap[method]) method = methodsMap[method];

                    value = select2[method].apply(select2, args.slice(1));
                }
                if (indexOf(args[0], valueMethods) >= 0
                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
                    return false; // abort the iteration, ready to return first matched value
                }
            } else {
                throw "Invalid arguments to select2 plugin: " + args;
            }
        });
        return (value === undefined) ? this : value;
    };

    // plugin defaults, accessible to users
    $.fn.select2.defaults = {
        width: "copy",
        loadMorePadding: 0,
        closeOnSelect: true,
        openOnEnter: true,
        containerCss: {},
        dropdownCss: {},
        containerCssClass: "",
        dropdownCssClass: "",
        formatResult: function(result, container, query, escapeMarkup) {
            var markup=[];
            markMatch(result.text, query.term, markup, escapeMarkup);
            return markup.join("");
        },
        formatSelection: function (data, container, escapeMarkup) {
            return data ? escapeMarkup(data.text) : undefined;
        },
        sortResults: function (results, container, query) {
            return results;
        },
        formatResultCssClass: function(data) {return data.css;},
        formatSelectionCssClass: function(data, container) {return undefined;},
        minimumResultsForSearch: 0,
        minimumInputLength: 0,
        maximumInputLength: null,
        maximumSelectionSize: 0,
        id: function (e) { return e == undefined ? null : e.id; },
        matcher: function(term, text) {
            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
        },
        separator: ",",
        tokenSeparators: [],
        tokenizer: defaultTokenizer,
        escapeMarkup: defaultEscapeMarkup,
        blurOnChange: false,
        selectOnBlur: false,
        adaptContainerCssClass: function(c) { return c; },
        adaptDropdownCssClass: function(c) { return null; },
        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
        searchInputPlaceholder: '',
        createSearchChoicePosition: 'top',
        shouldFocusInput: function (instance) {
            // Attempt to detect touch devices
            var supportsTouchEvents = (('ontouchstart' in window) ||
                                       (navigator.msMaxTouchPoints > 0));

            // Only devices which support touch events should be special cased
            if (!supportsTouchEvents) {
                return true;
            }

            // Never focus the input if search is disabled
            if (instance.opts.minimumResultsForSearch < 0) {
                return false;
            }

            return true;
        }
    };

    $.fn.select2.locales = [];

    $.fn.select2.locales['en'] = {
         formatMatches: function (matches) { if (matches === 1) { return "One result is available, press enter to select it."; } return matches + " results are available, use up and down arrow keys to navigate."; },
         formatNoMatches: function () { return "No matches found"; },
         formatAjaxError: function (jqXHR, textStatus, errorThrown) { return "Loading failed"; },
         formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1 ? "" : "s"); },
         formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1 ? "" : "s"); },
         formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
         formatLoadMore: function (pageNumber) { return "Loading more results…"; },
         formatSearching: function () { return "Searching…"; },
    };

    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);

    $.fn.select2.ajaxDefaults = {
        transport: $.ajax,
        params: {
            type: "GET",
            cache: false,
            dataType: "json"
        }
    };

    // exports
    window.Select2 = {
        query: {
            ajax: ajax,
            local: local,
            tags: tags
        }, util: {
            debounce: debounce,
            markMatch: markMatch,
            escapeMarkup: defaultEscapeMarkup,
            stripDiacritics: stripDiacritics
        }, "class": {
            "abstract": AbstractSelect2,
            "single": SingleSelect2,
            "multi": MultiSelect2
        }
    };

}(jQuery));

},{}],344:[function(require,module,exports){
(function() {
  app.templates = [];
app.templates['admin-emailForUsers-EmailForUsersFormView'] = ' <form id="users-email-data-form"><fieldset><legend>Laiškas sistemo vartotojams</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input"><input id="title" type="text" placeholder="Pavadinimas" name="title" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Laiško tekstas</div><div class="game-form-item-input"><input id="content" type="text" placeholder="Laiško tekstas" name="content" data-error-style="inline"/></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsiųsti</button></form> '; 
app.templates['availableGameTripRanking-availableGameTripRankingDisplayPage-AvailableGameTripRankingDataDisplayView'] = ' <div class="main-info row-fluid"><div class="text"><h3 class="main-text"><%= name %></h3></div></div><fieldset><legend class="uppercase no-border"><%= app.getMessage("ranking_plural") %></legend><table id="ratings-info" class="table table-condensed table-hover"><tr><td class="title"> <%= app.getMessage("referee_genitive") %> <%= app.getMessage("ranking") %></td><td> <%= referee_ranking %></td></tr><tr></tr><td class="title"> <%= app.getMessage("commissioner_genitive") %> <%= app.getMessage("ranking") %></td><td> <%= commissioner_ranking %></td><tr><td class="title"> <%= app.getMessage("driver_genitive") %> <%= app.getMessage("ranking") %></td><td> <%= driver_ranking %></td></tr></table></fieldset> '; 
app.templates['availableGameTripRanking-availableGameTripRankingEditPage-AvailableGameTripRankingFormView'] = ' <form id="league-data-form"><fieldset><legend>Kelionės reitingai</legend><div class="row-fluid with-margin-top"><div class="game-form-item span6"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input"><input id="name" type="text" placeholder="Pavadinimas" name="name" data-error-style="inline"/></div></div></div></fieldset><fieldset><legend class="uppercase"><%= app.getMessage("ranking_plural") %></legend><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label"><%= app.getMessage("referee_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_ranking" type="text" placeholder="30" name="referee_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label capitalize"><%= app.getMessage("commissioner_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="commissioner_ranking" type="text" placeholder="30" name="commissioner_ranking" data-error-style="inline"/></div></div><div class="game-form-item span4"><div class="game-form-item-label"><%= app.getMessage("driver_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="driver_ranking" type="text" placeholder="30" name="driver_ranking" data-error-style="inline"/></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['availableGameTripRanking-availableGameTripRankingsPage-AvailableGameTripRankingListItemView'] = ' <td><%= name %></td><td class="actions-column"><div class="btn-group"><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['availableGameTripRanking-availableGameTripRankingsPage-AvailableGameTripRankingsListView'] = ' <div class="scrollable-content"><table id="available-rankings-list" class="table table-condensed table-hover"><thead><tr><th>Pavadinimas</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['components-gamesList-GamesListItemView'] = ' <td><%= game_number %></td><td class="league-col big-letters"><%= league.code %></td><td class="time-col"><%= shortTimeExpr %></td><td class="hidden-on-mobile"><%= team1 %> -  <%= team2 %></td><td><%= address %></td><td data-content="refs-selection" class="hidden-on-mobile appointment-display"></td><td data-content="persons-selection" class="hidden-on-mobile appointment-display"></td> '; 
app.templates['components-gamesList-GamesListSeparatorView'] = ' <td colspan="8"><%= date %> (<%= dayExpr %>)</td> '; 
app.templates['components-gamesList-GamesListView'] = ' <div class="scrollable-content"><div class="form-inline filters-form"><label>Rungtynių data nuo:</label><input id="filter_by_date" type="text" placeholder="2012-02-02" name="date-filter"/></div><table id="games-list" class="table table-condensed table-hover schedule-display"><thead><tr><th data-value="game_number">Nr.</th><th data-value="league-code" class="league-col">Lyga:</th><th data-value="event-date">Data:</th><th data-value="event-teams" class="hidden-on-mobile">Komandos:</th><th data-value="event-address">Adresas:</th><th class="hidden-on-mobile game-appointments-display-col-big">Teisėjai:</th><th data-content="persons-selection" class="capitalize hidden-on-mobile game-appointments-display-col-big">Kiti dalyviai</th></tr></thead><tbody></tbody></table></div> '; 
app.templates['components-leagueSelection-LeagueSelectionView'] = ' <select name="league_id"></select> '; 
app.templates['components-modalWindow-ModalWindowView'] = ' <div class="modal-header"><button type="button" data-dismiss="modal" aria-hidden="true" class="close">×</button><h3><%= headerText %></h3><div class="modal-body"></div></div> '; 
app.templates['components-monthSelectionFilter-MonthSelectionFilterView'] = ' <div class="form-inline filters-form"><label>Mėnuo:</label><select id="filter_month" name="month-filter"></select></div> '; 
app.templates['components-postsList-PostListItemView'] = ' <div class="news-date span2"><div class="day"><%= postDay %></div><div class="month"><%= postMonth %></div></div><div class="news-content span10"><div data-action="close-post" class="title"><%= title %></div><div class="intro-text"><%= croppedContent %></div></div><div class="row-fluid"><div class="span12"><div class="btn-group pull-right with-margin-top"><a href="#" title="Redaguoti" data-action="edit-post" data-display-type="only-admin" class="btn btn-blue btn-mini">Redaguoti</a><a href="#" title="Ištrinti" data-action="delete-post" data-display-type="only-admin" class="btn btn-mini btn-danger">Ištrinti</a></div></div></div> '; 
app.templates['components-postsList-PostView'] = ' <div class="post-display-view"><div class="full-width"><%= content %></div></div> '; 
app.templates['components-postsList-PostsListView'] = ' <div class="scrollable-content"><div class="row-fluid news-list"></div></div> '; 
app.templates['components-rangeSelectionFilter-RangeSelectionFilterView'] = ' <div class="filter-item"><label>Nuo:</label><input id="date_from" type="text" placeholder="2012-12-12" name="date_from"/></div><div class="filter-item"><label>Iki:</label><input id="date_to" type="text" placeholder="2012-12-14" name="date_to"/></div> '; 
app.templates['components-usersList-UsersListFilterView'] = ' <label>Tipas:</label><select id="filter_user_type" name="user_type" class="capitalize"><option value="referee">teisėjas</option><option value="commissioner" class="capitalize">Inspektorius</option><option value="administration" data-display-type="only-admin" class="capitalize">Administracija</option><option value="delegate" class="capitalize">Delegatas</option></select><label>Vardas arba pavardė:</label><input id="filter_text" type="text" placeholder="Jonas Jonaitis" name="user_name"/> '; 
app.templates['dashboard-DashboardMyGamesListItemView'] = ' <td class="league-col big-letters"><%= league.code %></td><td><%= shortTimeExpr %></td><td class="hidden-on-mobile"><%= team1 %> -  <%= team2 %></td><td><%= address %></td><td data-content="refs-selection" class="hidden-on-mobile appointment-display inline game-appointments-display-col-big"></td><td data-content="persons-selection" class="hidden-on-mobile appointment-display inline game-appointments-display-col-big"></td> '; 
app.templates['dashboard-DashboardMyGamesListView'] = ' <div class="scrollable-content"><div class="form-inline"><label><%= app.getMessage("fieldDate") %></label><input id="filter_by_date" type="text" placeholder="2012-02-02" name="date-filter"/></div><table id="games-list" class="table table-condensed table-hover schedule-display"><thead><tr><th data-value="league-code"><%= app.getMessage("fieldLeague") %></th><th data-value="event-date"><%= app.getMessage("fieldDate") %></th><th data-value="event-teams" class="hidden-on-mobile"><%= app.getMessage("fieldTeams") %></th><th data-value="event-address"><%= app.getMessage("fieldAddress") %></th><th data-content="refs-selection" class="hidden-on-mobile game-appointments-display-col-big"><%= app.getMessage("referees") %></th><th data-content="persons-selection" class="hidden-on-mobile game-appointments-display-col-big"><%= app.getMessage("other_participant") %></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['dashboard-DashboardPopupContentView'] = ' <p>VKTS ragina pasinaudoti Lietuvos Respublikos gyventojų pajamų mokesčio įstatymu ir be papildomų išlaidų skirti 2 procentų paramą nuo per mokestinį laikotarpį (2013 m.) savo sumokėtų pajamų mokesčio.</p><p>VISOS SURINKTOS LĖŠOS BUS SKIRIAMOS VKTS NARIŲ PERŽIŪROMS, ŠVENTĖMS IR KITIEMS SVARBIEMS KLAUSIMAMS SPRĘSTI.</p><h4>Detalesnę informaciją rasite naujienų skiltyje</h4> '; 
app.templates['documents-documentsPage-DocumentCategoryDisplay'] = ' <div data-action="close-item" style="border-bottom: 1px solid #e5e5e5;" class="margin-bottom"><%= title %><i style="font-size: 18px;float: right;" data-original-title="Redaguoti" class="icon-double-angle-up"></i></div><div data-content="documents" class="documents inlineGrid margin-bottom"></div><div data-display-type="only-admin" class="actions margin-bottom"><div class="btn-group"><button data-action="add-document" class="btn btn-success btn-small"><i class="icon-plus"></i>&nbsp; Pridėti dokumentą</button><button data-action="remove-item" class="btn btn-danger btn-small"><i class="icon-remove"></i></button><button data-action="edit-item" class="btn btn-success btn-small"><i class="icon-edit"></i></button></div></div> '; 
app.templates['documents-documentsPage-DocumentCategoryFormView'] = ' <form id="document-category-form" autocomplete="off"><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("fieldTitle") %></div><div class="game-form-item-input"><input id="title" type="text" placeholder="" name="title" data-error-style="inline"/></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></div></form> '; 
app.templates['documents-documentsPage-DocumentCategoryListItemView'] = ' <td><%= title %></td><td style="vertical-align:middle"><i style="font-size: 18px;float: right;" data-original-title="Redaguoti" class="icon-double-angle-down"></i></td> '; 
app.templates['documents-documentsPage-DocumentCategoryListView'] = ' <button data-action="add-record" data-display-type="only-admin" class="btn btn-success margin-bottom"><i class="icon-plus"></i>&nbsp; Pridėti kategoriją</button><div class="scrollable-content"><table id="doc-categories-list" class="table table-condensed table-hover"><thead><tr><th></th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['documents-documentsPage-DocumentDisplayView'] = ' <div class="box"><div class="padding-div"><a data-content="link" target="_blank" class="margin-right"><%= title %></a><button data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></button></div></div> '; 
app.templates['documents-documentsPage-DocumentFormView'] = ' <form id="document-category-form" autocomplete="off"><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("fieldTitle") %></div><div class="game-form-item-input"><input id="title" type="text" placeholder="" name="title" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("fieldFile") %></div><div class="game-form-item-input"><input id="file" type="file" placeholder="" name="file" data-error-style="inline"/></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></div></form> '; 
app.templates['documents-documentsPage-DocumentsFormView'] = ' <form id="documents-form" autocomplete="off"><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("startDate") %></div><div class="game-form-item-input"><input id="start_date" type="text" placeholder="2012-05-05" name="start_date" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("endDate") %></div><div class="game-form-item-input"><input id="end_date" type="text" placeholder="2012-05-05" name="end_date" data-error-style="inline"/></div></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['game-gameDisplayPage-GameDataDisplayView'] = ' <div class="main-info row-fluid"><div class="text"><h3 class="main-text">Rungtynių informacija</h3><table id="league-info" class="table table-condensed table-hover"><tr><td class="title">Rungtynių numeris:</td><td> <%= game_number %></td></tr><tr><td class="title"> Lyga:</td><td> <%= league.name %></td></tr><tr><td class="title">Data:</td><td><%= event_date %></td></tr><tr><td class="title">Adresas:</td><td><%= address %></td></tr><tr><td class="title">Komandos:</td><td><%= team1 %> - <%= team2 %></td></tr><tr class="modified"><td class="title">Kuri rungtynių informacija pasikeitė?:</td><td><%= modified_text %></td></tr><tr><td class="title">TV transliacija:</td><td><%= tv_broadcast ? app.getMessage("yes") : app.getMessage("no") %></td></tr><tr class="canceled"><td colspan="2">Rungtynės neįvyks</td></tr></table></div></div><fieldset data-content="appointments-display"><legend>Paskyrimai</legend><div class="row-fluid"><div data-content="refs-selection" class="span6"><h5>Teisėjai</h5></div><div data-content="secretary-selection" class="span6"><h5>Sekretoriato darbuotojai</h5></div></div></fieldset><div data-content="game-driver"></div><div data-content="evaluations"></div> '; 
app.templates['game-gameDisplayPage-GameDriverSelectionView'] = ' <div><fieldset><legend>Rungtynių vairuotojas</legend></fieldset><div class="row-fluid"><div class="span12"><select id="driver" name="driver"><option value=""></option></select></div></div></div> '; 
app.templates['game-gameEditPage-GameFormView'] = ' <form id="league-data-form"><div data-content="appointments-selection"></div><fieldset><legend>Rungtynių informacija</legend><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">Lyga</div><div data-content="league-selection" class="game-form-item-input"></div></div><div class="game-form-item span6"><div class="game-form-item-label">Rungtynių numeris</div><div class="game-form-item-input"><input id="game_number" type="text" placeholder="0" name="game_number" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span6 game-form-item"><div class="game-form-item-label">Šeimininkai</div><div class="game-form-item-input"><input id="team1" type="text" placeholder="Šeimininkai" name="team1" data-error-style="inline"/></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Svečiai</div><div class="game-form-item-input"><input id="team2" type="text" placeholder="Svečiai" name="team2" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span4 game-form-item"><div class="game-form-item-label">Data</div><div class="game-form-item-input"><input id="event_date" type="text" placeholder="2012-05-05 05:15" name="event_date" data-error-style="inline"/></div></div><div class="span8 game-form-item"><div class="game-form-item-label">Adresas</div><div class="game-form-item-input full-width"><input id="address" type="text" placeholder="Adresas" name="address" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid with-margin-top"><div class="span4 game-form-item trip-mail clearfix"><label style="float:left" class="checkbox"><a data-action="open-trip-mail">Kelionės informacija</a></label></div><div class="span4 game-form-item clearfix"><label style="float:left" class="checkbox"><span class="checkbox-label">TV transliacija</span><input id="tv_broadcast" data-action="tv_broadcast" type="checkbox" name="tv_broadcast"/></label></div><div class="span4 game-form-item"><label class="checkbox"><span class="checkbox-label">Pasikeitė informacija</span><input id="modified" data-action="modified" type="checkbox" name="modified"/></label></div><div class="span4 game-form-item"><label class="checkbox"><span class="checkbox-label">Atšaukta</span><input id="canceled" type="checkbox" name="canceled"/></label></div><div class="span4 game-form-item"><label class="checkbox"><span class="checkbox-label">Rungtynių analitikas</span><input id="commissioner_remotely" type="checkbox" name="commissioner_remotely"/></label></div></div><div data-type="modified-text" class="row-fluid with-margin-top"><div class="game-form-item-label">Kuri rungtynių informacija pasikeitė?<div class="game-form-item-input full-width"><textarea id="modified_text" type="text" placeholder="Kuri rungtynių informacija pasikeitė?" name="modified_text" data-error-style="inline" class="full-width"></textarea></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['game-gamesPage-GamesListItemView'] = ' <td><%= game_number %></td><td class="league-col big-letters"><%= league.code %></td><td><%= shortTimeExpr %></td><td class="hidden-on-mobile"><%= team1 %> - <%= team2 %></td><td><%= address %></td><td data-content="refs-selection" class="hidden-on-mobile appointment-display inline game-appointments-display-col-big"></td><td data-content="persons-selection" class="hidden-on-mobile appointment-display inline game-appointments-display-col-big"></td><td style="vertical-align:middle"><i style="font-size: 18px;" data-original-title="Redaguoti" class="icon-double-angle-down"></i></td> '; 
app.templates['game-gamesPage-GamesListView'] = ' <div class="scrollable-content"><div class="form-inline filters-form"><div class="filter-holder"><label>Rungtynių data nuo:</label><input id="filter_by_date" type="text" placeholder="2012-02-02" name="date-filter"/></div><div data-content="league-selection" class="filter-holder league-selection"><label class="pull-left">Lyga:</label></div><div class="filter-holder"><label>Atvaizduoti:</label><select id="display_user_type" name="user_type" class="capitalize"><option value="refs-selection">teisėjus</option><option value="persons-selection"><%= app.getMessage("other_participants_accusative") %></option><option value="all">Rodyti visus įrašus</option></select></div></div><table id="games-list" class="table table-condensed table-hover schedule-display"><thead><tr><th data-value="game_number">Nr.</th><th data-value="league-code" class="league-col">Lyga</th><th data-value="event-date">Data</th><th data-value="event-teams" class="hidden-on-mobile">Komandos</th><th data-value="event-address">Adresas</th><th data-content="refs-selection" class="hidden-on-mobile game-appointments-display-col-big">Teisėjai</th><th data-content="persons-selection" class="hidden-on-mobile game-appointments-display-col-big"><%= app.getMessage("other_participant") %></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['gameAppointment-GameAppointmentConfirmButtonView'] = ' <a href="#" class="dropdown-toogle selectable"><i data-value="status-display" class="with-tooltip-top"></i></a><ul class="dropdown-menu pull-right"><li><a data-action="status-approved">Tinka</a></li><li><a data-action="status-declined">Netinka</a></li><li data-display-type="only-admin"><a data-action="status-pending">Nepatvirtinta</a></li></ul> '; 
app.templates['gameAppointment-gameAppointmentDisplay-GameAppointmentDisplayView'] = ' <div class="appointment-title span3"> <%= app.getMessage(user_type_in_event) %></div><div class="appointment-owner span3"> <%= user!=null?user.short_name:"" %></div><div class="appointment-status span2"></div> '; 
app.templates['gameAppointment-gameAppointmentsEdit-GameAppointmentInputView'] = ' <div class="appointment-title span3 capitalize"><%= app.getMessage(user_type_in_event) %></div><div class="span9 appointment-selection"><input id="user_name" data-value="appointment-user" autocomplete="off" type="text"/><div class="appointment-status"></div></div> '; 
app.templates['gameAppointment-gameAppointmentsEdit-GameAppointmentsFormView'] = ' <fieldset><legend>Paskyrimai<span data-action="close-record" data-original-title="Uždaryti redagavimą" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-double-angle-up"></i></span><span data-action="preview-record" data-original-title="Peržiūrėti rungtunes" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-search"></i></span><span data-action="send-mail" data-original-title="Išsiųsti laišką rungtynių dalyviams" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-envelope-alt"></i></span><span data-action="show-history" data-original-title="Istorija" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-book"></i></span><span data-action="game-evaluations" data-original-title="Rungtynių ataskaitos" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-bar-chart"></i></span><span data-action="delete-record" data-original-title="Ištrinti" class="pull-right with-tooltip-top action-icon with-hand"><i class="icon-trash"></i></span></legend><div class="row-fluid appointments-form"><div data-content="refs-selection" class="span6"><h5>Teisėjai</h5></div><div data-content="persons-selection" class="span6"></div></div></fieldset> '; 
app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationDataDisplayView'] = ' <fieldset class="form-info-display"><legend>Rungtynių informacija<span data-content="referee_evaluation_report_export" data-original-title="Eksportuoti teisėjų įvertinimą" class="pull-right with-tooltip-top action-icon with-hand text"><span>Eksportuoti teisėjų įvertinimą</span></span><span data-content="commissioner_report_short_export" data-original-title="Eksportuoti trumpą analizę" class="pull-right with-tooltip-top action-icon with-hand text"><span>Eksportuoti trumpą analizę</span></span><span data-content="commissioner_report_export" data-original-title="Eksportuoti analizę" class="pull-right with-tooltip-top action-icon with-hand text"><span>Eksportuoti analizę</span></span></legend><div class="row-fluid"><div class="span6"><div class="info-label"><%= app.getMessage("commissioner") %></div><div class="info-value"><%= commisionier_appointment ? (commisionier_appointment.user ? commisionier_appointment.user.short_name : "") : "" %></div></div><div class="span6"><div class="info-label">Adresas</div><div class="info-value"><%= game.address %></div></div></div><div class="row-fluid"><div class="span6"><div class="info-label">Rungtynių numeris</div><div class="info-value"><%= game.game_number %></div></div><div class="span6"><div class="info-label">Data</div><div class="info-value"><%= game.event_date %></div></div></div><div class="row-fluid"><div class="span6"><div class="info-label">Šeimininkai</div><div class="info-value"><%= game.team1 %></div></div><div class="span6"><div class="info-label">Svečiai</div><div class="info-value"><%= game.team2 %></div></div></div><div class="row-fluid"><div class="span6"><div data-content="user_display"><div class="info-label">Vardas Pavardė</div><div class="info-value"><%= user_appointment ? (user_appointment.user ? user_appointment.user.short_name : ""): "" %></div></div><div data-content="game_referees_display"><div class="info-label">Teisėjai</div><div class="info-value"></div></div></div><div data-content="game_status_display" class="span6"><div class="info-label">Statusas</div><div class="info-value"><%= user_appointment ? (app.getMessage(user_appointment.user_type_in_event)) : "" %></div></div></div></fieldset><fieldset data-content="game-review-display"><legend>Rungtyniu apibendrinimas</legend><div class="row-fluid"><div data-content="game-review-display-items" class="span12"></div></div></fieldset><fieldset data-content="referee-evaluation-by-params-display"><legend>Teisėjų vertinimo kriterijai</legend><div class="row-fluid"><div data-content="referee-evaluation-by-params-display-items" class="span12"></div></div></fieldset><fieldset data-content="referee-evaluation-display"><legend>Teisėjų darbo vertinimas</legend><div class="row-fluid"><div data-content="referee-evaluation-display-items" class="span12"></div></div></fieldset><fieldset data-content="good-bad-things-display"><legend>Esminių sezono akcentų įgyvendinimas</legend><div data-content="good-things-display"><div class="row-fluid"><div class="span12 bold">Gerai įgyvendinta šiose rungtynėse</div></div><div class="row-fluid"><div data-content="good-things-display-items" class="span12"></div></div></div><div data-content="bad-things-display" class="with-margin-top"><div class="row-fluid"><div class="span12 bold">Būtina pagerinti kitose rungtynėse</div></div><div class="row-fluid"><div data-content="bad-things-display-items" class="span12"></div></div></div></fieldset><fieldset data-content="video-situations-display"><legend>Situacijos</legend><div class="row-fluid"><div data-content="video-situations-display-items" class="span12"></div></div></fieldset> '; 
app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationRefereeParametersDisplay'] = ' <div class="items-row-item mw100"><div><%= user.short_name %>:</div></div><div class="items-col items-row-item"><div class="form-info-display"><div class="info-label">Bendras įvertinimas</div><div data-content="add-value-display" class="info-value"></div></div><div class="items-row no-space"><div class="form-info-display"><div class="info-label">Pražangos</div><div class="info-value"><%= data.fouls %></div></div><div class="form-info-display"><div class="info-label">Rungtynių valdymas</div><div class="info-value"><%= data.game_control %></div></div><div class="form-info-display"><div class="info-label">Pažeidimai</div><div class="info-value"><%= data.violations %></div></div><div class="form-info-display"><div class="info-label">Mechanika</div><div class="info-value"><%= data.mechanics %></div></div><div class="form-info-display"><div class="info-label">Fizinis pasirengimas</div><div class="info-value"><%= data.looks %></div></div></div></div> '; 
app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationRefereeRankingDisplay'] = ' <div class="span12 form-info-display"><div class="info-label"><%= user.short_name %></div><div class="info-value"><%= app.getMessage(values) %></div></div> '; 
app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationSimpleTextDisplay'] = ' <div class="span12 form-info-display"><div class="info-label full-width"><%= index ? index : "" %> </div><div class="info-value wrap-white-space"><%= values %></div></div> '; 
app.templates['gameEvaluation-gameEvaluationDisplayPage-GameEvaluationVideoDisplay'] = ' <div class="span12 element"><div class="row-fluid"><div class="span12 video-label"><div>Epizodas <%= index %>:</div></div></div><div class="row-fluid"><div class="span4 form-info-display"><div class="info-label">Kėlinys</div><div class="info-value"><%= app.getMessage(values.period) %></div></div><div class="span4 form-info-display"><div class="info-label">Laikas</div><div class="info-value"><%= values.time %></div></div><div class="span4 form-info-display"><div class="info-label">Sprendimas (pražanga, pažeidimas, kita)</div><div class="info-value"><%=  app.getMessage(values.decision) %></div></div></div><div class="row-fluid with-margin-top"><div class="span3 form-info-display"><div class="info-label">Atsakomybė</div><div class="info-value"><%=  app.getMessage(values.priority) %></div></div><div class="span3 form-info-display"><div class="info-label">teisėjas</div><div class="info-value"><%= values.referee %></div></div><div class="span3 form-info-display"><div class="info-label">Teisinga/neteisinga/diskutuotina</div><div class="info-value"><%=  app.getMessage("video_evaluation_"+values.evaluation) %></div></div><div class="span3 form-info-display"><div class="info-label">Video situacija?</div><div class="info-value"><%= values.has_video ? app.getMessage("yes") : app.getMessage("no") %></div></div></div><div class="row-fluid with-margin-top"><div class="span12 form-info-display"><div class="info-label full-width">Komentaras</div><div class="info-value wrap-white-space"> <%= values.comment %></div></div></div></div> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationFormView'] = ' <form id="game-evaluation-form"><fieldset class="form-info-display"><legend>Rungtynių informacija</legend><div class="row-fluid"><div class="span6"><div class="info-label"><%= app.getMessage("commissioner") %></div><div class="info-value"><%= commisionier_appointment ? (commisionier_appointment.user ? commisionier_appointment.user.short_name : "") : "" %></div></div><div class="span6"><div class="info-label">Adresas</div><div class="info-value"><%= game.address %></div></div></div><div class="row-fluid"><div class="span6"><div class="info-label">Rungtynių numeris</div><div class="info-value"><%= game.game_number %></div></div><div class="span6"><div class="info-label">Data</div><div class="info-value"><%= game.event_date %></div></div></div><div class="row-fluid"><div class="span6"><div class="info-label">Šeimininkai</div><div class="info-value"><%= game.team1 %></div></div><div class="span6"><div class="info-label">Svečiai</div><div class="info-value"><%= game.team2 %></div></div></div><div class="row-fluid"><div class="span6"><div data-content="user_display"><div class="info-label">Vardas Pavardė</div><div class="info-value"><%= user_appointment ? (user_appointment.user ? user_appointment.user.short_name : ""): "" %></div></div><div data-content="game_referees_display"><div class="info-label">Teisėjai</div><div class="info-value"></div></div></div><div data-content="game_status_display" class="span6"><div class="info-label">Statusas</div><div class="info-value"><%= user_appointment ? (app.getMessage(user_appointment.user_type_in_event)) : "" %></div></div></div></fieldset><fieldset data-content="game-review-display"><legend>Rungtyniu apibendrinimas</legend><div class="row-fluid"><div data-content="game-review-display-items" class="span12"></div></div></fieldset><fieldset data-content="referee-evaluation-by-params-display"><legend>Teisėjų vertinimo kriterijai</legend><div class="row-fluid"><div data-content="referee-evaluation-by-params-display-items" class="span12"></div></div></fieldset><fieldset data-content="referee-evaluation-display"><legend>Teisėjų darbo vertinimas</legend><div class="row-fluid"><div data-content="referee-evaluation-display-items" class="span12"></div></div></fieldset><fieldset data-content="good-bad-things-display"><legend>Esminių sezono akcentų įgyvendinimas</legend><div data-content="good-things-display"><div class="row-fluid"><div class="span12 bold">Gerai įgyvendinta šiose rungtynėse</div></div><div class="row-fluid"><div data-content="good-things-display-items" class="span12"></div></div></div><div data-content="bad-things-display"><div class="row-fluid"><div class="span12 bold">Būtina pagerinti kitose rungtynėse</div></div><div class="row-fluid"><div data-content="bad-things-display-items" class="span12"></div></div></div></fieldset><fieldset data-content="video-situations-display"><legend>Situacijos</legend><div class="row-fluid"><div data-content="video-situations-display-items" class="span12"></div></div><a data-action="add-video" class="btn btn-success with-margin-top">Pridėti situaciją</a></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeParametersInput'] = ' <div class="items-row-item mw100"><div><%= user.short_name %></div></div><div class="items-col items-row-item"><div class="form-info-display"><div class="info-label">Bendras įvertinimas</div><div data-content="parameter-agg" class="info-value"></div></div><div class="items-row no-space flex-end"><div class="items-row-item game-form-item"><div class="game-form-item-label">Pražangos</div><div class="game-form-item-input full-width"><select name="refereeParametersInputFouls" data-error-style="inline" class="full-width"><option value="0"></option><option value="10">10</option><option value="9">9</option><option value="8">8</option><option value="7">7</option><option value="6">6</option><option value="5">5</option><option value="4">4</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div><div class="items-row-item game-form-item"><div class="game-form-item-label">Rungtynių valdymas</div><div class="game-form-item-input full-width"><select name="refereeParametersInputGameControl" data-error-style="inline" class="full-width"><option value="0"></option><option value="10">10</option><option value="9">9</option><option value="8">8</option><option value="7">7</option><option value="6">6</option><option value="5">5</option><option value="4">4</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div><div class="items-row-item game-form-item"><div class="game-form-item-label">Pažeidimai</div><div class="game-form-item-input full-width"><select name="refereeParametersInputViolations" data-error-style="inline" class="full-width"><option value="0"></option><option value="10">10</option><option value="9">9</option><option value="8">8</option><option value="7">7</option><option value="6">6</option><option value="5">5</option><option value="4">4</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div><div class="items-row-item game-form-item"><div class="game-form-item-label">Mechanika</div><div class="game-form-item-input full-width"><select name="refereeParametersInputMechanics" data-error-style="inline" class="full-width"><option value="0"></option><option value="10">10</option><option value="9">9</option><option value="8">8</option><option value="7">7</option><option value="6">6</option><option value="5">5</option><option value="4">4</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div><div class="items-row-item game-form-item"><div class="game-form-item-label">Fizinis pasirengimas</div><div class="game-form-item-input full-width"><select name="refereeParametersInputLooks" data-error-style="inline" class="full-width"><option value="0"></option><option value="10">10</option><option value="9">9</option><option value="8">8</option><option value="7">7</option><option value="6">6</option><option value="5">5</option><option value="4">4</option><option value="3">3</option><option value="2">2</option><option value="1">1</option></select></div></div></div></div> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeParametersInputsView'] = ' <div data-content="parameter-inputs"></div> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationRefereeRankingInput'] = ' <div class="span12 game-form-item"><div class="game-form-item-label"><%= user.short_name %></div><div class="game-form-item-input full-width"><select name="evaluation" data-error-style="inline" class="full-width"><option value="ranking_very_good">Labai gerai</option><option value="ranking_good">Gerai</option><option value="ranking_satisfied">Patenkinamai</option><option value="ranking_unsatisfied">Nepatenkinamai</option></select></div></div> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationSimpleInput'] = ' <div class="span12 game-form-item"><div class="game-form-item-label"><%= index ? index : "" %> </div><div class="game-form-item-input full-width"><textarea rows="3" type="text" data-error-style="inline" name="comment" class="full-width"></textarea></div></div> '; 
app.templates['gameEvaluation-gameEvaluationEditPage-GameEvaluationVideoInput'] = ' <div class="span12 element"><input type="text" name="referee_id" data-error-style="inline" class="visually-hidden full-width"/><div class="row-fluid"><div class="span12 video-label"><div>Epizodas <%= index %>:</div></div></div><div class="row-fluid"><div class="span4 game-form-item"><div class="game-form-item-label">Kėlinys</div><div class="game-form-item-input full-width"><select name="period" data-error-style="inline" class="full-width"><option value="1_quarter">1 kėlinys</option><option value="2_quarter">2 kėlinys</option><option value="3_quarter">3 kėlinys</option><option value="4_quarter">4 kėlinys</option><option value="1_overtime">1 pratęsimas</option><option value="2_overtime">2 pratęsimas</option><option value="3_overtime">3 pratęsimas</option></select></div></div><div class="span4 game-form-item"><div class="game-form-item-label">Laikas</div><div class="game-form-item-input full-width"><input type="text" name="time" data-error-style="inline" class="full-width"/></div></div><div class="span4 game-form-item"><div class="game-form-item-label">Teisinga/neteisinga/diskutuotina</div><div class="game-form-item-input full-width"><select name="evaluation" data-error-style="inline" class="full-width"><option value=""></option><option value="incorrect">Neteisingas švilpukas</option><option value="incorrect_no_call">Neteisingas nefiksavimas</option><option value="debatable">Diskutuotina</option><option value="correct">Teisingas švilpukas</option><option value="correct_no_call">Teisingas nefiksavimas</option></select></div></div></div><div class="row-fluid with-margin-top"><div class="span4 game-form-item"><div class="game-form-item-label">Atsakomybė</div><div class="game-form-item-input full-width"><select name="priority" data-error-style="inline" class="full-width"><option value=""></option><option value="priority_center">Centrinis (Center) teisėjas</option><option value="priority_lead">Vedantysis(Lead) teisėjas</option><option value="priority_trail">Vedamasis(Trail) teisėjas</option><option value="priority_double">Dviguba atsakomybė</option></select></div></div><div class="span4 game-form-item"><div class="game-form-item-label">teisėjas</div><div class="game-form-item-input full-width"><select name="referee" data-error-style="inline" class="full-width"><option value=""></option></select></div></div><div class="span4 game-form-item"><div class="game-form-item-label">Sprendimas (pražanga, pažeidimas, kita)</div><div class="game-form-item-input full-width"><select name="decision" data-error-style="inline" class="full-width"><option value=""></option><optgroup label="Pažeidimai"><option value="decision_traveling">Žingsniai</option><option value="decision_out_of_bounds_v2">Užribis, vidurio linija</option><option value="decision_time_control_v2">Atakos, rungtynių laikas</option><option value="decision_time_3_5_8_sec_v2">3sek, 5sek, 8sek, ginčas</option><option value="decision_violations_other_v2">Kita (neštas, dvigubas varymas, trukdymas įmetimui ir kt.</option><option value="decision_quick_inbound">Greitas kamuolio įmetimas</option></optgroup><optgroup label="Pražangos"><option value="decision_blocking_v2">Žaidėjas su kamuoliu (blokavimas/įsirėžimas)</option><option value="decision_aos">AOS nustatymas, metiko apsauga</option><option value="decision_foul_player_with_ball_v2">Pražangos prieš žaidėją su kamuoliu (illegal hands, laikymas, kt.)</option><option value="decision_foul_without_ball_v2">Pražangos be kamuolio (laikymas, blokavimas,kita)</option><option value="marginal_calls_v2">Marginal calls</option><option value="decision_flop">Vaidyba</option><option value="decision_unsportsmanlike_foul_v2">DI,FL</option></optgroup><optgroup label="Rungtynių valdymas"><option value="decision_game_control2_v2">OW,TF už elgesį, suolelio kontrolė, komunikavimas</option><option value="decision_administration_v2">Administravimas (keitimai, SPS procedūra,kt.)</option></optgroup><optgroup label="Mechanika"><option value="decision_discipline_v2">Disciplina (AOR, pagalba, 2-gubi, 3-gubi švilukai)</option><option value="decision_rotation">Rotacijos</option><option value="decision_mechanics_other_v2">Kita (IOT, ...)</option></optgroup><option value="decision_looks">Fizinis pasirengimas ir išvaizda (svoris, greitis, ištvermė, apranga, elgsena)</option></select></div></div></div><div class="row-fluid with-margin-top"><div class="span5 game-form-item"><label class="checkbox"><span class="checkbox-label">Video situacija?</span><input id="has_video" type="checkbox" name="has_video"/></label></div></div><div class="row-fluid with-margin-top"><div class="row-fluid with-margin-top"><div class="span12 game-form-item"><div class="game-form-item-label">Komentaras</div><div class="game-form-item-input full-width"><textarea rows="3" type="text" name="comment" data-error-style="inline" class="full-width"></textarea></div></div></div></div></div> '; 
app.templates['gameEvaluation-gameEvaluationsDisplay-GameEvaluationItemDisplayView'] = ' <div><div class="pull-left"><%= app.getMessage(content_type) %> <%= user.short_name %>: &nbsp;</div><a href="" data-action="preview" target="evalutions" class="pull-left">Peržiūrėti</a></div> '; 
app.templates['gameEvaluation-gameEvaluationsDisplay-GameEvaluationsDisplayView'] = ' <div><fieldset><legend class="js-legend-display">Rungtynių ataskaitos</legend></fieldset><div class="row-fluid"><div data-content="game-evaluations"></div></div></div> '; 
app.templates['gameExpenses-gameExpensesDisplay-GameExpenseFormView'] = ' <form id="game-expenses-form" autocomplete="off"><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("expensesField") %></div><div class="game-form-item-input"><input id="expense_amount" type="text" placeholder="20.22" name="expense_amount" data-error-style="inline"/></div></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['gameExpenses-gameExpensesDisplay-GameExpensesDisplayView'] = ' <div class="margin-bottom"><fieldset><legend class="js-legend-display">Rungtynių išlaidos</legend></fieldset><div class="row-fluid margin-bottom"><button data-action="add-record" class="btn btn-success margin-right btn-small"><i class="icon-plus"></i>&nbsp; Pridėti</button></div><div class="row-fluid margin-bottom"><div data-content="game-expenses"></div></div></div> '; 
app.templates['gameExpenses-gameExpensesDisplay-GameExpensesItemDisplayView'] = ' <div class="margin-bottom"><div class="pull-left"><%= user.short_name %> &nbsp;</div><div class="pull-left"><%= expense_amount %> &nbsp;</div><a data-action="remove-element" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div> '; 
app.templates['gameLog-GameLogsItemView'] = ' <span><%= created_at %></span><span><strong>(<%= performer_name %>)</strong></span><span><%= displayText%></span> '; 
app.templates['gameLog-GameLogsListView'] = ' <div class="scrollable-content"><div class="full-width"><strong>Sukurta: &nbsp;</strong><span class="created-display"></span></div><div class="full-width"><strong>Atnaujinta: &nbsp;</strong><span class="updated-display"></span></div><div class="full-width"><strong>Paskyrimų istorija:</strong></div><div class="aaa"></div></div> '; 
app.templates['gameTripInfo-GameTripInfoFormView'] = ' <form id="trip-info-form"><fieldset><div class="row-fluid with-margin-top"><div class="span12 game-form-item"><div class="game-form-item-label span12">Laiško turinys</div><div style="margin:0" class="game-form-item-input span12"><textarea id="content" type="text" placeholder="Laiško turinys" name="content" data-error-style="inline" style="height:200px; width:100%"></textarea></div></div></div></fieldset><button data-action="save-record" class="btn btn-success"><i class="icon-save"></i>&nbsp; Išsiųsti</button></form> '; 
app.templates['gameTripRanking-GameTripRankingFormView'] = ' <form id="league-data-form"><select id="trip_target" name="trip_target" class="excludable"><option value=""></option></select><legend class="uppercase"><%= app.getMessage("ranking_plural") %></legend><input id="game_id" type="hidden" placeholder="30" name="game_id" data-error-style="inline"/><input id="driver_id" type="hidden" placeholder="30" name="driver_id" data-error-style="inline"/><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("referee_one") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_one_ranking" type="text" placeholder="30" name="referee_one_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("referee_two") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_two_ranking" type="text" placeholder="30" name="referee_two_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("referee_three") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_three_ranking" type="text" placeholder="30" name="referee_three_ranking" data-error-style="inline"/></div></div></div></div></div><div class="row-fluid with-margin-top"><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("driver_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="driver_ranking" type="text" placeholder="30" name="driver_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label"><%= app.getMessage("commissioner_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="commissioner_ranking" type="text" placeholder="30" name="commissioner_ranking" data-error-style="inline"/></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['invoice-invoiceCreationPage-InvoiceCreationConfirmationModalView'] = ' <div class="row-fluid"><strong>Jei sąskaitos informacija teisinga, patvirtinkite</strong></div><div class="row-fluid"><div class="span12 with-margin-top"><div class="btn-group"><button data-action="confirm-invoice" class="btn btn-green">Patvirtinti sąskaitą</button><button data-action="edit-invoice" class="btn btn-danger">Redaguoti sąskaitą</button></div></div></div><div class="row-fluid with-margin-top"><div><i class="icon-info-sign"></i>&nbsp; Patvirtinus sąskaitą, bus sukurtas kitos sąskaitos numeris</div></div> '; 
app.templates['invoice-invoiceCreationPage-InvoiceCreationFormView'] = ' <form id="league-data-form"><fieldset><legend>Sąskaitos duomenys</legend><div class="row-fluid"><div class="game-form-item span6"><div class="game-form-item-label">Sąskaitos serija<i data-original-title="Numatytąją seriją galite pakeisti redaguodami vartotojo profilį" class="with-tooltip-right icon-info-sign"></i></div><div class="game-form-item-input"><input id="serial" type="text" placeholder="SS" name="serial" data-error-style="inline"/></div></div><div class="game-form-item span6"><div class="game-form-item-label">Sąskaitos numeris<i data-original-title="Sąsk. numeris redaguojamas vartotojo profilyje. Patvirtinus sugeneruotą sąskaitą, numeris padidinamas" class="with-tooltip-right icon-info-sign"></i></div><div class="game-form-item-input"><input id="number" type="text" placeholder="1" name="number" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span6"><div class="game-form-item-label">Sąskaitos data</div><div class="game-form-item-input"><input id="invoice_date" type="text" placeholder="2012-05-05" name="invoice_date" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Pardavėjas<i data-original-title="Numatytoji pardavėjo informacija redaguojama vartotojo profilyje" class="with-tooltip-right icon-info-sign"></i></div><div class="game-form-item-input full-width"><textarea id="invoice_seller_info" placeholder="Vardenis Pavardenis, Fabijoniškių g. 12-12, Vilnius, Nuolatinio Lietuvos gyventojo individualios vykdymo pažyma Nr. 000000" name="invoice_seller_info" data-error-style="inline" rows="5" class="full-width"></textarea></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span6"><div class="game-form-item-label">Pirkėjas</div><div class="game-form-item-input"><select id="invoice_buyer" name="invoice_buyer" data-error-style="inline"><option>----</option></select></div></div></div></fieldset><fieldset><legend>Sąskaitos įrašai</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-input"><input id="invoice_items" type="text" name="invoice_items" data-error-style="inline" class="visually-hidden"/></div></div></div><div class="row-fluid"><div data-content="invoice-items-list"></div></div></fieldset><fieldset><div class="row-fluid"><div class="inline-divs push-right-med"><span><strong>Viso rungtynių:   &nbsp;</strong></span><span data-content="games-count">0</span></div><div class="inline-divs"><span><strong>Suma &nbsp;</strong></span><span data-content="games-sum">0</span></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Sukurti sąskaitą</button></form> '; 
app.templates['invoice-invoiceCreationPage-InvoiceCreationListItemView'] = ' <td><input id="selected" type="checkbox" name=""/></td><td><%= league_name %></td><td><%= appointments_count %></td><td><%= split_rankings ? summed_original_ranking : summed_ranking %></td><td><%= summed_driver_ranking > 0 ? app.getMessage("journalDriverRanking") + ": " + summed_driver_ranking : "" %></td> '; 
app.templates['invoice-invoiceCreationPage-InvoiceCreationListView'] = ' <div class="scrollable-content"><table id="my-ranking-records-list" class="table table-condensed table-hover"><thead><tr><th>Įtraukti</th><th>Lyga</th><th>Rungtynių skaičius</th><th><%= app.getMessage("ranking") %></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['invoice-myInvoicesPage-MyInvoicesListItemView'] = ' <td><%= serial %> - <%= number %></td><td><%= invoice_date %></td><td class="actions-column"><div class="btn-group"><a data-action="preview-element" class="btn btn-success btn-small"><i class="icon-search"></i></a><a data-action="remove-element" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['invoice-myInvoicesPage-MyInvoicesListView'] = ' <div class="scrollable-content"><table id="my-invoices-list" class="table table-condensed table-hover"><thead><tr><th>Sąskaita</th><th>Sąskaitos data</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['journal-customUserJournalPage-CustomUserJournalListView'] = ' <div class="row-fluid"><div class="inline-divs push-right-med"><span><strong>Viso rungtynių:   &nbsp;</strong></span><span data-content="games-count"></span></div><div class="inline-divs"><span><strong><%= app.getMessage("ranking") %> &nbsp;</strong></span><span data-content="games-sum"></span></div></div><div class="scrollable-content"><table id="my-journal-records-list" class="table table-condensed table-hover"><thead><tr><th>Lyga</th><th>Data</th><th>Komandos</th><th>Darbo pobūdis</th><th><%= app.getMessage("ranking") %></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['journal-globalRankingPage-GlobalRankingListItemView'] = ' <td class="big-col"><%= first_name %> <%= last_name %></td><td><%= rankings_display %></td> '; 
app.templates['journal-globalRankingPage-GlobalRankingListView'] = ' <div class="scrollable-content"><table id="global-ranking-records-list" class="table table-condensed table-hover"><thead><tr><th class="game-appointments-display-col-big">Vartotojas</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['journal-journalsExportsPage-JournalExportItemView'] = ' <div><a data-action="export-journal"><%= title %><img src="/images/excel-icon.png"/></a></div> '; 
app.templates['journal-myBalance-MyBalancePageContentItemView'] = ' <div class="balance-group"><div class="balance-row"><div class="balance-title"><%= title %></div></div><div class="balance-row"><div class="balance-title">Šio mėnesio balansas:&nbsp;</div><div><%= summedRankingTotal.toFixed(2) %></div></div><div class="balance-row"><div class="balance-title">Praėjusio mėnesio balansas:&nbsp;</div><div><%= prevMonthBalance.toFixed(2) %></div></div><div class="balance-row"><div class="balance-title">Varžybų skaičius:&nbsp;</div><div><%= appointmentsCountTotal %></div></div><div class="balance-row"><div class="balance-title">Viso:&nbsp;</div><div><%= total.toFixed(2) %></div></div></div> '; 
app.templates['journal-myJournalPage-MyJournalListItemView'] = ' <td><%= league.name %></td><td><%= game.date %></td><td><%= game.teams %></td><td><%= app.getMessage(user.type) %></td><td><%= league.split_rankings ? ( ranking.ranking_diff > 0 ? ranking.original_ranking + " (Už išvyką: "+ ranking.ranking_diff +")" : ranking.original_ranking) : ranking.ranking_value %></td><td><%= ranking.driver_ranking > 0 ? app.getMessage("journalDriverRanking") + ": " + ranking.driver_ranking : "" %></td> '; 
app.templates['journal-myJournalPage-MyJournalListView'] = ' <div class="row-fluid"><div class="inline-divs push-right-med"><span><strong>Viso rungtynių:   &nbsp;</strong></span><span data-content="games-count"></span></div><div class="inline-divs push-right-med"><span class="capitalize strong"><%= app.getMessage("ranking") %>: &nbsp;</span><span data-content="games-sum"></span></div><div class="inline-divs"><span class="capitalize strong"><%= app.getMessage("tripRanking_genitive") %> <%= app.getMessage("ranking") %>: &nbsp;</span><span data-content="driver-sum"></span></div></div><div class="scrollable-content"><table id="my-journal-records-list" class="table table-condensed table-hover"><thead><tr><th>Lyga</th><th>Data</th><th>Komandos</th><th>Darbo pobūdis</th><th><%= app.getMessage("ranking") %></th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['journal-myRankingPage-MyRankingListItemView'] = ' <td><%= league_name %></td><td><%= appointments_count %></td><td><%= split_rankings ? ( ranking_diff > 0 ? summed_original_ranking + " (Už išvyką: "+ ranking_diff +")" : summed_original_ranking) : summed_ranking %></td><td><%= summed_driver_ranking > 0 ? app.getMessage("journalDriverRanking") + ": " + summed_driver_ranking : "" %></td> '; 
app.templates['journal-myRankingPage-MyRankingListView'] = ' <div class="row-fluid"><div class="inline-divs push-right-med"><span><strong>Viso rungtynių:   &nbsp;</strong></span><span data-content="games-count"></span></div><div class="inline-divs push-right-med"><span class="capitalize strong"><%= app.getMessage("ranking") %>: &nbsp;</span><span data-content="games-sum"></span></div><div class="inline-divs"><span class="capitalize strong"><%= app.getMessage("tripRanking_genitive") %> <%= app.getMessage("ranking") %>: &nbsp;</span><span data-content="summed_driver_ranking"></span></div></div><div class="scrollable-content"><table id="my-ranking-records-list" class="table table-condensed table-hover"><thead><tr><th>Lyga</th><th>Rungtynių skaičius</th><th><%= app.getMessage("ranking") %></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['league-leagueDisplayPage-LeagueDataDisplayView'] = ' <div class="main-info row-fluid"><div class="text"><h3 class="main-text"><%= name %></h3><span class="subheader"><%= code %></span></div></div><fieldset><legend class="no-border"><%= app.getMessage("ranking_plural") %></legend><table id="ratings-info" class="table table-condensed table-hover"><tr><td class="title"> <%= app.getMessage("referee") %> <%= app.getMessage("ranking") %></td><td> <%= referee_ranking %></td></tr><tr></tr><td class="title"> <%= app.getMessage("commissioner_genitive") %> <%= app.getMessage("ranking") %></td><td> <%= commissioner_ranking %></td><tr></tr><td class="title"> <%= app.getMessage("delegate_genitive") %> <%= app.getMessage("ranking") %></td><td> <%= delegate_ranking %></td></table></fieldset> '; 
app.templates['league-leagueEditPage-LeagueFormView'] = ' <form id="league-data-form"><fieldset><legend>Lygos duomenys</legend><div class="row-fluid"><div class="game-form-item span6"><div class="game-form-item-label">Kodas</div><div class="game-form-item-input"><input id="code" type="text" placeholder="Kodas" name="code" data-error-style="inline"/></div></div><div class="game-form-item span6"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input"><input id="name" type="text" placeholder="Pavadinimas" name="name" data-error-style="inline"/></div></div></div></fieldset><fieldset><legend>Lygos nustatymai</legend><div class="row-fluid"><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label">Grynieji</span><input id="in_cash" type="checkbox" name="in_cash"/></label></div><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label">Moka kiti</span><input id="payed_by_other" type="checkbox" name="payed_by_other"/></label></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label">Reikalinga sąskaita</span><input id="invoiceable" type="checkbox" name="invoiceable"/></label></div><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label"><%= app.getMessage("splintRankingStart") %> <%= app.getMessage("ranking_accusative_plural") %></span><input id="split_rankings" type="checkbox" name="split_rankings"/></label></div></div><legend><%= app.getMessage("ranking_plural") %></legend><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label uppercase"><%= app.getMessage("referee_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_ranking" type="text" placeholder="30" name="referee_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label capitalize"><%= app.getMessage("commissioner_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="commissioner_ranking" type="text" placeholder="30" name="commissioner_ranking" data-error-style="inline"/></div></div><div class="game-form-item span4"><div class="game-form-item-label capitalize"><%= app.getMessage("commissioner_analytics_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="commissioner_remotely_ranking" type="text" placeholder="30" name="commissioner_remotely_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label capitalize"><%= app.getMessage("delegate_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="delegate_ranking" type="text" placeholder="30" name="delegate_ranking" data-error-style="inline"/></div></div><div class="game-form-item span4"><div class="game-form-item-label"><%= app.getMessage("tripRanking_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="trip_ranking" type="text" placeholder="30" name="trip_ranking" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span4"><div class="game-form-item-label"> <%= app.getMessage("refereeNomination_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="referee_appointment_ranking" type="text" placeholder="30" name="referee_appointment_ranking" data-error-style="inline"/></div></div><div class="game-form-item span4"><div class="game-form-item-label"> <%= app.getMessage("secretaryNomination_genitive") %> <%= app.getMessage("ranking") %></div><div class="game-form-item-input"><input id="secretary_appointment_ranking" type="text" placeholder="30" name="secretary_appointment_ranking" data-error-style="inline"/></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['league-leaguesPage-LeaguesListItemView'] = ' <td class="league-col big-letters"><%= code %></td><td><%= name %></td><td><%= league_group.name %></td><td class="actions-column"><div class="btn-group"><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['league-leaguesPage-LeaguesListView'] = ' <div class="scrollable-content"><table id="leagues-list" class="table table-condensed table-hover"><thead><tr><th>Kodas</th><th>Pavadinimas</th><th>Lygų grupė</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['leagueGroup-leagueGroupDisplayPage-LeagueGroupDataDisplayView'] = ' <div class="main-info row-fluid"><div class="text"><h3 class="main-text"><%= name %></h3></div></div><fieldset><legend>Priklausančios lygos</legend><div class="row-fluid"><div data-content="leagues" class="span12"></div></div></fieldset> '; 
app.templates['leagueGroup-leagueGroupsEditPage-LeagueGroupFormView'] = ' <form id="league-data-form"><fieldset><legend>Lygos grupės duomenys</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input"><input id="name" type="text" placeholder="Pavadinimas" name="name" data-error-style="inline"/></div></div></div></fieldset><fieldset data-content="leagues-selection"><legend>Priklausančios lygos</legend><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-input full-width"><inpu id="leagues" type="text" placeholder="" name="leagues" data-error-style="inline"></inpu></div></div></div></fieldset><fieldset><legend>Nustatymai</legend><div class="row-fluid"><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label">Archyvuota</span><input id="is_archived" type="checkbox" name="is_archived"/></label></div></div></fieldset><fieldset><legend>Lygos API</legend><div class="row-fluid"><div class="game-form-item span4"><label class="checkbox"><span class="checkbox-label">API</span><input id="has_api" type="checkbox" name="has_api"/></label></div><div class="game-form-item span8"><div class="game-form-item-label">API raktas</div><div class="game-form-item-input"><input id="api_key" type="text" placeholder="API raktas" name="api_key" data-error-style="inline"/></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['leagueGroup-leagueGroupsPage-LeagueGroupsListItemView'] = ' <td><%= name %></td><td><%= is_archived ? app.getMessage("yes") : app.getMessage("no") %></td><td class="actions-column"><div class="btn-group"><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['leagueGroup-leagueGroupsPage-LeagueGroupsListView'] = ' <div class="scrollable-content"><div class="form-inline filters-form"><span data-value="group-archived"><label>Archyvuota:</label><select id="is_archived" name="is_archived"><option value="yes">Taip</option><option value="no">Ne</option></select></span></div><table id="league-groups-list" class="table table-condensed table-hover"><thead><tr><th>Pavadinimas</th><th>Archyvuota</th></tr></thead><tbody></tbody></table></div> '; 
app.templates['post-postEditPage-PostFormView'] = ' <form id="league-data-form"><fieldset><legend>Naujiena</legend><div class="row-fluid"><div class="control-group"><label for="title" class="control-label">Pavadinimas</label><div class="controls"><input id="title" type="text" placeholder="Pavadinimas" name="title" data-error-style="inline" class="span12"/></div></div></div><div class="row-fluid"><div class="control-group"><div class="controls"><input id="content" type="text" placeholder="Tekstas" name="content" data-error-style="inline"/></div></div></div><div class="row-fluid"><div data-value="send-mail" class="control-group"><div class="controls"><span class="checkbox"><input id="send_mail" type="checkbox" name="send_mail"/>Išsiųsti laišką</span></div></div></div><div class="row-fluid"><div data-value="important" class="control-group"><div class="controls"><span class="checkbox"><input id="important" type="checkbox" name="important"/>Svarbi naujiena</span></div></div></div></fieldset><button data-action="save-record" class="btn btn-success margin-right"><i class="icon-save"></i>&nbsp; Išsaugoti</button><button data-action="delete-record" class="btn btn-danger"><i class="icon-remove"></i>&nbsp; Ištrinti</button></form> '; 
app.templates['report-reportsPage-ReportsPageFormView'] = ' <form id="league-data-form"><fieldset><legend>Data</legend><div class="row-fluid"><div class="range-filter form-filters-inline"></div></div></fieldset><fieldset><a data-action="game-schedule-report" class="full-row-display"><img src="/images/excel-icon.png"/>Rungtynių tvarkaraštis</a><a data-action="cancelation-suspension-report" class="full-row-display"><img src="/images/excel-icon.png"/>Atsisakymų/suspendavimų ataskaita</a><a data-action="team-people-report" class="full-row-display"><img src="/images/excel-icon.png"/>Komandų-teisėjų ataskaita</a><a data-action="team-expenses-report" class="full-row-display"><img src="/images/excel-icon.png"/>Komandų išlaidų ataskaita</a><a data-action="league-people-report" class="full-row-display"><img src="/images/excel-icon.png"/>Lygų ir personalo ataskaita</a></fieldset></form> '; 
app.templates['schedule-scheduleExportPage-ScheduleExportView'] = ' <div class="row-fluid"><div data-original-title="Eksportuoti" class="with-tooltip-left"><a data-action="export">Pasirinkto mėnesio<img src="/images/excel-icon.png"/></a><a data-action="export-custom-date">Nuo pasirinkto mėnesio<img src="/images/excel-icon.png"/></a></div></div> '; 
app.templates['statistic-statisticsPage-StatisticsPageContent'] = ' <div data-content="filter"><div class="row-fluid with-margin-top"><div class="span4 game-form-item"><div class="game-form-item-label">Pradžia</div><div class="game-form-item-input full-width"><input id="start-date-selection" data-content="start-date-selection" type="text" placeholder="2012-02-02" name="start-date-selection"/></div></div><div class="span4 game-form-item"><div class="game-form-item-label">Pabaiga</div><div class="game-form-item-input full-width"><input id="end-date-selection" data-content="end-date-selection" type="text" placeholder="2012-02-02" name="end-date-selection"/></div></div></div><div class="row-fluid with-margin-top"><div class="span4 game-form-item"><div class="game-form-item-label">Teisinga/neteisinga/diskutuotina</div><div class="game-form-item-input full-width"><select name="evaluation" data-error-style="inline" class="full-width"><option value=""></option><option value="incorrect">Neteisingas švilpukas</option><option value="incorrect_no_call">Neteisingas nefiksavimas</option><option value="debatable">Diskutuotina</option><option value="correct">Teisingas švilpukas</option><option value="correct_no_call">Teisingas nefiksavimas</option></select></div></div><div class="span8 game-form-item"><div class="game-form-item-label">Teisėjai</div><div class="game-form-item-input full-width"><div data-content="refs-selection" class="full-width"></div></div></div></div><div class="row-fluid"><div class="span12 game-form-item"><div class="game-form-item-label">Sprendimas (pražanga, pažeidimas, kita)</div><div class="game-form-item-input full-width"><select name="decision" data-error-style="inline" multiple="multiple" style="height: 200px" class="full-width"><option value=""></option><optgroup label="Pažeidimai"><option value="decision_traveling">Žingsniai</option><option value="decision_out_of_bounds_v2">Užribis, vidurio linija</option><option value="decision_time_control_v2">Atakos, rungtynių laikas</option><option value="decision_time_3_5_8_sec_v2">3sek, 5sek, 8sek, ginčas</option><option value="decision_violations_other_v2">Kita (neštas, dvigubas varymas, trukdymas įmetimui ir kt.</option><option value="decision_quick_inbound">Greitas kamuolio įmetimas</option></optgroup><optgroup label="Pražangos"><option value="decision_blocking_v2">Žaidėjas su kamuoliu (blokavimas/įsirėžimas)</option><option value="decision_aos">AOS nustatymas, metiko apsauga</option><option value="decision_foul_player_with_ball_v2">Pražangos prieš žaidėją su kamuoliu (illegal hands, laikymas, kt.)</option><option value="decision_foul_without_ball_v2">Pražangos be kamuolio (laikymas, blokavimas,kita)</option><option value="marginal_calls_v2">Marginal calls</option><option value="decision_flop">Vaidyba</option><option value="decision_unsportsmanlike_foul_v2">DI,FL</option></optgroup><optgroup label="Rungtynių valdymas"><option value="decision_game_control2_v2">OW,TF už elgesį, suolelio kontrolė, komunikavimas</option><option value="decision_administration_v2">Administravimas (keitimai, SPS procedūra,kt.)</option></optgroup><optgroup label="Mechanika"><option value="decision_discipline_v2">Disciplina (AOR, pagalba, 2-gubi, 3-gubi švilukai)</option><option value="decision_rotation">Rotacijos</option><option value="decision_mechanics_other_v2">Kita (IOT, ...)</option></optgroup><option value="decision_looks">Fizinis pasirengimas ir išvaizda (svoris, greitis, ištvermė, apranga, elgsena)</option></select></div></div></div><div class="row-fluid with-margin-top"><button data-action="execute-search" class="btn btn-success with-margin-top"><i class="icon-search"></i>&nbsp; Ieškoti</button></div></div><div data-content="statistics-list" style="min-height: 500px" class="row-fluid with-margin-top scrollable-content"></div> '; 
app.templates['statistic-statisticsPage-StatisticsRefereeInputView'] = ' <input id="user_name" data-value="appointment-user" autocomplete="off" type="text"/> '; 
app.templates['statistic-statisticsPage-StatisticsResultItemView'] = ' <div class="row-fluid"><div class="span4 form-info-display"><div class="info-label">Rungtynės</div><div class="info-value"><%= game.team1 %> - <%= game.team2 %></div></div><div class="span4 form-info-display"><div class="info-label">Autorius</div><div class="info-value"><%= user.short_name %></div></div><div class="span4 form-info-display"><div class="info-label">Pilna analizė</div><div class="info-value"><a href="" data-action="preview">Pilna analizė</a></div></div></div><div data-content="videos" class="row-fluid"></div> '; 
app.templates['statistic-statisticsPage-StatisticsResultsView'] = ' <div id="statistics-list"></div> '; 
app.templates['statistic-statisticsPage-StatisticsVideoDisplay'] = ' <div class="span12 element"><div class="row-fluid"><div class="span4 form-info-display"><div class="info-label">Kėlinys</div><div class="info-value"><%= app.getMessage(period) %></div></div><div class="span4 form-info-display"><div class="info-label">Laikas</div><div class="info-value"><%= time %></div></div><div class="span4 form-info-display"><div class="info-label">Sprendimas (pražanga, pažeidimas, kita)</div><div class="info-value"><%=  app.getMessage(decision) %></div></div></div><div class="row-fluid with-margin-top"><div class="span3 form-info-display"><div class="info-label">Atsakomybė</div><div class="info-value"><%=  app.getMessage(priority) %></div></div><div class="span4 form-info-display"><div class="info-label">Teisėjas</div><div class="info-value"><%= referee %></div></div><div class="span5 form-info-display"><div class="info-label">Teisinga/neteisinga/diskutuotina</div><div class="info-value"><%=  app.getMessage("video_evaluation_"+evaluation) %></div></div></div><div class="row-fluid with-margin-top"><div class="span12 form-info-display"><div class="info-label full-width">Komentaras</div><div class="info-value wrap-white-space"> <%= comment %></div></div></div></div> '; 
app.templates['test-testAnswersPage-TestAnswersQuestionAnswersItemView'] = ' <div class="row-fluid"><div class="span12"><div class="answers-wrapper"><%= answer_text %> <%= isIconVisible ? (correct ? "<i class=icon-ok-sign></i>" : "<i class=icon-remove-sign></i>") : "" %> </div></div></div> '; 
app.templates['test-testAnswersPage-TestAnswersQuestionResultsItemView'] = ' <div class="span12"><div class="row-fluid"><div class="span12"><div class="test-results-item"><div data-content="question-data-display" class="test-question wrap-white-space"><%= question_text %></div><div class="row-fluid"><div class="span12"><div class="strong">Atsakymai:</div><div data-content="answers-display" class="answers-wrapper"></div></div></div><div data-content="comment" class="row-fluid with-margin-top"><div class="span12"><div class="strong">Komentaras</div><div><%= comment %></div></div></div><div data-content="question_answer_explanation" class="row-fluid with-margin-top"><div class="span12"><div class="strong">Atsakymo paaiškinimas</div><div><%= question_answer_explanation %></div></div></div></div></div></div></div> '; 
app.templates['test-testAnswersPage-TestAnswersView'] = ' <fieldset class="form-info-display"><legend>Testo informacija</legend><div class="row-fluid"><div class="span12"><div class="info-label">Pavadinimas</div><div class="info-value"><%= title %></div></div></div><div class="row-fluid"><div class="span12"><div class="info-label">Aprašymas</div><div class="info-value full-width"><%= description %></div></div></div></fieldset><fieldset class="form-info-display"><legend>Testo klausimai</legend><div class="row-fluid"><div class="span12"><div data-content="test-questions" class="content-box"></div></div></div></fieldset> '; 
app.templates['test-testEditPage-TestFormView'] = ' <form id="league-data-form"><fieldset><legend>Testo informacija</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input full-width"><input id="title" type="text" placeholder="Pavadinimas" name="title" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Aprašymas</div><div class="game-form-item-input full-width"><textarea id="description" rows="3" placeholder="Aprašymas" name="description" data-error-style="inline" class="full-width"></textarea></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Tipas</div><div class="game-form-item-input full-width"><select id="test_type" name="test_type" data-error-style="inline" class="full-width"><option value="test">Testas</option><option value="survey">Apklausa</option></select></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Sprendimus pateikti iki</div><div class="game-form-item-input full-width"><input id="solvable_until" type="text" placeholder="2012-12-12" name="solvable_until" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid with-margin-top"><div class="game-form-item span12"><label class="checkbox"><span class="checkbox-label">Aktyvus</span><input id="enabled" type="checkbox" name="enabled"/></label></div></div></fieldset><fieldset><legend>Testo klausimai</legend><div class="row-fluid"><div class="span12"><div data-content="test-questions" class="content-box"></div></div></div><div class="row-fluid with-margin-top"><div class="span12"><a data-action="add-question" class="btn with-margin-top btn-blue btn-small"><i class="icon-plus"></i>&nbsp; Pridėti klausimą</a></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['test-testEditPage-TestQuestionAnswerInputView'] = ' <div class="span12"><div class="row-fluid"><div class="game-form-item span8"><div class="game-form-item-input full-width"><input id="answer_text" type="text" placeholder="Atsakymas" name="answer_text" data-error-style="inline" class="full-width"/></div></div><div class="game-form-item span2"><label class="checkbox"><span class="checkbox-label">Teisingas</span><input id="correct" type="radio" name="correct"/></label></div><div class="game-form-item span2"><a data-action="delete-row" class="btn btn-danger btn-small"><i class="icon-trash"></i>&nbsp; Ištrinti atsakymą</a></div></div></div> '; 
app.templates['test-testEditPage-TestQuestionInputView'] = ' <div class="span12 element"><form id="league-data-form"><fieldset><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Klausimas</div><div class="game-form-item-input full-width"><textarea id="question_text" rows="3" placeholder="Klausimas" name="question_text" data-error-style="inline" class="full-width"></textarea></div></div></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Tipas</div><div class="game-form-item-input full-width"><select name="question_type"><option value="simple">Paprastas</option><option value="video">Video</option></select></div></div></div><div data-content="video-input" class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Video nuoroda</div><div class="game-form-item-input full-width"><input id="question_video" type="text" placeholder="Video nuoroda" name="question_video" data-error-style="inline" class="full-width"/></div></div></div><div data-content="video-input" class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Video nuoroda</div><div class="game-form-item-input full-width"><input id="question_video" type="text" placeholder="Video nuoroda" name="question_video_1" data-error-style="inline" class="full-width"/></div></div></div><div data-content="video-input" class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Video nuoroda</div><div class="game-form-item-input full-width"><input id="question_video" type="text" placeholder="Video nuoroda" name="question_video_2" data-error-style="inline" class="full-width"/></div></div></div><div data-content="video-input" class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Video nuoroda</div><div class="game-form-item-input full-width"><input id="question_video" type="text" placeholder="Video nuoroda" name="question_video_3" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Atsakymo paaiškinimas</div><div class="game-form-item-input full-width"><textarea id="question_answer_explanation" rows="3" placeholder="Atsakymo paaiškinimas" name="question_answer_explanation" data-error-style="inline" class="full-width"></textarea></div></div></div><div data-content="video-input" class="row-fluid"></div></fieldset><fieldset><legend class="small">Atsakymai</legend><div data-content="no-correct-answer-selected" style="display:none" class="row-fluid"><div class="span12 error">Pasirinkite teisingą atsakymą</div></div><div class="row-fluid"><div data-content="question-answers" class="span12"></div></div><div class="row-fluid with-margin-top"><div class="span12"><div class="btn-group with-margin-top"><a data-action="add-answer" class="btn btn-blue btn-small"><i class="icon-plus"></i>&nbsp; Pridėti atsakymą</a><a data-action="delete-question" class="btn btn-danger btn-small"><i class="icon-remove"></i>&nbsp; Ištrinti atsakymą</a></div></div></div></fieldset></form></div> '; 
app.templates['test-testResultsPage-TestGroupedResultsModalView'] = ' <table class="table table-condensed table-hover"><thead><tr><th>Vardas Pavardė</th><th>Teisingai</th><th>Neteisingai</th></tr></thead><tbody data-content="results-display"></tbody></table> '; 
app.templates['test-testResultsPage-TestResultsAnswerUsersModalView'] = ' <div class="row-fluid"><div class="span12"><div data-content="users-display"></div></div></div> '; 
app.templates['test-testResultsPage-TestResultsQuestionResultsItemAnswerView'] = ' <div class="row-fluid"><div class="span12"><div class="answers-wrapper"><%= answer_text %><span class="strong">(<%= test_result_items.length %> pasirinkimas(-ai))</span><i data-original-title="Peržiūtėti, kurie vartotojai pasirinko šį atsakymą" data-action="show-answer-users" class="icon-user with-tooltip-bottom hand"></i></div></div></div> '; 
app.templates['test-testResultsPage-TestResultsQuestionResultsItemView'] = ' <div class="span12"><div class="row-fluid"><div class="span12"><div class="test-results-item"><div data-content="question-data-display" class="test-question wrap-white-space"><%= question_text %></div><div class="row-fluid"><div class="span12"><div class="strong">Atsakymai:</div><div data-content="answers-display" class="answers-wrapper"></div></div></div><div data-content="question_answer_explanation" class="row-fluid"><div class="span12"><div class="strong">Atsakymo paaiškinimas</div><div><%= question_answer_explanation %></div></div></div></div></div></div></div> '; 
app.templates['test-testResultsPage-TestResultsView'] = ' <fieldset class="form-info-display"><legend>Testo informacija</legend><div class="row-fluid"><div class="span12"><div class="info-label">Pavadinimas</div><div class="info-value"><%= title %></div></div></div><div class="row-fluid"><div class="span12"><div class="info-label">Aprašymas</div><div class="info-value full-width"><%= description %></div></div></div></fieldset><fieldset class="form-info-display"><legend>Testo rezultatai</legend><div class="row-fluid"><div class="span12"><a data-action="view-grouped-results">Peržiūrėti suskaičiuotus rezultatus</a></div></div><div class="row-fluid"><div class="span12"><a data-action="export-results">Eksportuoti rezultatus</a></div></div></fieldset><fieldset class="form-info-display"><legend>Testo rezultatai pagal klausimus</legend><div class="row-fluid"><div class="span12"><div data-content="test-questions" class="content-box"></div></div></div></fieldset> '; 
app.templates['test-testSolvePage-TestSolveFormView'] = ' <form id="test-solve-form"><fieldset class="form-info-display"><legend>Testo informacija</legend><div class="row-fluid"><div class="span12"><div class="info-label">Pavadinimas</div><div class="info-value"><%= title %></div></div></div><div class="row-fluid"><div class="span12"><div class="info-label">Aprašymas</div><div class="info-value full-width"><%= description %></div></div></div></fieldset><fieldset class="form-info-display"><legend>Testo klausimai</legend><div class="row-fluid"><div class="span12"><div data-content="test-questions" class="content-box"></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['test-testSolvePage-TestSolveItemView'] = ' <form><div class="span12"><div class="test-solve-item"><div data-content="question-data-display" class="test-question wrap-white-space"><%= question_text %></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-input"><input id="selected_answer" type="text" name="selected_answer" data-error-style="inline" class="visually-hidden"/></div></div><div data-content="answers-display" class="span12 answers-wrapper"></div></div><div data-content="comment-display" class="row-fluid with-margin-top"><div class="game-form-item span12"><div class="game-form-item-label">Komentaras</div><div class="game-form-item-input full-width"><textarea id="comment" rows="3" placeholder="Komentaras" name="comment" data-error-style="inline" class="full-width"></textarea></div></div></div></div></div></form> '; 
app.templates['test-testsPage-TestsListItemView'] = ' <td><%= title %></td><td><%= solvable_until %></td><td data-display-type="only-admin"><%= enabled ? "Taip" : "Ne" %></td><td class="actions-column"><div class="btn-group"><a data-action="solve-test" class="btn btn-green btn-small">Spręsti</a><a data-action="test-answers" class="btn btn-orange btn-small">Atsakymai</a><a data-action="test-stats" data-display-type="only-admin" class="btn btn-blue btn-small"><i class="icon-bar-chart"></i></a><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['test-testsPage-TestsListView'] = ' <div class="scrollable-content"><table id="tests-list" class="table table-condensed table-hover"><thead><tr><th></th><th>Sprendimus pateikti iki</th><th data-display-type="only-admin">Aktyvus</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['user-userChangePasswordPage-UserChangePasswordFormView'] = ' <form id="user-password-form"><div class="row-fluid"><div class="control-group game-form-item"><label for="password" class="control-label">Slaptažodis</label><div class="controls game-form-item-input"><input id="password" type="password" placeholder="Slaptažodis" name="password" data-error-style="inline"/></div></div></div><div class="row-fluid"><div class="control-group game-form-item"><label for="passwordRepeat" class="control-label">Pakartotas slaptažodis</label><div class="controls game-form-item-input"><input id="passwordRepeat" type="password" placeholder="Pakartotas slaptažodis" name="passwordRepeat" data-error-style="inline"/></div></div></div><button data-action="save-record" class="btn">Išsaugoti</button></form> '; 
app.templates['user-userDisplayPage-UserDataDisplayView'] = ' <div class="main-info row-fluid"><img id="profile-picture-display" src="" class="avatar"/><div class="text"><h3 class="main-text"><%= first_name %>  <%= last_name %></h3><span class="subheader"><%= app.getMessage(user_type) %></span></div></div><div class="row-fluid"><fieldset><legend><%= app.getMessage("userType") %></legend><div class="contact-item"><span class="title"><%= app.getMessage("userCategory") %>:</span><span class="value"><%= app.getMessage("user_category_"+category) %></span></div><div class="contact-item"><span class="title"><%= app.getMessage("userAssociationMember") %>:</span><span class="value"><%= is_association_member? app.getMessage("yes") : app.getMessage("no") %></span></div><div data-type="suspended_until" class="contact-item"><span class="title"><%= app.getMessage("userSuspendedUntil") %>:</span><span class="value"> <%= suspended_until %></span></div></fieldset><fieldset><legend><%= app.getMessage("userContacts") %></legend><div class="contact-item"><span class="title"><%= app.getMessage("userAddress") %>:</span><span class="value"><%= address %></span></div><div class="contact-item"><span class="title"><%= app.getMessage("userPhone") %>:</span><span class="value"><%= phone_number %></span></div><div class="contact-item"><span class="title"><%= app.getMessage("userEmail") %>:</span><span class="value"><%= email %></span></div></fieldset></div> '; 
app.templates['user-userEditPage-UserFormView'] = ' <form id="user-data-form"><fieldset><legend>Vartotojo duomenys</legend><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">Vardas</div><div class="game-form-item-input"><input id="first_name" type="text" placeholder="Vardas" name="first_name" data-error-style="inline"/></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Pavardė</div><div class="game-form-item-input"><input id="last_name" type="text" placeholder="Pavardė" name="last_name" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span6 game-form-item"><div class="game-form-item-label">Asmens kodas</div><div class="game-form-item-input"><input id="person_code" type="text" placeholder="Asmens kodas" name="person_code" data-error-style="inline"/></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Sąskaita</div><div class="game-form-item-input"><input id="account_number" type="text" placeholder="Sąskaita" name="account_number" data-error-style="inline"/></div></div></div></fieldset><fieldset><legend>Vartotojo kontaktai</legend><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">El. paštas</div><div class="game-form-item-input"><input id="email" type="email" placeholder="El. paštas" name="email" data-error-style="inline"/></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Telefonas</div><div class="game-form-item-input"><input id="phone_number" type="text" placeholder="Telefonas" name="phone_number" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span12 game-form-item"><div class="game-form-item-label">Adresas</div><div class="game-form-item-input"><input id="address" type="text" placeholder="Adresas" name="address" data-error-style="inline"/></div></div></div></fieldset><fieldset><legend>Nustatymai</legend><div class="row-fluid"><div class="span12 game-form-item"><label class="checkbox"><span class="checkbox-label">Kasdieninis priminimas apie rungtynes</span><input id="daily_mail" type="checkbox" name="daily_mail"/></label></div></div></fieldset><fieldset><legend>Sąskaitos duomenys</legend><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">Sąskaitos serija</div><div class="game-form-item-input"><input id="invoice_serial" type="text" placeholder="SS" name="invoice_serial" data-error-style="inline"/></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Sąskaitos numeris</div><div class="game-form-item-input"><input id="invoice_number" type="text" placeholder="1" name="invoice_number" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span12 game-form-item"><div class="game-form-item-label">Sąskaitos pardavėjo informacija</div><div class="game-form-item-input full-width"><textarea id="invoice_seller_info" placeholder="Vardenis Pavardenis, Fabijoniškių g. 12-12, Vilnius, Nuolatinio Lietuvos gyventojo individualios vykdymo pažyma Nr. 000000" name="invoice_seller_info" rows="5" class="full-width"></textarea></div></div></div></fieldset><fieldset data-display-type="only-admin"><legend>Informacija</legend><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">Tipas</div><div class="game-form-item-input"><select id="user_type" name="user_type" data-error-style="inline" class="capitalize"><option value="referee">teisėjas</option><option value="commissioner" class="capitalize">Inspektorius</option><option value="administration" data-display-type="only-admin" class="capitalize">Administracija</option><option value="delegate" class="capitalize">Delegatas</option></select></div></div><div class="span6 game-form-item"><div class="game-form-item-label">Kategorija</div><div class="game-form-item-input"><select id="category" name="category" data-error-style="inline"><option value="none">Be kategorijos</option><option value="fiba">FIBA</option><option value="lkl">LKL</option><option value="nkl">NKL</option><option value="rkl">RKL</option><option value="national">Nacionalinė</option></select></div></div></div><div data-display-type="only-admin" class="row-fluid with-margin-top"><div class="span6 game-form-item"><label class="checkbox"><span class="checkbox-label">Asociacijos narys</span><input id="is_association_member" type="checkbox" name="is_association_member"/></label></div><div class="span6 game-form-item"><div class="game-form-item-label">Suspenduotas iki</div><div class="game-form-item-input"><input id="suspended_until" type="text" placeholder="2012-05-05 05:15" name="suspended_until" data-error-style="inline"/></div></div><div class="row-fluid"><div class="span6 game-form-item"><div class="game-form-item-label">Galimybių pasas galioja iki</div><div class="game-form-item-input"><input id="certificate_until" type="text" placeholder="2012-05-05 05:15" name="certificate_until" data-error-style="inline"/></div></div></div></div></fieldset><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['user-userForgotPasswordPage-UserForgotPasswordFormView'] = ' <form id="user-password-form"><fieldset><div class="fields"><input id="email" type="email" placeholder="" name="email" data-error-style="tooltip" class="span12"/></div><a href="/login" id="forgot-password" class="forgot-password">Prisijungti</a><button data-action="save-record" style="float:right" class="btn btn-green btn-block">Priminti slaptažodį</button></fieldset></form> '; 
app.templates['user-usersPage-UsersListItemView'] = ' <td><%= first_name %> <%= last_name %></td><td><%= phone_number %></td><td class="actions-column"><div class="btn-group"><a data-original-title="Vartotojo rungtynių žiniaraštis" data-action="user-list-element" data-display-type="only-admin" class="btn btn-orange btn-small with-tooltip-left"><i class="icon-align-justify"></i></a><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="delete-element" data-display-type="only-admin" data-original-title="Ištrinti vartotoją" class="btn btn-danger btn-small with-tooltip-left"><i class="icon-remove"></i></a></div></td> '; 
app.templates['user-usersPage-UsersListView'] = ' <div class="form-inline filters-form"><div data-original-title="&lt;%= app.getMessage(&quot;export&quot;) %&gt;" data-display-type="only-admin" class="export-button with-tooltip-left"><a href="/api/users/export" target="_blank"><img src="images/excel-icon.png"/></a></div><div data-original-title="&lt;%= app.getMessage(&quot;exportFullList&quot;) %&gt;" data-display-type="only-admin" class="export-button with-tooltip-left admin-button"><a href="/api/users/export-all" target="_blank"><img src="images/excel-icon.png"/></a></div></div><div class="scrollable-content"><table id="users-list" class="table table-condensed table-hover"><thead><tr><th>Vardas Pavardė</th><th>Telefonas</th></tr></thead><tbody></tbody></table></div> '; 
app.templates['userAvailability-myAvailability-MyAvailabilityFormView'] = ' <form id="my-availability-form" autocomplete="off"><div class="row-fluid"><div class="span12"><div class="row-fluid with-margin-top"><div class="game-form-item span6"><div class="game-form-item-label"><%= app.getMessage("startDate") %></div><div class="game-form-item-input"><input id="start_date" type="text" placeholder="2012-05-05" name="start_date" data-error-style="inline"/></div></div><div class="game-form-item span6"><div class="game-form-item-label"><%= app.getMessage("endDate") %></div><div class="game-form-item-input"><input id="end_date" type="text" placeholder="2012-05-05" name="end_date" data-error-style="inline"/></div></div></div><div class="row-fluid with-margin-top"><div class="span5 game-form-item"><label class="checkbox"><span class="checkbox-label">Užsiėmęs</span><input id="unavailable" type="checkbox" name="unavailable"/></label></div></div><div class="row-fluid with-margin-top"><div class="span12 game-form-item"><div class="game-form-item-label span12">Komentaras</div><div style="margin:0" class="game-form-item-input span12"><textarea id="comment" type="text" placeholder="Komentaras" name="comment" data-error-style="inline" style="height:100px; width:100%"></textarea></div></div></div></div></div><button data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</button></form> '; 
app.templates['userAvailability-myAvailability-MyAvailabilityListItemView'] = ' <td><%= start_date %></td><td><%= end_date %></td><td><%= comment %></td><td><%= unavailable? app.getMessage("yes") : app.getMessage("no") %></td><td class="actions-column"><div class="btn-group"><a data-action="edit-element" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['userAvailability-myAvailability-MyAvailabilityListView'] = ' <div class="scrollable-content"><button data-action="add-record" class="btn btn-success margin-right"><i class="icon-plus"></i>&nbsp; Pridėti</button><table id="my-availability-list" class="table table-condensed table-hover"><thead><tr><th>Pradžia</th><th>Pabaiga</th><th>Komentaras</th><th>Užsiėmęs</th><th></th></tr></thead><tbody></tbody></table></div> '; 
app.templates['userAvailability-userAvailability-UserAvailabilityDisplayView'] = ' <div id="picker"></div> '; 
app.templates['userAvailability-usersAvailability-UsersAvailabilityDisplayView'] = ' <div id="picker"></div><div><fieldset><a data-action="export-user-availability-report" class="full-row-display"><img src="/images/excel-icon.png"/>Eksportuoti vartotojų užimtumo ataskaitą</a></fieldset></div> '; 
app.templates['userAvailability-usersAvailability-UsersDayAvailabilityDisplayView'] = ' <div id="availability-list"><div id="unavailable-info"><h4>Užsiėmę</h4></div><div id="available-info"><h4>Kiti komentarai</h4></div></div> '; 
app.templates['videoGroup-videoGroupDisplayPage-VideoDisplayView'] = ' <div class="row-fluid"><fieldset><legend><%= title %></legend><div class="row-fluid"><div class="span12"><div class="full-width bold">Aprašymas</div><div class="full-width"><%= description %></div></div></div><div class="row-fluid"><div class="span12"></div><div data-content="video-display"></div></div></fieldset></div> '; 
app.templates['videoGroup-videoGroupDisplayPage-VideoGroupDataDisplayView'] = ' <div class="row-fluid"><fieldset><legend><%= title %></legend><div class="row-fluid"><div class="span12"><div class="full-width bold">Aprašymas</div><div class="full-width"><%= description %></div></div></div><div class="row-fluid with-margin-top"><div data-content="videos-display" class="span12"></div></div></fieldset></div> '; 
app.templates['videoGroup-videoGroupEditPage-VideoFormView'] = ' <fieldset><legend>Video</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input full-width"><input id="title" type="text" placeholder="Pavadinimas" name="title" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Aprašymas</div><div class="game-form-item-input full-width"><textarea id="description" placeholder="Aprašymas" name="description" data-error-style="inline" rows="5" class="full-width full-width"></textarea></div></div></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Nuoroda</div><div class="game-form-item-input full-width"><input id="video_link" type="text" placeholder="Nuoroda" name="video_link" data-error-style="inline" class="full-width"/></div></div></div></fieldset><button data-action="remove-record" class="btn btn-danger btn-small with-margin-top"><i class="icon-remove"></i>&nbsp; Ištrinti video</button> '; 
app.templates['videoGroup-videoGroupEditPage-VideoGroupFormView'] = ' <form id="league-data-form"><fieldset><legend>Video grupė</legend><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Pavadinimas</div><div class="game-form-item-input full-width"><input id="title" type="text" placeholder="Pavadinimas" name="title" data-error-style="inline" class="full-width"/></div></div></div><div class="row-fluid"><div class="game-form-item span12"><div class="game-form-item-label">Aprašymas</div><div class="game-form-item-input full-width"><textarea id="description" placeholder="Aprašymas" name="description" data-error-style="inline" rows="5" class="full-width full-width"></textarea></div></div></div><div class="row-fluid with-margin-top"><div data-content="videos" class="span12"></div></div></fieldset><div class="row-fluid"><div class="span12"><a data-action="add-video" class="btn btn-blue btn-small with-margin-top"><i class="icon-plus"></i>&nbsp; Pridėti video</a></div></div><div class="row-fluid"><div class="span12"><a data-action="save-record" class="btn btn-success with-margin-top"><i class="icon-save"></i>&nbsp; Išsaugoti</a></div></div></form> '; 
app.templates['videoGroup-videoGroupsPage-VideoGroupsListItemView'] = ' <td><%= title %></td><td><%= updated_at %></td><td class="actions-column"><div class="btn-group"><a data-action="edit-element" data-display-type="only-admin" class="btn btn-success btn-small"><i class="icon-edit"></i></a><a data-action="remove-element" data-display-type="only-admin" class="btn btn-danger btn-small"><i class="icon-remove"></i></a></div></td> '; 
app.templates['videoGroup-videoGroupsPage-VideoGroupsListView'] = ' <div class="scrollable-content"><table id="videos-list" class="table table-condensed table-hover"><thead><tr><th>Pavadinimas</th><th>Atnaujinta</th></tr></thead><tbody></tbody></table></div> '; 
})();
},{}],345:[function(require,module,exports){
const moment = require("moment");
var setupAppUtils = function() {
    this.Global = {};
    var app = this;
    this.Global.systemDateFormat = "yy-mm-dd";
    this.pkg = function(includePath) {

        var splitted = includePath.split(".");

        var elObj = this;

        for (var i = 0; i < splitted.length; i++) {
            var pathEl = splitted[i];

            elObj[pathEl] = elObj[pathEl] || {};
            elObj = elObj[pathEl];
        }
    };

    this.isSmallScreen = function() {
        return $(window).width() < 500;
    }

    this.isMobile = function() {
        var a = navigator.userAgent || navigator.vendor || window.opera;
        if (/android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(ad|hone|od)|iris|kindle|lge |maemo|meego.+mobile|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|playbook|silk/i.test(a) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,
                4))) {
            return true;
        } else {
            return false;
        }
    };

    this.addScrollBar = function(el, removeSize, onBottomScrollFunction, disableScroll) {
        if (app.isMobile() || disableScroll) {
            var id = new Date().getTime();
            var loadMore = $("<div class='load-more btn btn-orange'><div>"+app.getMessage("moreRecords")+"</div></div>").attr("id", id);
            el.append(loadMore);
            $('body').on('click', '#' + id, function() {
                onBottomScrollFunction();
            });

        } else {
            var height = $(window).height() - removeSize;
            $(el).css('height', height);
            $(el).mCustomScrollbar({
                advanced: {
                    updateOnContentResize: true
                },
                scrollInertia: 400,
                callbacks: {
                    whileScrolling: function(params) {
                        if (params.topPct >= 85 && params.topPct <= 95) {
                            if (onBottomScrollFunction) {
                                onBottomScrollFunction();
                            }
                        }
                    },
                    onTotalScrollOffset: 500
                },
                theme: "dark"
            });
        }

    };
    this.isStringEmpty = function(value) {
        if (value === undefined || value === null || value === "") {
            return true
        } else {
            return false;
        }
    };

    this.addTooltips = function(el) {
        $(".with-tooltip-right", el).tooltip({
            placement: "right",
            html: true
        });
        $(".with-tooltip-top", el).tooltip({
            placement: "top",
            html: true
        });
        $(".with-tooltip-left", el).tooltip({
            placement: "left",
            html: true
        });
        $(".with-tooltip-bottom", el).tooltip({
            placement: "bottom",
            html: true
        });
    };

    this.getMonday = function(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    };

    this.getTwoDaysBefore = function(d) {
        d = new Date(d);
        return new Date(d.setDate(d.getDate() - 2));
    };

    app.isDateBefore = function(date1, date2) {
        return date1.getTime() < date2.getTime();
    };



    this.displayAlertMessage = function(type, title, text) {
        $.pnotify.defaults.history = false;
        $.pnotify.defaults.delay = 800;
        $.pnotify({
            title: title,
            text: text,
            type: type,
            shadow: false
        });
    };

    this.openGameEditPage = function(gameId) {
        window.location = "/game/edit/" + gameId;
    };

    this.openGamePage = function(gameId) {
        window.location = "/game/" + gameId;
    };

    this.openLeagueEditPage = function(league) {
        window.location = "/league/edit/" + league;
    };

    this.openPostEditPage = function(postId) {
        window.location = "/post/edit/" + postId;
    };

    this.openLeagueGroupEditPage = function(id) {
        window.location = "/league-groups/edit/" + id;
    };

    this.openGameDisplayPage = function(gameId) {
        window.location = "/game/" + gameId;
    };

    this.openLeagueDisplayPage = function(leagueId) {
        window.location = "/league/" + leagueId;
    };

    this.openAvailbleGameRankingDisplayPage = function(id) {
        window.location = "/availbale-game-trip-rankings/" + id;
    };

    this.openAvailbleGameRankingEditPage = function(id) {
        window.location = "/availbale-game-trip-rankings/edit/" + id;
    };

    this.openLeagueGroupDisplayPage = function(leagueId) {
        window.location = "/league-groups/" + leagueId;
    };

    this.openUserDisplayPage = function(userId) {
        window.location = "/user/" + userId;
    };

    this.openMyInvoicesDisplayPage = function() {
        window.location = "/invoices/my";
    };

    this.openUserEditPage = function(userId) {
        window.location = "/user/edit/" + userId;
    };

    this.openGameEvaluationEditPage = function(gameId, evaluationId) {
        window.location = "/game-evaluation/edit/" + gameId + "/" + evaluationId;
    };

    this.openTestEditPage = function(test) {
        window.location = "/tests/edit/" + test;
    };

    this.openTestSolvePage = function(testId) {
        window.location = "/tests/solve/" + testId;
    };

    this.openTestAnswersPage = function(testId) {
        window.location = "/tests/answers/" + testId;
    };

    this.openVideoGroupEditPage = function(testId) {
        window.location = "/video-group/edit/" + testId;
    }


    this.openTestsPage = function() {
        window.location = "/tests";
    };

    this.sendGameEmailUrl = function(gameId) {
        return "/api/email/game/" + gameId;
    };

    this.openHomePage = function() {
        window.location = "/";

    };
    this.openVideoGroupDisplayPage = function(videoId) {
        window.location = "/video-group/" + videoId;
    };

    this.isIntFromString = function(n) {
        return n % 1 == 0;
    };

    this.displayLoadDialog = function() {
        $.blockUI({
            blockMsgClass: 'blocker-holder',
            message: '<h1>'+ app.getMessage('pleaseWait')+'</h1>',
            css: {
                border: 'none',
                padding: '15px',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                opacity: .5,
                color: '#fff',
                zIndex: '123123'
            }
        });
    };
    this.hideLoadDialog = function() {
        $.unblockUI()
    };

    this.serialize = function(obj) {
        var str = [];
        for (var p in obj)
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
    };

    this.cropText = function(text, size) {
        if (text == null) {
            text = "";
        }
        var cropedText = "";
        text = text.replace(/\n/g, "<br/>");
        text = text.replace(/<(?:.|\n)*?>/gm, '');

        if (text.length > size) {
            cropedText = text.slice(0, size);
            var lastIndex = cropedText.lastIndexOf(" ");
            cropedText = cropedText.substring(0, lastIndex) + " ...";
        } else {
            cropedText = text;
        }
        return cropedText;
    };

    this.getDateStringFromDateTimeString = function(date) {
        return date.substring(0, date.length - 6)
    };

    this.setCookie = function(name, value, expires, path, domain, secure) {
        var cookie = name + "=" + escape(value) + "; ";
        if (expires) {
            expires = this.setExpiration(expires);
            cookie += "expires=" + expires + "; ";
        }
        if (path) {
            cookie += "; path=" + path + " ";
        }
        if (domain) {
            cookie += "domain=" + domain + "; ";
        }
        if (secure) {
            cookie += "secure; ";
        }
        document.cookie = cookie;
    };

    this.getCookie = function(w) {
        var cName = "";
        var pCOOKIES = new Array();
        pCOOKIES = document.cookie.split('; ');
        for (var bb = 0; bb < pCOOKIES.length; bb++) {
            var NmeVal = new Array();
            NmeVal = pCOOKIES[bb].split('=');
            if (NmeVal[0] == w) {
                cName = unescape(NmeVal[1]);
            }
        }
        return cName;
    };

    this.setExpiration = function(cookieExpiresInDays) {
        var today = new Date();
        return expr.toGMTString();
    };

    this.getRequestParameterByName = function(name) {
        var name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }


    this.getVideoIframe = function(url) {
        //https://github.com/erost/ng-videosharing-embed/tree/master/src
        var isPlayerFromURL = function(url, playerRegExp) {
                return (url.match(this.playerRegExp) != null);
            },
            configs = [{
                type: "youtube",
                playerID: 'www.youtube.com/embed/',
                playerRegExp: /([a-z\:\/]*\/\/)(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
                timeRegExp: /t=(([0-9]+)h)?(([0-9]{1,2})m)?(([0-9]+)s?)?/
            }];
        var player = null;
        _(configs).each(function(config) {
            if (isPlayerFromURL(url, config.playerRegExp)) {
                player = config;
            }
        }, this);
        if (player === null) {
            return; //haven't found a match for a valid registered player
        }

        var parameters = url.match(player.playerRegExp),
            videoID = parameters[2],
            protocol = parameters[1],
            time = url.match(player.timeRegExp);
        return '<div class="video-container"><iframe width="560" height="315" src="' + protocol + player.playerID + videoID + '" frameborder="0" allowfullscreen></iframe></div>'


    }

    this.getDaysArray = function(start, end) {
        for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
            arr.push(new Date(dt));
        }
        return arr;
    };

    this.getStartAndEndOfMonth = (inputDate)=>{
        const date = moment(inputDate);
        return {
            start: date.clone().startOf('month'),
            end: date.clone().endOf('month')
        }
    }

    this.isDateBetween = function(startDate, endDate, dateToCheck) {
        return dateToCheck >= startDate && dateToCheck <= endDate;
    }

    this.formatDateWithTime = function(date){
        return moment(date).format("YYYY-MM-DD HH:mm");
    }
    return this;
};
module.exports = new setupAppUtils();

},{"moment":347}],346:[function(require,module,exports){
module.exports = (app) => {
  return [
    app.getMessage('monthFullJan'),
    app.getMessage('monthFullFeb'),
    app.getMessage('monthFullMar'),
    app.getMessage('monthFullApr'),
    app.getMessage('monthFullMay'),
    app.getMessage('monthFullJun'),
    app.getMessage('monthFullJul'),
    app.getMessage('monthFullAug'),
    app.getMessage('monthFullSep'),
    app.getMessage('monthFullOct'),
    app.getMessage('monthFullNov'),
    app.getMessage('monthFullDec'),
  ];
};

},{}],347:[function(require,module,exports){
//! moment.js
//! version : 2.10.6
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, function () { 'use strict';

    var hookCallback;

    function utils_hooks__hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function create_utc__createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    function valid__isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            m._isValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        return m._isValid;
    }

    function valid__createInvalid (flags) {
        var m = create_utc__createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    var momentProperties = utils_hooks__hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (typeof from._isAMomentObject !== 'undefined') {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (typeof from._i !== 'undefined') {
            to._i = from._i;
        }
        if (typeof from._f !== 'undefined') {
            to._f = from._f;
        }
        if (typeof from._l !== 'undefined') {
            to._l = from._l;
        }
        if (typeof from._strict !== 'undefined') {
            to._strict = from._strict;
        }
        if (typeof from._tzm !== 'undefined') {
            to._tzm = from._tzm;
        }
        if (typeof from._isUTC !== 'undefined') {
            to._isUTC = from._isUTC;
        }
        if (typeof from._offset !== 'undefined') {
            to._offset = from._offset;
        }
        if (typeof from._pf !== 'undefined') {
            to._pf = getParsingFlags(from);
        }
        if (typeof from._locale !== 'undefined') {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (typeof val !== 'undefined') {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            utils_hooks__hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function Locale() {
    }

    var locales = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && typeof module !== 'undefined' &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we
                // want to undo that for lazy loaded locales
                locale_locales__getSetGlobalLocale(oldLocale);
            } catch (e) { }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function locale_locales__getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (typeof values === 'undefined') {
                data = locale_locales__getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, values) {
        if (values !== null) {
            values.abbr = name;
            locales[name] = locales[name] || new Locale();
            locales[name].set(values);

            // backwards compat for now: also set the locale
            locale_locales__getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    // returns locale data
    function locale_locales__getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                get_set__set(this, unit, value);
                utils_hooks__hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get_set__get(this, unit);
            }
        };
    }

    function get_set__get (mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function get_set__set (mom, unit, value) {
        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }

    // MOMENTS

    function getSet (units, value) {
        var unit;
        if (typeof units === 'object') {
            for (unit in units) {
                this.set(unit, units[unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                return this[units](value);
            }
        }
        return this;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;

    var regexes = {};

    function isFunction (sth) {
        // https://github.com/moment/moment/issues/2325
        return typeof sth === 'function' &&
            Object.prototype.toString.call(sth) === '[object Function]';
    }


    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (typeof callback === 'number') {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  matchWord);
    addRegexToken('MMMM', matchWord);

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m) {
        return this._months[m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m) {
        return this._monthsShort[m.month()];
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = create_utc__createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            utils_hooks__hooks.updateOffset(this, true);
            return this;
        } else {
            return get_set__get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    function warn(msg) {
        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (firstTime) {
                warn(msg + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    utils_hooks__hooks.suppressDeprecationWarnings = false;

    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
        ['YYYY-DDD', /\d{4}-\d{3}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
        ['HH:mm', /(T| )\d\d:\d\d/],
        ['HH', /(T| )\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = from_string__isoRegex.exec(string);

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    config._f = isoDates[i][0];
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    // match[6] should be 'T' or space
                    config._f += (match[6] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (string.match(matchOffset)) {
                config._f += 'Z';
            }
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    utils_hooks__hooks.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    function createDate (y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    utils_hooks__hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', false);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
        if (d < firstDayOfWeek) {
            d += 7;
        }

        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;

        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
        }
        return [now.getFullYear(), now.getMonth(), now.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
            week = defaults(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < dow) {
                    ++week;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }

    utils_hooks__hooks.ISO_8601 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === utils_hooks__hooks.ISO_8601) {
            configFromISO(config);
            return;
        }

        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (getParsingFlags(config).bigHour === true &&
                config._a[HOUR] <= 12 &&
                config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!valid__isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || locale_locales__getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return valid__createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else if (isDate(input)) {
            config._d = input;
        } else {
            configFromInput(config);
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (input === undefined) {
            config._d = new Date();
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (typeof(input) === 'object') {
            configFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            utils_hooks__hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function local__createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
         function () {
             var other = local__createLocal.apply(null, arguments);
             return other < this ? this : other;
         }
     );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
        function () {
            var other = local__createLocal.apply(null, arguments);
            return other > this ? this : other;
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return local__createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = locale_locales__getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchOffset);
    addRegexToken('ZZ', matchOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(string) {
        var matches = ((string || '').match(matchOffset) || []);
        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(+res._d + diff);
            utils_hooks__hooks.updateOffset(res, false);
            return res;
        } else {
            return local__createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    utils_hooks__hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime) {
        var offset = this._offset || 0,
            localAdjust;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(input);
            }
            if (Math.abs(input) < 16) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    utils_hooks__hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm) {
            this.utcOffset(this._tzm);
        } else if (typeof this._i === 'string') {
            this.utcOffset(offsetFromString(this._i));
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        input = input ? local__createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (typeof this._isDSTShifted !== 'undefined') {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return !this._isUTC;
    }

    function isUtcOffset () {
        return this._isUTC;
    }

    function isUtc () {
        return this._isUTC && this._offset === 0;
    }

    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;

    function create__createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])        * sign,
                h  : toInt(match[HOUR])        * sign,
                m  : toInt(match[MINUTE])      * sign,
                s  : toInt(match[SECOND])      * sign,
                ms : toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = create__isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                d : parseIso(match[4], sign),
                h : parseIso(match[5], sign),
                m : parseIso(match[6], sign),
                s : parseIso(match[7], sign),
                w : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    create__createDuration.fn = Duration.prototype;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = create__createDuration(val, period);
            add_subtract__addSubtract(this, dur, direction);
            return this;
        };
    }

    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
        }
        if (months) {
            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            utils_hooks__hooks.updateOffset(mom, days || months);
        }
    }

    var add_subtract__add      = createAdder(1, 'add');
    var add_subtract__subtract = createAdder(-1, 'subtract');

    function moment_calendar__calendar (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || local__createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            diff = this.diff(sod, 'days', true),
            format = diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var inputMs;
        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this > +input;
        } else {
            inputMs = isMoment(input) ? +input : +local__createLocal(input);
            return inputMs < +this.clone().startOf(units);
        }
    }

    function isBefore (input, units) {
        var inputMs;
        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this < +input;
        } else {
            inputMs = isMoment(input) ? +input : +local__createLocal(input);
            return +this.clone().endOf(units) < inputMs;
        }
    }

    function isBetween (from, to, units) {
        return this.isAfter(from, units) && this.isBefore(to, units);
    }

    function isSame (input, units) {
        var inputMs;
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            input = isMoment(input) ? input : local__createLocal(input);
            return +this === +input;
        } else {
            inputMs = +local__createLocal(input);
            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
        }
    }

    function diff (input, units, asFloat) {
        var that = cloneWithOffset(input, this),
            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
            delta, output;

        units = normalizeUnits(units);

        if (units === 'year' || units === 'month' || units === 'quarter') {
            output = monthDiff(this, that);
            if (units === 'quarter') {
                output = output / 3;
            } else if (units === 'year') {
                output = output / 12;
            }
        } else {
            delta = this - that;
            output = units === 'second' ? delta / 1e3 : // 1000
                units === 'minute' ? delta / 6e4 : // 1000 * 60
                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                delta;
        }
        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        return -(wholeMonthDiff + adjust);
    }

    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function moment_format__toISOString () {
        var m = this.clone().utc();
        if (0 < m.year() && m.year() <= 9999) {
            if ('function' === typeof Date.prototype.toISOString) {
                // native implementation is ~50x faster, use it when we can
                return this.toDate().toISOString();
            } else {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        } else {
            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
        }
    }

    function format (inputString) {
        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }
        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    }

    function fromNow (withoutSuffix) {
        return this.from(local__createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }
        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    }

    function toNow (withoutSuffix) {
        return this.to(local__createLocal(), withoutSuffix);
    }

    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = locale_locales__getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }
        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function to_type__valueOf () {
        return +this._d - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(+this / 1000);
    }

    function toDate () {
        return this._offset ? new Date(+this) : this._d;
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function moment_valid__isValid () {
        return valid__isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
    });

    // HELPERS

    function weeksInYear(year, dow, doy) {
        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    // MOMENTS

    function getSetWeekYear (input) {
        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
        return input == null ? year : this.add((input - year), 'y');
    }

    function getSetISOWeekYear (input) {
        var year = weekOfYear(this, 1, 4).year;
        return input == null ? year : this.add((input - year), 'y');
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    addFormatToken('Q', 0, 0, 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0], 10);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   matchWord);
    addRegexToken('ddd',  matchWord);
    addRegexToken('dddd', matchWord);

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
        var weekday = config._locale.weekdaysParse(input);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m) {
        return this._weekdays[m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return this._weekdaysShort[m.day()];
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return this._weekdaysMin[m.day()];
    }

    function localeWeekdaysParse (weekdayName) {
        var i, mom, regex;

        this._weekdaysParse = this._weekdaysParse || [];

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            if (!this._weekdaysParse[i]) {
                mom = local__createLocal([2000, 1]).day(i);
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, function () {
        return this.hours() % 12 || 12;
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var momentPrototype__proto = Moment.prototype;

    momentPrototype__proto.add          = add_subtract__add;
    momentPrototype__proto.calendar     = moment_calendar__calendar;
    momentPrototype__proto.clone        = clone;
    momentPrototype__proto.diff         = diff;
    momentPrototype__proto.endOf        = endOf;
    momentPrototype__proto.format       = format;
    momentPrototype__proto.from         = from;
    momentPrototype__proto.fromNow      = fromNow;
    momentPrototype__proto.to           = to;
    momentPrototype__proto.toNow        = toNow;
    momentPrototype__proto.get          = getSet;
    momentPrototype__proto.invalidAt    = invalidAt;
    momentPrototype__proto.isAfter      = isAfter;
    momentPrototype__proto.isBefore     = isBefore;
    momentPrototype__proto.isBetween    = isBetween;
    momentPrototype__proto.isSame       = isSame;
    momentPrototype__proto.isValid      = moment_valid__isValid;
    momentPrototype__proto.lang         = lang;
    momentPrototype__proto.locale       = locale;
    momentPrototype__proto.localeData   = localeData;
    momentPrototype__proto.max          = prototypeMax;
    momentPrototype__proto.min          = prototypeMin;
    momentPrototype__proto.parsingFlags = parsingFlags;
    momentPrototype__proto.set          = getSet;
    momentPrototype__proto.startOf      = startOf;
    momentPrototype__proto.subtract     = add_subtract__subtract;
    momentPrototype__proto.toArray      = toArray;
    momentPrototype__proto.toObject     = toObject;
    momentPrototype__proto.toDate       = toDate;
    momentPrototype__proto.toISOString  = moment_format__toISOString;
    momentPrototype__proto.toJSON       = moment_format__toISOString;
    momentPrototype__proto.toString     = toString;
    momentPrototype__proto.unix         = unix;
    momentPrototype__proto.valueOf      = to_type__valueOf;

    // Year
    momentPrototype__proto.year       = getSetYear;
    momentPrototype__proto.isLeapYear = getIsLeapYear;

    // Week Year
    momentPrototype__proto.weekYear    = getSetWeekYear;
    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

    // Quarter
    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

    // Month
    momentPrototype__proto.month       = getSetMonth;
    momentPrototype__proto.daysInMonth = getDaysInMonth;

    // Week
    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
    momentPrototype__proto.weeksInYear    = getWeeksInYear;
    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

    // Day
    momentPrototype__proto.date       = getSetDayOfMonth;
    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

    // Hour
    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

    // Minute
    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

    // Second
    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

    // Millisecond
    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

    // Offset
    momentPrototype__proto.utcOffset            = getSetOffset;
    momentPrototype__proto.utc                  = setOffsetToUTC;
    momentPrototype__proto.local                = setOffsetToLocal;
    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
    momentPrototype__proto.isDST                = isDaylightSavingTime;
    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
    momentPrototype__proto.isLocal              = isLocal;
    momentPrototype__proto.isUtcOffset          = isUtcOffset;
    momentPrototype__proto.isUtc                = isUtc;
    momentPrototype__proto.isUTC                = isUtc;

    // Timezone
    momentPrototype__proto.zoneAbbr = getZoneAbbr;
    momentPrototype__proto.zoneName = getZoneName;

    // Deprecations
    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

    var momentPrototype = momentPrototype__proto;

    function moment__createUnix (input) {
        return local__createLocal(input * 1000);
    }

    function moment__createInZone () {
        return local__createLocal.apply(null, arguments).parseZone();
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function locale_calendar__calendar (key, mom, now) {
        var output = this._calendar[key];
        return typeof output === 'function' ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    function preParsePostFormat (string) {
        return string;
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (typeof output === 'function') ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
    }

    function locale_set__set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (typeof prop === 'function') {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _ordinalParseLenient.
        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
    }

    var prototype__proto = Locale.prototype;

    prototype__proto._calendar       = defaultCalendar;
    prototype__proto.calendar        = locale_calendar__calendar;
    prototype__proto._longDateFormat = defaultLongDateFormat;
    prototype__proto.longDateFormat  = longDateFormat;
    prototype__proto._invalidDate    = defaultInvalidDate;
    prototype__proto.invalidDate     = invalidDate;
    prototype__proto._ordinal        = defaultOrdinal;
    prototype__proto.ordinal         = ordinal;
    prototype__proto._ordinalParse   = defaultOrdinalParse;
    prototype__proto.preparse        = preParsePostFormat;
    prototype__proto.postformat      = preParsePostFormat;
    prototype__proto._relativeTime   = defaultRelativeTime;
    prototype__proto.relativeTime    = relative__relativeTime;
    prototype__proto.pastFuture      = pastFuture;
    prototype__proto.set             = locale_set__set;

    // Month
    prototype__proto.months       =        localeMonths;
    prototype__proto._months      = defaultLocaleMonths;
    prototype__proto.monthsShort  =        localeMonthsShort;
    prototype__proto._monthsShort = defaultLocaleMonthsShort;
    prototype__proto.monthsParse  =        localeMonthsParse;

    // Week
    prototype__proto.week = localeWeek;
    prototype__proto._week = defaultLocaleWeek;
    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

    // Day of Week
    prototype__proto.weekdays       =        localeWeekdays;
    prototype__proto._weekdays      = defaultLocaleWeekdays;
    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

    // Hours
    prototype__proto.isPM = localeIsPM;
    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
    prototype__proto.meridiem = localeMeridiem;

    function lists__get (format, index, field, setter) {
        var locale = locale_locales__getLocale();
        var utc = create_utc__createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function list (format, index, field, count, setter) {
        if (typeof format === 'number') {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return lists__get(format, index, field, setter);
        }

        var i;
        var out = [];
        for (i = 0; i < count; i++) {
            out[i] = lists__get(format, i, field, setter);
        }
        return out;
    }

    function lists__listMonths (format, index) {
        return list(format, index, 'months', 12, 'month');
    }

    function lists__listMonthsShort (format, index) {
        return list(format, index, 'monthsShort', 12, 'month');
    }

    function lists__listWeekdays (format, index) {
        return list(format, index, 'weekdays', 7, 'day');
    }

    function lists__listWeekdaysShort (format, index) {
        return list(format, index, 'weekdaysShort', 7, 'day');
    }

    function lists__listWeekdaysMin (format, index) {
        return list(format, index, 'weekdaysMin', 7, 'day');
    }

    locale_locales__getSetGlobalLocale('en', {
        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports
    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

    var mathAbs = Math.abs;

    function duration_abs__abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function duration_add_subtract__addSubtract (duration, input, value, direction) {
        var other = create__createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function duration_add_subtract__add (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function duration_add_subtract__subtract (input, value) {
        return duration_add_subtract__addSubtract(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function duration_as__valueOf () {
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function duration_get__get (units) {
        units = normalizeUnits(units);
        return this[units + 's']();
    }

    function makeGetter(name) {
        return function () {
            return this._data[name];
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        s: 45,  // seconds to minute
        m: 45,  // minutes to hour
        h: 22,  // hours to day
        d: 26,  // days to month
        M: 11   // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
        var duration = create__createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds < thresholds.s && ['s', seconds]  ||
                minutes === 1          && ['m']           ||
                minutes < thresholds.m && ['mm', minutes] ||
                hours   === 1          && ['h']           ||
                hours   < thresholds.h && ['hh', hours]   ||
                days    === 1          && ['d']           ||
                days    < thresholds.d && ['dd', days]    ||
                months  === 1          && ['M']           ||
                months  < thresholds.M && ['MM', months]  ||
                years   === 1          && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set a threshold for relative time strings
    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        return true;
    }

    function humanize (withSuffix) {
        var locale = this.localeData();
        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var iso_string__abs = Math.abs;

    function iso_string__toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        var seconds = iso_string__abs(this._milliseconds) / 1000;
        var days         = iso_string__abs(this._days);
        var months       = iso_string__abs(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds;
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        return (total < 0 ? '-' : '') +
            'P' +
            (Y ? Y + 'Y' : '') +
            (M ? M + 'M' : '') +
            (D ? D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? h + 'H' : '') +
            (m ? m + 'M' : '') +
            (s ? s + 'S' : '');
    }

    var duration_prototype__proto = Duration.prototype;

    duration_prototype__proto.abs            = duration_abs__abs;
    duration_prototype__proto.add            = duration_add_subtract__add;
    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
    duration_prototype__proto.as             = as;
    duration_prototype__proto.asMilliseconds = asMilliseconds;
    duration_prototype__proto.asSeconds      = asSeconds;
    duration_prototype__proto.asMinutes      = asMinutes;
    duration_prototype__proto.asHours        = asHours;
    duration_prototype__proto.asDays         = asDays;
    duration_prototype__proto.asWeeks        = asWeeks;
    duration_prototype__proto.asMonths       = asMonths;
    duration_prototype__proto.asYears        = asYears;
    duration_prototype__proto.valueOf        = duration_as__valueOf;
    duration_prototype__proto._bubble        = bubble;
    duration_prototype__proto.get            = duration_get__get;
    duration_prototype__proto.milliseconds   = milliseconds;
    duration_prototype__proto.seconds        = seconds;
    duration_prototype__proto.minutes        = minutes;
    duration_prototype__proto.hours          = hours;
    duration_prototype__proto.days           = days;
    duration_prototype__proto.weeks          = weeks;
    duration_prototype__proto.months         = months;
    duration_prototype__proto.years          = years;
    duration_prototype__proto.humanize       = humanize;
    duration_prototype__proto.toISOString    = iso_string__toISOString;
    duration_prototype__proto.toString       = iso_string__toISOString;
    duration_prototype__proto.toJSON         = iso_string__toISOString;
    duration_prototype__proto.locale         = locale;
    duration_prototype__proto.localeData     = localeData;

    // Deprecations
    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
    duration_prototype__proto.lang = lang;

    // Side effect imports

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    utils_hooks__hooks.version = '2.10.6';

    setHookCallback(local__createLocal);

    utils_hooks__hooks.fn                    = momentPrototype;
    utils_hooks__hooks.min                   = min;
    utils_hooks__hooks.max                   = max;
    utils_hooks__hooks.utc                   = create_utc__createUTC;
    utils_hooks__hooks.unix                  = moment__createUnix;
    utils_hooks__hooks.months                = lists__listMonths;
    utils_hooks__hooks.isDate                = isDate;
    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
    utils_hooks__hooks.invalid               = valid__createInvalid;
    utils_hooks__hooks.duration              = create__createDuration;
    utils_hooks__hooks.isMoment              = isMoment;
    utils_hooks__hooks.weekdays              = lists__listWeekdays;
    utils_hooks__hooks.parseZone             = moment__createInZone;
    utils_hooks__hooks.localeData            = locale_locales__getLocale;
    utils_hooks__hooks.isDuration            = isDuration;
    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
    utils_hooks__hooks.defineLocale          = defineLocale;
    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;

    var _moment = utils_hooks__hooks;

    return _moment;

}));
},{}],348:[function(require,module,exports){
(function (global){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.7
  //     https://underscorejs.org
  //     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.7';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global) ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  // Also, there are cases where an application can override the native
  // `DataView` object, in cases like that we can't use the constructor
  // safely and should just rely on alternate `DataView` checks
  var hasDataViewBug = (
        supportsDataView && (!/\[native code\]/.test(String(DataView)) || hasObjectTag(new DataView(new ArrayBuffer(8))))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  // Also, in cases where the native `DataView` is
  // overridden we can't rely on the tag itself.
  function alternateIsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasDataViewBug ? alternateIsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasDataViewBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[324]);
